/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type ManageResourcePermissionInput = {
  entityType?: PermissionEntityType | null,
  entityId?: string | null,
  resourceType?: PermissionResourceType | null,
  resourceId?: string | null,
  propertyId?: string | null,
  permissionType?: PermissionType | null,
};

export enum PermissionEntityType {
  USER = "USER",
  TEAM = "TEAM",
}


export enum PermissionResourceType {
  PROPERTY = "PROPERTY",
  LOCATION = "LOCATION",
  ISSUE = "ISSUE",
  DIMENSION = "DIMENSION",
  WORK_SPECIFICATION = "WORK_SPECIFICATION",
  ATTACHMENT = "ATTACHMENT",
  QUOTE = "QUOTE",
  SOLUTION = "SOLUTION",
  PROPOSAL = "PROPOSAL",
  ASSESSMENT = "ASSESSMENT",
  POLICY_TEMPLATE_LINK = "POLICY_TEMPLATE_LINK",
  TEAM = "TEAM",
  TEAM_MEMBER = "TEAM_MEMBER",
}


export enum PermissionType {
  VIEW = "VIEW",
  EDIT = "EDIT",
  DELETE = "DELETE",
  CREATE_CHILDREN = "CREATE_CHILDREN",
  MANAGE_STATE = "MANAGE_STATE",
  SHARE_PERMISSION = "SHARE_PERMISSION",
  REMOVE_PERMISSION = "REMOVE_PERMISSION",
}


export type CompleteEvent = {
  __typename: "CompleteEvent",
  executionId: string,
  status: CompleteEventStatus,
  result?: string | null,
};

export enum CompleteEventStatus {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}


export enum AttendeeRole {
  INSPECTOR = "INSPECTOR",
  AGENT = "AGENT",
}


export type ChimeMeetingOutput = {
  __typename: "ChimeMeetingOutput",
  meetingInfo: string,
  attendeeInfo: string,
};

export type CreateAttachmentInput = {
  id?: string | null,
  name?: string | null,
  type?: AttachmentType | null,
  parentId: string,
  parentType?: PermissionResourceType | null,
  propertyId?: string | null,
  key?: string | null,
  localCreatedAtTime?: number | null,
  status?: string | null,
  imageSource?: ImageSource | null,
  opaqueSyncReconciliationToken?: string | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdBy?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  _version?: number | null,
};

export enum AttachmentType {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
}


export enum ImageSource {
  CAMERA = "CAMERA",
  GALLERY = "GALLERY",
}


export type ModelAttachmentConditionInput = {
  name?: ModelStringInput | null,
  type?: ModelAttachmentTypeInput | null,
  parentId?: ModelIDInput | null,
  parentType?: ModelPermissionResourceTypeInput | null,
  propertyId?: ModelIDInput | null,
  key?: ModelStringInput | null,
  localCreatedAtTime?: ModelIntInput | null,
  status?: ModelStringInput | null,
  imageSource?: ModelImageSourceInput | null,
  opaqueSyncReconciliationToken?: ModelStringInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  canViewList?: ModelStringInput | null,
  canViewEntityVersionMap?: ModelStringInput | null,
  and?: Array< ModelAttachmentConditionInput | null > | null,
  or?: Array< ModelAttachmentConditionInput | null > | null,
  not?: ModelAttachmentConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelAttachmentTypeInput = {
  eq?: AttachmentType | null,
  ne?: AttachmentType | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelPermissionResourceTypeInput = {
  eq?: PermissionResourceType | null,
  ne?: PermissionResourceType | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelImageSourceInput = {
  eq?: ImageSource | null,
  ne?: ImageSource | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type Attachment = {
  __typename: "Attachment",
  id: string,
  name?: string | null,
  type?: AttachmentType | null,
  parentId: string,
  parentType?: PermissionResourceType | null,
  propertyId?: string | null,
  key?: string | null,
  localCreatedAtTime?: number | null,
  status?: string | null,
  imageSource?: ImageSource | null,
  opaqueSyncReconciliationToken?: string | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdBy?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateAttachmentInput = {
  id: string,
  name?: string | null,
  type?: AttachmentType | null,
  parentId?: string | null,
  parentType?: PermissionResourceType | null,
  propertyId?: string | null,
  key?: string | null,
  localCreatedAtTime?: number | null,
  status?: string | null,
  imageSource?: ImageSource | null,
  opaqueSyncReconciliationToken?: string | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdBy?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  _version?: number | null,
};

export type DeleteAttachmentInput = {
  id: string,
  _version?: number | null,
};

export type CreateBiddingContactInput = {
  id?: string | null,
  email: string,
  ownerEntityId?: string | null,
  contactEntityId?: string | null,
  name?: string | null,
  privateDescription?: string | null,
  publicDescription?: string | null,
  _version?: number | null,
};

export type ModelBiddingContactConditionInput = {
  email?: ModelStringInput | null,
  ownerEntityId?: ModelStringInput | null,
  contactEntityId?: ModelStringInput | null,
  name?: ModelStringInput | null,
  privateDescription?: ModelStringInput | null,
  publicDescription?: ModelStringInput | null,
  and?: Array< ModelBiddingContactConditionInput | null > | null,
  or?: Array< ModelBiddingContactConditionInput | null > | null,
  not?: ModelBiddingContactConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type BiddingContact = {
  __typename: "BiddingContact",
  id: string,
  email: string,
  ownerEntityId?: string | null,
  contactEntityId?: string | null,
  name?: string | null,
  privateDescription?: string | null,
  publicDescription?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateBiddingContactInput = {
  id: string,
  email?: string | null,
  ownerEntityId?: string | null,
  contactEntityId?: string | null,
  name?: string | null,
  privateDescription?: string | null,
  publicDescription?: string | null,
  _version?: number | null,
};

export type DeleteBiddingContactInput = {
  id: string,
  _version?: number | null,
};

export type CreateBidInvitationInput = {
  id?: string | null,
  biddingContactId?: string | null,
  tenderId?: string | null,
  ownerEntityId?: string | null,
  _version?: number | null,
};

export type ModelBidInvitationConditionInput = {
  biddingContactId?: ModelStringInput | null,
  tenderId?: ModelStringInput | null,
  ownerEntityId?: ModelStringInput | null,
  and?: Array< ModelBidInvitationConditionInput | null > | null,
  or?: Array< ModelBidInvitationConditionInput | null > | null,
  not?: ModelBidInvitationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type BidInvitation = {
  __typename: "BidInvitation",
  id: string,
  biddingContactId?: string | null,
  tenderId?: string | null,
  ownerEntityId?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateBidInvitationInput = {
  id: string,
  biddingContactId?: string | null,
  tenderId?: string | null,
  ownerEntityId?: string | null,
  _version?: number | null,
};

export type DeleteBidInvitationInput = {
  id: string,
  _version?: number | null,
};

export type CreateBidInput = {
  id?: string | null,
  tenderId?: string | null,
  latestMinorVersion?: number | null,
  latestAcceptedMinorVersion?: number | null,
  latestSubmittedMinorVersion?: number | null,
  status?: BidStatus | null,
  bidNumber?: number | null,
  createdBy?: string | null,
  _version?: number | null,
};

export enum BidStatus {
  AWARDED = "AWARDED",
  REJECTED = "REJECTED",
  CANCELLED = "CANCELLED",
}


export type ModelBidConditionInput = {
  tenderId?: ModelStringInput | null,
  latestMinorVersion?: ModelIntInput | null,
  latestAcceptedMinorVersion?: ModelIntInput | null,
  latestSubmittedMinorVersion?: ModelIntInput | null,
  status?: ModelBidStatusInput | null,
  bidNumber?: ModelIntInput | null,
  createdBy?: ModelStringInput | null,
  and?: Array< ModelBidConditionInput | null > | null,
  or?: Array< ModelBidConditionInput | null > | null,
  not?: ModelBidConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelBidStatusInput = {
  eq?: BidStatus | null,
  ne?: BidStatus | null,
};

export type Bid = {
  __typename: "Bid",
  id: string,
  tenderId?: string | null,
  latestMinorVersion?: number | null,
  latestAcceptedMinorVersion?: number | null,
  latestSubmittedMinorVersion?: number | null,
  status?: BidStatus | null,
  bidNumber?: number | null,
  createdBy?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateBidInput = {
  id: string,
  tenderId?: string | null,
  latestMinorVersion?: number | null,
  latestAcceptedMinorVersion?: number | null,
  latestSubmittedMinorVersion?: number | null,
  status?: BidStatus | null,
  bidNumber?: number | null,
  createdBy?: string | null,
  _version?: number | null,
};

export type DeleteBidInput = {
  id: string,
  _version?: number | null,
};

export type CreateBidMinorVersionInput = {
  id?: string | null,
  bidId?: string | null,
  minorVersion?: number | null,
  tenderId?: string | null,
  tenderMinorVersion?: number | null,
  proposalId?: string | null,
  status?: DocumentStatus | null,
  metadata?: BidMetadataInput | null,
  _version?: number | null,
};

export enum DocumentStatus {
  DRAFT = "DRAFT",
  SUBMITTED = "SUBMITTED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
}


export type BidMetadataInput = {
  bidderContactName?: string | null,
  bidderContactEmail?: string | null,
  bidderCompanyName?: string | null,
  bidderContactAddress?: string | null,
  bidderContactPhoneNumber?: string | null,
  bidderWebsite?: string | null,
};

export type ModelBidMinorVersionConditionInput = {
  bidId?: ModelStringInput | null,
  minorVersion?: ModelIntInput | null,
  tenderId?: ModelStringInput | null,
  tenderMinorVersion?: ModelIntInput | null,
  proposalId?: ModelStringInput | null,
  status?: ModelDocumentStatusInput | null,
  and?: Array< ModelBidMinorVersionConditionInput | null > | null,
  or?: Array< ModelBidMinorVersionConditionInput | null > | null,
  not?: ModelBidMinorVersionConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelDocumentStatusInput = {
  eq?: DocumentStatus | null,
  ne?: DocumentStatus | null,
};

export type BidMinorVersion = {
  __typename: "BidMinorVersion",
  id: string,
  bidId?: string | null,
  minorVersion?: number | null,
  tenderId?: string | null,
  tenderMinorVersion?: number | null,
  proposalId?: string | null,
  status?: DocumentStatus | null,
  metadata?: BidMetadata | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type BidMetadata = {
  __typename: "BidMetadata",
  bidderContactName?: string | null,
  bidderContactEmail?: string | null,
  bidderCompanyName?: string | null,
  bidderContactAddress?: string | null,
  bidderContactPhoneNumber?: string | null,
  bidderWebsite?: string | null,
};

export type UpdateBidMinorVersionInput = {
  id: string,
  bidId?: string | null,
  minorVersion?: number | null,
  tenderId?: string | null,
  tenderMinorVersion?: number | null,
  proposalId?: string | null,
  status?: DocumentStatus | null,
  metadata?: BidMetadataInput | null,
  _version?: number | null,
};

export type DeleteBidMinorVersionInput = {
  id: string,
  _version?: number | null,
};

export type CreateClientLogInput = {
  id?: string | null,
  userId?: string | null,
  userAgent?: string | null,
  severityLevel: LogSeverityLevel,
  componentName: string,
  message?: string | null,
  details?: string | null,
  tags?: string | null,
  _version?: number | null,
};

export enum LogSeverityLevel {
  DEBUG = "DEBUG",
  INFO = "INFO",
  WARN = "WARN",
  ERROR = "ERROR",
}


export type ModelClientLogConditionInput = {
  userId?: ModelStringInput | null,
  userAgent?: ModelStringInput | null,
  severityLevel?: ModelLogSeverityLevelInput | null,
  componentName?: ModelStringInput | null,
  message?: ModelStringInput | null,
  details?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  and?: Array< ModelClientLogConditionInput | null > | null,
  or?: Array< ModelClientLogConditionInput | null > | null,
  not?: ModelClientLogConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLogSeverityLevelInput = {
  eq?: LogSeverityLevel | null,
  ne?: LogSeverityLevel | null,
};

export type ClientLog = {
  __typename: "ClientLog",
  id: string,
  userId?: string | null,
  userAgent?: string | null,
  severityLevel: LogSeverityLevel,
  componentName: string,
  message?: string | null,
  details?: string | null,
  tags?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateClientLogInput = {
  id: string,
  userId?: string | null,
  userAgent?: string | null,
  severityLevel?: LogSeverityLevel | null,
  componentName?: string | null,
  message?: string | null,
  details?: string | null,
  tags?: string | null,
  _version?: number | null,
};

export type DeleteClientLogInput = {
  id: string,
  _version?: number | null,
};

export type CreateCounterInput = {
  id?: string | null,
  type: ResourceType,
  _version?: number | null,
};

export enum ResourceType {
  PROPERTY = "PROPERTY",
  PROPOSAL = "PROPOSAL",
  SOLUTION = "SOLUTION",
  SOLUTION_MINOR_VERSION = "SOLUTION_MINOR_VERSION",
  WORKTYPE = "WORKTYPE",
  EXTERNAL_REPORT = "EXTERNAL_REPORT",
  TENDER = "TENDER",
  TENDER_MINOR_VERSION = "TENDER_MINOR_VERSION",
  BID = "BID",
  BID_MINOR_VERSION = "BID_MINOR_VERSION",
}


export type ModelCounterConditionInput = {
  type?: ModelResourceTypeInput | null,
  and?: Array< ModelCounterConditionInput | null > | null,
  or?: Array< ModelCounterConditionInput | null > | null,
  not?: ModelCounterConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelResourceTypeInput = {
  eq?: ResourceType | null,
  ne?: ResourceType | null,
};

export type Counter = {
  __typename: "Counter",
  id: string,
  type: ResourceType,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateCounterInput = {
  id: string,
  type?: ResourceType | null,
  _version?: number | null,
};

export type DeleteCounterInput = {
  id: string,
  _version?: number | null,
};

export type CreateDesignDocumentInput = {
  id?: string | null,
  designDocumentGroupId?: string | null,
  propertyId: string,
  projectId: string,
  name: string,
  status?: DesignDocumentStatus | null,
  lastEvaluatedValidityStatus?: boolean | null,
  uploadStatus?: string | null,
  documentKey?: string | null,
  lastWorkScopeSpecificationItemNumber?: number | null,
  version?: number | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export enum DesignDocumentStatus {
  AUTOSAVE_DRAFT = "AUTOSAVE_DRAFT",
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
  APPROVED = "APPROVED",
}


export type ModelDesignDocumentConditionInput = {
  designDocumentGroupId?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  status?: ModelDesignDocumentStatusInput | null,
  lastEvaluatedValidityStatus?: ModelBooleanInput | null,
  uploadStatus?: ModelStringInput | null,
  documentKey?: ModelStringInput | null,
  lastWorkScopeSpecificationItemNumber?: ModelIntInput | null,
  version?: ModelIntInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  and?: Array< ModelDesignDocumentConditionInput | null > | null,
  or?: Array< ModelDesignDocumentConditionInput | null > | null,
  not?: ModelDesignDocumentConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelDesignDocumentStatusInput = {
  eq?: DesignDocumentStatus | null,
  ne?: DesignDocumentStatus | null,
};

export type DesignDocument = {
  __typename: "DesignDocument",
  id: string,
  designDocumentGroupId?: string | null,
  propertyId: string,
  projectId: string,
  name: string,
  status?: DesignDocumentStatus | null,
  lastEvaluatedValidityStatus?: boolean | null,
  uploadStatus?: string | null,
  documentKey?: string | null,
  lastWorkScopeSpecificationItemNumber?: number | null,
  version?: number | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateDesignDocumentInput = {
  id: string,
  designDocumentGroupId?: string | null,
  propertyId?: string | null,
  projectId?: string | null,
  name?: string | null,
  status?: DesignDocumentStatus | null,
  lastEvaluatedValidityStatus?: boolean | null,
  uploadStatus?: string | null,
  documentKey?: string | null,
  lastWorkScopeSpecificationItemNumber?: number | null,
  version?: number | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export type DeleteDesignDocumentInput = {
  id: string,
  _version?: number | null,
};

export type CreateDesignDocumentGroupInput = {
  id?: string | null,
  projectId: string,
  propertyId: string,
  name: string,
  latestDocumentVersion: number,
  documentContentKey?: string | null,
  solutionGroupNumber?: number | null,
  isLocked: boolean,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export type ModelDesignDocumentGroupConditionInput = {
  projectId?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  latestDocumentVersion?: ModelIntInput | null,
  documentContentKey?: ModelStringInput | null,
  solutionGroupNumber?: ModelIntInput | null,
  isLocked?: ModelBooleanInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  and?: Array< ModelDesignDocumentGroupConditionInput | null > | null,
  or?: Array< ModelDesignDocumentGroupConditionInput | null > | null,
  not?: ModelDesignDocumentGroupConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type DesignDocumentGroup = {
  __typename: "DesignDocumentGroup",
  id: string,
  projectId: string,
  propertyId: string,
  name: string,
  latestDocumentVersion: number,
  documentContentKey?: string | null,
  solutionGroupNumber?: number | null,
  isLocked: boolean,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateDesignDocumentGroupInput = {
  id: string,
  projectId?: string | null,
  propertyId?: string | null,
  name?: string | null,
  latestDocumentVersion?: number | null,
  documentContentKey?: string | null,
  solutionGroupNumber?: number | null,
  isLocked?: boolean | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export type DeleteDesignDocumentGroupInput = {
  id: string,
  _version?: number | null,
};

export type CreateDimensionInput = {
  id?: string | null,
  parentId?: string | null,
  propertyId?: string | null,
  createdInSolution?: boolean | null,
  description?: string | null,
  length?: number | null,
  lengthUnit?: string | null,
  width?: number | null,
  widthUnit?: string | null,
  dimensionType?: DimensionType | null,
  measurementUnit?: MeasurementUnit | null,
  measurement?: MeasurementInput | null,
  localLastUpdatedTime?: number | null,
  opaqueSyncReconciliationToken?: string | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdBy?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  _version?: number | null,
};

export enum DimensionType {
  LINEAR = "LINEAR",
  SQUARE = "SQUARE",
}


export enum MeasurementUnit {
  METER = "METER",
  CENTIMETER = "CENTIMETER",
  FOOT = "FOOT",
  INCH = "INCH",
}


export type MeasurementInput = {
  length?: number | null,
  width?: number | null,
  dimensionType?: DimensionType | null,
  measurementUnit?: MeasurementUnit | null,
};

export type ModelDimensionConditionInput = {
  parentId?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  createdInSolution?: ModelBooleanInput | null,
  description?: ModelStringInput | null,
  length?: ModelFloatInput | null,
  lengthUnit?: ModelStringInput | null,
  width?: ModelFloatInput | null,
  widthUnit?: ModelStringInput | null,
  dimensionType?: ModelDimensionTypeInput | null,
  measurementUnit?: ModelMeasurementUnitInput | null,
  localLastUpdatedTime?: ModelIntInput | null,
  opaqueSyncReconciliationToken?: ModelStringInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  canViewList?: ModelStringInput | null,
  canViewEntityVersionMap?: ModelStringInput | null,
  and?: Array< ModelDimensionConditionInput | null > | null,
  or?: Array< ModelDimensionConditionInput | null > | null,
  not?: ModelDimensionConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelDimensionTypeInput = {
  eq?: DimensionType | null,
  ne?: DimensionType | null,
};

export type ModelMeasurementUnitInput = {
  eq?: MeasurementUnit | null,
  ne?: MeasurementUnit | null,
};

export type Dimension = {
  __typename: "Dimension",
  id: string,
  parentId?: string | null,
  propertyId?: string | null,
  createdInSolution?: boolean | null,
  description?: string | null,
  length?: number | null,
  lengthUnit?: string | null,
  width?: number | null,
  widthUnit?: string | null,
  dimensionType?: DimensionType | null,
  measurementUnit?: MeasurementUnit | null,
  measurement?: Measurement | null,
  localLastUpdatedTime?: number | null,
  opaqueSyncReconciliationToken?: string | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdBy?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type Measurement = {
  __typename: "Measurement",
  length?: number | null,
  width?: number | null,
  dimensionType?: DimensionType | null,
  measurementUnit?: MeasurementUnit | null,
};

export type UpdateDimensionInput = {
  id: string,
  parentId?: string | null,
  propertyId?: string | null,
  createdInSolution?: boolean | null,
  description?: string | null,
  length?: number | null,
  lengthUnit?: string | null,
  width?: number | null,
  widthUnit?: string | null,
  dimensionType?: DimensionType | null,
  measurementUnit?: MeasurementUnit | null,
  measurement?: MeasurementInput | null,
  localLastUpdatedTime?: number | null,
  opaqueSyncReconciliationToken?: string | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdBy?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  _version?: number | null,
};

export type DeleteDimensionInput = {
  id: string,
  _version?: number | null,
};

export type CreateDiscoverableWorkTypesInput = {
  id?: string | null,
  workTypeGroupId: string,
  defaultVersion: number,
  _version?: number | null,
};

export type ModelDiscoverableWorkTypesConditionInput = {
  workTypeGroupId?: ModelIDInput | null,
  defaultVersion?: ModelIntInput | null,
  and?: Array< ModelDiscoverableWorkTypesConditionInput | null > | null,
  or?: Array< ModelDiscoverableWorkTypesConditionInput | null > | null,
  not?: ModelDiscoverableWorkTypesConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type DiscoverableWorkTypes = {
  __typename: "DiscoverableWorkTypes",
  id: string,
  workTypeGroupId: string,
  defaultVersion: number,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateDiscoverableWorkTypesInput = {
  id: string,
  workTypeGroupId?: string | null,
  defaultVersion?: number | null,
  _version?: number | null,
};

export type DeleteDiscoverableWorkTypesInput = {
  id: string,
  _version?: number | null,
};

export type CreateEntityResourcePermissionInput = {
  id?: string | null,
  propertyId?: string | null,
  entityId?: string | null,
  entityType?: PermissionEntityType | null,
  resourceId?: string | null,
  resourceType?: PermissionResourceType | null,
  permissionType?: PermissionType | null,
  isGranted?: boolean | null,
  _version?: number | null,
};

export type ModelEntityResourcePermissionConditionInput = {
  propertyId?: ModelIDInput | null,
  entityId?: ModelIDInput | null,
  entityType?: ModelPermissionEntityTypeInput | null,
  resourceId?: ModelIDInput | null,
  resourceType?: ModelPermissionResourceTypeInput | null,
  permissionType?: ModelPermissionTypeInput | null,
  isGranted?: ModelBooleanInput | null,
  and?: Array< ModelEntityResourcePermissionConditionInput | null > | null,
  or?: Array< ModelEntityResourcePermissionConditionInput | null > | null,
  not?: ModelEntityResourcePermissionConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelPermissionEntityTypeInput = {
  eq?: PermissionEntityType | null,
  ne?: PermissionEntityType | null,
};

export type ModelPermissionTypeInput = {
  eq?: PermissionType | null,
  ne?: PermissionType | null,
};

export type EntityResourcePermission = {
  __typename: "EntityResourcePermission",
  id: string,
  propertyId?: string | null,
  entityId?: string | null,
  entityType?: PermissionEntityType | null,
  resourceId?: string | null,
  resourceType?: PermissionResourceType | null,
  permissionType?: PermissionType | null,
  isGranted?: boolean | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateEntityResourcePermissionInput = {
  id: string,
  propertyId?: string | null,
  entityId?: string | null,
  entityType?: PermissionEntityType | null,
  resourceId?: string | null,
  resourceType?: PermissionResourceType | null,
  permissionType?: PermissionType | null,
  isGranted?: boolean | null,
  _version?: number | null,
};

export type DeleteEntityResourcePermissionInput = {
  id: string,
  _version?: number | null,
};

export type CreateEntityWorkTypeAssociationInput = {
  id?: string | null,
  entityId: string,
  entityType: WorkTypeAssociationScopeEntity,
  workTypeGroupId: string,
  workTypeVersion?: number | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export enum WorkTypeAssociationScopeEntity {
  PROPERTY = "PROPERTY",
  USER = "USER",
  ORGANIZATION = "ORGANIZATION",
}


export type ModelEntityWorkTypeAssociationConditionInput = {
  entityId?: ModelIDInput | null,
  entityType?: ModelWorkTypeAssociationScopeEntityInput | null,
  workTypeGroupId?: ModelIDInput | null,
  workTypeVersion?: ModelIntInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  and?: Array< ModelEntityWorkTypeAssociationConditionInput | null > | null,
  or?: Array< ModelEntityWorkTypeAssociationConditionInput | null > | null,
  not?: ModelEntityWorkTypeAssociationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelWorkTypeAssociationScopeEntityInput = {
  eq?: WorkTypeAssociationScopeEntity | null,
  ne?: WorkTypeAssociationScopeEntity | null,
};

export type EntityWorkTypeAssociation = {
  __typename: "EntityWorkTypeAssociation",
  id: string,
  entityId: string,
  entityType: WorkTypeAssociationScopeEntity,
  workTypeGroupId: string,
  workTypeVersion?: number | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateEntityWorkTypeAssociationInput = {
  id: string,
  entityId?: string | null,
  entityType?: WorkTypeAssociationScopeEntity | null,
  workTypeGroupId?: string | null,
  workTypeVersion?: number | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export type DeleteEntityWorkTypeAssociationInput = {
  id: string,
  _version?: number | null,
};

export type CreateInspectionInput = {
  id?: string | null,
  propertyId: string,
  createdByOrganizationId: string,
  createdByUserId: string,
  startTime: number,
  endTime?: number | null,
  status: InspectionStatus,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export enum InspectionStatus {
  IN_PROGRESS = "IN_PROGRESS",
  PAUSED = "PAUSED",
  COMPLETED = "COMPLETED",
  ABANDONED = "ABANDONED",
}


export type ModelInspectionConditionInput = {
  propertyId?: ModelIDInput | null,
  createdByOrganizationId?: ModelStringInput | null,
  createdByUserId?: ModelStringInput | null,
  startTime?: ModelIntInput | null,
  endTime?: ModelIntInput | null,
  status?: ModelInspectionStatusInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  and?: Array< ModelInspectionConditionInput | null > | null,
  or?: Array< ModelInspectionConditionInput | null > | null,
  not?: ModelInspectionConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelInspectionStatusInput = {
  eq?: InspectionStatus | null,
  ne?: InspectionStatus | null,
};

export type Inspection = {
  __typename: "Inspection",
  id: string,
  propertyId: string,
  createdByOrganizationId: string,
  createdByUserId: string,
  startTime: number,
  endTime?: number | null,
  status: InspectionStatus,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateInspectionInput = {
  id: string,
  propertyId?: string | null,
  createdByOrganizationId?: string | null,
  createdByUserId?: string | null,
  startTime?: number | null,
  endTime?: number | null,
  status?: InspectionStatus | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export type DeleteInspectionInput = {
  id: string,
  _version?: number | null,
};

export type CreateIssueInput = {
  id?: string | null,
  locationId?: string | null,
  propertyId?: string | null,
  inspectionId?: string | null,
  createdInSolution?: boolean | null,
  name?: string | null,
  description?: string | null,
  note?: string | null,
  tags?: string | null,
  tagIds?: Array< string > | null,
  status?: IssueStatus | null,
  clientCreationDate?: number | null,
  localLastUpdatedTime?: number | null,
  createdBy?: string | null,
  opaqueSyncReconciliationToken?: string | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  isPubliclySubmitted?: boolean | null,
  suggestedWorkTypeIds?: Array< string > | null,
  quickQuoteIds?: Array< string > | null,
  proposalDocLinks?: Array< ProposalDocLinkInput > | null,
  priority?: IssuePriority | null,
  _version?: number | null,
};

export enum IssueStatus {
  SUBMITTED = "SUBMITTED",
  ARCHIVED = "ARCHIVED",
  APPROVED = "APPROVED",
  ON_HOLD = "ON_HOLD",
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  DESIGN_PENDING = "DESIGN_PENDING",
  DESIGNED = "DESIGNED",
  SCHEDULED = "SCHEDULED",
}


export type ProposalDocLinkInput = {
  name: string,
  link: string,
  date: number,
};

export enum IssuePriority {
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
}


export type ModelIssueConditionInput = {
  locationId?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  inspectionId?: ModelIDInput | null,
  createdInSolution?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  note?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  tagIds?: ModelIDInput | null,
  status?: ModelIssueStatusInput | null,
  clientCreationDate?: ModelIntInput | null,
  localLastUpdatedTime?: ModelIntInput | null,
  createdBy?: ModelStringInput | null,
  opaqueSyncReconciliationToken?: ModelStringInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  canViewList?: ModelStringInput | null,
  canViewEntityVersionMap?: ModelStringInput | null,
  isPubliclySubmitted?: ModelBooleanInput | null,
  suggestedWorkTypeIds?: ModelStringInput | null,
  quickQuoteIds?: ModelIDInput | null,
  priority?: ModelIssuePriorityInput | null,
  and?: Array< ModelIssueConditionInput | null > | null,
  or?: Array< ModelIssueConditionInput | null > | null,
  not?: ModelIssueConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelIssueStatusInput = {
  eq?: IssueStatus | null,
  ne?: IssueStatus | null,
};

export type ModelIssuePriorityInput = {
  eq?: IssuePriority | null,
  ne?: IssuePriority | null,
};

export type Issue = {
  __typename: "Issue",
  id: string,
  locationId?: string | null,
  propertyId?: string | null,
  inspectionId?: string | null,
  createdInSolution?: boolean | null,
  name?: string | null,
  description?: string | null,
  note?: string | null,
  tags?: string | null,
  tagIds?: Array< string > | null,
  status?: IssueStatus | null,
  clientCreationDate?: number | null,
  localLastUpdatedTime?: number | null,
  createdBy?: string | null,
  opaqueSyncReconciliationToken?: string | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  isPubliclySubmitted?: boolean | null,
  suggestedWorkTypeIds?: Array< string > | null,
  quickQuoteIds?: Array< string > | null,
  proposalDocLinks?:  Array<ProposalDocLink > | null,
  priority?: IssuePriority | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ProposalDocLink = {
  __typename: "ProposalDocLink",
  name: string,
  link: string,
  date: number,
};

export type UpdateIssueInput = {
  id: string,
  locationId?: string | null,
  propertyId?: string | null,
  inspectionId?: string | null,
  createdInSolution?: boolean | null,
  name?: string | null,
  description?: string | null,
  note?: string | null,
  tags?: string | null,
  tagIds?: Array< string > | null,
  status?: IssueStatus | null,
  clientCreationDate?: number | null,
  localLastUpdatedTime?: number | null,
  createdBy?: string | null,
  opaqueSyncReconciliationToken?: string | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  isPubliclySubmitted?: boolean | null,
  suggestedWorkTypeIds?: Array< string > | null,
  quickQuoteIds?: Array< string > | null,
  proposalDocLinks?: Array< ProposalDocLinkInput > | null,
  priority?: IssuePriority | null,
  _version?: number | null,
};

export type DeleteIssueInput = {
  id: string,
  _version?: number | null,
};

export type CreateQuickQuoteInput = {
  id?: string | null,
  propertyId: string,
  generatedProposalId?: string | null,
  status: QuickQuoteStatus,
  generatedSolutionId?: string | null,
  issueIds?: Array< string > | null,
  _version?: number | null,
};

export enum QuickQuoteStatus {
  STARTED = "STARTED",
  PENDING_REVIEW = "PENDING_REVIEW",
  REVIEWED = "REVIEWED",
  COMPLETED = "COMPLETED",
}


export type ModelQuickQuoteConditionInput = {
  propertyId?: ModelIDInput | null,
  generatedProposalId?: ModelIDInput | null,
  status?: ModelQuickQuoteStatusInput | null,
  generatedSolutionId?: ModelIDInput | null,
  issueIds?: ModelIDInput | null,
  and?: Array< ModelQuickQuoteConditionInput | null > | null,
  or?: Array< ModelQuickQuoteConditionInput | null > | null,
  not?: ModelQuickQuoteConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelQuickQuoteStatusInput = {
  eq?: QuickQuoteStatus | null,
  ne?: QuickQuoteStatus | null,
};

export type QuickQuote = {
  __typename: "QuickQuote",
  id: string,
  propertyId: string,
  generatedProposalId?: string | null,
  status: QuickQuoteStatus,
  generatedSolutionId?: string | null,
  issueIds?: Array< string > | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateQuickQuoteInput = {
  id: string,
  propertyId?: string | null,
  generatedProposalId?: string | null,
  status?: QuickQuoteStatus | null,
  generatedSolutionId?: string | null,
  issueIds?: Array< string > | null,
  _version?: number | null,
};

export type DeleteQuickQuoteInput = {
  id: string,
  _version?: number | null,
};

export type CreateLocationInput = {
  id?: string | null,
  propertyId?: string | null,
  createdInSolution?: boolean | null,
  name?: string | null,
  tags?: string | null,
  localCreationTime?: number | null,
  localLastUpdatedTime?: number | null,
  opaqueSyncReconciliationToken?: string | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdBy?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  _version?: number | null,
};

export type ModelLocationConditionInput = {
  propertyId?: ModelIDInput | null,
  createdInSolution?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  localCreationTime?: ModelIntInput | null,
  localLastUpdatedTime?: ModelIntInput | null,
  opaqueSyncReconciliationToken?: ModelStringInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  canViewList?: ModelStringInput | null,
  canViewEntityVersionMap?: ModelStringInput | null,
  and?: Array< ModelLocationConditionInput | null > | null,
  or?: Array< ModelLocationConditionInput | null > | null,
  not?: ModelLocationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Location = {
  __typename: "Location",
  id: string,
  propertyId?: string | null,
  createdInSolution?: boolean | null,
  name?: string | null,
  tags?: string | null,
  localCreationTime?: number | null,
  localLastUpdatedTime?: number | null,
  opaqueSyncReconciliationToken?: string | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdBy?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateLocationInput = {
  id: string,
  propertyId?: string | null,
  createdInSolution?: boolean | null,
  name?: string | null,
  tags?: string | null,
  localCreationTime?: number | null,
  localLastUpdatedTime?: number | null,
  opaqueSyncReconciliationToken?: string | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdBy?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  _version?: number | null,
};

export type DeleteLocationInput = {
  id: string,
  _version?: number | null,
};

export type CreateNoteInput = {
  id?: string | null,
  parentId?: string | null,
  propertyId?: string | null,
  note?: string | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export type ModelNoteConditionInput = {
  parentId?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  note?: ModelStringInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  and?: Array< ModelNoteConditionInput | null > | null,
  or?: Array< ModelNoteConditionInput | null > | null,
  not?: ModelNoteConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Note = {
  __typename: "Note",
  id: string,
  parentId?: string | null,
  propertyId?: string | null,
  note?: string | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateNoteInput = {
  id: string,
  parentId?: string | null,
  propertyId?: string | null,
  note?: string | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export type DeleteNoteInput = {
  id: string,
  _version?: number | null,
};

export type CreateOrganizationInput = {
  id?: string | null,
  legalName: string,
  type?: OrganizationType | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export enum OrganizationType {
  CONSULTANT = "CONSULTANT",
  PROPERTY_MANAGEMENT = "PROPERTY_MANAGEMENT",
  SOLE_SOURCE = "SOLE_SOURCE",
  VENDOR = "VENDOR",
}


export type ModelOrganizationConditionInput = {
  legalName?: ModelStringInput | null,
  type?: ModelOrganizationTypeInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  and?: Array< ModelOrganizationConditionInput | null > | null,
  or?: Array< ModelOrganizationConditionInput | null > | null,
  not?: ModelOrganizationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelOrganizationTypeInput = {
  eq?: OrganizationType | null,
  ne?: OrganizationType | null,
};

export type Organization = {
  __typename: "Organization",
  id: string,
  legalName: string,
  type?: OrganizationType | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateOrganizationInput = {
  id: string,
  legalName?: string | null,
  type?: OrganizationType | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export type DeleteOrganizationInput = {
  id: string,
  _version?: number | null,
};

export type CreateOrganizationBillingProfileInput = {
  organizationId: string,
  billingProfileId: string,
  billingProvider: BillingProvider,
  _version?: number | null,
};

export enum BillingProvider {
  STRIPE = "STRIPE",
}


export type ModelOrganizationBillingProfileConditionInput = {
  billingProfileId?: ModelStringInput | null,
  billingProvider?: ModelBillingProviderInput | null,
  and?: Array< ModelOrganizationBillingProfileConditionInput | null > | null,
  or?: Array< ModelOrganizationBillingProfileConditionInput | null > | null,
  not?: ModelOrganizationBillingProfileConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelBillingProviderInput = {
  eq?: BillingProvider | null,
  ne?: BillingProvider | null,
};

export type OrganizationBillingProfile = {
  __typename: "OrganizationBillingProfile",
  organizationId: string,
  billingProfileId: string,
  billingProvider: BillingProvider,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateOrganizationBillingProfileInput = {
  organizationId: string,
  billingProfileId?: string | null,
  billingProvider?: BillingProvider | null,
  _version?: number | null,
};

export type DeleteOrganizationBillingProfileInput = {
  organizationId: string,
  _version?: number | null,
};

export type CreateTeamInput = {
  id?: string | null,
  organizationId: string,
  type: TeamType,
  name?: string | null,
  _version?: number | null,
};

export enum TeamType {
  OWNER = "OWNER",
  MEMBER = "MEMBER",
}


export type ModelTeamConditionInput = {
  organizationId?: ModelIDInput | null,
  type?: ModelTeamTypeInput | null,
  name?: ModelStringInput | null,
  and?: Array< ModelTeamConditionInput | null > | null,
  or?: Array< ModelTeamConditionInput | null > | null,
  not?: ModelTeamConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelTeamTypeInput = {
  eq?: TeamType | null,
  ne?: TeamType | null,
};

export type Team = {
  __typename: "Team",
  id: string,
  organizationId: string,
  type: TeamType,
  name?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateTeamInput = {
  id: string,
  organizationId?: string | null,
  type?: TeamType | null,
  name?: string | null,
  _version?: number | null,
};

export type DeleteTeamInput = {
  id: string,
  _version?: number | null,
};

export type CreateTeamMemberInput = {
  id?: string | null,
  teamId: string,
  organizationId: string,
  userId: string,
  joinedAt?: string | null,
  _version?: number | null,
};

export type ModelTeamMemberConditionInput = {
  teamId?: ModelIDInput | null,
  organizationId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  joinedAt?: ModelStringInput | null,
  and?: Array< ModelTeamMemberConditionInput | null > | null,
  or?: Array< ModelTeamMemberConditionInput | null > | null,
  not?: ModelTeamMemberConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type TeamMember = {
  __typename: "TeamMember",
  id: string,
  teamId: string,
  organizationId: string,
  userId: string,
  joinedAt?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateTeamMemberInput = {
  id: string,
  teamId?: string | null,
  organizationId?: string | null,
  userId?: string | null,
  joinedAt?: string | null,
  _version?: number | null,
};

export type DeleteTeamMemberInput = {
  id: string,
  _version?: number | null,
};

export type CreateAccountInvitationInput = {
  id?: string | null,
  organizationId: string,
  role?: TeamType | null,
  email: string,
  expiresAt: number,
  status?: AccountInvitationStatus | null,
  _version?: number | null,
};

export enum AccountInvitationStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
}


export type ModelAccountInvitationConditionInput = {
  organizationId?: ModelIDInput | null,
  role?: ModelTeamTypeInput | null,
  email?: ModelStringInput | null,
  expiresAt?: ModelIntInput | null,
  status?: ModelAccountInvitationStatusInput | null,
  and?: Array< ModelAccountInvitationConditionInput | null > | null,
  or?: Array< ModelAccountInvitationConditionInput | null > | null,
  not?: ModelAccountInvitationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelAccountInvitationStatusInput = {
  eq?: AccountInvitationStatus | null,
  ne?: AccountInvitationStatus | null,
};

export type AccountInvitation = {
  __typename: "AccountInvitation",
  id: string,
  organizationId: string,
  role?: TeamType | null,
  email: string,
  expiresAt: number,
  status?: AccountInvitationStatus | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateAccountInvitationInput = {
  id: string,
  organizationId?: string | null,
  role?: TeamType | null,
  email?: string | null,
  expiresAt?: number | null,
  status?: AccountInvitationStatus | null,
  _version?: number | null,
};

export type DeleteAccountInvitationInput = {
  id: string,
  _version?: number | null,
};

export type CreateProjectInput = {
  id?: string | null,
  propertyId: string,
  name: string,
  tenderNumber?: string | null,
  customer?: string | null,
  address?: string | null,
  propertyType?: string | null,
  dueDate?: string | null,
  contactName?: string | null,
  contactNumber?: string | null,
  contactEmail?: string | null,
  _version?: number | null,
};

export type ModelProjectConditionInput = {
  propertyId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  tenderNumber?: ModelStringInput | null,
  customer?: ModelStringInput | null,
  address?: ModelStringInput | null,
  propertyType?: ModelStringInput | null,
  dueDate?: ModelStringInput | null,
  contactName?: ModelStringInput | null,
  contactNumber?: ModelStringInput | null,
  contactEmail?: ModelStringInput | null,
  and?: Array< ModelProjectConditionInput | null > | null,
  or?: Array< ModelProjectConditionInput | null > | null,
  not?: ModelProjectConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Project = {
  __typename: "Project",
  id: string,
  propertyId: string,
  name: string,
  tenderNumber?: string | null,
  customer?: string | null,
  address?: string | null,
  propertyType?: string | null,
  dueDate?: string | null,
  contactName?: string | null,
  contactNumber?: string | null,
  contactEmail?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateProjectInput = {
  id: string,
  propertyId?: string | null,
  name?: string | null,
  tenderNumber?: string | null,
  customer?: string | null,
  address?: string | null,
  propertyType?: string | null,
  dueDate?: string | null,
  contactName?: string | null,
  contactNumber?: string | null,
  contactEmail?: string | null,
  _version?: number | null,
};

export type DeleteProjectInput = {
  id: string,
  _version?: number | null,
};

export type CreateProjectCounterInput = {
  id?: string | null,
  propertyId: string,
  latestProjectNumber?: number | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export type ModelProjectCounterConditionInput = {
  propertyId?: ModelIDInput | null,
  latestProjectNumber?: ModelIntInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  and?: Array< ModelProjectCounterConditionInput | null > | null,
  or?: Array< ModelProjectCounterConditionInput | null > | null,
  not?: ModelProjectCounterConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ProjectCounter = {
  __typename: "ProjectCounter",
  id: string,
  propertyId: string,
  latestProjectNumber?: number | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateProjectCounterInput = {
  id: string,
  propertyId?: string | null,
  latestProjectNumber?: number | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export type DeleteProjectCounterInput = {
  id: string,
  _version?: number | null,
};

export type CreatePropertyInput = {
  id?: string | null,
  name?: string | null,
  description?: string | null,
  address?: string | null,
  ownerOrganizationId?: string | null,
  primaryContactNumber?: string | null,
  primaryContactEmail?: string | null,
  primaryContactName?: string | null,
  propertyNumber?: string | null,
  createdBy?: string | null,
  localLastUpdatedTime?: number | null,
  opaqueSyncReconciliationToken?: string | null,
  autoDashboardRebuild?: boolean | null,
  canView?: string | null,
  canEdit?: string | null,
  canCreateSolutions?: string | null,
  canDelete?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  isTestProperty?: boolean | null,
  isArchived?: boolean | null,
  _version?: number | null,
};

export type ModelPropertyConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  address?: ModelStringInput | null,
  ownerOrganizationId?: ModelStringInput | null,
  primaryContactNumber?: ModelStringInput | null,
  primaryContactEmail?: ModelStringInput | null,
  primaryContactName?: ModelStringInput | null,
  propertyNumber?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  localLastUpdatedTime?: ModelIntInput | null,
  opaqueSyncReconciliationToken?: ModelStringInput | null,
  autoDashboardRebuild?: ModelBooleanInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canCreateSolutions?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  canViewList?: ModelStringInput | null,
  canViewEntityVersionMap?: ModelStringInput | null,
  isTestProperty?: ModelBooleanInput | null,
  isArchived?: ModelBooleanInput | null,
  and?: Array< ModelPropertyConditionInput | null > | null,
  or?: Array< ModelPropertyConditionInput | null > | null,
  not?: ModelPropertyConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Property = {
  __typename: "Property",
  id: string,
  name?: string | null,
  description?: string | null,
  address?: string | null,
  ownerOrganizationId?: string | null,
  primaryContactNumber?: string | null,
  primaryContactEmail?: string | null,
  primaryContactName?: string | null,
  propertyNumber?: string | null,
  locations?: ModelLocationConnection | null,
  createdBy?: string | null,
  localLastUpdatedTime?: number | null,
  opaqueSyncReconciliationToken?: string | null,
  autoDashboardRebuild?: boolean | null,
  canView?: string | null,
  canEdit?: string | null,
  canCreateSolutions?: string | null,
  canDelete?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  isTestProperty?: boolean | null,
  isArchived?: boolean | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ModelLocationConnection = {
  __typename: "ModelLocationConnection",
  items:  Array<Location | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type UpdatePropertyInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  address?: string | null,
  ownerOrganizationId?: string | null,
  primaryContactNumber?: string | null,
  primaryContactEmail?: string | null,
  primaryContactName?: string | null,
  propertyNumber?: string | null,
  createdBy?: string | null,
  localLastUpdatedTime?: number | null,
  opaqueSyncReconciliationToken?: string | null,
  autoDashboardRebuild?: boolean | null,
  canView?: string | null,
  canEdit?: string | null,
  canCreateSolutions?: string | null,
  canDelete?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  isTestProperty?: boolean | null,
  isArchived?: boolean | null,
  _version?: number | null,
};

export type DeletePropertyInput = {
  id: string,
  _version?: number | null,
};

export type CreatePropertyCounterInput = {
  id?: string | null,
  _version?: number | null,
};

export type ModelPropertyCounterConditionInput = {
  and?: Array< ModelPropertyCounterConditionInput | null > | null,
  or?: Array< ModelPropertyCounterConditionInput | null > | null,
  not?: ModelPropertyCounterConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PropertyCounter = {
  __typename: "PropertyCounter",
  id: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdatePropertyCounterInput = {
  id: string,
  _version?: number | null,
};

export type DeletePropertyCounterInput = {
  id: string,
  _version?: number | null,
};

export type CreateProposalInput = {
  id?: string | null,
  schemaVersion?: number | null,
  designDocumentGroupId: string,
  designDocumentVersion: number,
  proposalKey: string,
  proposalNumber?: number | null,
  status?: ProposalStatus | null,
  author?: string | null,
  createdAt?: string | null,
  localLastUpdatedTime?: number | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdBy?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  quickQuoteId?: string | null,
  _version?: number | null,
};

export enum ProposalStatus {
  DRAFT = "DRAFT",
  SUBMITTED = "SUBMITTED",
}


export type ModelProposalConditionInput = {
  schemaVersion?: ModelIntInput | null,
  designDocumentGroupId?: ModelIDInput | null,
  designDocumentVersion?: ModelIntInput | null,
  proposalKey?: ModelStringInput | null,
  proposalNumber?: ModelIntInput | null,
  status?: ModelProposalStatusInput | null,
  author?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  localLastUpdatedTime?: ModelIntInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  canViewList?: ModelStringInput | null,
  canViewEntityVersionMap?: ModelStringInput | null,
  quickQuoteId?: ModelIDInput | null,
  and?: Array< ModelProposalConditionInput | null > | null,
  or?: Array< ModelProposalConditionInput | null > | null,
  not?: ModelProposalConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelProposalStatusInput = {
  eq?: ProposalStatus | null,
  ne?: ProposalStatus | null,
};

export type Proposal = {
  __typename: "Proposal",
  id: string,
  schemaVersion?: number | null,
  designDocumentGroupId: string,
  designDocumentVersion: number,
  proposalKey: string,
  proposalNumber?: number | null,
  status?: ProposalStatus | null,
  author?: string | null,
  createdAt?: string | null,
  localLastUpdatedTime?: number | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdBy?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  quickQuoteId?: string | null,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateProposalInput = {
  id: string,
  schemaVersion?: number | null,
  designDocumentGroupId?: string | null,
  designDocumentVersion?: number | null,
  proposalKey?: string | null,
  proposalNumber?: number | null,
  status?: ProposalStatus | null,
  author?: string | null,
  createdAt?: string | null,
  localLastUpdatedTime?: number | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdBy?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  quickQuoteId?: string | null,
  _version?: number | null,
};

export type DeleteProposalInput = {
  id: string,
  _version?: number | null,
};

export type CreateProposalCounterInput = {
  id?: string | null,
  solutionGroupId?: string | null,
  solutionVersion?: number | null,
  _version?: number | null,
};

export type ModelProposalCounterConditionInput = {
  solutionGroupId?: ModelIDInput | null,
  solutionVersion?: ModelIntInput | null,
  and?: Array< ModelProposalCounterConditionInput | null > | null,
  or?: Array< ModelProposalCounterConditionInput | null > | null,
  not?: ModelProposalCounterConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ProposalCounter = {
  __typename: "ProposalCounter",
  id: string,
  solutionGroupId?: string | null,
  solutionVersion?: number | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateProposalCounterInput = {
  id: string,
  solutionGroupId?: string | null,
  solutionVersion?: number | null,
  _version?: number | null,
};

export type DeleteProposalCounterInput = {
  id: string,
  _version?: number | null,
};

export type CreateResourceUserPermissionsInput = {
  id?: string | null,
  resourceId: string,
  userId?: string | null,
  userEmail?: string | null,
  userFullName?: string | null,
  resourceAndUserId?: string | null,
  permissions: string,
  resourceType?: ResourceType | null,
  _version?: number | null,
};

export type ModelResourceUserPermissionsConditionInput = {
  resourceId?: ModelIDInput | null,
  userId?: ModelStringInput | null,
  userEmail?: ModelStringInput | null,
  userFullName?: ModelStringInput | null,
  resourceAndUserId?: ModelStringInput | null,
  permissions?: ModelStringInput | null,
  resourceType?: ModelResourceTypeInput | null,
  and?: Array< ModelResourceUserPermissionsConditionInput | null > | null,
  or?: Array< ModelResourceUserPermissionsConditionInput | null > | null,
  not?: ModelResourceUserPermissionsConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ResourceUserPermissions = {
  __typename: "ResourceUserPermissions",
  id: string,
  resourceId: string,
  userId?: string | null,
  userEmail?: string | null,
  userFullName?: string | null,
  resourceAndUserId?: string | null,
  permissions: string,
  resourceType?: ResourceType | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateResourceUserPermissionsInput = {
  id: string,
  resourceId?: string | null,
  userId?: string | null,
  userEmail?: string | null,
  userFullName?: string | null,
  resourceAndUserId?: string | null,
  permissions?: string | null,
  resourceType?: ResourceType | null,
  _version?: number | null,
};

export type DeleteResourceUserPermissionsInput = {
  id: string,
  _version?: number | null,
};

export type CreateSolutionInput = {
  id?: string | null,
  propertyId?: string | null,
  projectId?: string | null,
  name?: string | null,
  status?: SolutionStatus | null,
  latestMinorVersion?: number | null,
  latestContentKey?: string | null,
  serialNumber?: number | null,
  metadata?: SolutionMetadataInput | null,
  localLastUpdatedTime?: number | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdBy?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  isArchived?: boolean | null,
  _version?: number | null,
};

export enum SolutionStatus {
  NEW_DOCUMENT = "NEW_DOCUMENT",
  DRAFT = "DRAFT",
  PENDING_REVIEW = "PENDING_REVIEW",
  APPROVED = "APPROVED",
  CANCELED = "CANCELED",
}


export type SolutionMetadataInput = {
  name?: string | null,
  propertyContactName?: string | null,
  propertyAddress?: string | null,
  propertyType?: string | null,
  solutionDueDate?: string | null,
  consultantName?: string | null,
  consultantPhoneNumber?: string | null,
  consultantEmail?: string | null,
  tenderingType?: SolutionTenderingType | null,
  warranty?: number | null,
};

export enum SolutionTenderingType {
  SOLE_SOURCE = "SOLE_SOURCE",
  TENDERED = "TENDERED",
}


export type ModelSolutionConditionInput = {
  propertyId?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  status?: ModelSolutionStatusInput | null,
  latestMinorVersion?: ModelIntInput | null,
  latestContentKey?: ModelStringInput | null,
  serialNumber?: ModelIntInput | null,
  localLastUpdatedTime?: ModelIntInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  canViewList?: ModelStringInput | null,
  canViewEntityVersionMap?: ModelStringInput | null,
  isArchived?: ModelBooleanInput | null,
  and?: Array< ModelSolutionConditionInput | null > | null,
  or?: Array< ModelSolutionConditionInput | null > | null,
  not?: ModelSolutionConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelSolutionStatusInput = {
  eq?: SolutionStatus | null,
  ne?: SolutionStatus | null,
};

export type Solution = {
  __typename: "Solution",
  id: string,
  propertyId?: string | null,
  projectId?: string | null,
  name?: string | null,
  status?: SolutionStatus | null,
  latestMinorVersion?: number | null,
  latestContentKey?: string | null,
  serialNumber?: number | null,
  metadata?: SolutionMetadata | null,
  localLastUpdatedTime?: number | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdBy?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  isArchived?: boolean | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type SolutionMetadata = {
  __typename: "SolutionMetadata",
  name?: string | null,
  propertyContactName?: string | null,
  propertyAddress?: string | null,
  propertyType?: string | null,
  solutionDueDate?: string | null,
  consultantName?: string | null,
  consultantPhoneNumber?: string | null,
  consultantEmail?: string | null,
  tenderingType?: SolutionTenderingType | null,
  warranty?: number | null,
};

export type UpdateSolutionInput = {
  id: string,
  propertyId?: string | null,
  projectId?: string | null,
  name?: string | null,
  status?: SolutionStatus | null,
  latestMinorVersion?: number | null,
  latestContentKey?: string | null,
  serialNumber?: number | null,
  metadata?: SolutionMetadataInput | null,
  localLastUpdatedTime?: number | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdBy?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  isArchived?: boolean | null,
  _version?: number | null,
};

export type DeleteSolutionInput = {
  id: string,
  _version?: number | null,
};

export type CreateSolutionMinorVersionInput = {
  id?: string | null,
  solutionId?: string | null,
  propertyId?: string | null,
  name?: string | null,
  contentKey?: string | null,
  minorVersion?: number | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export type ModelSolutionMinorVersionConditionInput = {
  solutionId?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  contentKey?: ModelStringInput | null,
  minorVersion?: ModelIntInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  and?: Array< ModelSolutionMinorVersionConditionInput | null > | null,
  or?: Array< ModelSolutionMinorVersionConditionInput | null > | null,
  not?: ModelSolutionMinorVersionConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type SolutionMinorVersion = {
  __typename: "SolutionMinorVersion",
  id: string,
  solutionId?: string | null,
  propertyId?: string | null,
  name?: string | null,
  contentKey?: string | null,
  minorVersion?: number | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateSolutionMinorVersionInput = {
  id: string,
  solutionId?: string | null,
  propertyId?: string | null,
  name?: string | null,
  contentKey?: string | null,
  minorVersion?: number | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export type DeleteSolutionMinorVersionInput = {
  id: string,
  _version?: number | null,
};

export type CreateSolutionGroupCounterInput = {
  id?: string | null,
  propertyId?: string | null,
  _version?: number | null,
};

export type ModelSolutionGroupCounterConditionInput = {
  propertyId?: ModelIDInput | null,
  and?: Array< ModelSolutionGroupCounterConditionInput | null > | null,
  or?: Array< ModelSolutionGroupCounterConditionInput | null > | null,
  not?: ModelSolutionGroupCounterConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type SolutionGroupCounter = {
  __typename: "SolutionGroupCounter",
  id: string,
  propertyId?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateSolutionGroupCounterInput = {
  id: string,
  propertyId?: string | null,
  _version?: number | null,
};

export type DeleteSolutionGroupCounterInput = {
  id: string,
  _version?: number | null,
};

export type CreateUserGroupInput = {
  id?: string | null,
  resourceId: string,
  groupType: string,
  _version?: number | null,
};

export type ModelUserGroupConditionInput = {
  resourceId?: ModelIDInput | null,
  groupType?: ModelStringInput | null,
  and?: Array< ModelUserGroupConditionInput | null > | null,
  or?: Array< ModelUserGroupConditionInput | null > | null,
  not?: ModelUserGroupConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UserGroup = {
  __typename: "UserGroup",
  id: string,
  resourceId: string,
  groupType: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateUserGroupInput = {
  id: string,
  resourceId?: string | null,
  groupType?: string | null,
  _version?: number | null,
};

export type DeleteUserGroupInput = {
  id: string,
  _version?: number | null,
};

export type CreateUserGroupMemberInput = {
  id?: string | null,
  resourceId: string,
  resourceAndUserId: string,
  userId: string,
  userGroupId: string,
  _version?: number | null,
};

export type ModelUserGroupMemberConditionInput = {
  resourceId?: ModelIDInput | null,
  resourceAndUserId?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  userGroupId?: ModelIDInput | null,
  and?: Array< ModelUserGroupMemberConditionInput | null > | null,
  or?: Array< ModelUserGroupMemberConditionInput | null > | null,
  not?: ModelUserGroupMemberConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UserGroupMember = {
  __typename: "UserGroupMember",
  id: string,
  resourceId: string,
  resourceAndUserId: string,
  userId: string,
  userGroupId: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateUserGroupMemberInput = {
  id: string,
  resourceId?: string | null,
  resourceAndUserId?: string | null,
  userId?: string | null,
  userGroupId?: string | null,
  _version?: number | null,
};

export type DeleteUserGroupMemberInput = {
  id: string,
  _version?: number | null,
};

export type CreateUserOrganizationAssociationInput = {
  id?: string | null,
  userId: string,
  organizationId: string,
  associationType: UserOrganizationAssociationType,
  permissions?: string | null,
  role?: UserOrganizationRole | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export enum UserOrganizationAssociationType {
  MEMBER_OF = "MEMBER_OF",
}


export enum UserOrganizationRole {
  ESTIMATOR = "ESTIMATOR",
  ENGINEER = "ENGINEER",
  PROPERTY_MANAGER = "PROPERTY_MANAGER",
  OWNER = "OWNER",
}


export type ModelUserOrganizationAssociationConditionInput = {
  userId?: ModelIDInput | null,
  organizationId?: ModelIDInput | null,
  associationType?: ModelUserOrganizationAssociationTypeInput | null,
  permissions?: ModelStringInput | null,
  role?: ModelUserOrganizationRoleInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  and?: Array< ModelUserOrganizationAssociationConditionInput | null > | null,
  or?: Array< ModelUserOrganizationAssociationConditionInput | null > | null,
  not?: ModelUserOrganizationAssociationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelUserOrganizationAssociationTypeInput = {
  eq?: UserOrganizationAssociationType | null,
  ne?: UserOrganizationAssociationType | null,
};

export type ModelUserOrganizationRoleInput = {
  eq?: UserOrganizationRole | null,
  ne?: UserOrganizationRole | null,
};

export type UserOrganizationAssociation = {
  __typename: "UserOrganizationAssociation",
  id: string,
  userId: string,
  organizationId: string,
  associationType: UserOrganizationAssociationType,
  permissions?: string | null,
  role?: UserOrganizationRole | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateUserOrganizationAssociationInput = {
  id: string,
  userId?: string | null,
  organizationId?: string | null,
  associationType?: UserOrganizationAssociationType | null,
  permissions?: string | null,
  role?: UserOrganizationRole | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export type DeleteUserOrganizationAssociationInput = {
  id: string,
  _version?: number | null,
};

export type CreateWorkSpecificationInput = {
  id?: string | null,
  dimensionId?: string | null,
  issueId?: string | null,
  propertyId?: string | null,
  createdInSolution?: boolean | null,
  body?: string | null,
  description?: string | null,
  workTypeId?: string | null,
  itemNumber?: number | null,
  measurement?: MeasurementInput | null,
  version?: number | null,
  localLastUpdatedTime?: number | null,
  opaqueSyncReconciliationToken?: string | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdBy?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  _version?: number | null,
};

export type ModelWorkSpecificationConditionInput = {
  dimensionId?: ModelIDInput | null,
  issueId?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  createdInSolution?: ModelBooleanInput | null,
  body?: ModelStringInput | null,
  description?: ModelStringInput | null,
  workTypeId?: ModelIDInput | null,
  itemNumber?: ModelIntInput | null,
  version?: ModelIntInput | null,
  localLastUpdatedTime?: ModelIntInput | null,
  opaqueSyncReconciliationToken?: ModelStringInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  canViewList?: ModelStringInput | null,
  canViewEntityVersionMap?: ModelStringInput | null,
  and?: Array< ModelWorkSpecificationConditionInput | null > | null,
  or?: Array< ModelWorkSpecificationConditionInput | null > | null,
  not?: ModelWorkSpecificationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type WorkSpecification = {
  __typename: "WorkSpecification",
  id: string,
  dimensionId?: string | null,
  issueId?: string | null,
  propertyId?: string | null,
  createdInSolution?: boolean | null,
  body?: string | null,
  description?: string | null,
  workTypeId?: string | null,
  itemNumber?: number | null,
  measurement?: Measurement | null,
  version?: number | null,
  localLastUpdatedTime?: number | null,
  opaqueSyncReconciliationToken?: string | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdBy?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateWorkSpecificationInput = {
  id: string,
  dimensionId?: string | null,
  issueId?: string | null,
  propertyId?: string | null,
  createdInSolution?: boolean | null,
  body?: string | null,
  description?: string | null,
  workTypeId?: string | null,
  itemNumber?: number | null,
  measurement?: MeasurementInput | null,
  version?: number | null,
  localLastUpdatedTime?: number | null,
  opaqueSyncReconciliationToken?: string | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdBy?: string | null,
  canViewList?: Array< string | null > | null,
  canViewEntityVersionMap?: string | null,
  _version?: number | null,
};

export type DeleteWorkSpecificationInput = {
  id: string,
  _version?: number | null,
};

export type CreateWorkTypeInput = {
  id?: string | null,
  name: string,
  shortDescription?: string | null,
  longDescription?: string | null,
  groupName?: string | null,
  unitPrice?: number | null,
  unitCost?: number | null,
  dimensionType?: DimensionType | null,
  measurementUnit?: MeasurementUnit | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export type ModelWorkTypeConditionInput = {
  name?: ModelStringInput | null,
  shortDescription?: ModelStringInput | null,
  longDescription?: ModelStringInput | null,
  groupName?: ModelStringInput | null,
  unitPrice?: ModelFloatInput | null,
  unitCost?: ModelFloatInput | null,
  dimensionType?: ModelDimensionTypeInput | null,
  measurementUnit?: ModelMeasurementUnitInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  and?: Array< ModelWorkTypeConditionInput | null > | null,
  or?: Array< ModelWorkTypeConditionInput | null > | null,
  not?: ModelWorkTypeConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type WorkType = {
  __typename: "WorkType",
  id: string,
  name: string,
  shortDescription?: string | null,
  longDescription?: string | null,
  groupName?: string | null,
  unitPrice?: number | null,
  unitCost?: number | null,
  dimensionType?: DimensionType | null,
  measurementUnit?: MeasurementUnit | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateWorkTypeInput = {
  id: string,
  name?: string | null,
  shortDescription?: string | null,
  longDescription?: string | null,
  groupName?: string | null,
  unitPrice?: number | null,
  unitCost?: number | null,
  dimensionType?: DimensionType | null,
  measurementUnit?: MeasurementUnit | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export type DeleteWorkTypeInput = {
  id: string,
  _version?: number | null,
};

export type CreateWorkTypeGroupInput = {
  id?: string | null,
  latestWorkTypeVersion: number,
  environmentAgnosticWorkTypeGroupId?: string | null,
  isDiscoverable?: boolean | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export type ModelWorkTypeGroupConditionInput = {
  latestWorkTypeVersion?: ModelIntInput | null,
  environmentAgnosticWorkTypeGroupId?: ModelIDInput | null,
  isDiscoverable?: ModelBooleanInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  and?: Array< ModelWorkTypeGroupConditionInput | null > | null,
  or?: Array< ModelWorkTypeGroupConditionInput | null > | null,
  not?: ModelWorkTypeGroupConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type WorkTypeGroup = {
  __typename: "WorkTypeGroup",
  id: string,
  latestWorkTypeVersion: number,
  environmentAgnosticWorkTypeGroupId?: string | null,
  isDiscoverable?: boolean | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateWorkTypeGroupInput = {
  id: string,
  latestWorkTypeVersion?: number | null,
  environmentAgnosticWorkTypeGroupId?: string | null,
  isDiscoverable?: boolean | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export type DeleteWorkTypeGroupInput = {
  id: string,
  _version?: number | null,
};

export type CreateWorkTypePricingInput = {
  id?: string | null,
  entityId: string,
  workTypeGroupId: string,
  body: string,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export type ModelWorkTypePricingConditionInput = {
  entityId?: ModelIDInput | null,
  workTypeGroupId?: ModelIDInput | null,
  body?: ModelStringInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  and?: Array< ModelWorkTypePricingConditionInput | null > | null,
  or?: Array< ModelWorkTypePricingConditionInput | null > | null,
  not?: ModelWorkTypePricingConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type WorkTypePricing = {
  __typename: "WorkTypePricing",
  id: string,
  entityId: string,
  workTypeGroupId: string,
  body: string,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateWorkTypePricingInput = {
  id: string,
  entityId?: string | null,
  workTypeGroupId?: string | null,
  body?: string | null,
  canView?: string | null,
  canEdit?: string | null,
  canDelete?: string | null,
  _version?: number | null,
};

export type DeleteWorkTypePricingInput = {
  id: string,
  _version?: number | null,
};

export type CreateDefaultWorkTypePricingInput = {
  id?: string | null,
  unitCost?: number | null,
  unitPrice?: number | null,
  _version?: number | null,
};

export type ModelDefaultWorkTypePricingConditionInput = {
  unitCost?: ModelFloatInput | null,
  unitPrice?: ModelFloatInput | null,
  and?: Array< ModelDefaultWorkTypePricingConditionInput | null > | null,
  or?: Array< ModelDefaultWorkTypePricingConditionInput | null > | null,
  not?: ModelDefaultWorkTypePricingConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type DefaultWorkTypePricing = {
  __typename: "DefaultWorkTypePricing",
  id: string,
  unitCost?: number | null,
  unitPrice?: number | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateDefaultWorkTypePricingInput = {
  id: string,
  unitCost?: number | null,
  unitPrice?: number | null,
  _version?: number | null,
};

export type DeleteDefaultWorkTypePricingInput = {
  id: string,
  _version?: number | null,
};

export type CreateTemporaryWorkTypeInput = {
  id?: string | null,
  workTypeGroupId: string,
  environmentAgnosticWorkTypeGroupId?: string | null,
  body: string,
  version: number,
  schemaVersion: number,
  _version?: number | null,
};

export type ModelTemporaryWorkTypeConditionInput = {
  workTypeGroupId?: ModelIDInput | null,
  environmentAgnosticWorkTypeGroupId?: ModelIDInput | null,
  body?: ModelStringInput | null,
  version?: ModelIntInput | null,
  schemaVersion?: ModelIntInput | null,
  and?: Array< ModelTemporaryWorkTypeConditionInput | null > | null,
  or?: Array< ModelTemporaryWorkTypeConditionInput | null > | null,
  not?: ModelTemporaryWorkTypeConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type TemporaryWorkType = {
  __typename: "TemporaryWorkType",
  id: string,
  workTypeGroupId: string,
  environmentAgnosticWorkTypeGroupId?: string | null,
  body: string,
  version: number,
  schemaVersion: number,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateTemporaryWorkTypeInput = {
  id: string,
  workTypeGroupId?: string | null,
  environmentAgnosticWorkTypeGroupId?: string | null,
  body?: string | null,
  version?: number | null,
  schemaVersion?: number | null,
  _version?: number | null,
};

export type DeleteTemporaryWorkTypeInput = {
  id: string,
  _version?: number | null,
};

export type CreateTenderInput = {
  id?: string | null,
  solutionId?: string | null,
  status?: TenderStatus | null,
  latestVersion?: number | null,
  awardedVersion?: number | null,
  projectNumber?: number | null,
  createdBy?: string | null,
  _version?: number | null,
};

export enum TenderStatus {
  PUBLISHED = "PUBLISHED",
  AWARDED = "AWARDED",
  COMPLETE = "COMPLETE",
  CANCELLED = "CANCELLED",
  CLOSED = "CLOSED",
}


export type ModelTenderConditionInput = {
  solutionId?: ModelStringInput | null,
  status?: ModelTenderStatusInput | null,
  latestVersion?: ModelIntInput | null,
  awardedVersion?: ModelIntInput | null,
  projectNumber?: ModelIntInput | null,
  createdBy?: ModelStringInput | null,
  and?: Array< ModelTenderConditionInput | null > | null,
  or?: Array< ModelTenderConditionInput | null > | null,
  not?: ModelTenderConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelTenderStatusInput = {
  eq?: TenderStatus | null,
  ne?: TenderStatus | null,
};

export type Tender = {
  __typename: "Tender",
  id: string,
  solutionId?: string | null,
  status?: TenderStatus | null,
  latestVersion?: number | null,
  awardedVersion?: number | null,
  projectNumber?: number | null,
  createdBy?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateTenderInput = {
  id: string,
  solutionId?: string | null,
  status?: TenderStatus | null,
  latestVersion?: number | null,
  awardedVersion?: number | null,
  projectNumber?: number | null,
  createdBy?: string | null,
  _version?: number | null,
};

export type DeleteTenderInput = {
  id: string,
  _version?: number | null,
};

export type CreateTenderMinorVersionInput = {
  id?: string | null,
  tenderId?: string | null,
  version?: number | null,
  solutionId?: string | null,
  solutionMinorVersion?: number | null,
  metadata?: TenderMetadataInput | null,
  contentKey?: string | null,
  _version?: number | null,
};

export type TenderMetadataInput = {
  name?: string | null,
  propertyContactName?: string | null,
  propertyAddress?: string | null,
  propertyType?: string | null,
  solutionDueDate?: string | null,
  consultantName?: string | null,
  consultantPhoneNumber?: string | null,
  consultantEmail?: string | null,
};

export type ModelTenderMinorVersionConditionInput = {
  tenderId?: ModelStringInput | null,
  version?: ModelIntInput | null,
  solutionId?: ModelStringInput | null,
  solutionMinorVersion?: ModelIntInput | null,
  contentKey?: ModelStringInput | null,
  and?: Array< ModelTenderMinorVersionConditionInput | null > | null,
  or?: Array< ModelTenderMinorVersionConditionInput | null > | null,
  not?: ModelTenderMinorVersionConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type TenderMinorVersion = {
  __typename: "TenderMinorVersion",
  id: string,
  tenderId?: string | null,
  version?: number | null,
  solutionId?: string | null,
  solutionMinorVersion?: number | null,
  metadata?: TenderMetadata | null,
  contentKey?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type TenderMetadata = {
  __typename: "TenderMetadata",
  name?: string | null,
  propertyContactName?: string | null,
  propertyAddress?: string | null,
  propertyType?: string | null,
  solutionDueDate?: string | null,
  consultantName?: string | null,
  consultantPhoneNumber?: string | null,
  consultantEmail?: string | null,
};

export type UpdateTenderMinorVersionInput = {
  id: string,
  tenderId?: string | null,
  version?: number | null,
  solutionId?: string | null,
  solutionMinorVersion?: number | null,
  metadata?: TenderMetadataInput | null,
  contentKey?: string | null,
  _version?: number | null,
};

export type DeleteTenderMinorVersionInput = {
  id: string,
  _version?: number | null,
};

export type CreateTagInput = {
  id?: string | null,
  name?: string | null,
  createdBy?: string | null,
  propertyId?: string | null,
  _version?: number | null,
};

export type ModelTagConditionInput = {
  name?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  propertyId?: ModelIDInput | null,
  and?: Array< ModelTagConditionInput | null > | null,
  or?: Array< ModelTagConditionInput | null > | null,
  not?: ModelTagConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Tag = {
  __typename: "Tag",
  id: string,
  name?: string | null,
  createdBy?: string | null,
  propertyId?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateTagInput = {
  id: string,
  name?: string | null,
  createdBy?: string | null,
  propertyId?: string | null,
  _version?: number | null,
};

export type DeleteTagInput = {
  id: string,
  _version?: number | null,
};

export type CreateUserOnboardingProgressInput = {
  id?: string | null,
  userId: string,
  hasUserBeenAssociatedWithOrganization: boolean,
  _version?: number | null,
};

export type ModelUserOnboardingProgressConditionInput = {
  userId?: ModelIDInput | null,
  hasUserBeenAssociatedWithOrganization?: ModelBooleanInput | null,
  and?: Array< ModelUserOnboardingProgressConditionInput | null > | null,
  or?: Array< ModelUserOnboardingProgressConditionInput | null > | null,
  not?: ModelUserOnboardingProgressConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UserOnboardingProgress = {
  __typename: "UserOnboardingProgress",
  id: string,
  userId: string,
  hasUserBeenAssociatedWithOrganization: boolean,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateUserOnboardingProgressInput = {
  id: string,
  userId?: string | null,
  hasUserBeenAssociatedWithOrganization?: boolean | null,
  _version?: number | null,
};

export type DeleteUserOnboardingProgressInput = {
  id: string,
  _version?: number | null,
};

export type CreateTemplateInput = {
  id?: string | null,
  type?: TemplateType | null,
  name?: string | null,
  s3Key?: string | null,
  ownerId?: string | null,
  ownerType?: TemplateEntityType | null,
  _version?: number | null,
};

export enum TemplateType {
  SOLUTION = "SOLUTION",
}


export enum TemplateEntityType {
  USER = "USER",
  TEAM = "TEAM",
}


export type ModelTemplateConditionInput = {
  type?: ModelTemplateTypeInput | null,
  name?: ModelStringInput | null,
  s3Key?: ModelStringInput | null,
  ownerId?: ModelStringInput | null,
  ownerType?: ModelTemplateEntityTypeInput | null,
  and?: Array< ModelTemplateConditionInput | null > | null,
  or?: Array< ModelTemplateConditionInput | null > | null,
  not?: ModelTemplateConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelTemplateTypeInput = {
  eq?: TemplateType | null,
  ne?: TemplateType | null,
};

export type ModelTemplateEntityTypeInput = {
  eq?: TemplateEntityType | null,
  ne?: TemplateEntityType | null,
};

export type Template = {
  __typename: "Template",
  id: string,
  type?: TemplateType | null,
  name?: string | null,
  s3Key?: string | null,
  ownerId?: string | null,
  ownerType?: TemplateEntityType | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateTemplateInput = {
  id: string,
  type?: TemplateType | null,
  name?: string | null,
  s3Key?: string | null,
  ownerId?: string | null,
  ownerType?: TemplateEntityType | null,
  _version?: number | null,
};

export type DeleteTemplateInput = {
  id: string,
  _version?: number | null,
};

export type CreateTemporaryAuthorizationCodeInput = {
  id?: string | null,
  code: string,
  userId: string,
  expiresAt: number,
  createdAt?: string | null,
  ttl: number,
  _version?: number | null,
};

export type ModelTemporaryAuthorizationCodeConditionInput = {
  code?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  expiresAt?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  ttl?: ModelIntInput | null,
  and?: Array< ModelTemporaryAuthorizationCodeConditionInput | null > | null,
  or?: Array< ModelTemporaryAuthorizationCodeConditionInput | null > | null,
  not?: ModelTemporaryAuthorizationCodeConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type TemporaryAuthorizationCode = {
  __typename: "TemporaryAuthorizationCode",
  id: string,
  code: string,
  userId: string,
  expiresAt: number,
  createdAt: string,
  ttl: number,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateTemporaryAuthorizationCodeInput = {
  id: string,
  code?: string | null,
  userId?: string | null,
  expiresAt?: number | null,
  createdAt?: string | null,
  ttl?: number | null,
  _version?: number | null,
};

export type DeleteTemporaryAuthorizationCodeInput = {
  id: string,
  _version?: number | null,
};

export type CreateLinkRegistryInput = {
  id?: string | null,
  propertyId?: string | null,
  action?: LinkAction | null,
  variables?: string | null,
  published?: boolean | null,
  createdBy?: string | null,
  _version?: number | null,
};

export enum LinkAction {
  ISSUE_FORM = "ISSUE_FORM",
  PROPERTY_FORM = "PROPERTY_FORM",
  ASSESSMENT_FORM = "ASSESSMENT_FORM",
  EXTERNAL_REPORT = "EXTERNAL_REPORT",
  CUSTOM_LINK = "CUSTOM_LINK",
  UNASSIGNED = "UNASSIGNED",
}


export type ModelLinkRegistryConditionInput = {
  propertyId?: ModelIDInput | null,
  action?: ModelLinkActionInput | null,
  variables?: ModelStringInput | null,
  published?: ModelBooleanInput | null,
  createdBy?: ModelIDInput | null,
  and?: Array< ModelLinkRegistryConditionInput | null > | null,
  or?: Array< ModelLinkRegistryConditionInput | null > | null,
  not?: ModelLinkRegistryConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLinkActionInput = {
  eq?: LinkAction | null,
  ne?: LinkAction | null,
};

export type LinkRegistry = {
  __typename: "LinkRegistry",
  id: string,
  propertyId?: string | null,
  action?: LinkAction | null,
  variables?: string | null,
  published?: boolean | null,
  createdBy?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateLinkRegistryInput = {
  id: string,
  propertyId?: string | null,
  action?: LinkAction | null,
  variables?: string | null,
  published?: boolean | null,
  createdBy?: string | null,
  _version?: number | null,
};

export type DeleteLinkRegistryInput = {
  id: string,
  _version?: number | null,
};

export type CreateExternalReportBrandingInput = {
  id?: string | null,
  name?: string | null,
  logoKey?: string | null,
  createdBy?: string | null,
  _version?: number | null,
};

export type ModelExternalReportBrandingConditionInput = {
  name?: ModelStringInput | null,
  logoKey?: ModelStringInput | null,
  createdBy?: ModelIDInput | null,
  and?: Array< ModelExternalReportBrandingConditionInput | null > | null,
  or?: Array< ModelExternalReportBrandingConditionInput | null > | null,
  not?: ModelExternalReportBrandingConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ExternalReportBranding = {
  __typename: "ExternalReportBranding",
  id: string,
  name?: string | null,
  logoKey?: string | null,
  createdBy?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateExternalReportBrandingInput = {
  id: string,
  name?: string | null,
  logoKey?: string | null,
  createdBy?: string | null,
  _version?: number | null,
};

export type DeleteExternalReportBrandingInput = {
  id: string,
  _version?: number | null,
};

export type CreateMeetingInput = {
  id?: string | null,
  status?: MeetingStatus | null,
  data: string,
  createdBy?: string | null,
  mediaPipelineId?: string | null,
  recordingKey?: string | null,
  recordingAttachmentId?: string | null,
  _version?: number | null,
};

export enum MeetingStatus {
  ACTIVE = "ACTIVE",
  ENDED = "ENDED",
}


export type ModelMeetingConditionInput = {
  status?: ModelMeetingStatusInput | null,
  data?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  mediaPipelineId?: ModelStringInput | null,
  recordingKey?: ModelStringInput | null,
  recordingAttachmentId?: ModelStringInput | null,
  and?: Array< ModelMeetingConditionInput | null > | null,
  or?: Array< ModelMeetingConditionInput | null > | null,
  not?: ModelMeetingConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelMeetingStatusInput = {
  eq?: MeetingStatus | null,
  ne?: MeetingStatus | null,
};

export type Meeting = {
  __typename: "Meeting",
  id: string,
  status?: MeetingStatus | null,
  data: string,
  createdBy?: string | null,
  mediaPipelineId?: string | null,
  recordingKey?: string | null,
  recordingAttachmentId?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateMeetingInput = {
  id: string,
  status?: MeetingStatus | null,
  data?: string | null,
  createdBy?: string | null,
  mediaPipelineId?: string | null,
  recordingKey?: string | null,
  recordingAttachmentId?: string | null,
  _version?: number | null,
};

export type DeleteMeetingInput = {
  id: string,
  _version?: number | null,
};

export type CreateAttendeeInput = {
  id?: string | null,
  meetingId: string,
  entityId?: string | null,
  name?: string | null,
  role?: AttendeeRole | null,
  _version?: number | null,
};

export type ModelAttendeeConditionInput = {
  meetingId?: ModelIDInput | null,
  entityId?: ModelStringInput | null,
  name?: ModelStringInput | null,
  role?: ModelAttendeeRoleInput | null,
  and?: Array< ModelAttendeeConditionInput | null > | null,
  or?: Array< ModelAttendeeConditionInput | null > | null,
  not?: ModelAttendeeConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelAttendeeRoleInput = {
  eq?: AttendeeRole | null,
  ne?: AttendeeRole | null,
};

export type Attendee = {
  __typename: "Attendee",
  id: string,
  meetingId: string,
  entityId?: string | null,
  name?: string | null,
  role?: AttendeeRole | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateAttendeeInput = {
  id: string,
  meetingId?: string | null,
  entityId?: string | null,
  name?: string | null,
  role?: AttendeeRole | null,
  _version?: number | null,
};

export type DeleteAttendeeInput = {
  id: string,
  _version?: number | null,
};

export type CreateCodeBuildJobInput = {
  id?: string | null,
  parentId?: string | null,
  projectName?: string | null,
  status?: BuildStatus | null,
  artifactPath?: string | null,
  buildStartTime?: number | null,
  buildEndTime?: number | null,
  requestedBy?: string | null,
  _version?: number | null,
};

export enum BuildStatus {
  IN_PROGRESS = "IN_PROGRESS",
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
  STOPPED = "STOPPED",
}


export type ModelCodeBuildJobConditionInput = {
  parentId?: ModelStringInput | null,
  projectName?: ModelStringInput | null,
  status?: ModelBuildStatusInput | null,
  artifactPath?: ModelStringInput | null,
  buildStartTime?: ModelIntInput | null,
  buildEndTime?: ModelIntInput | null,
  requestedBy?: ModelStringInput | null,
  and?: Array< ModelCodeBuildJobConditionInput | null > | null,
  or?: Array< ModelCodeBuildJobConditionInput | null > | null,
  not?: ModelCodeBuildJobConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelBuildStatusInput = {
  eq?: BuildStatus | null,
  ne?: BuildStatus | null,
};

export type CodeBuildJob = {
  __typename: "CodeBuildJob",
  id: string,
  parentId?: string | null,
  projectName?: string | null,
  status?: BuildStatus | null,
  artifactPath?: string | null,
  buildStartTime?: number | null,
  buildEndTime?: number | null,
  requestedBy?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateCodeBuildJobInput = {
  id: string,
  parentId?: string | null,
  projectName?: string | null,
  status?: BuildStatus | null,
  artifactPath?: string | null,
  buildStartTime?: number | null,
  buildEndTime?: number | null,
  requestedBy?: string | null,
  _version?: number | null,
};

export type DeleteCodeBuildJobInput = {
  id: string,
  _version?: number | null,
};

export type CreateResourceNotificationSettingInput = {
  resourceId: string,
  resourceType: NotificationResourceType,
  notificationType: NotificationType,
  recipients?: Array< NotificationRecipientInput > | null,
  enabled?: boolean | null,
  _version?: number | null,
};

export enum NotificationResourceType {
  PROPERTY = "PROPERTY",
  ASSESSMENT_SCHEDULE = "ASSESSMENT_SCHEDULE",
}


export enum NotificationType {
  MISSED_ASSESSMENT = "MISSED_ASSESSMENT",
  EXTERNAL_SUBMISSION = "EXTERNAL_SUBMISSION",
}


export type NotificationRecipientInput = {
  recipientId?: string | null,
  recipientIdType?: NotificationRecipientIdType | null,
  notificationChannels?: Array< NotificationChannel > | null,
  enabled?: boolean | null,
};

export enum NotificationRecipientIdType {
  CONTACT = "CONTACT",
  USER = "USER",
}


export enum NotificationChannel {
  EMAIL = "EMAIL",
  SMS = "SMS",
}


export type ModelResourceNotificationSettingConditionInput = {
  enabled?: ModelBooleanInput | null,
  and?: Array< ModelResourceNotificationSettingConditionInput | null > | null,
  or?: Array< ModelResourceNotificationSettingConditionInput | null > | null,
  not?: ModelResourceNotificationSettingConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ResourceNotificationSetting = {
  __typename: "ResourceNotificationSetting",
  resourceId: string,
  resourceType: NotificationResourceType,
  notificationType: NotificationType,
  recipients?:  Array<NotificationRecipient > | null,
  enabled?: boolean | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type NotificationRecipient = {
  __typename: "NotificationRecipient",
  recipientId?: string | null,
  recipientIdType?: NotificationRecipientIdType | null,
  notificationChannels?: Array< NotificationChannel > | null,
  enabled?: boolean | null,
};

export type UpdateResourceNotificationSettingInput = {
  resourceId: string,
  resourceType: NotificationResourceType,
  notificationType: NotificationType,
  recipients?: Array< NotificationRecipientInput > | null,
  enabled?: boolean | null,
  _version?: number | null,
};

export type DeleteResourceNotificationSettingInput = {
  resourceId: string,
  resourceType: NotificationResourceType,
  notificationType: NotificationType,
  _version?: number | null,
};

export type CreateAssessmentScheduleInput = {
  id?: string | null,
  propertyId?: string | null,
  name?: string | null,
  description?: string | null,
  startDate?: number | null,
  endDate?: number | null,
  recurrence?: RecurrenceInput | null,
  authorizedIdentifiers?: Array< string > | null,
  _version?: number | null,
};

export type RecurrenceInput = {
  type?: RecurrenceType | null,
  dailyRecurrence?: DailyRecurrenceInput | null,
  weeklyRecurrence?: WeeklyRecurrenceInput | null,
  monthlyRecurrence?: MonthlyRecurrenceInput | null,
};

export enum RecurrenceType {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
}


export type DailyRecurrenceInput = {
  interval?: number | null,
};

export type WeeklyRecurrenceInput = {
  interval?: number | null,
  daysOfWeek?: Array< DayOfWeek | null > | null,
};

export enum DayOfWeek {
  SUNDAY = "SUNDAY",
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
}


export type MonthlyRecurrenceInput = {
  type?: MonthlyScheduleType | null,
  interval?: number | null,
  dayOfMonth?: string | null,
  nthWeekDay?: NthWeekDayInput | null,
};

export enum MonthlyScheduleType {
  DAY_OF_MONTH = "DAY_OF_MONTH",
  NTH_WEEK_DAY = "NTH_WEEK_DAY",
}


export type NthWeekDayInput = {
  weekNumber?: string | null,
  day?: DayOfWeek | null,
};

export type ModelAssessmentScheduleConditionInput = {
  propertyId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  startDate?: ModelIntInput | null,
  endDate?: ModelIntInput | null,
  authorizedIdentifiers?: ModelStringInput | null,
  and?: Array< ModelAssessmentScheduleConditionInput | null > | null,
  or?: Array< ModelAssessmentScheduleConditionInput | null > | null,
  not?: ModelAssessmentScheduleConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type AssessmentSchedule = {
  __typename: "AssessmentSchedule",
  id: string,
  propertyId?: string | null,
  name?: string | null,
  description?: string | null,
  startDate?: number | null,
  endDate?: number | null,
  recurrence?: Recurrence | null,
  authorizedIdentifiers?: Array< string > | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type Recurrence = {
  __typename: "Recurrence",
  type?: RecurrenceType | null,
  dailyRecurrence?: DailyRecurrence | null,
  weeklyRecurrence?: WeeklyRecurrence | null,
  monthlyRecurrence?: MonthlyRecurrence | null,
};

export type DailyRecurrence = {
  __typename: "DailyRecurrence",
  interval?: number | null,
};

export type WeeklyRecurrence = {
  __typename: "WeeklyRecurrence",
  interval?: number | null,
  daysOfWeek?: Array< DayOfWeek | null > | null,
};

export type MonthlyRecurrence = {
  __typename: "MonthlyRecurrence",
  type?: MonthlyScheduleType | null,
  interval?: number | null,
  dayOfMonth?: string | null,
  nthWeekDay?: NthWeekDay | null,
};

export type NthWeekDay = {
  __typename: "NthWeekDay",
  weekNumber?: string | null,
  day?: DayOfWeek | null,
};

export type UpdateAssessmentScheduleInput = {
  id: string,
  propertyId?: string | null,
  name?: string | null,
  description?: string | null,
  startDate?: number | null,
  endDate?: number | null,
  recurrence?: RecurrenceInput | null,
  authorizedIdentifiers?: Array< string > | null,
  _version?: number | null,
};

export type DeleteAssessmentScheduleInput = {
  id: string,
  _version?: number | null,
};

export type CreateResourceAssessmentScheduleAssociationInput = {
  id?: string | null,
  assessmentScheduleId?: string | null,
  resourceId?: string | null,
  resourceType?: PermissionResourceType | null,
  _version?: number | null,
};

export type ModelResourceAssessmentScheduleAssociationConditionInput = {
  assessmentScheduleId?: ModelIDInput | null,
  resourceId?: ModelIDInput | null,
  resourceType?: ModelPermissionResourceTypeInput | null,
  and?: Array< ModelResourceAssessmentScheduleAssociationConditionInput | null > | null,
  or?: Array< ModelResourceAssessmentScheduleAssociationConditionInput | null > | null,
  not?: ModelResourceAssessmentScheduleAssociationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ResourceAssessmentScheduleAssociation = {
  __typename: "ResourceAssessmentScheduleAssociation",
  id: string,
  assessmentScheduleId?: string | null,
  resourceId?: string | null,
  resourceType?: PermissionResourceType | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateResourceAssessmentScheduleAssociationInput = {
  id: string,
  assessmentScheduleId?: string | null,
  resourceId?: string | null,
  resourceType?: PermissionResourceType | null,
  _version?: number | null,
};

export type DeleteResourceAssessmentScheduleAssociationInput = {
  id: string,
  _version?: number | null,
};

export type CreateAssessmentInput = {
  id?: string | null,
  scheduleId?: string | null,
  resourceId?: string | null,
  propertyId?: string | null,
  resourceType?: PermissionResourceType | null,
  createdBy?: string | null,
  submittedBy?: ExternalUserInfoInput | null,
  createdTime?: number | null,
  status?: AssessmentStatus | null,
  issueIds?: Array< string | null > | null,
  tagIds?: Array< string > | null,
  description?: string | null,
  _version?: number | null,
};

export type ExternalUserInfoInput = {
  firstName?: string | null,
  lastName?: string | null,
};

export enum AssessmentStatus {
  NO_ISSUES = "NO_ISSUES",
  ISSUES_FOUND = "ISSUES_FOUND",
}


export type ModelAssessmentConditionInput = {
  scheduleId?: ModelIDInput | null,
  resourceId?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  resourceType?: ModelPermissionResourceTypeInput | null,
  createdBy?: ModelStringInput | null,
  createdTime?: ModelIntInput | null,
  status?: ModelAssessmentStatusInput | null,
  issueIds?: ModelIDInput | null,
  tagIds?: ModelIDInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelAssessmentConditionInput | null > | null,
  or?: Array< ModelAssessmentConditionInput | null > | null,
  not?: ModelAssessmentConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelAssessmentStatusInput = {
  eq?: AssessmentStatus | null,
  ne?: AssessmentStatus | null,
};

export type Assessment = {
  __typename: "Assessment",
  id: string,
  scheduleId?: string | null,
  resourceId?: string | null,
  propertyId?: string | null,
  resourceType?: PermissionResourceType | null,
  createdBy?: string | null,
  submittedBy?: ExternalUserInfo | null,
  createdTime?: number | null,
  status?: AssessmentStatus | null,
  issueIds?: Array< string | null > | null,
  tagIds?: Array< string > | null,
  description?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ExternalUserInfo = {
  __typename: "ExternalUserInfo",
  firstName?: string | null,
  lastName?: string | null,
};

export type UpdateAssessmentInput = {
  id: string,
  scheduleId?: string | null,
  resourceId?: string | null,
  propertyId?: string | null,
  resourceType?: PermissionResourceType | null,
  createdBy?: string | null,
  submittedBy?: ExternalUserInfoInput | null,
  createdTime?: number | null,
  status?: AssessmentStatus | null,
  issueIds?: Array< string | null > | null,
  tagIds?: Array< string > | null,
  description?: string | null,
  _version?: number | null,
};

export type DeleteAssessmentInput = {
  id: string,
  _version?: number | null,
};

export type CreateContactInput = {
  id?: string | null,
  name?: string | null,
  email?: string | null,
  phoneNumber?: string | null,
  createdBy?: string | null,
  _version?: number | null,
};

export type ModelContactConditionInput = {
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  and?: Array< ModelContactConditionInput | null > | null,
  or?: Array< ModelContactConditionInput | null > | null,
  not?: ModelContactConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Contact = {
  __typename: "Contact",
  id: string,
  name?: string | null,
  email?: string | null,
  phoneNumber?: string | null,
  createdBy?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateContactInput = {
  id: string,
  name?: string | null,
  email?: string | null,
  phoneNumber?: string | null,
  createdBy?: string | null,
  _version?: number | null,
};

export type DeleteContactInput = {
  id: string,
  _version?: number | null,
};

export type CreateProperty3PIntegrationConfigurationInput = {
  id?: string | null,
  propertyId: string,
  workflowEndpoint: string,
  workflowName: string,
  clientId: string,
  clientSecret: string,
  tokenUrl: string,
  authorizeUrl: string,
  scope: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  _version?: number | null,
};

export type ModelProperty3PIntegrationConfigurationConditionInput = {
  propertyId?: ModelIDInput | null,
  workflowEndpoint?: ModelStringInput | null,
  workflowName?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  clientSecret?: ModelStringInput | null,
  tokenUrl?: ModelStringInput | null,
  authorizeUrl?: ModelStringInput | null,
  scope?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProperty3PIntegrationConfigurationConditionInput | null > | null,
  or?: Array< ModelProperty3PIntegrationConfigurationConditionInput | null > | null,
  not?: ModelProperty3PIntegrationConfigurationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type Property3PIntegrationConfiguration = {
  __typename: "Property3PIntegrationConfiguration",
  id: string,
  propertyId: string,
  workflowEndpoint: string,
  workflowName: string,
  clientId: string,
  clientSecret: string,
  tokenUrl: string,
  authorizeUrl: string,
  scope: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateProperty3PIntegrationConfigurationInput = {
  id: string,
  propertyId?: string | null,
  workflowEndpoint?: string | null,
  workflowName?: string | null,
  clientId?: string | null,
  clientSecret?: string | null,
  tokenUrl?: string | null,
  authorizeUrl?: string | null,
  scope?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  _version?: number | null,
};

export type DeleteProperty3PIntegrationConfigurationInput = {
  id: string,
  _version?: number | null,
};

export type CreateConversationStateInput = {
  id?: string | null,
  attachments?: Array< string | null > | null,
  conversationType: string,
  extractedDetails: string,
  conversationStatus: ConversationStatus,
  invokerId: string,
  nextStep?: ConversationNextStep | null,
  nextStepMessage?: string | null,
  userId?: string | null,
  externalConversationId?: string | null,
  phoneNumber?: string | null,
  _version?: number | null,
};

export enum ConversationStatus {
  IN_PROGRESS = "IN_PROGRESS",
  DONE = "DONE",
}


export enum ConversationNextStep {
  FOLLOW_UP = "FOLLOW_UP",
  EXIT = "EXIT",
  ESCALATE = "ESCALATE",
}


export type ModelConversationStateConditionInput = {
  attachments?: ModelStringInput | null,
  conversationType?: ModelStringInput | null,
  extractedDetails?: ModelStringInput | null,
  conversationStatus?: ModelConversationStatusInput | null,
  invokerId?: ModelStringInput | null,
  nextStep?: ModelConversationNextStepInput | null,
  nextStepMessage?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  externalConversationId?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  and?: Array< ModelConversationStateConditionInput | null > | null,
  or?: Array< ModelConversationStateConditionInput | null > | null,
  not?: ModelConversationStateConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelConversationStatusInput = {
  eq?: ConversationStatus | null,
  ne?: ConversationStatus | null,
};

export type ModelConversationNextStepInput = {
  eq?: ConversationNextStep | null,
  ne?: ConversationNextStep | null,
};

export type ConversationState = {
  __typename: "ConversationState",
  id: string,
  attachments?: Array< string | null > | null,
  conversationType: string,
  extractedDetails: string,
  conversationStatus: ConversationStatus,
  invokerId: string,
  nextStep?: ConversationNextStep | null,
  nextStepMessage?: string | null,
  userId?: string | null,
  externalConversationId?: string | null,
  phoneNumber?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateConversationStateInput = {
  id: string,
  attachments?: Array< string | null > | null,
  conversationType?: string | null,
  extractedDetails?: string | null,
  conversationStatus?: ConversationStatus | null,
  invokerId?: string | null,
  nextStep?: ConversationNextStep | null,
  nextStepMessage?: string | null,
  userId?: string | null,
  externalConversationId?: string | null,
  phoneNumber?: string | null,
  _version?: number | null,
};

export type DeleteConversationStateInput = {
  id: string,
  _version?: number | null,
};

export type CreatePolicyTemplateLinkInput = {
  id?: string | null,
  templateId: string,
  entityId: string,
  entityType: PermissionEntityType,
  resourceId: string,
  resourceType: PermissionResourceType,
  grantedBy?: string | null,
  grantedAt?: string | null,
  _version?: number | null,
};

export type ModelPolicyTemplateLinkConditionInput = {
  templateId?: ModelStringInput | null,
  entityId?: ModelStringInput | null,
  entityType?: ModelPermissionEntityTypeInput | null,
  resourceId?: ModelStringInput | null,
  resourceType?: ModelPermissionResourceTypeInput | null,
  grantedBy?: ModelStringInput | null,
  grantedAt?: ModelStringInput | null,
  and?: Array< ModelPolicyTemplateLinkConditionInput | null > | null,
  or?: Array< ModelPolicyTemplateLinkConditionInput | null > | null,
  not?: ModelPolicyTemplateLinkConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PolicyTemplateLink = {
  __typename: "PolicyTemplateLink",
  id: string,
  templateId: string,
  entityId: string,
  entityType: PermissionEntityType,
  resourceId: string,
  resourceType: PermissionResourceType,
  grantedBy?: string | null,
  grantedAt?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdatePolicyTemplateLinkInput = {
  id: string,
  templateId?: string | null,
  entityId?: string | null,
  entityType?: PermissionEntityType | null,
  resourceId?: string | null,
  resourceType?: PermissionResourceType | null,
  grantedBy?: string | null,
  grantedAt?: string | null,
  _version?: number | null,
};

export type DeletePolicyTemplateLinkInput = {
  id: string,
  _version?: number | null,
};

export type CreateGenerateIssuesFromImagesJobInput = {
  id?: string | null,
  extractedIssues: string,
  status: GenerateIssuesFromImagesJobStatus,
  invokerId: string,
  userId?: string | null,
  _version?: number | null,
};

export enum GenerateIssuesFromImagesJobStatus {
  IN_PROGRESS = "IN_PROGRESS",
  DONE = "DONE",
}


export type ModelGenerateIssuesFromImagesJobConditionInput = {
  extractedIssues?: ModelStringInput | null,
  status?: ModelGenerateIssuesFromImagesJobStatusInput | null,
  invokerId?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  and?: Array< ModelGenerateIssuesFromImagesJobConditionInput | null > | null,
  or?: Array< ModelGenerateIssuesFromImagesJobConditionInput | null > | null,
  not?: ModelGenerateIssuesFromImagesJobConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelGenerateIssuesFromImagesJobStatusInput = {
  eq?: GenerateIssuesFromImagesJobStatus | null,
  ne?: GenerateIssuesFromImagesJobStatus | null,
};

export type GenerateIssuesFromImagesJob = {
  __typename: "GenerateIssuesFromImagesJob",
  id: string,
  extractedIssues: string,
  status: GenerateIssuesFromImagesJobStatus,
  invokerId: string,
  userId?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateGenerateIssuesFromImagesJobInput = {
  id: string,
  extractedIssues?: string | null,
  status?: GenerateIssuesFromImagesJobStatus | null,
  invokerId?: string | null,
  userId?: string | null,
  _version?: number | null,
};

export type DeleteGenerateIssuesFromImagesJobInput = {
  id: string,
  _version?: number | null,
};

export type CreateStaticDashboardDataInput = {
  propertyId: string,
};

export type CreateBillingProfileSessionInput = {
  returnURL: string,
};

export type CreateBillingProfileSessionResponse = {
  __typename: "CreateBillingProfileSessionResponse",
  status: ResponseStatus,
  message?: string | null,
  url: string,
};

export enum ResponseStatus {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}


export type CreateBillingProfileInput = {
  organizationId: string,
  name: string,
  email: string,
};

export type CreateBillingProfileResponse = {
  __typename: "CreateBillingProfileResponse",
  status?: ResponseStatus | null,
  message?: string | null,
};

export type ReportMeteringUsageRequest = {
  userId: string,
  quantity?: number | null,
};

export type ReportMeteringUsageResponse = {
  __typename: "ReportMeteringUsageResponse",
  status?: ResponseStatus | null,
  message?: string | null,
};

export type UpdateSubscriptionTierInput = {
  tier: AccountTier,
};

export enum AccountTier {
  DEVELOPER = "DEVELOPER",
  STARTER = "STARTER",
  STANDARD = "STANDARD",
  PREMIUM = "PREMIUM",
  ENTERPRISE = "ENTERPRISE",
}


export type UpdatesubscriptionTierResponse = {
  __typename: "UpdatesubscriptionTierResponse",
  status?: ResponseStatus | null,
  message?: string | null,
};

export type ExternalReportSubmission = {
  id: string,
  type?: ExternalReportType | null,
  images?: Array< ExternalReportSubmissionImage | null > | null,
  propertyId?: string | null,
  locationId?: string | null,
  locationName?: string | null,
  submissionTime?: number | null,
  contactInfo?: ExternalReportSubmissionContactInfo | null,
  linkRegistrationCreatorId: string,
  issues?: Array< ExternalReportSubmissionIssue | null > | null,
  scheduleId?: string | null,
  description?: string | null,
};

export enum ExternalReportType {
  ISSUE = "ISSUE",
  ASSESSMENT = "ASSESSMENT",
}


export type ExternalReportSubmissionImage = {
  key?: string | null,
  imageSource?: ImageSource | null,
};

export type ExternalReportSubmissionContactInfo = {
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  phoneNumber?: string | null,
  emailOptIn?: boolean | null,
  phoneNumberOptIn?: boolean | null,
};

export type ExternalReportSubmissionIssue = {
  summary?: string | null,
  description?: string | null,
  images?: Array< ExternalReportSubmissionImage | null > | null,
  measurement?: ExternalReportSubmissionMeasurement | null,
  suggestedWorkTypeIds?: Array< string | null > | null,
};

export type ExternalReportSubmissionMeasurement = {
  length?: number | null,
  width?: number | null,
  depth?: number | null,
  dimensionType?: DimensionType | null,
  measurementUnit?: MeasurementUnit | null,
};

export type GenerateReportRequest = {
  resourceId: string,
  resourceType: GenerateReportResourceType,
  templateId: string,
  parameters?: string | null,
};

export enum GenerateReportResourceType {
  SOLE_SOURCE = "SOLE_SOURCE",
  BID = "BID",
  TENDER_SUMMARY = "TENDER_SUMMARY",
}


export type sendNotificationToUsersInput = {
  recipients: Array< string | null >,
  title?: string | null,
  body: string,
  channel?: NotificationChannel | null,
};

export type ShareMeetingLinkInput = {
  linkType: MeetingLinkType,
  meetingId: string,
  channel: NotificationChannel,
  recipients: Array< string | null >,
  propertyId?: string | null,
};

export enum MeetingLinkType {
  INSPECTOR = "INSPECTOR",
  AGENT = "AGENT",
}


export type SubmitQuickQuoteInput = {
  issueId: string,
  width?: number | null,
  length?: number | null,
  measurementUnit?: MeasurementUnit | null,
  dimensionType?: DimensionType | null,
};

export type SubmitQuickQuoteOutput = {
  __typename: "SubmitQuickQuoteOutput",
  status: string,
  solutionId?: string | null,
};

export type SubmitQuickQuoteExistingDataInput = {
  workSpecifications: Array< SubmitQuickQuoteWorkSpecificationInput | null >,
};

export type SubmitQuickQuoteWorkSpecificationInput = {
  workSpecificationId: string,
};

export type ConversationStateInput = {
  id?: string | null,
  conversationType: string,
  conversation: string,
  attachments?: Array< string | null > | null,
  invokerId?: string | null,
  userId: string,
  externalConversationId?: string | null,
  phoneNumber?: string | null,
};

export type ConversationStateOutput = {
  __typename: "ConversationStateOutput",
  id: string,
  attachments?: Array< string | null > | null,
  conversationType: string,
  extractedDetails: string,
  nextStep?: ConversationNextStep | null,
  nextStepMessage?: string | null,
  externalConversationId?: string | null,
  phoneNumber?: string | null,
};

export type ChangeRoleInput = {
  userId: string,
  organizationId: string,
  targetRole: TeamType,
};

export type RemoveMemberFromOrganizationInput = {
  organizationId: string,
  userId: string,
};

export type InviteUserToOrganizationInput = {
  organizationId: string,
  emails: Array< string >,
  targetRole: TeamType,
};

export type AcceptInvitationInput = {
  invitationId: string,
  email?: string | null,
  userId?: string | null,
};

export type UpdateSubscriptionQuantityInput = {
  organizationId: string,
};

export type GenerateIssuesFromImagesJobInput = {
  note?: string | null,
  images: Array< string >,
  address: string,
  authToken?: string | null,
  userId?: string | null,
};

export type ListResourceAggregateUserPermissionsOutput = {
  __typename: "ListResourceAggregateUserPermissionsOutput",
  items?:  Array<AggregateUserPermissions | null > | null,
  nextToken?: string | null,
};

export type AggregateUserPermissions = {
  __typename: "AggregateUserPermissions",
  userId?: string | null,
  username?: string | null,
  permissions?: Array< PermissionType | null > | null,
};

export type ModelAttachmentFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  type?: ModelAttachmentTypeInput | null,
  parentId?: ModelIDInput | null,
  parentType?: ModelPermissionResourceTypeInput | null,
  propertyId?: ModelIDInput | null,
  key?: ModelStringInput | null,
  localCreatedAtTime?: ModelIntInput | null,
  status?: ModelStringInput | null,
  imageSource?: ModelImageSourceInput | null,
  opaqueSyncReconciliationToken?: ModelStringInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  canViewList?: ModelStringInput | null,
  canViewEntityVersionMap?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAttachmentFilterInput | null > | null,
  or?: Array< ModelAttachmentFilterInput | null > | null,
  not?: ModelAttachmentFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelAttachmentConnection = {
  __typename: "ModelAttachmentConnection",
  items:  Array<Attachment | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelBiddingContactFilterInput = {
  id?: ModelIDInput | null,
  email?: ModelStringInput | null,
  ownerEntityId?: ModelStringInput | null,
  contactEntityId?: ModelStringInput | null,
  name?: ModelStringInput | null,
  privateDescription?: ModelStringInput | null,
  publicDescription?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelBiddingContactFilterInput | null > | null,
  or?: Array< ModelBiddingContactFilterInput | null > | null,
  not?: ModelBiddingContactFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelBiddingContactConnection = {
  __typename: "ModelBiddingContactConnection",
  items:  Array<BiddingContact | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelBidInvitationFilterInput = {
  id?: ModelIDInput | null,
  biddingContactId?: ModelStringInput | null,
  tenderId?: ModelStringInput | null,
  ownerEntityId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelBidInvitationFilterInput | null > | null,
  or?: Array< ModelBidInvitationFilterInput | null > | null,
  not?: ModelBidInvitationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelBidInvitationConnection = {
  __typename: "ModelBidInvitationConnection",
  items:  Array<BidInvitation | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelBidFilterInput = {
  id?: ModelIDInput | null,
  tenderId?: ModelStringInput | null,
  latestMinorVersion?: ModelIntInput | null,
  latestAcceptedMinorVersion?: ModelIntInput | null,
  latestSubmittedMinorVersion?: ModelIntInput | null,
  status?: ModelBidStatusInput | null,
  bidNumber?: ModelIntInput | null,
  createdBy?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelBidFilterInput | null > | null,
  or?: Array< ModelBidFilterInput | null > | null,
  not?: ModelBidFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelBidConnection = {
  __typename: "ModelBidConnection",
  items:  Array<Bid | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelBidMinorVersionFilterInput = {
  id?: ModelIDInput | null,
  bidId?: ModelStringInput | null,
  minorVersion?: ModelIntInput | null,
  tenderId?: ModelStringInput | null,
  tenderMinorVersion?: ModelIntInput | null,
  proposalId?: ModelStringInput | null,
  status?: ModelDocumentStatusInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelBidMinorVersionFilterInput | null > | null,
  or?: Array< ModelBidMinorVersionFilterInput | null > | null,
  not?: ModelBidMinorVersionFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelBidMinorVersionConnection = {
  __typename: "ModelBidMinorVersionConnection",
  items:  Array<BidMinorVersion | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelIntKeyConditionInput = {
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelClientLogFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelStringInput | null,
  userAgent?: ModelStringInput | null,
  severityLevel?: ModelLogSeverityLevelInput | null,
  componentName?: ModelStringInput | null,
  message?: ModelStringInput | null,
  details?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelClientLogFilterInput | null > | null,
  or?: Array< ModelClientLogFilterInput | null > | null,
  not?: ModelClientLogFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelClientLogConnection = {
  __typename: "ModelClientLogConnection",
  items:  Array<ClientLog | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelCounterFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelResourceTypeInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCounterFilterInput | null > | null,
  or?: Array< ModelCounterFilterInput | null > | null,
  not?: ModelCounterFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelCounterConnection = {
  __typename: "ModelCounterConnection",
  items:  Array<Counter | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelDesignDocumentFilterInput = {
  id?: ModelIDInput | null,
  designDocumentGroupId?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  status?: ModelDesignDocumentStatusInput | null,
  lastEvaluatedValidityStatus?: ModelBooleanInput | null,
  uploadStatus?: ModelStringInput | null,
  documentKey?: ModelStringInput | null,
  lastWorkScopeSpecificationItemNumber?: ModelIntInput | null,
  version?: ModelIntInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDesignDocumentFilterInput | null > | null,
  or?: Array< ModelDesignDocumentFilterInput | null > | null,
  not?: ModelDesignDocumentFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelDesignDocumentConnection = {
  __typename: "ModelDesignDocumentConnection",
  items:  Array<DesignDocument | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelDesignDocumentGroupFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  latestDocumentVersion?: ModelIntInput | null,
  documentContentKey?: ModelStringInput | null,
  solutionGroupNumber?: ModelIntInput | null,
  isLocked?: ModelBooleanInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDesignDocumentGroupFilterInput | null > | null,
  or?: Array< ModelDesignDocumentGroupFilterInput | null > | null,
  not?: ModelDesignDocumentGroupFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelDesignDocumentGroupConnection = {
  __typename: "ModelDesignDocumentGroupConnection",
  items:  Array<DesignDocumentGroup | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelDimensionFilterInput = {
  id?: ModelIDInput | null,
  parentId?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  createdInSolution?: ModelBooleanInput | null,
  description?: ModelStringInput | null,
  length?: ModelFloatInput | null,
  lengthUnit?: ModelStringInput | null,
  width?: ModelFloatInput | null,
  widthUnit?: ModelStringInput | null,
  dimensionType?: ModelDimensionTypeInput | null,
  measurementUnit?: ModelMeasurementUnitInput | null,
  localLastUpdatedTime?: ModelIntInput | null,
  opaqueSyncReconciliationToken?: ModelStringInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  canViewList?: ModelStringInput | null,
  canViewEntityVersionMap?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDimensionFilterInput | null > | null,
  or?: Array< ModelDimensionFilterInput | null > | null,
  not?: ModelDimensionFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelDimensionConnection = {
  __typename: "ModelDimensionConnection",
  items:  Array<Dimension | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelDiscoverableWorkTypesFilterInput = {
  id?: ModelIDInput | null,
  workTypeGroupId?: ModelIDInput | null,
  defaultVersion?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDiscoverableWorkTypesFilterInput | null > | null,
  or?: Array< ModelDiscoverableWorkTypesFilterInput | null > | null,
  not?: ModelDiscoverableWorkTypesFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelDiscoverableWorkTypesConnection = {
  __typename: "ModelDiscoverableWorkTypesConnection",
  items:  Array<DiscoverableWorkTypes | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelEntityResourcePermissionFilterInput = {
  id?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  entityId?: ModelIDInput | null,
  entityType?: ModelPermissionEntityTypeInput | null,
  resourceId?: ModelIDInput | null,
  resourceType?: ModelPermissionResourceTypeInput | null,
  permissionType?: ModelPermissionTypeInput | null,
  isGranted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEntityResourcePermissionFilterInput | null > | null,
  or?: Array< ModelEntityResourcePermissionFilterInput | null > | null,
  not?: ModelEntityResourcePermissionFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelEntityResourcePermissionConnection = {
  __typename: "ModelEntityResourcePermissionConnection",
  items:  Array<EntityResourcePermission | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelIDKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelEntityWorkTypeAssociationFilterInput = {
  id?: ModelIDInput | null,
  entityId?: ModelIDInput | null,
  entityType?: ModelWorkTypeAssociationScopeEntityInput | null,
  workTypeGroupId?: ModelIDInput | null,
  workTypeVersion?: ModelIntInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEntityWorkTypeAssociationFilterInput | null > | null,
  or?: Array< ModelEntityWorkTypeAssociationFilterInput | null > | null,
  not?: ModelEntityWorkTypeAssociationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelEntityWorkTypeAssociationConnection = {
  __typename: "ModelEntityWorkTypeAssociationConnection",
  items:  Array<EntityWorkTypeAssociation | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelInspectionFilterInput = {
  id?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  createdByOrganizationId?: ModelStringInput | null,
  createdByUserId?: ModelStringInput | null,
  startTime?: ModelIntInput | null,
  endTime?: ModelIntInput | null,
  status?: ModelInspectionStatusInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelInspectionFilterInput | null > | null,
  or?: Array< ModelInspectionFilterInput | null > | null,
  not?: ModelInspectionFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelInspectionConnection = {
  __typename: "ModelInspectionConnection",
  items:  Array<Inspection | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelIssueFilterInput = {
  id?: ModelIDInput | null,
  locationId?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  inspectionId?: ModelIDInput | null,
  createdInSolution?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  note?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  tagIds?: ModelIDInput | null,
  status?: ModelIssueStatusInput | null,
  clientCreationDate?: ModelIntInput | null,
  localLastUpdatedTime?: ModelIntInput | null,
  createdBy?: ModelStringInput | null,
  opaqueSyncReconciliationToken?: ModelStringInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  canViewList?: ModelStringInput | null,
  canViewEntityVersionMap?: ModelStringInput | null,
  isPubliclySubmitted?: ModelBooleanInput | null,
  suggestedWorkTypeIds?: ModelStringInput | null,
  quickQuoteIds?: ModelIDInput | null,
  priority?: ModelIssuePriorityInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelIssueFilterInput | null > | null,
  or?: Array< ModelIssueFilterInput | null > | null,
  not?: ModelIssueFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelIssueConnection = {
  __typename: "ModelIssueConnection",
  items:  Array<Issue | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelQuickQuoteFilterInput = {
  id?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  generatedProposalId?: ModelIDInput | null,
  status?: ModelQuickQuoteStatusInput | null,
  generatedSolutionId?: ModelIDInput | null,
  issueIds?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelQuickQuoteFilterInput | null > | null,
  or?: Array< ModelQuickQuoteFilterInput | null > | null,
  not?: ModelQuickQuoteFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelQuickQuoteConnection = {
  __typename: "ModelQuickQuoteConnection",
  items:  Array<QuickQuote | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelLocationFilterInput = {
  id?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  createdInSolution?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  localCreationTime?: ModelIntInput | null,
  localLastUpdatedTime?: ModelIntInput | null,
  opaqueSyncReconciliationToken?: ModelStringInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  canViewList?: ModelStringInput | null,
  canViewEntityVersionMap?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLocationFilterInput | null > | null,
  or?: Array< ModelLocationFilterInput | null > | null,
  not?: ModelLocationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelNoteFilterInput = {
  id?: ModelIDInput | null,
  parentId?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  note?: ModelStringInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelNoteFilterInput | null > | null,
  or?: Array< ModelNoteFilterInput | null > | null,
  not?: ModelNoteFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelNoteConnection = {
  __typename: "ModelNoteConnection",
  items:  Array<Note | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelOrganizationFilterInput = {
  id?: ModelIDInput | null,
  legalName?: ModelStringInput | null,
  type?: ModelOrganizationTypeInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelOrganizationFilterInput | null > | null,
  or?: Array< ModelOrganizationFilterInput | null > | null,
  not?: ModelOrganizationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelOrganizationConnection = {
  __typename: "ModelOrganizationConnection",
  items:  Array<Organization | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelOrganizationBillingProfileFilterInput = {
  organizationId?: ModelIDInput | null,
  billingProfileId?: ModelStringInput | null,
  billingProvider?: ModelBillingProviderInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelOrganizationBillingProfileFilterInput | null > | null,
  or?: Array< ModelOrganizationBillingProfileFilterInput | null > | null,
  not?: ModelOrganizationBillingProfileFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelOrganizationBillingProfileConnection = {
  __typename: "ModelOrganizationBillingProfileConnection",
  items:  Array<OrganizationBillingProfile | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelTeamFilterInput = {
  id?: ModelIDInput | null,
  organizationId?: ModelIDInput | null,
  type?: ModelTeamTypeInput | null,
  name?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTeamFilterInput | null > | null,
  or?: Array< ModelTeamFilterInput | null > | null,
  not?: ModelTeamFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTeamConnection = {
  __typename: "ModelTeamConnection",
  items:  Array<Team | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelTeamMemberFilterInput = {
  id?: ModelIDInput | null,
  teamId?: ModelIDInput | null,
  organizationId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  joinedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTeamMemberFilterInput | null > | null,
  or?: Array< ModelTeamMemberFilterInput | null > | null,
  not?: ModelTeamMemberFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTeamMemberConnection = {
  __typename: "ModelTeamMemberConnection",
  items:  Array<TeamMember | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAccountInvitationFilterInput = {
  id?: ModelIDInput | null,
  organizationId?: ModelIDInput | null,
  role?: ModelTeamTypeInput | null,
  email?: ModelStringInput | null,
  expiresAt?: ModelIntInput | null,
  status?: ModelAccountInvitationStatusInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAccountInvitationFilterInput | null > | null,
  or?: Array< ModelAccountInvitationFilterInput | null > | null,
  not?: ModelAccountInvitationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAccountInvitationConnection = {
  __typename: "ModelAccountInvitationConnection",
  items:  Array<AccountInvitation | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelProjectFilterInput = {
  id?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  tenderNumber?: ModelStringInput | null,
  customer?: ModelStringInput | null,
  address?: ModelStringInput | null,
  propertyType?: ModelStringInput | null,
  dueDate?: ModelStringInput | null,
  contactName?: ModelStringInput | null,
  contactNumber?: ModelStringInput | null,
  contactEmail?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProjectFilterInput | null > | null,
  or?: Array< ModelProjectFilterInput | null > | null,
  not?: ModelProjectFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelProjectConnection = {
  __typename: "ModelProjectConnection",
  items:  Array<Project | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelProjectCounterFilterInput = {
  id?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  latestProjectNumber?: ModelIntInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProjectCounterFilterInput | null > | null,
  or?: Array< ModelProjectCounterFilterInput | null > | null,
  not?: ModelProjectCounterFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelProjectCounterConnection = {
  __typename: "ModelProjectCounterConnection",
  items:  Array<ProjectCounter | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelPropertyFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  address?: ModelStringInput | null,
  ownerOrganizationId?: ModelStringInput | null,
  primaryContactNumber?: ModelStringInput | null,
  primaryContactEmail?: ModelStringInput | null,
  primaryContactName?: ModelStringInput | null,
  propertyNumber?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  localLastUpdatedTime?: ModelIntInput | null,
  opaqueSyncReconciliationToken?: ModelStringInput | null,
  autoDashboardRebuild?: ModelBooleanInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canCreateSolutions?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  canViewList?: ModelStringInput | null,
  canViewEntityVersionMap?: ModelStringInput | null,
  isTestProperty?: ModelBooleanInput | null,
  isArchived?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPropertyFilterInput | null > | null,
  or?: Array< ModelPropertyFilterInput | null > | null,
  not?: ModelPropertyFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelPropertyConnection = {
  __typename: "ModelPropertyConnection",
  items:  Array<Property | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelPropertyCounterFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPropertyCounterFilterInput | null > | null,
  or?: Array< ModelPropertyCounterFilterInput | null > | null,
  not?: ModelPropertyCounterFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelPropertyCounterConnection = {
  __typename: "ModelPropertyCounterConnection",
  items:  Array<PropertyCounter | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelProposalFilterInput = {
  id?: ModelIDInput | null,
  schemaVersion?: ModelIntInput | null,
  designDocumentGroupId?: ModelIDInput | null,
  designDocumentVersion?: ModelIntInput | null,
  proposalKey?: ModelStringInput | null,
  proposalNumber?: ModelIntInput | null,
  status?: ModelProposalStatusInput | null,
  author?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  localLastUpdatedTime?: ModelIntInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  canViewList?: ModelStringInput | null,
  canViewEntityVersionMap?: ModelStringInput | null,
  quickQuoteId?: ModelIDInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProposalFilterInput | null > | null,
  or?: Array< ModelProposalFilterInput | null > | null,
  not?: ModelProposalFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelProposalConnection = {
  __typename: "ModelProposalConnection",
  items:  Array<Proposal | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelProposalCounterFilterInput = {
  id?: ModelIDInput | null,
  solutionGroupId?: ModelIDInput | null,
  solutionVersion?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProposalCounterFilterInput | null > | null,
  or?: Array< ModelProposalCounterFilterInput | null > | null,
  not?: ModelProposalCounterFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelProposalCounterConnection = {
  __typename: "ModelProposalCounterConnection",
  items:  Array<ProposalCounter | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelResourceUserPermissionsFilterInput = {
  id?: ModelIDInput | null,
  resourceId?: ModelIDInput | null,
  userId?: ModelStringInput | null,
  userEmail?: ModelStringInput | null,
  userFullName?: ModelStringInput | null,
  resourceAndUserId?: ModelStringInput | null,
  permissions?: ModelStringInput | null,
  resourceType?: ModelResourceTypeInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelResourceUserPermissionsFilterInput | null > | null,
  or?: Array< ModelResourceUserPermissionsFilterInput | null > | null,
  not?: ModelResourceUserPermissionsFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelResourceUserPermissionsConnection = {
  __typename: "ModelResourceUserPermissionsConnection",
  items:  Array<ResourceUserPermissions | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelSolutionFilterInput = {
  id?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  status?: ModelSolutionStatusInput | null,
  latestMinorVersion?: ModelIntInput | null,
  latestContentKey?: ModelStringInput | null,
  serialNumber?: ModelIntInput | null,
  localLastUpdatedTime?: ModelIntInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  canViewList?: ModelStringInput | null,
  canViewEntityVersionMap?: ModelStringInput | null,
  isArchived?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSolutionFilterInput | null > | null,
  or?: Array< ModelSolutionFilterInput | null > | null,
  not?: ModelSolutionFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSolutionConnection = {
  __typename: "ModelSolutionConnection",
  items:  Array<Solution | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelSolutionMinorVersionFilterInput = {
  id?: ModelIDInput | null,
  solutionId?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  contentKey?: ModelStringInput | null,
  minorVersion?: ModelIntInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSolutionMinorVersionFilterInput | null > | null,
  or?: Array< ModelSolutionMinorVersionFilterInput | null > | null,
  not?: ModelSolutionMinorVersionFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSolutionMinorVersionConnection = {
  __typename: "ModelSolutionMinorVersionConnection",
  items:  Array<SolutionMinorVersion | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelSolutionGroupCounterFilterInput = {
  id?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSolutionGroupCounterFilterInput | null > | null,
  or?: Array< ModelSolutionGroupCounterFilterInput | null > | null,
  not?: ModelSolutionGroupCounterFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSolutionGroupCounterConnection = {
  __typename: "ModelSolutionGroupCounterConnection",
  items:  Array<SolutionGroupCounter | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelUserGroupFilterInput = {
  id?: ModelIDInput | null,
  resourceId?: ModelIDInput | null,
  groupType?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserGroupFilterInput | null > | null,
  or?: Array< ModelUserGroupFilterInput | null > | null,
  not?: ModelUserGroupFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUserGroupConnection = {
  __typename: "ModelUserGroupConnection",
  items:  Array<UserGroup | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelUserGroupMemberFilterInput = {
  id?: ModelIDInput | null,
  resourceId?: ModelIDInput | null,
  resourceAndUserId?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  userGroupId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserGroupMemberFilterInput | null > | null,
  or?: Array< ModelUserGroupMemberFilterInput | null > | null,
  not?: ModelUserGroupMemberFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUserGroupMemberConnection = {
  __typename: "ModelUserGroupMemberConnection",
  items:  Array<UserGroupMember | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelUserOrganizationAssociationFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  organizationId?: ModelIDInput | null,
  associationType?: ModelUserOrganizationAssociationTypeInput | null,
  permissions?: ModelStringInput | null,
  role?: ModelUserOrganizationRoleInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserOrganizationAssociationFilterInput | null > | null,
  or?: Array< ModelUserOrganizationAssociationFilterInput | null > | null,
  not?: ModelUserOrganizationAssociationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUserOrganizationAssociationConnection = {
  __typename: "ModelUserOrganizationAssociationConnection",
  items:  Array<UserOrganizationAssociation | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelWorkSpecificationFilterInput = {
  id?: ModelIDInput | null,
  dimensionId?: ModelIDInput | null,
  issueId?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  createdInSolution?: ModelBooleanInput | null,
  body?: ModelStringInput | null,
  description?: ModelStringInput | null,
  workTypeId?: ModelIDInput | null,
  itemNumber?: ModelIntInput | null,
  version?: ModelIntInput | null,
  localLastUpdatedTime?: ModelIntInput | null,
  opaqueSyncReconciliationToken?: ModelStringInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  canViewList?: ModelStringInput | null,
  canViewEntityVersionMap?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelWorkSpecificationFilterInput | null > | null,
  or?: Array< ModelWorkSpecificationFilterInput | null > | null,
  not?: ModelWorkSpecificationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelWorkSpecificationConnection = {
  __typename: "ModelWorkSpecificationConnection",
  items:  Array<WorkSpecification | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelWorkTypeFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  shortDescription?: ModelStringInput | null,
  longDescription?: ModelStringInput | null,
  groupName?: ModelStringInput | null,
  unitPrice?: ModelFloatInput | null,
  unitCost?: ModelFloatInput | null,
  dimensionType?: ModelDimensionTypeInput | null,
  measurementUnit?: ModelMeasurementUnitInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelWorkTypeFilterInput | null > | null,
  or?: Array< ModelWorkTypeFilterInput | null > | null,
  not?: ModelWorkTypeFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelWorkTypeConnection = {
  __typename: "ModelWorkTypeConnection",
  items:  Array<WorkType | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelWorkTypeGroupFilterInput = {
  id?: ModelIDInput | null,
  latestWorkTypeVersion?: ModelIntInput | null,
  environmentAgnosticWorkTypeGroupId?: ModelIDInput | null,
  isDiscoverable?: ModelBooleanInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelWorkTypeGroupFilterInput | null > | null,
  or?: Array< ModelWorkTypeGroupFilterInput | null > | null,
  not?: ModelWorkTypeGroupFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelWorkTypeGroupConnection = {
  __typename: "ModelWorkTypeGroupConnection",
  items:  Array<WorkTypeGroup | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelWorkTypePricingFilterInput = {
  id?: ModelIDInput | null,
  entityId?: ModelIDInput | null,
  workTypeGroupId?: ModelIDInput | null,
  body?: ModelStringInput | null,
  canView?: ModelStringInput | null,
  canEdit?: ModelStringInput | null,
  canDelete?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelWorkTypePricingFilterInput | null > | null,
  or?: Array< ModelWorkTypePricingFilterInput | null > | null,
  not?: ModelWorkTypePricingFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelWorkTypePricingConnection = {
  __typename: "ModelWorkTypePricingConnection",
  items:  Array<WorkTypePricing | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelDefaultWorkTypePricingFilterInput = {
  id?: ModelIDInput | null,
  unitCost?: ModelFloatInput | null,
  unitPrice?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDefaultWorkTypePricingFilterInput | null > | null,
  or?: Array< ModelDefaultWorkTypePricingFilterInput | null > | null,
  not?: ModelDefaultWorkTypePricingFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelDefaultWorkTypePricingConnection = {
  __typename: "ModelDefaultWorkTypePricingConnection",
  items:  Array<DefaultWorkTypePricing | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelTemporaryWorkTypeFilterInput = {
  id?: ModelIDInput | null,
  workTypeGroupId?: ModelIDInput | null,
  environmentAgnosticWorkTypeGroupId?: ModelIDInput | null,
  body?: ModelStringInput | null,
  version?: ModelIntInput | null,
  schemaVersion?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTemporaryWorkTypeFilterInput | null > | null,
  or?: Array< ModelTemporaryWorkTypeFilterInput | null > | null,
  not?: ModelTemporaryWorkTypeFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTemporaryWorkTypeConnection = {
  __typename: "ModelTemporaryWorkTypeConnection",
  items:  Array<TemporaryWorkType | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelTenderFilterInput = {
  id?: ModelIDInput | null,
  solutionId?: ModelStringInput | null,
  status?: ModelTenderStatusInput | null,
  latestVersion?: ModelIntInput | null,
  awardedVersion?: ModelIntInput | null,
  projectNumber?: ModelIntInput | null,
  createdBy?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTenderFilterInput | null > | null,
  or?: Array< ModelTenderFilterInput | null > | null,
  not?: ModelTenderFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTenderConnection = {
  __typename: "ModelTenderConnection",
  items:  Array<Tender | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelTenderMinorVersionFilterInput = {
  id?: ModelIDInput | null,
  tenderId?: ModelStringInput | null,
  version?: ModelIntInput | null,
  solutionId?: ModelStringInput | null,
  solutionMinorVersion?: ModelIntInput | null,
  contentKey?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTenderMinorVersionFilterInput | null > | null,
  or?: Array< ModelTenderMinorVersionFilterInput | null > | null,
  not?: ModelTenderMinorVersionFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTenderMinorVersionConnection = {
  __typename: "ModelTenderMinorVersionConnection",
  items:  Array<TenderMinorVersion | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelTagFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  propertyId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTagFilterInput | null > | null,
  or?: Array< ModelTagFilterInput | null > | null,
  not?: ModelTagFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTagConnection = {
  __typename: "ModelTagConnection",
  items:  Array<Tag | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelUserOnboardingProgressFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  hasUserBeenAssociatedWithOrganization?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserOnboardingProgressFilterInput | null > | null,
  or?: Array< ModelUserOnboardingProgressFilterInput | null > | null,
  not?: ModelUserOnboardingProgressFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUserOnboardingProgressConnection = {
  __typename: "ModelUserOnboardingProgressConnection",
  items:  Array<UserOnboardingProgress | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type User = {
  __typename: "User",
  id: string,
  name?: string | null,
  email?: string | null,
  phoneNumber?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelTemplateFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelTemplateTypeInput | null,
  name?: ModelStringInput | null,
  s3Key?: ModelStringInput | null,
  ownerId?: ModelStringInput | null,
  ownerType?: ModelTemplateEntityTypeInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTemplateFilterInput | null > | null,
  or?: Array< ModelTemplateFilterInput | null > | null,
  not?: ModelTemplateFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTemplateConnection = {
  __typename: "ModelTemplateConnection",
  items:  Array<Template | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelTemporaryAuthorizationCodeFilterInput = {
  id?: ModelIDInput | null,
  code?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  expiresAt?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  ttl?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTemporaryAuthorizationCodeFilterInput | null > | null,
  or?: Array< ModelTemporaryAuthorizationCodeFilterInput | null > | null,
  not?: ModelTemporaryAuthorizationCodeFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTemporaryAuthorizationCodeConnection = {
  __typename: "ModelTemporaryAuthorizationCodeConnection",
  items:  Array<TemporaryAuthorizationCode | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelLinkRegistryFilterInput = {
  id?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  action?: ModelLinkActionInput | null,
  variables?: ModelStringInput | null,
  published?: ModelBooleanInput | null,
  createdBy?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLinkRegistryFilterInput | null > | null,
  or?: Array< ModelLinkRegistryFilterInput | null > | null,
  not?: ModelLinkRegistryFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelLinkRegistryConnection = {
  __typename: "ModelLinkRegistryConnection",
  items:  Array<LinkRegistry | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelExternalReportBrandingFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  logoKey?: ModelStringInput | null,
  createdBy?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelExternalReportBrandingFilterInput | null > | null,
  or?: Array< ModelExternalReportBrandingFilterInput | null > | null,
  not?: ModelExternalReportBrandingFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelExternalReportBrandingConnection = {
  __typename: "ModelExternalReportBrandingConnection",
  items:  Array<ExternalReportBranding | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelMeetingFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelMeetingStatusInput | null,
  data?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  mediaPipelineId?: ModelStringInput | null,
  recordingKey?: ModelStringInput | null,
  recordingAttachmentId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMeetingFilterInput | null > | null,
  or?: Array< ModelMeetingFilterInput | null > | null,
  not?: ModelMeetingFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelMeetingConnection = {
  __typename: "ModelMeetingConnection",
  items:  Array<Meeting | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAttendeeFilterInput = {
  id?: ModelIDInput | null,
  meetingId?: ModelIDInput | null,
  entityId?: ModelStringInput | null,
  name?: ModelStringInput | null,
  role?: ModelAttendeeRoleInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAttendeeFilterInput | null > | null,
  or?: Array< ModelAttendeeFilterInput | null > | null,
  not?: ModelAttendeeFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAttendeeConnection = {
  __typename: "ModelAttendeeConnection",
  items:  Array<Attendee | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelCodeBuildJobFilterInput = {
  id?: ModelIDInput | null,
  parentId?: ModelStringInput | null,
  projectName?: ModelStringInput | null,
  status?: ModelBuildStatusInput | null,
  artifactPath?: ModelStringInput | null,
  buildStartTime?: ModelIntInput | null,
  buildEndTime?: ModelIntInput | null,
  requestedBy?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCodeBuildJobFilterInput | null > | null,
  or?: Array< ModelCodeBuildJobFilterInput | null > | null,
  not?: ModelCodeBuildJobFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelCodeBuildJobConnection = {
  __typename: "ModelCodeBuildJobConnection",
  items:  Array<CodeBuildJob | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelResourceNotificationSettingPrimaryCompositeKeyConditionInput = {
  eq?: ModelResourceNotificationSettingPrimaryCompositeKeyInput | null,
  le?: ModelResourceNotificationSettingPrimaryCompositeKeyInput | null,
  lt?: ModelResourceNotificationSettingPrimaryCompositeKeyInput | null,
  ge?: ModelResourceNotificationSettingPrimaryCompositeKeyInput | null,
  gt?: ModelResourceNotificationSettingPrimaryCompositeKeyInput | null,
  between?: Array< ModelResourceNotificationSettingPrimaryCompositeKeyInput | null > | null,
  beginsWith?: ModelResourceNotificationSettingPrimaryCompositeKeyInput | null,
};

export type ModelResourceNotificationSettingPrimaryCompositeKeyInput = {
  resourceType?: NotificationResourceType | null,
  notificationType?: NotificationType | null,
};

export type ModelResourceNotificationSettingFilterInput = {
  resourceId?: ModelIDInput | null,
  resourceType?: ModelNotificationResourceTypeInput | null,
  notificationType?: ModelNotificationTypeInput | null,
  enabled?: ModelBooleanInput | null,
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelResourceNotificationSettingFilterInput | null > | null,
  or?: Array< ModelResourceNotificationSettingFilterInput | null > | null,
  not?: ModelResourceNotificationSettingFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelNotificationResourceTypeInput = {
  eq?: NotificationResourceType | null,
  ne?: NotificationResourceType | null,
};

export type ModelNotificationTypeInput = {
  eq?: NotificationType | null,
  ne?: NotificationType | null,
};

export type ModelResourceNotificationSettingConnection = {
  __typename: "ModelResourceNotificationSettingConnection",
  items:  Array<ResourceNotificationSetting | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAssessmentScheduleFilterInput = {
  id?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  startDate?: ModelIntInput | null,
  endDate?: ModelIntInput | null,
  authorizedIdentifiers?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAssessmentScheduleFilterInput | null > | null,
  or?: Array< ModelAssessmentScheduleFilterInput | null > | null,
  not?: ModelAssessmentScheduleFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAssessmentScheduleConnection = {
  __typename: "ModelAssessmentScheduleConnection",
  items:  Array<AssessmentSchedule | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelResourceAssessmentScheduleAssociationFilterInput = {
  id?: ModelIDInput | null,
  assessmentScheduleId?: ModelIDInput | null,
  resourceId?: ModelIDInput | null,
  resourceType?: ModelPermissionResourceTypeInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelResourceAssessmentScheduleAssociationFilterInput | null > | null,
  or?: Array< ModelResourceAssessmentScheduleAssociationFilterInput | null > | null,
  not?: ModelResourceAssessmentScheduleAssociationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelResourceAssessmentScheduleAssociationConnection = {
  __typename: "ModelResourceAssessmentScheduleAssociationConnection",
  items:  Array<ResourceAssessmentScheduleAssociation | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAssessmentFilterInput = {
  id?: ModelIDInput | null,
  scheduleId?: ModelIDInput | null,
  resourceId?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  resourceType?: ModelPermissionResourceTypeInput | null,
  createdBy?: ModelStringInput | null,
  createdTime?: ModelIntInput | null,
  status?: ModelAssessmentStatusInput | null,
  issueIds?: ModelIDInput | null,
  tagIds?: ModelIDInput | null,
  description?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAssessmentFilterInput | null > | null,
  or?: Array< ModelAssessmentFilterInput | null > | null,
  not?: ModelAssessmentFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAssessmentConnection = {
  __typename: "ModelAssessmentConnection",
  items:  Array<Assessment | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelContactFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelContactFilterInput | null > | null,
  or?: Array< ModelContactFilterInput | null > | null,
  not?: ModelContactFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelContactConnection = {
  __typename: "ModelContactConnection",
  items:  Array<Contact | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelProperty3PIntegrationConfigurationFilterInput = {
  id?: ModelIDInput | null,
  propertyId?: ModelIDInput | null,
  workflowEndpoint?: ModelStringInput | null,
  workflowName?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  clientSecret?: ModelStringInput | null,
  tokenUrl?: ModelStringInput | null,
  authorizeUrl?: ModelStringInput | null,
  scope?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProperty3PIntegrationConfigurationFilterInput | null > | null,
  or?: Array< ModelProperty3PIntegrationConfigurationFilterInput | null > | null,
  not?: ModelProperty3PIntegrationConfigurationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelProperty3PIntegrationConfigurationConnection = {
  __typename: "ModelProperty3PIntegrationConfigurationConnection",
  items:  Array<Property3PIntegrationConfiguration | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelConversationStateFilterInput = {
  id?: ModelIDInput | null,
  attachments?: ModelStringInput | null,
  conversationType?: ModelStringInput | null,
  extractedDetails?: ModelStringInput | null,
  conversationStatus?: ModelConversationStatusInput | null,
  invokerId?: ModelStringInput | null,
  nextStep?: ModelConversationNextStepInput | null,
  nextStepMessage?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  externalConversationId?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelConversationStateFilterInput | null > | null,
  or?: Array< ModelConversationStateFilterInput | null > | null,
  not?: ModelConversationStateFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelConversationStateConnection = {
  __typename: "ModelConversationStateConnection",
  items:  Array<ConversationState | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelPolicyTemplateLinkFilterInput = {
  id?: ModelIDInput | null,
  templateId?: ModelStringInput | null,
  entityId?: ModelStringInput | null,
  entityType?: ModelPermissionEntityTypeInput | null,
  resourceId?: ModelStringInput | null,
  resourceType?: ModelPermissionResourceTypeInput | null,
  grantedBy?: ModelStringInput | null,
  grantedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPolicyTemplateLinkFilterInput | null > | null,
  or?: Array< ModelPolicyTemplateLinkFilterInput | null > | null,
  not?: ModelPolicyTemplateLinkFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelPolicyTemplateLinkConnection = {
  __typename: "ModelPolicyTemplateLinkConnection",
  items:  Array<PolicyTemplateLink | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelGenerateIssuesFromImagesJobFilterInput = {
  id?: ModelIDInput | null,
  extractedIssues?: ModelStringInput | null,
  status?: ModelGenerateIssuesFromImagesJobStatusInput | null,
  invokerId?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelGenerateIssuesFromImagesJobFilterInput | null > | null,
  or?: Array< ModelGenerateIssuesFromImagesJobFilterInput | null > | null,
  not?: ModelGenerateIssuesFromImagesJobFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelGenerateIssuesFromImagesJobConnection = {
  __typename: "ModelGenerateIssuesFromImagesJobConnection",
  items:  Array<GenerateIssuesFromImagesJob | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type GetPreSignedUploadURLRequest = {
  executionId: string,
};

export type GetPreSignedDownloadRequest = {
  executionId: string,
  key: string,
  location: S3DownloadLocation,
};

export enum S3DownloadLocation {
  LOGO = "LOGO",
}


export type GetAccountClaimStatusResponse = {
  __typename: "GetAccountClaimStatusResponse",
  status?: AccountClaimStatus | null,
};

export enum AccountClaimStatus {
  CLAIMED = "CLAIMED",
  UNCLAIMED = "UNCLAIMED",
}


export type HandleConverseCommandInput = {
  converseCommand: string,
};

export type SummarizeIssueInput = {
  images?: Array< string > | null,
  description?: string | null,
  attachmentLocation?: AttachmentLocation | null,
};

export enum AttachmentLocation {
  DEFAULT = "DEFAULT",
  EXTERNAL_SUBMISSION = "EXTERNAL_SUBMISSION",
}


export type SummarizeIssueOutput = {
  __typename: "SummarizeIssueOutput",
  description: string,
  workTypes?:  Array<WorkTypeDTO | null > | null,
};

export type WorkTypeDTO = {
  __typename: "WorkTypeDTO",
  id?: string | null,
  groupId?: string | null,
  version?: number | null,
  name?: string | null,
  categoryName?: string | null,
  shortDescription?: string | null,
  longDescription?: string | null,
  dimensionType?: DimensionType | null,
};

export type SearchUsersVariables = {
  filter?: SearchableUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SearchableUserFilterInput = {
  id?: SearchableStringFilterInput | null,
  name?: SearchableStringFilterInput | null,
  email?: SearchableStringFilterInput | null,
  phoneNumber?: SearchableStringFilterInput | null,
  and?: Array< SearchableUserFilterInput | null > | null,
  or?: Array< SearchableUserFilterInput | null > | null,
  not?: SearchableUserFilterInput | null,
};

export type SearchableStringFilterInput = {
  ne?: string | null,
  eq?: string | null,
  contains?: string | null,
};

export type SearchUsersOutput = {
  __typename: "SearchUsersOutput",
  items?:  Array<User | null > | null,
  nextToken?: string | null,
};

export type SearchOrganizationsVariables = {
  filter?: SearchableOrganizationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SearchableOrganizationFilterInput = {
  id?: SearchableStringFilterInput | null,
  legalName?: SearchableStringFilterInput | null,
  type?: SearchableStringFilterInput | null,
  and?: Array< SearchableOrganizationFilterInput | null > | null,
  or?: Array< SearchableOrganizationFilterInput | null > | null,
  not?: SearchableOrganizationFilterInput | null,
};

export type SearchOrganizationsOutput = {
  __typename: "SearchOrganizationsOutput",
  items?:  Array<Organization | null > | null,
  nextToken?: string | null,
};

export type SearchContactsVariables = {
  filter?: SearchableContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SearchableContactFilterInput = {
  name?: SearchableStringFilterInput | null,
  email?: SearchableStringFilterInput | null,
  phoneNumber?: SearchableStringFilterInput | null,
  createdBy?: SearchableStringFilterInput | null,
  and?: Array< SearchableContactFilterInput | null > | null,
  or?: Array< SearchableContactFilterInput | null > | null,
  not?: SearchableContactFilterInput | null,
};

export type SearchableContactFilterOutput = {
  __typename: "SearchableContactFilterOutput",
  items?:  Array<Contact | null > | null,
  nextToken?: string | null,
};

export type FormConfiguration = PlainFormConfiguration | AssessmentFormConfiguration | IssueSubmissionFormConfiguration


export type PlainFormConfiguration = {
  __typename: "PlainFormConfiguration",
  linkRegistry?: LinkRegistry | null,
};

export type IFormConfiguration = {
  __typename: "IFormConfiguration",
  linkRegistry?: LinkRegistry | null,
};

export type AssessmentFormConfiguration = {
  __typename: "AssessmentFormConfiguration",
  linkRegistry?: LinkRegistry | null,
  branding?: ExternalReportBranding | null,
  locationId?: string | null,
  locationName?: string | null,
  propertyId?: string | null,
  authorizedIdentifiers?: Array< string > | null,
};

export type IssueSubmissionFormConfiguration = {
  __typename: "IssueSubmissionFormConfiguration",
  linkRegistry?: LinkRegistry | null,
  branding?: ExternalReportBranding | null,
  locationId?: string | null,
  locationName?: string | null,
  propertyId?: string | null,
};

export type ListFormConfigurationsByPropertyOutput = {
  __typename: "ListFormConfigurationsByPropertyOutput",
  items?: Array< string | null > | null,
  nextToken?: string | null,
};

export type ListAssessmentSchedulesByAssessorsOutput = {
  __typename: "ListAssessmentSchedulesByAssessorsOutput",
  items?:  Array<AssessmentScheduleByAssessors | null > | null,
  nextToken?: string | null,
};

export type AssessmentScheduleByAssessors = {
  __typename: "AssessmentScheduleByAssessors",
  scheduleName?: string | null,
  locationNames?: Array< string | null > | null,
  scheduleDate?: number | null,
  assessors: Array< string >,
  status: AssessmentCompletionStatus,
  overdue: boolean,
};

export enum AssessmentCompletionStatus {
  COMPLETED = "COMPLETED",
  INCOMPLETE = "INCOMPLETE",
}


export type SubscriptionDetails = {
  __typename: "SubscriptionDetails",
  plan?: string | null,
  meteringLimit?: number | null,
  meteringUsage?: number | null,
  trialEnd?: number | null,
};

export type FilterImagesInput = {
  images?: Array< string > | null,
  attachmentLocation?: AttachmentLocation | null,
};

export type FilterImagesOutput = {
  __typename: "FilterImagesOutput",
  validImages?: Array< string > | null,
};

export type ClassifyIssuesInput = {
  note?: string | null,
  images?: Array< string > | null,
  attachmentLocation?: AttachmentLocation | null,
};

export type ClassifyIssuesOutput = {
  __typename: "ClassifyIssuesOutput",
  issues?:  Array<ClassifiedIssue > | null,
};

export type ClassifiedIssue = {
  __typename: "ClassifiedIssue",
  note: string,
  images?: Array< string > | null,
  attachmentLocation?: AttachmentLocation | null,
};

export type ModelSubscriptionAttachmentFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  parentId?: ModelSubscriptionIDInput | null,
  parentType?: ModelSubscriptionStringInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  key?: ModelSubscriptionStringInput | null,
  localCreatedAtTime?: ModelSubscriptionIntInput | null,
  status?: ModelSubscriptionStringInput | null,
  imageSource?: ModelSubscriptionStringInput | null,
  opaqueSyncReconciliationToken?: ModelSubscriptionStringInput | null,
  canView?: ModelSubscriptionStringInput | null,
  canEdit?: ModelSubscriptionStringInput | null,
  canDelete?: ModelSubscriptionStringInput | null,
  createdBy?: ModelSubscriptionStringInput | null,
  canViewList?: ModelSubscriptionStringInput | null,
  canViewEntityVersionMap?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAttachmentFilterInput | null > | null,
  or?: Array< ModelSubscriptionAttachmentFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionBiddingContactFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  email?: ModelSubscriptionStringInput | null,
  ownerEntityId?: ModelSubscriptionStringInput | null,
  contactEntityId?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  privateDescription?: ModelSubscriptionStringInput | null,
  publicDescription?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionBiddingContactFilterInput | null > | null,
  or?: Array< ModelSubscriptionBiddingContactFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionBidInvitationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  biddingContactId?: ModelSubscriptionStringInput | null,
  tenderId?: ModelSubscriptionStringInput | null,
  ownerEntityId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionBidInvitationFilterInput | null > | null,
  or?: Array< ModelSubscriptionBidInvitationFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionBidFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  tenderId?: ModelSubscriptionStringInput | null,
  latestMinorVersion?: ModelSubscriptionIntInput | null,
  latestAcceptedMinorVersion?: ModelSubscriptionIntInput | null,
  latestSubmittedMinorVersion?: ModelSubscriptionIntInput | null,
  status?: ModelSubscriptionStringInput | null,
  bidNumber?: ModelSubscriptionIntInput | null,
  createdBy?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionBidFilterInput | null > | null,
  or?: Array< ModelSubscriptionBidFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionBidMinorVersionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  bidId?: ModelSubscriptionStringInput | null,
  minorVersion?: ModelSubscriptionIntInput | null,
  tenderId?: ModelSubscriptionStringInput | null,
  tenderMinorVersion?: ModelSubscriptionIntInput | null,
  proposalId?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionBidMinorVersionFilterInput | null > | null,
  or?: Array< ModelSubscriptionBidMinorVersionFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionClientLogFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionStringInput | null,
  userAgent?: ModelSubscriptionStringInput | null,
  severityLevel?: ModelSubscriptionStringInput | null,
  componentName?: ModelSubscriptionStringInput | null,
  message?: ModelSubscriptionStringInput | null,
  details?: ModelSubscriptionStringInput | null,
  tags?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionClientLogFilterInput | null > | null,
  or?: Array< ModelSubscriptionClientLogFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionCounterFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCounterFilterInput | null > | null,
  or?: Array< ModelSubscriptionCounterFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionDesignDocumentFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  designDocumentGroupId?: ModelSubscriptionIDInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  projectId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  lastEvaluatedValidityStatus?: ModelSubscriptionBooleanInput | null,
  uploadStatus?: ModelSubscriptionStringInput | null,
  documentKey?: ModelSubscriptionStringInput | null,
  lastWorkScopeSpecificationItemNumber?: ModelSubscriptionIntInput | null,
  version?: ModelSubscriptionIntInput | null,
  canView?: ModelSubscriptionStringInput | null,
  canEdit?: ModelSubscriptionStringInput | null,
  canDelete?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDesignDocumentFilterInput | null > | null,
  or?: Array< ModelSubscriptionDesignDocumentFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionDesignDocumentGroupFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  projectId?: ModelSubscriptionIDInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  latestDocumentVersion?: ModelSubscriptionIntInput | null,
  documentContentKey?: ModelSubscriptionStringInput | null,
  solutionGroupNumber?: ModelSubscriptionIntInput | null,
  isLocked?: ModelSubscriptionBooleanInput | null,
  canView?: ModelSubscriptionStringInput | null,
  canEdit?: ModelSubscriptionStringInput | null,
  canDelete?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDesignDocumentGroupFilterInput | null > | null,
  or?: Array< ModelSubscriptionDesignDocumentGroupFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionDimensionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  parentId?: ModelSubscriptionIDInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  createdInSolution?: ModelSubscriptionBooleanInput | null,
  description?: ModelSubscriptionStringInput | null,
  length?: ModelSubscriptionFloatInput | null,
  lengthUnit?: ModelSubscriptionStringInput | null,
  width?: ModelSubscriptionFloatInput | null,
  widthUnit?: ModelSubscriptionStringInput | null,
  dimensionType?: ModelSubscriptionStringInput | null,
  measurementUnit?: ModelSubscriptionStringInput | null,
  localLastUpdatedTime?: ModelSubscriptionIntInput | null,
  opaqueSyncReconciliationToken?: ModelSubscriptionStringInput | null,
  canView?: ModelSubscriptionStringInput | null,
  canEdit?: ModelSubscriptionStringInput | null,
  canDelete?: ModelSubscriptionStringInput | null,
  createdBy?: ModelSubscriptionStringInput | null,
  canViewList?: ModelSubscriptionStringInput | null,
  canViewEntityVersionMap?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDimensionFilterInput | null > | null,
  or?: Array< ModelSubscriptionDimensionFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionDiscoverableWorkTypesFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  workTypeGroupId?: ModelSubscriptionIDInput | null,
  defaultVersion?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDiscoverableWorkTypesFilterInput | null > | null,
  or?: Array< ModelSubscriptionDiscoverableWorkTypesFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionEntityResourcePermissionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  entityId?: ModelSubscriptionIDInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  resourceId?: ModelSubscriptionIDInput | null,
  resourceType?: ModelSubscriptionStringInput | null,
  permissionType?: ModelSubscriptionStringInput | null,
  isGranted?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionEntityResourcePermissionFilterInput | null > | null,
  or?: Array< ModelSubscriptionEntityResourcePermissionFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionEntityWorkTypeAssociationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  entityId?: ModelSubscriptionIDInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  workTypeGroupId?: ModelSubscriptionIDInput | null,
  workTypeVersion?: ModelSubscriptionIntInput | null,
  canView?: ModelSubscriptionStringInput | null,
  canEdit?: ModelSubscriptionStringInput | null,
  canDelete?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionEntityWorkTypeAssociationFilterInput | null > | null,
  or?: Array< ModelSubscriptionEntityWorkTypeAssociationFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionInspectionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  createdByOrganizationId?: ModelSubscriptionStringInput | null,
  createdByUserId?: ModelSubscriptionStringInput | null,
  startTime?: ModelSubscriptionIntInput | null,
  endTime?: ModelSubscriptionIntInput | null,
  status?: ModelSubscriptionStringInput | null,
  canView?: ModelSubscriptionStringInput | null,
  canEdit?: ModelSubscriptionStringInput | null,
  canDelete?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionInspectionFilterInput | null > | null,
  or?: Array< ModelSubscriptionInspectionFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionIssueFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  locationId?: ModelSubscriptionIDInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  inspectionId?: ModelSubscriptionIDInput | null,
  createdInSolution?: ModelSubscriptionBooleanInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  note?: ModelSubscriptionStringInput | null,
  tags?: ModelSubscriptionStringInput | null,
  tagIds?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  clientCreationDate?: ModelSubscriptionIntInput | null,
  localLastUpdatedTime?: ModelSubscriptionIntInput | null,
  createdBy?: ModelSubscriptionStringInput | null,
  opaqueSyncReconciliationToken?: ModelSubscriptionStringInput | null,
  canView?: ModelSubscriptionStringInput | null,
  canEdit?: ModelSubscriptionStringInput | null,
  canDelete?: ModelSubscriptionStringInput | null,
  canViewList?: ModelSubscriptionStringInput | null,
  canViewEntityVersionMap?: ModelSubscriptionStringInput | null,
  isPubliclySubmitted?: ModelSubscriptionBooleanInput | null,
  suggestedWorkTypeIds?: ModelSubscriptionStringInput | null,
  quickQuoteIds?: ModelSubscriptionIDInput | null,
  priority?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionIssueFilterInput | null > | null,
  or?: Array< ModelSubscriptionIssueFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionQuickQuoteFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  generatedProposalId?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  generatedSolutionId?: ModelSubscriptionIDInput | null,
  issueIds?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionQuickQuoteFilterInput | null > | null,
  or?: Array< ModelSubscriptionQuickQuoteFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionLocationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  createdInSolution?: ModelSubscriptionBooleanInput | null,
  name?: ModelSubscriptionStringInput | null,
  tags?: ModelSubscriptionStringInput | null,
  localCreationTime?: ModelSubscriptionIntInput | null,
  localLastUpdatedTime?: ModelSubscriptionIntInput | null,
  opaqueSyncReconciliationToken?: ModelSubscriptionStringInput | null,
  canView?: ModelSubscriptionStringInput | null,
  canEdit?: ModelSubscriptionStringInput | null,
  canDelete?: ModelSubscriptionStringInput | null,
  createdBy?: ModelSubscriptionStringInput | null,
  canViewList?: ModelSubscriptionStringInput | null,
  canViewEntityVersionMap?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLocationFilterInput | null > | null,
  or?: Array< ModelSubscriptionLocationFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionNoteFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  parentId?: ModelSubscriptionIDInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  note?: ModelSubscriptionStringInput | null,
  canView?: ModelSubscriptionStringInput | null,
  canEdit?: ModelSubscriptionStringInput | null,
  canDelete?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionNoteFilterInput | null > | null,
  or?: Array< ModelSubscriptionNoteFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionOrganizationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  legalName?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  canView?: ModelSubscriptionStringInput | null,
  canEdit?: ModelSubscriptionStringInput | null,
  canDelete?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionOrganizationFilterInput | null > | null,
  or?: Array< ModelSubscriptionOrganizationFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionOrganizationBillingProfileFilterInput = {
  organizationId?: ModelSubscriptionIDInput | null,
  billingProfileId?: ModelSubscriptionStringInput | null,
  billingProvider?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionOrganizationBillingProfileFilterInput | null > | null,
  or?: Array< ModelSubscriptionOrganizationBillingProfileFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionTeamFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  organizationId?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTeamFilterInput | null > | null,
  or?: Array< ModelSubscriptionTeamFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionTeamMemberFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  teamId?: ModelSubscriptionIDInput | null,
  organizationId?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  joinedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTeamMemberFilterInput | null > | null,
  or?: Array< ModelSubscriptionTeamMemberFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionAccountInvitationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  organizationId?: ModelSubscriptionIDInput | null,
  role?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  expiresAt?: ModelSubscriptionIntInput | null,
  status?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAccountInvitationFilterInput | null > | null,
  or?: Array< ModelSubscriptionAccountInvitationFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionProjectFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  tenderNumber?: ModelSubscriptionStringInput | null,
  customer?: ModelSubscriptionStringInput | null,
  address?: ModelSubscriptionStringInput | null,
  propertyType?: ModelSubscriptionStringInput | null,
  dueDate?: ModelSubscriptionStringInput | null,
  contactName?: ModelSubscriptionStringInput | null,
  contactNumber?: ModelSubscriptionStringInput | null,
  contactEmail?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProjectFilterInput | null > | null,
  or?: Array< ModelSubscriptionProjectFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionProjectCounterFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  latestProjectNumber?: ModelSubscriptionIntInput | null,
  canView?: ModelSubscriptionStringInput | null,
  canEdit?: ModelSubscriptionStringInput | null,
  canDelete?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProjectCounterFilterInput | null > | null,
  or?: Array< ModelSubscriptionProjectCounterFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionPropertyFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  address?: ModelSubscriptionStringInput | null,
  ownerOrganizationId?: ModelSubscriptionStringInput | null,
  primaryContactNumber?: ModelSubscriptionStringInput | null,
  primaryContactEmail?: ModelSubscriptionStringInput | null,
  primaryContactName?: ModelSubscriptionStringInput | null,
  propertyNumber?: ModelSubscriptionStringInput | null,
  createdBy?: ModelSubscriptionStringInput | null,
  localLastUpdatedTime?: ModelSubscriptionIntInput | null,
  opaqueSyncReconciliationToken?: ModelSubscriptionStringInput | null,
  autoDashboardRebuild?: ModelSubscriptionBooleanInput | null,
  canView?: ModelSubscriptionStringInput | null,
  canEdit?: ModelSubscriptionStringInput | null,
  canCreateSolutions?: ModelSubscriptionStringInput | null,
  canDelete?: ModelSubscriptionStringInput | null,
  canViewList?: ModelSubscriptionStringInput | null,
  canViewEntityVersionMap?: ModelSubscriptionStringInput | null,
  isTestProperty?: ModelSubscriptionBooleanInput | null,
  isArchived?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPropertyFilterInput | null > | null,
  or?: Array< ModelSubscriptionPropertyFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionPropertyCounterFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPropertyCounterFilterInput | null > | null,
  or?: Array< ModelSubscriptionPropertyCounterFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionProposalFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  schemaVersion?: ModelSubscriptionIntInput | null,
  designDocumentGroupId?: ModelSubscriptionIDInput | null,
  designDocumentVersion?: ModelSubscriptionIntInput | null,
  proposalKey?: ModelSubscriptionStringInput | null,
  proposalNumber?: ModelSubscriptionIntInput | null,
  status?: ModelSubscriptionStringInput | null,
  author?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  localLastUpdatedTime?: ModelSubscriptionIntInput | null,
  canView?: ModelSubscriptionStringInput | null,
  canEdit?: ModelSubscriptionStringInput | null,
  canDelete?: ModelSubscriptionStringInput | null,
  createdBy?: ModelSubscriptionStringInput | null,
  canViewList?: ModelSubscriptionStringInput | null,
  canViewEntityVersionMap?: ModelSubscriptionStringInput | null,
  quickQuoteId?: ModelSubscriptionIDInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProposalFilterInput | null > | null,
  or?: Array< ModelSubscriptionProposalFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionProposalCounterFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  solutionGroupId?: ModelSubscriptionIDInput | null,
  solutionVersion?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProposalCounterFilterInput | null > | null,
  or?: Array< ModelSubscriptionProposalCounterFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionResourceUserPermissionsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  resourceId?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionStringInput | null,
  userEmail?: ModelSubscriptionStringInput | null,
  userFullName?: ModelSubscriptionStringInput | null,
  resourceAndUserId?: ModelSubscriptionStringInput | null,
  permissions?: ModelSubscriptionStringInput | null,
  resourceType?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionResourceUserPermissionsFilterInput | null > | null,
  or?: Array< ModelSubscriptionResourceUserPermissionsFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionSolutionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  projectId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  latestMinorVersion?: ModelSubscriptionIntInput | null,
  latestContentKey?: ModelSubscriptionStringInput | null,
  serialNumber?: ModelSubscriptionIntInput | null,
  localLastUpdatedTime?: ModelSubscriptionIntInput | null,
  canView?: ModelSubscriptionStringInput | null,
  canEdit?: ModelSubscriptionStringInput | null,
  canDelete?: ModelSubscriptionStringInput | null,
  createdBy?: ModelSubscriptionStringInput | null,
  canViewList?: ModelSubscriptionStringInput | null,
  canViewEntityVersionMap?: ModelSubscriptionStringInput | null,
  isArchived?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSolutionFilterInput | null > | null,
  or?: Array< ModelSubscriptionSolutionFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionSolutionMinorVersionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  solutionId?: ModelSubscriptionIDInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  contentKey?: ModelSubscriptionStringInput | null,
  minorVersion?: ModelSubscriptionIntInput | null,
  canView?: ModelSubscriptionStringInput | null,
  canEdit?: ModelSubscriptionStringInput | null,
  canDelete?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSolutionMinorVersionFilterInput | null > | null,
  or?: Array< ModelSubscriptionSolutionMinorVersionFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionSolutionGroupCounterFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSolutionGroupCounterFilterInput | null > | null,
  or?: Array< ModelSubscriptionSolutionGroupCounterFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionUserGroupFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  resourceId?: ModelSubscriptionIDInput | null,
  groupType?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserGroupFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserGroupFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionUserGroupMemberFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  resourceId?: ModelSubscriptionIDInput | null,
  resourceAndUserId?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
  userGroupId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserGroupMemberFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserGroupMemberFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionUserOrganizationAssociationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  organizationId?: ModelSubscriptionIDInput | null,
  associationType?: ModelSubscriptionStringInput | null,
  permissions?: ModelSubscriptionStringInput | null,
  role?: ModelSubscriptionStringInput | null,
  canView?: ModelSubscriptionStringInput | null,
  canEdit?: ModelSubscriptionStringInput | null,
  canDelete?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserOrganizationAssociationFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserOrganizationAssociationFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionWorkSpecificationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  dimensionId?: ModelSubscriptionIDInput | null,
  issueId?: ModelSubscriptionIDInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  createdInSolution?: ModelSubscriptionBooleanInput | null,
  body?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  workTypeId?: ModelSubscriptionIDInput | null,
  itemNumber?: ModelSubscriptionIntInput | null,
  version?: ModelSubscriptionIntInput | null,
  localLastUpdatedTime?: ModelSubscriptionIntInput | null,
  opaqueSyncReconciliationToken?: ModelSubscriptionStringInput | null,
  canView?: ModelSubscriptionStringInput | null,
  canEdit?: ModelSubscriptionStringInput | null,
  canDelete?: ModelSubscriptionStringInput | null,
  createdBy?: ModelSubscriptionStringInput | null,
  canViewList?: ModelSubscriptionStringInput | null,
  canViewEntityVersionMap?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionWorkSpecificationFilterInput | null > | null,
  or?: Array< ModelSubscriptionWorkSpecificationFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionWorkTypeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  shortDescription?: ModelSubscriptionStringInput | null,
  longDescription?: ModelSubscriptionStringInput | null,
  groupName?: ModelSubscriptionStringInput | null,
  unitPrice?: ModelSubscriptionFloatInput | null,
  unitCost?: ModelSubscriptionFloatInput | null,
  dimensionType?: ModelSubscriptionStringInput | null,
  measurementUnit?: ModelSubscriptionStringInput | null,
  canView?: ModelSubscriptionStringInput | null,
  canEdit?: ModelSubscriptionStringInput | null,
  canDelete?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionWorkTypeFilterInput | null > | null,
  or?: Array< ModelSubscriptionWorkTypeFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionWorkTypeGroupFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  latestWorkTypeVersion?: ModelSubscriptionIntInput | null,
  environmentAgnosticWorkTypeGroupId?: ModelSubscriptionIDInput | null,
  isDiscoverable?: ModelSubscriptionBooleanInput | null,
  canView?: ModelSubscriptionStringInput | null,
  canEdit?: ModelSubscriptionStringInput | null,
  canDelete?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionWorkTypeGroupFilterInput | null > | null,
  or?: Array< ModelSubscriptionWorkTypeGroupFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionWorkTypePricingFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  entityId?: ModelSubscriptionIDInput | null,
  workTypeGroupId?: ModelSubscriptionIDInput | null,
  body?: ModelSubscriptionStringInput | null,
  canView?: ModelSubscriptionStringInput | null,
  canEdit?: ModelSubscriptionStringInput | null,
  canDelete?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionWorkTypePricingFilterInput | null > | null,
  or?: Array< ModelSubscriptionWorkTypePricingFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionDefaultWorkTypePricingFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  unitCost?: ModelSubscriptionFloatInput | null,
  unitPrice?: ModelSubscriptionFloatInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDefaultWorkTypePricingFilterInput | null > | null,
  or?: Array< ModelSubscriptionDefaultWorkTypePricingFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionTemporaryWorkTypeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  workTypeGroupId?: ModelSubscriptionIDInput | null,
  environmentAgnosticWorkTypeGroupId?: ModelSubscriptionIDInput | null,
  body?: ModelSubscriptionStringInput | null,
  version?: ModelSubscriptionIntInput | null,
  schemaVersion?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTemporaryWorkTypeFilterInput | null > | null,
  or?: Array< ModelSubscriptionTemporaryWorkTypeFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionTenderFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  solutionId?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  latestVersion?: ModelSubscriptionIntInput | null,
  awardedVersion?: ModelSubscriptionIntInput | null,
  projectNumber?: ModelSubscriptionIntInput | null,
  createdBy?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTenderFilterInput | null > | null,
  or?: Array< ModelSubscriptionTenderFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionTenderMinorVersionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  tenderId?: ModelSubscriptionStringInput | null,
  version?: ModelSubscriptionIntInput | null,
  solutionId?: ModelSubscriptionStringInput | null,
  solutionMinorVersion?: ModelSubscriptionIntInput | null,
  contentKey?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTenderMinorVersionFilterInput | null > | null,
  or?: Array< ModelSubscriptionTenderMinorVersionFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionTagFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  createdBy?: ModelSubscriptionStringInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTagFilterInput | null > | null,
  or?: Array< ModelSubscriptionTagFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionUserOnboardingProgressFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  hasUserBeenAssociatedWithOrganization?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserOnboardingProgressFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserOnboardingProgressFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionTemplateFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  s3Key?: ModelSubscriptionStringInput | null,
  ownerId?: ModelSubscriptionStringInput | null,
  ownerType?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTemplateFilterInput | null > | null,
  or?: Array< ModelSubscriptionTemplateFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionTemporaryAuthorizationCodeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  code?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
  expiresAt?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  ttl?: ModelSubscriptionIntInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTemporaryAuthorizationCodeFilterInput | null > | null,
  or?: Array< ModelSubscriptionTemporaryAuthorizationCodeFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionLinkRegistryFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  action?: ModelSubscriptionStringInput | null,
  variables?: ModelSubscriptionStringInput | null,
  published?: ModelSubscriptionBooleanInput | null,
  createdBy?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLinkRegistryFilterInput | null > | null,
  or?: Array< ModelSubscriptionLinkRegistryFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionExternalReportBrandingFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  logoKey?: ModelSubscriptionStringInput | null,
  createdBy?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionExternalReportBrandingFilterInput | null > | null,
  or?: Array< ModelSubscriptionExternalReportBrandingFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionMeetingFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  data?: ModelSubscriptionStringInput | null,
  createdBy?: ModelSubscriptionStringInput | null,
  mediaPipelineId?: ModelSubscriptionStringInput | null,
  recordingKey?: ModelSubscriptionStringInput | null,
  recordingAttachmentId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionMeetingFilterInput | null > | null,
  or?: Array< ModelSubscriptionMeetingFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionAttendeeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  meetingId?: ModelSubscriptionIDInput | null,
  entityId?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  role?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAttendeeFilterInput | null > | null,
  or?: Array< ModelSubscriptionAttendeeFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionCodeBuildJobFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  parentId?: ModelSubscriptionStringInput | null,
  projectName?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  artifactPath?: ModelSubscriptionStringInput | null,
  buildStartTime?: ModelSubscriptionIntInput | null,
  buildEndTime?: ModelSubscriptionIntInput | null,
  requestedBy?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCodeBuildJobFilterInput | null > | null,
  or?: Array< ModelSubscriptionCodeBuildJobFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionResourceNotificationSettingFilterInput = {
  resourceId?: ModelSubscriptionIDInput | null,
  resourceType?: ModelSubscriptionStringInput | null,
  notificationType?: ModelSubscriptionStringInput | null,
  enabled?: ModelSubscriptionBooleanInput | null,
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionResourceNotificationSettingFilterInput | null > | null,
  or?: Array< ModelSubscriptionResourceNotificationSettingFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionAssessmentScheduleFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionIntInput | null,
  endDate?: ModelSubscriptionIntInput | null,
  authorizedIdentifiers?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAssessmentScheduleFilterInput | null > | null,
  or?: Array< ModelSubscriptionAssessmentScheduleFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionResourceAssessmentScheduleAssociationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  assessmentScheduleId?: ModelSubscriptionIDInput | null,
  resourceId?: ModelSubscriptionIDInput | null,
  resourceType?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionResourceAssessmentScheduleAssociationFilterInput | null > | null,
  or?: Array< ModelSubscriptionResourceAssessmentScheduleAssociationFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionAssessmentFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  scheduleId?: ModelSubscriptionIDInput | null,
  resourceId?: ModelSubscriptionIDInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  resourceType?: ModelSubscriptionStringInput | null,
  createdBy?: ModelSubscriptionStringInput | null,
  createdTime?: ModelSubscriptionIntInput | null,
  status?: ModelSubscriptionStringInput | null,
  issueIds?: ModelSubscriptionIDInput | null,
  tagIds?: ModelSubscriptionIDInput | null,
  description?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAssessmentFilterInput | null > | null,
  or?: Array< ModelSubscriptionAssessmentFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionProperty3PIntegrationConfigurationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  propertyId?: ModelSubscriptionIDInput | null,
  workflowEndpoint?: ModelSubscriptionStringInput | null,
  workflowName?: ModelSubscriptionStringInput | null,
  clientId?: ModelSubscriptionStringInput | null,
  clientSecret?: ModelSubscriptionStringInput | null,
  tokenUrl?: ModelSubscriptionStringInput | null,
  authorizeUrl?: ModelSubscriptionStringInput | null,
  scope?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProperty3PIntegrationConfigurationFilterInput | null > | null,
  or?: Array< ModelSubscriptionProperty3PIntegrationConfigurationFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionConversationStateFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  attachments?: ModelSubscriptionStringInput | null,
  conversationType?: ModelSubscriptionStringInput | null,
  extractedDetails?: ModelSubscriptionStringInput | null,
  conversationStatus?: ModelSubscriptionStringInput | null,
  invokerId?: ModelSubscriptionStringInput | null,
  nextStep?: ModelSubscriptionStringInput | null,
  nextStepMessage?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
  externalConversationId?: ModelSubscriptionStringInput | null,
  phoneNumber?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionConversationStateFilterInput | null > | null,
  or?: Array< ModelSubscriptionConversationStateFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionPolicyTemplateLinkFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  templateId?: ModelSubscriptionStringInput | null,
  entityId?: ModelSubscriptionStringInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  resourceId?: ModelSubscriptionStringInput | null,
  resourceType?: ModelSubscriptionStringInput | null,
  grantedBy?: ModelSubscriptionStringInput | null,
  grantedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPolicyTemplateLinkFilterInput | null > | null,
  or?: Array< ModelSubscriptionPolicyTemplateLinkFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionGenerateIssuesFromImagesJobFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  extractedIssues?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  invokerId?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionGenerateIssuesFromImagesJobFilterInput | null > | null,
  or?: Array< ModelSubscriptionGenerateIssuesFromImagesJobFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ShareResourcePermissionMutationVariables = {
  executionId: string,
  input: Array< ManageResourcePermissionInput | null >,
};

export type ShareResourcePermissionMutation = {
  shareResourcePermission?:  {
    __typename: "CompleteEvent",
    executionId: string,
    status: CompleteEventStatus,
    result?: string | null,
  } | null,
};

export type RevokeResourcePermissionMutationVariables = {
  executionId: string,
  input: Array< ManageResourcePermissionInput | null >,
};

export type RevokeResourcePermissionMutation = {
  revokeResourcePermission?:  {
    __typename: "CompleteEvent",
    executionId: string,
    status: CompleteEventStatus,
    result?: string | null,
  } | null,
};

export type CreateChimeMeetingMutationVariables = {
  name: string,
  role: AttendeeRole,
};

export type CreateChimeMeetingMutation = {
  createChimeMeeting?:  {
    __typename: "ChimeMeetingOutput",
    meetingInfo: string,
    attendeeInfo: string,
  } | null,
};

export type JoinChimeMeetingMutationVariables = {
  meetingId: string,
  name: string,
  role: AttendeeRole,
};

export type JoinChimeMeetingMutation = {
  joinChimeMeeting?:  {
    __typename: "ChimeMeetingOutput",
    meetingInfo: string,
    attendeeInfo: string,
  } | null,
};

export type EndChimeMeetingMutationVariables = {
  meetingId: string,
};

export type EndChimeMeetingMutation = {
  endChimeMeeting?: string | null,
};

export type StartChimeMeetingRecordingMutationVariables = {
  meetingId: string,
  attachmentParentResourceType?: PermissionResourceType | null,
  attachmentParentId?: string | null,
};

export type StartChimeMeetingRecordingMutation = {
  startChimeMeetingRecording?: string | null,
};

export type CreateAttachmentMutationVariables = {
  input: CreateAttachmentInput,
  condition?: ModelAttachmentConditionInput | null,
};

export type CreateAttachmentMutation = {
  createAttachment?:  {
    __typename: "Attachment",
    id: string,
    name?: string | null,
    type?: AttachmentType | null,
    parentId: string,
    parentType?: PermissionResourceType | null,
    propertyId?: string | null,
    key?: string | null,
    localCreatedAtTime?: number | null,
    status?: string | null,
    imageSource?: ImageSource | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAttachmentMutationVariables = {
  input: UpdateAttachmentInput,
  condition?: ModelAttachmentConditionInput | null,
};

export type UpdateAttachmentMutation = {
  updateAttachment?:  {
    __typename: "Attachment",
    id: string,
    name?: string | null,
    type?: AttachmentType | null,
    parentId: string,
    parentType?: PermissionResourceType | null,
    propertyId?: string | null,
    key?: string | null,
    localCreatedAtTime?: number | null,
    status?: string | null,
    imageSource?: ImageSource | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAttachmentMutationVariables = {
  input: DeleteAttachmentInput,
  condition?: ModelAttachmentConditionInput | null,
};

export type DeleteAttachmentMutation = {
  deleteAttachment?:  {
    __typename: "Attachment",
    id: string,
    name?: string | null,
    type?: AttachmentType | null,
    parentId: string,
    parentType?: PermissionResourceType | null,
    propertyId?: string | null,
    key?: string | null,
    localCreatedAtTime?: number | null,
    status?: string | null,
    imageSource?: ImageSource | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateBiddingContactMutationVariables = {
  input: CreateBiddingContactInput,
  condition?: ModelBiddingContactConditionInput | null,
};

export type CreateBiddingContactMutation = {
  createBiddingContact?:  {
    __typename: "BiddingContact",
    id: string,
    email: string,
    ownerEntityId?: string | null,
    contactEntityId?: string | null,
    name?: string | null,
    privateDescription?: string | null,
    publicDescription?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateBiddingContactMutationVariables = {
  input: UpdateBiddingContactInput,
  condition?: ModelBiddingContactConditionInput | null,
};

export type UpdateBiddingContactMutation = {
  updateBiddingContact?:  {
    __typename: "BiddingContact",
    id: string,
    email: string,
    ownerEntityId?: string | null,
    contactEntityId?: string | null,
    name?: string | null,
    privateDescription?: string | null,
    publicDescription?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteBiddingContactMutationVariables = {
  input: DeleteBiddingContactInput,
  condition?: ModelBiddingContactConditionInput | null,
};

export type DeleteBiddingContactMutation = {
  deleteBiddingContact?:  {
    __typename: "BiddingContact",
    id: string,
    email: string,
    ownerEntityId?: string | null,
    contactEntityId?: string | null,
    name?: string | null,
    privateDescription?: string | null,
    publicDescription?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateBidInvitationMutationVariables = {
  input: CreateBidInvitationInput,
  condition?: ModelBidInvitationConditionInput | null,
};

export type CreateBidInvitationMutation = {
  createBidInvitation?:  {
    __typename: "BidInvitation",
    id: string,
    biddingContactId?: string | null,
    tenderId?: string | null,
    ownerEntityId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateBidInvitationMutationVariables = {
  input: UpdateBidInvitationInput,
  condition?: ModelBidInvitationConditionInput | null,
};

export type UpdateBidInvitationMutation = {
  updateBidInvitation?:  {
    __typename: "BidInvitation",
    id: string,
    biddingContactId?: string | null,
    tenderId?: string | null,
    ownerEntityId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteBidInvitationMutationVariables = {
  input: DeleteBidInvitationInput,
  condition?: ModelBidInvitationConditionInput | null,
};

export type DeleteBidInvitationMutation = {
  deleteBidInvitation?:  {
    __typename: "BidInvitation",
    id: string,
    biddingContactId?: string | null,
    tenderId?: string | null,
    ownerEntityId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateBidMutationVariables = {
  input: CreateBidInput,
  condition?: ModelBidConditionInput | null,
};

export type CreateBidMutation = {
  createBid?:  {
    __typename: "Bid",
    id: string,
    tenderId?: string | null,
    latestMinorVersion?: number | null,
    latestAcceptedMinorVersion?: number | null,
    latestSubmittedMinorVersion?: number | null,
    status?: BidStatus | null,
    bidNumber?: number | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateBidMutationVariables = {
  input: UpdateBidInput,
  condition?: ModelBidConditionInput | null,
};

export type UpdateBidMutation = {
  updateBid?:  {
    __typename: "Bid",
    id: string,
    tenderId?: string | null,
    latestMinorVersion?: number | null,
    latestAcceptedMinorVersion?: number | null,
    latestSubmittedMinorVersion?: number | null,
    status?: BidStatus | null,
    bidNumber?: number | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteBidMutationVariables = {
  input: DeleteBidInput,
  condition?: ModelBidConditionInput | null,
};

export type DeleteBidMutation = {
  deleteBid?:  {
    __typename: "Bid",
    id: string,
    tenderId?: string | null,
    latestMinorVersion?: number | null,
    latestAcceptedMinorVersion?: number | null,
    latestSubmittedMinorVersion?: number | null,
    status?: BidStatus | null,
    bidNumber?: number | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateBidMinorVersionMutationVariables = {
  input: CreateBidMinorVersionInput,
  condition?: ModelBidMinorVersionConditionInput | null,
};

export type CreateBidMinorVersionMutation = {
  createBidMinorVersion?:  {
    __typename: "BidMinorVersion",
    id: string,
    bidId?: string | null,
    minorVersion?: number | null,
    tenderId?: string | null,
    tenderMinorVersion?: number | null,
    proposalId?: string | null,
    status?: DocumentStatus | null,
    metadata?:  {
      __typename: "BidMetadata",
      bidderContactName?: string | null,
      bidderContactEmail?: string | null,
      bidderCompanyName?: string | null,
      bidderContactAddress?: string | null,
      bidderContactPhoneNumber?: string | null,
      bidderWebsite?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateBidMinorVersionMutationVariables = {
  input: UpdateBidMinorVersionInput,
  condition?: ModelBidMinorVersionConditionInput | null,
};

export type UpdateBidMinorVersionMutation = {
  updateBidMinorVersion?:  {
    __typename: "BidMinorVersion",
    id: string,
    bidId?: string | null,
    minorVersion?: number | null,
    tenderId?: string | null,
    tenderMinorVersion?: number | null,
    proposalId?: string | null,
    status?: DocumentStatus | null,
    metadata?:  {
      __typename: "BidMetadata",
      bidderContactName?: string | null,
      bidderContactEmail?: string | null,
      bidderCompanyName?: string | null,
      bidderContactAddress?: string | null,
      bidderContactPhoneNumber?: string | null,
      bidderWebsite?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteBidMinorVersionMutationVariables = {
  input: DeleteBidMinorVersionInput,
  condition?: ModelBidMinorVersionConditionInput | null,
};

export type DeleteBidMinorVersionMutation = {
  deleteBidMinorVersion?:  {
    __typename: "BidMinorVersion",
    id: string,
    bidId?: string | null,
    minorVersion?: number | null,
    tenderId?: string | null,
    tenderMinorVersion?: number | null,
    proposalId?: string | null,
    status?: DocumentStatus | null,
    metadata?:  {
      __typename: "BidMetadata",
      bidderContactName?: string | null,
      bidderContactEmail?: string | null,
      bidderCompanyName?: string | null,
      bidderContactAddress?: string | null,
      bidderContactPhoneNumber?: string | null,
      bidderWebsite?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateClientLogMutationVariables = {
  input: CreateClientLogInput,
  condition?: ModelClientLogConditionInput | null,
};

export type CreateClientLogMutation = {
  createClientLog?:  {
    __typename: "ClientLog",
    id: string,
    userId?: string | null,
    userAgent?: string | null,
    severityLevel: LogSeverityLevel,
    componentName: string,
    message?: string | null,
    details?: string | null,
    tags?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateClientLogMutationVariables = {
  input: UpdateClientLogInput,
  condition?: ModelClientLogConditionInput | null,
};

export type UpdateClientLogMutation = {
  updateClientLog?:  {
    __typename: "ClientLog",
    id: string,
    userId?: string | null,
    userAgent?: string | null,
    severityLevel: LogSeverityLevel,
    componentName: string,
    message?: string | null,
    details?: string | null,
    tags?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteClientLogMutationVariables = {
  input: DeleteClientLogInput,
  condition?: ModelClientLogConditionInput | null,
};

export type DeleteClientLogMutation = {
  deleteClientLog?:  {
    __typename: "ClientLog",
    id: string,
    userId?: string | null,
    userAgent?: string | null,
    severityLevel: LogSeverityLevel,
    componentName: string,
    message?: string | null,
    details?: string | null,
    tags?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateCounterMutationVariables = {
  input: CreateCounterInput,
  condition?: ModelCounterConditionInput | null,
};

export type CreateCounterMutation = {
  createCounter?:  {
    __typename: "Counter",
    id: string,
    type: ResourceType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateCounterMutationVariables = {
  input: UpdateCounterInput,
  condition?: ModelCounterConditionInput | null,
};

export type UpdateCounterMutation = {
  updateCounter?:  {
    __typename: "Counter",
    id: string,
    type: ResourceType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteCounterMutationVariables = {
  input: DeleteCounterInput,
  condition?: ModelCounterConditionInput | null,
};

export type DeleteCounterMutation = {
  deleteCounter?:  {
    __typename: "Counter",
    id: string,
    type: ResourceType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateDesignDocumentMutationVariables = {
  input: CreateDesignDocumentInput,
  condition?: ModelDesignDocumentConditionInput | null,
};

export type CreateDesignDocumentMutation = {
  createDesignDocument?:  {
    __typename: "DesignDocument",
    id: string,
    designDocumentGroupId?: string | null,
    propertyId: string,
    projectId: string,
    name: string,
    status?: DesignDocumentStatus | null,
    lastEvaluatedValidityStatus?: boolean | null,
    uploadStatus?: string | null,
    documentKey?: string | null,
    lastWorkScopeSpecificationItemNumber?: number | null,
    version?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateDesignDocumentMutationVariables = {
  input: UpdateDesignDocumentInput,
  condition?: ModelDesignDocumentConditionInput | null,
};

export type UpdateDesignDocumentMutation = {
  updateDesignDocument?:  {
    __typename: "DesignDocument",
    id: string,
    designDocumentGroupId?: string | null,
    propertyId: string,
    projectId: string,
    name: string,
    status?: DesignDocumentStatus | null,
    lastEvaluatedValidityStatus?: boolean | null,
    uploadStatus?: string | null,
    documentKey?: string | null,
    lastWorkScopeSpecificationItemNumber?: number | null,
    version?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteDesignDocumentMutationVariables = {
  input: DeleteDesignDocumentInput,
  condition?: ModelDesignDocumentConditionInput | null,
};

export type DeleteDesignDocumentMutation = {
  deleteDesignDocument?:  {
    __typename: "DesignDocument",
    id: string,
    designDocumentGroupId?: string | null,
    propertyId: string,
    projectId: string,
    name: string,
    status?: DesignDocumentStatus | null,
    lastEvaluatedValidityStatus?: boolean | null,
    uploadStatus?: string | null,
    documentKey?: string | null,
    lastWorkScopeSpecificationItemNumber?: number | null,
    version?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateDesignDocumentGroupMutationVariables = {
  input: CreateDesignDocumentGroupInput,
  condition?: ModelDesignDocumentGroupConditionInput | null,
};

export type CreateDesignDocumentGroupMutation = {
  createDesignDocumentGroup?:  {
    __typename: "DesignDocumentGroup",
    id: string,
    projectId: string,
    propertyId: string,
    name: string,
    latestDocumentVersion: number,
    documentContentKey?: string | null,
    solutionGroupNumber?: number | null,
    isLocked: boolean,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateDesignDocumentGroupMutationVariables = {
  input: UpdateDesignDocumentGroupInput,
  condition?: ModelDesignDocumentGroupConditionInput | null,
};

export type UpdateDesignDocumentGroupMutation = {
  updateDesignDocumentGroup?:  {
    __typename: "DesignDocumentGroup",
    id: string,
    projectId: string,
    propertyId: string,
    name: string,
    latestDocumentVersion: number,
    documentContentKey?: string | null,
    solutionGroupNumber?: number | null,
    isLocked: boolean,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteDesignDocumentGroupMutationVariables = {
  input: DeleteDesignDocumentGroupInput,
  condition?: ModelDesignDocumentGroupConditionInput | null,
};

export type DeleteDesignDocumentGroupMutation = {
  deleteDesignDocumentGroup?:  {
    __typename: "DesignDocumentGroup",
    id: string,
    projectId: string,
    propertyId: string,
    name: string,
    latestDocumentVersion: number,
    documentContentKey?: string | null,
    solutionGroupNumber?: number | null,
    isLocked: boolean,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateDimensionMutationVariables = {
  input: CreateDimensionInput,
  condition?: ModelDimensionConditionInput | null,
};

export type CreateDimensionMutation = {
  createDimension?:  {
    __typename: "Dimension",
    id: string,
    parentId?: string | null,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    description?: string | null,
    length?: number | null,
    lengthUnit?: string | null,
    width?: number | null,
    widthUnit?: string | null,
    dimensionType?: DimensionType | null,
    measurementUnit?: MeasurementUnit | null,
    measurement?:  {
      __typename: "Measurement",
      length?: number | null,
      width?: number | null,
      dimensionType?: DimensionType | null,
      measurementUnit?: MeasurementUnit | null,
    } | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateDimensionMutationVariables = {
  input: UpdateDimensionInput,
  condition?: ModelDimensionConditionInput | null,
};

export type UpdateDimensionMutation = {
  updateDimension?:  {
    __typename: "Dimension",
    id: string,
    parentId?: string | null,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    description?: string | null,
    length?: number | null,
    lengthUnit?: string | null,
    width?: number | null,
    widthUnit?: string | null,
    dimensionType?: DimensionType | null,
    measurementUnit?: MeasurementUnit | null,
    measurement?:  {
      __typename: "Measurement",
      length?: number | null,
      width?: number | null,
      dimensionType?: DimensionType | null,
      measurementUnit?: MeasurementUnit | null,
    } | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteDimensionMutationVariables = {
  input: DeleteDimensionInput,
  condition?: ModelDimensionConditionInput | null,
};

export type DeleteDimensionMutation = {
  deleteDimension?:  {
    __typename: "Dimension",
    id: string,
    parentId?: string | null,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    description?: string | null,
    length?: number | null,
    lengthUnit?: string | null,
    width?: number | null,
    widthUnit?: string | null,
    dimensionType?: DimensionType | null,
    measurementUnit?: MeasurementUnit | null,
    measurement?:  {
      __typename: "Measurement",
      length?: number | null,
      width?: number | null,
      dimensionType?: DimensionType | null,
      measurementUnit?: MeasurementUnit | null,
    } | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateDiscoverableWorkTypesMutationVariables = {
  input: CreateDiscoverableWorkTypesInput,
  condition?: ModelDiscoverableWorkTypesConditionInput | null,
};

export type CreateDiscoverableWorkTypesMutation = {
  createDiscoverableWorkTypes?:  {
    __typename: "DiscoverableWorkTypes",
    id: string,
    workTypeGroupId: string,
    defaultVersion: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateDiscoverableWorkTypesMutationVariables = {
  input: UpdateDiscoverableWorkTypesInput,
  condition?: ModelDiscoverableWorkTypesConditionInput | null,
};

export type UpdateDiscoverableWorkTypesMutation = {
  updateDiscoverableWorkTypes?:  {
    __typename: "DiscoverableWorkTypes",
    id: string,
    workTypeGroupId: string,
    defaultVersion: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteDiscoverableWorkTypesMutationVariables = {
  input: DeleteDiscoverableWorkTypesInput,
  condition?: ModelDiscoverableWorkTypesConditionInput | null,
};

export type DeleteDiscoverableWorkTypesMutation = {
  deleteDiscoverableWorkTypes?:  {
    __typename: "DiscoverableWorkTypes",
    id: string,
    workTypeGroupId: string,
    defaultVersion: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateEntityResourcePermissionMutationVariables = {
  input: CreateEntityResourcePermissionInput,
  condition?: ModelEntityResourcePermissionConditionInput | null,
};

export type CreateEntityResourcePermissionMutation = {
  createEntityResourcePermission?:  {
    __typename: "EntityResourcePermission",
    id: string,
    propertyId?: string | null,
    entityId?: string | null,
    entityType?: PermissionEntityType | null,
    resourceId?: string | null,
    resourceType?: PermissionResourceType | null,
    permissionType?: PermissionType | null,
    isGranted?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateEntityResourcePermissionMutationVariables = {
  input: UpdateEntityResourcePermissionInput,
  condition?: ModelEntityResourcePermissionConditionInput | null,
};

export type UpdateEntityResourcePermissionMutation = {
  updateEntityResourcePermission?:  {
    __typename: "EntityResourcePermission",
    id: string,
    propertyId?: string | null,
    entityId?: string | null,
    entityType?: PermissionEntityType | null,
    resourceId?: string | null,
    resourceType?: PermissionResourceType | null,
    permissionType?: PermissionType | null,
    isGranted?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteEntityResourcePermissionMutationVariables = {
  input: DeleteEntityResourcePermissionInput,
  condition?: ModelEntityResourcePermissionConditionInput | null,
};

export type DeleteEntityResourcePermissionMutation = {
  deleteEntityResourcePermission?:  {
    __typename: "EntityResourcePermission",
    id: string,
    propertyId?: string | null,
    entityId?: string | null,
    entityType?: PermissionEntityType | null,
    resourceId?: string | null,
    resourceType?: PermissionResourceType | null,
    permissionType?: PermissionType | null,
    isGranted?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateEntityWorkTypeAssociationMutationVariables = {
  input: CreateEntityWorkTypeAssociationInput,
  condition?: ModelEntityWorkTypeAssociationConditionInput | null,
};

export type CreateEntityWorkTypeAssociationMutation = {
  createEntityWorkTypeAssociation?:  {
    __typename: "EntityWorkTypeAssociation",
    id: string,
    entityId: string,
    entityType: WorkTypeAssociationScopeEntity,
    workTypeGroupId: string,
    workTypeVersion?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateEntityWorkTypeAssociationMutationVariables = {
  input: UpdateEntityWorkTypeAssociationInput,
  condition?: ModelEntityWorkTypeAssociationConditionInput | null,
};

export type UpdateEntityWorkTypeAssociationMutation = {
  updateEntityWorkTypeAssociation?:  {
    __typename: "EntityWorkTypeAssociation",
    id: string,
    entityId: string,
    entityType: WorkTypeAssociationScopeEntity,
    workTypeGroupId: string,
    workTypeVersion?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteEntityWorkTypeAssociationMutationVariables = {
  input: DeleteEntityWorkTypeAssociationInput,
  condition?: ModelEntityWorkTypeAssociationConditionInput | null,
};

export type DeleteEntityWorkTypeAssociationMutation = {
  deleteEntityWorkTypeAssociation?:  {
    __typename: "EntityWorkTypeAssociation",
    id: string,
    entityId: string,
    entityType: WorkTypeAssociationScopeEntity,
    workTypeGroupId: string,
    workTypeVersion?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateInspectionMutationVariables = {
  input: CreateInspectionInput,
  condition?: ModelInspectionConditionInput | null,
};

export type CreateInspectionMutation = {
  createInspection?:  {
    __typename: "Inspection",
    id: string,
    propertyId: string,
    createdByOrganizationId: string,
    createdByUserId: string,
    startTime: number,
    endTime?: number | null,
    status: InspectionStatus,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateInspectionMutationVariables = {
  input: UpdateInspectionInput,
  condition?: ModelInspectionConditionInput | null,
};

export type UpdateInspectionMutation = {
  updateInspection?:  {
    __typename: "Inspection",
    id: string,
    propertyId: string,
    createdByOrganizationId: string,
    createdByUserId: string,
    startTime: number,
    endTime?: number | null,
    status: InspectionStatus,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteInspectionMutationVariables = {
  input: DeleteInspectionInput,
  condition?: ModelInspectionConditionInput | null,
};

export type DeleteInspectionMutation = {
  deleteInspection?:  {
    __typename: "Inspection",
    id: string,
    propertyId: string,
    createdByOrganizationId: string,
    createdByUserId: string,
    startTime: number,
    endTime?: number | null,
    status: InspectionStatus,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateIssueMutationVariables = {
  input: CreateIssueInput,
  condition?: ModelIssueConditionInput | null,
};

export type CreateIssueMutation = {
  createIssue?:  {
    __typename: "Issue",
    id: string,
    locationId?: string | null,
    propertyId?: string | null,
    inspectionId?: string | null,
    createdInSolution?: boolean | null,
    name?: string | null,
    description?: string | null,
    note?: string | null,
    tags?: string | null,
    tagIds?: Array< string > | null,
    status?: IssueStatus | null,
    clientCreationDate?: number | null,
    localLastUpdatedTime?: number | null,
    createdBy?: string | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isPubliclySubmitted?: boolean | null,
    suggestedWorkTypeIds?: Array< string > | null,
    quickQuoteIds?: Array< string > | null,
    proposalDocLinks?:  Array< {
      __typename: "ProposalDocLink",
      name: string,
      link: string,
      date: number,
    } > | null,
    priority?: IssuePriority | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateIssueMutationVariables = {
  input: UpdateIssueInput,
  condition?: ModelIssueConditionInput | null,
};

export type UpdateIssueMutation = {
  updateIssue?:  {
    __typename: "Issue",
    id: string,
    locationId?: string | null,
    propertyId?: string | null,
    inspectionId?: string | null,
    createdInSolution?: boolean | null,
    name?: string | null,
    description?: string | null,
    note?: string | null,
    tags?: string | null,
    tagIds?: Array< string > | null,
    status?: IssueStatus | null,
    clientCreationDate?: number | null,
    localLastUpdatedTime?: number | null,
    createdBy?: string | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isPubliclySubmitted?: boolean | null,
    suggestedWorkTypeIds?: Array< string > | null,
    quickQuoteIds?: Array< string > | null,
    proposalDocLinks?:  Array< {
      __typename: "ProposalDocLink",
      name: string,
      link: string,
      date: number,
    } > | null,
    priority?: IssuePriority | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteIssueMutationVariables = {
  input: DeleteIssueInput,
  condition?: ModelIssueConditionInput | null,
};

export type DeleteIssueMutation = {
  deleteIssue?:  {
    __typename: "Issue",
    id: string,
    locationId?: string | null,
    propertyId?: string | null,
    inspectionId?: string | null,
    createdInSolution?: boolean | null,
    name?: string | null,
    description?: string | null,
    note?: string | null,
    tags?: string | null,
    tagIds?: Array< string > | null,
    status?: IssueStatus | null,
    clientCreationDate?: number | null,
    localLastUpdatedTime?: number | null,
    createdBy?: string | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isPubliclySubmitted?: boolean | null,
    suggestedWorkTypeIds?: Array< string > | null,
    quickQuoteIds?: Array< string > | null,
    proposalDocLinks?:  Array< {
      __typename: "ProposalDocLink",
      name: string,
      link: string,
      date: number,
    } > | null,
    priority?: IssuePriority | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateQuickQuoteMutationVariables = {
  input: CreateQuickQuoteInput,
  condition?: ModelQuickQuoteConditionInput | null,
};

export type CreateQuickQuoteMutation = {
  createQuickQuote?:  {
    __typename: "QuickQuote",
    id: string,
    propertyId: string,
    generatedProposalId?: string | null,
    status: QuickQuoteStatus,
    generatedSolutionId?: string | null,
    issueIds?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateQuickQuoteMutationVariables = {
  input: UpdateQuickQuoteInput,
  condition?: ModelQuickQuoteConditionInput | null,
};

export type UpdateQuickQuoteMutation = {
  updateQuickQuote?:  {
    __typename: "QuickQuote",
    id: string,
    propertyId: string,
    generatedProposalId?: string | null,
    status: QuickQuoteStatus,
    generatedSolutionId?: string | null,
    issueIds?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteQuickQuoteMutationVariables = {
  input: DeleteQuickQuoteInput,
  condition?: ModelQuickQuoteConditionInput | null,
};

export type DeleteQuickQuoteMutation = {
  deleteQuickQuote?:  {
    __typename: "QuickQuote",
    id: string,
    propertyId: string,
    generatedProposalId?: string | null,
    status: QuickQuoteStatus,
    generatedSolutionId?: string | null,
    issueIds?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateLocationMutationVariables = {
  input: CreateLocationInput,
  condition?: ModelLocationConditionInput | null,
};

export type CreateLocationMutation = {
  createLocation?:  {
    __typename: "Location",
    id: string,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    name?: string | null,
    tags?: string | null,
    localCreationTime?: number | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateLocationMutationVariables = {
  input: UpdateLocationInput,
  condition?: ModelLocationConditionInput | null,
};

export type UpdateLocationMutation = {
  updateLocation?:  {
    __typename: "Location",
    id: string,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    name?: string | null,
    tags?: string | null,
    localCreationTime?: number | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteLocationMutationVariables = {
  input: DeleteLocationInput,
  condition?: ModelLocationConditionInput | null,
};

export type DeleteLocationMutation = {
  deleteLocation?:  {
    __typename: "Location",
    id: string,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    name?: string | null,
    tags?: string | null,
    localCreationTime?: number | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateNoteMutationVariables = {
  input: CreateNoteInput,
  condition?: ModelNoteConditionInput | null,
};

export type CreateNoteMutation = {
  createNote?:  {
    __typename: "Note",
    id: string,
    parentId?: string | null,
    propertyId?: string | null,
    note?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateNoteMutationVariables = {
  input: UpdateNoteInput,
  condition?: ModelNoteConditionInput | null,
};

export type UpdateNoteMutation = {
  updateNote?:  {
    __typename: "Note",
    id: string,
    parentId?: string | null,
    propertyId?: string | null,
    note?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteNoteMutationVariables = {
  input: DeleteNoteInput,
  condition?: ModelNoteConditionInput | null,
};

export type DeleteNoteMutation = {
  deleteNote?:  {
    __typename: "Note",
    id: string,
    parentId?: string | null,
    propertyId?: string | null,
    note?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateOrganizationMutationVariables = {
  input: CreateOrganizationInput,
  condition?: ModelOrganizationConditionInput | null,
};

export type CreateOrganizationMutation = {
  createOrganization?:  {
    __typename: "Organization",
    id: string,
    legalName: string,
    type?: OrganizationType | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateOrganizationMutationVariables = {
  input: UpdateOrganizationInput,
  condition?: ModelOrganizationConditionInput | null,
};

export type UpdateOrganizationMutation = {
  updateOrganization?:  {
    __typename: "Organization",
    id: string,
    legalName: string,
    type?: OrganizationType | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteOrganizationMutationVariables = {
  input: DeleteOrganizationInput,
  condition?: ModelOrganizationConditionInput | null,
};

export type DeleteOrganizationMutation = {
  deleteOrganization?:  {
    __typename: "Organization",
    id: string,
    legalName: string,
    type?: OrganizationType | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateOrganizationBillingProfileMutationVariables = {
  input: CreateOrganizationBillingProfileInput,
  condition?: ModelOrganizationBillingProfileConditionInput | null,
};

export type CreateOrganizationBillingProfileMutation = {
  createOrganizationBillingProfile?:  {
    __typename: "OrganizationBillingProfile",
    organizationId: string,
    billingProfileId: string,
    billingProvider: BillingProvider,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateOrganizationBillingProfileMutationVariables = {
  input: UpdateOrganizationBillingProfileInput,
  condition?: ModelOrganizationBillingProfileConditionInput | null,
};

export type UpdateOrganizationBillingProfileMutation = {
  updateOrganizationBillingProfile?:  {
    __typename: "OrganizationBillingProfile",
    organizationId: string,
    billingProfileId: string,
    billingProvider: BillingProvider,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteOrganizationBillingProfileMutationVariables = {
  input: DeleteOrganizationBillingProfileInput,
  condition?: ModelOrganizationBillingProfileConditionInput | null,
};

export type DeleteOrganizationBillingProfileMutation = {
  deleteOrganizationBillingProfile?:  {
    __typename: "OrganizationBillingProfile",
    organizationId: string,
    billingProfileId: string,
    billingProvider: BillingProvider,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTeamMutationVariables = {
  input: CreateTeamInput,
  condition?: ModelTeamConditionInput | null,
};

export type CreateTeamMutation = {
  createTeam?:  {
    __typename: "Team",
    id: string,
    organizationId: string,
    type: TeamType,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTeamMutationVariables = {
  input: UpdateTeamInput,
  condition?: ModelTeamConditionInput | null,
};

export type UpdateTeamMutation = {
  updateTeam?:  {
    __typename: "Team",
    id: string,
    organizationId: string,
    type: TeamType,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTeamMutationVariables = {
  input: DeleteTeamInput,
  condition?: ModelTeamConditionInput | null,
};

export type DeleteTeamMutation = {
  deleteTeam?:  {
    __typename: "Team",
    id: string,
    organizationId: string,
    type: TeamType,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTeamMemberMutationVariables = {
  input: CreateTeamMemberInput,
  condition?: ModelTeamMemberConditionInput | null,
};

export type CreateTeamMemberMutation = {
  createTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    teamId: string,
    organizationId: string,
    userId: string,
    joinedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTeamMemberMutationVariables = {
  input: UpdateTeamMemberInput,
  condition?: ModelTeamMemberConditionInput | null,
};

export type UpdateTeamMemberMutation = {
  updateTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    teamId: string,
    organizationId: string,
    userId: string,
    joinedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTeamMemberMutationVariables = {
  input: DeleteTeamMemberInput,
  condition?: ModelTeamMemberConditionInput | null,
};

export type DeleteTeamMemberMutation = {
  deleteTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    teamId: string,
    organizationId: string,
    userId: string,
    joinedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAccountInvitationMutationVariables = {
  input: CreateAccountInvitationInput,
  condition?: ModelAccountInvitationConditionInput | null,
};

export type CreateAccountInvitationMutation = {
  createAccountInvitation?:  {
    __typename: "AccountInvitation",
    id: string,
    organizationId: string,
    role?: TeamType | null,
    email: string,
    expiresAt: number,
    status?: AccountInvitationStatus | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAccountInvitationMutationVariables = {
  input: UpdateAccountInvitationInput,
  condition?: ModelAccountInvitationConditionInput | null,
};

export type UpdateAccountInvitationMutation = {
  updateAccountInvitation?:  {
    __typename: "AccountInvitation",
    id: string,
    organizationId: string,
    role?: TeamType | null,
    email: string,
    expiresAt: number,
    status?: AccountInvitationStatus | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAccountInvitationMutationVariables = {
  input: DeleteAccountInvitationInput,
  condition?: ModelAccountInvitationConditionInput | null,
};

export type DeleteAccountInvitationMutation = {
  deleteAccountInvitation?:  {
    __typename: "AccountInvitation",
    id: string,
    organizationId: string,
    role?: TeamType | null,
    email: string,
    expiresAt: number,
    status?: AccountInvitationStatus | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateProjectMutationVariables = {
  input: CreateProjectInput,
  condition?: ModelProjectConditionInput | null,
};

export type CreateProjectMutation = {
  createProject?:  {
    __typename: "Project",
    id: string,
    propertyId: string,
    name: string,
    tenderNumber?: string | null,
    customer?: string | null,
    address?: string | null,
    propertyType?: string | null,
    dueDate?: string | null,
    contactName?: string | null,
    contactNumber?: string | null,
    contactEmail?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateProjectMutationVariables = {
  input: UpdateProjectInput,
  condition?: ModelProjectConditionInput | null,
};

export type UpdateProjectMutation = {
  updateProject?:  {
    __typename: "Project",
    id: string,
    propertyId: string,
    name: string,
    tenderNumber?: string | null,
    customer?: string | null,
    address?: string | null,
    propertyType?: string | null,
    dueDate?: string | null,
    contactName?: string | null,
    contactNumber?: string | null,
    contactEmail?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteProjectMutationVariables = {
  input: DeleteProjectInput,
  condition?: ModelProjectConditionInput | null,
};

export type DeleteProjectMutation = {
  deleteProject?:  {
    __typename: "Project",
    id: string,
    propertyId: string,
    name: string,
    tenderNumber?: string | null,
    customer?: string | null,
    address?: string | null,
    propertyType?: string | null,
    dueDate?: string | null,
    contactName?: string | null,
    contactNumber?: string | null,
    contactEmail?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateProjectCounterMutationVariables = {
  input: CreateProjectCounterInput,
  condition?: ModelProjectCounterConditionInput | null,
};

export type CreateProjectCounterMutation = {
  createProjectCounter?:  {
    __typename: "ProjectCounter",
    id: string,
    propertyId: string,
    latestProjectNumber?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateProjectCounterMutationVariables = {
  input: UpdateProjectCounterInput,
  condition?: ModelProjectCounterConditionInput | null,
};

export type UpdateProjectCounterMutation = {
  updateProjectCounter?:  {
    __typename: "ProjectCounter",
    id: string,
    propertyId: string,
    latestProjectNumber?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteProjectCounterMutationVariables = {
  input: DeleteProjectCounterInput,
  condition?: ModelProjectCounterConditionInput | null,
};

export type DeleteProjectCounterMutation = {
  deleteProjectCounter?:  {
    __typename: "ProjectCounter",
    id: string,
    propertyId: string,
    latestProjectNumber?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreatePropertyMutationVariables = {
  input: CreatePropertyInput,
  condition?: ModelPropertyConditionInput | null,
};

export type CreatePropertyMutation = {
  createProperty?:  {
    __typename: "Property",
    id: string,
    name?: string | null,
    description?: string | null,
    address?: string | null,
    ownerOrganizationId?: string | null,
    primaryContactNumber?: string | null,
    primaryContactEmail?: string | null,
    primaryContactName?: string | null,
    propertyNumber?: string | null,
    locations?:  {
      __typename: "ModelLocationConnection",
      items:  Array< {
        __typename: "Location",
        id: string,
        propertyId?: string | null,
        createdInSolution?: boolean | null,
        name?: string | null,
        tags?: string | null,
        localCreationTime?: number | null,
        localLastUpdatedTime?: number | null,
        opaqueSyncReconciliationToken?: string | null,
        canView?: string | null,
        canEdit?: string | null,
        canDelete?: string | null,
        createdBy?: string | null,
        canViewList?: Array< string | null > | null,
        canViewEntityVersionMap?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdBy?: string | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    autoDashboardRebuild?: boolean | null,
    canView?: string | null,
    canEdit?: string | null,
    canCreateSolutions?: string | null,
    canDelete?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isTestProperty?: boolean | null,
    isArchived?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdatePropertyMutationVariables = {
  input: UpdatePropertyInput,
  condition?: ModelPropertyConditionInput | null,
};

export type UpdatePropertyMutation = {
  updateProperty?:  {
    __typename: "Property",
    id: string,
    name?: string | null,
    description?: string | null,
    address?: string | null,
    ownerOrganizationId?: string | null,
    primaryContactNumber?: string | null,
    primaryContactEmail?: string | null,
    primaryContactName?: string | null,
    propertyNumber?: string | null,
    locations?:  {
      __typename: "ModelLocationConnection",
      items:  Array< {
        __typename: "Location",
        id: string,
        propertyId?: string | null,
        createdInSolution?: boolean | null,
        name?: string | null,
        tags?: string | null,
        localCreationTime?: number | null,
        localLastUpdatedTime?: number | null,
        opaqueSyncReconciliationToken?: string | null,
        canView?: string | null,
        canEdit?: string | null,
        canDelete?: string | null,
        createdBy?: string | null,
        canViewList?: Array< string | null > | null,
        canViewEntityVersionMap?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdBy?: string | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    autoDashboardRebuild?: boolean | null,
    canView?: string | null,
    canEdit?: string | null,
    canCreateSolutions?: string | null,
    canDelete?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isTestProperty?: boolean | null,
    isArchived?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeletePropertyMutationVariables = {
  input: DeletePropertyInput,
  condition?: ModelPropertyConditionInput | null,
};

export type DeletePropertyMutation = {
  deleteProperty?:  {
    __typename: "Property",
    id: string,
    name?: string | null,
    description?: string | null,
    address?: string | null,
    ownerOrganizationId?: string | null,
    primaryContactNumber?: string | null,
    primaryContactEmail?: string | null,
    primaryContactName?: string | null,
    propertyNumber?: string | null,
    locations?:  {
      __typename: "ModelLocationConnection",
      items:  Array< {
        __typename: "Location",
        id: string,
        propertyId?: string | null,
        createdInSolution?: boolean | null,
        name?: string | null,
        tags?: string | null,
        localCreationTime?: number | null,
        localLastUpdatedTime?: number | null,
        opaqueSyncReconciliationToken?: string | null,
        canView?: string | null,
        canEdit?: string | null,
        canDelete?: string | null,
        createdBy?: string | null,
        canViewList?: Array< string | null > | null,
        canViewEntityVersionMap?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdBy?: string | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    autoDashboardRebuild?: boolean | null,
    canView?: string | null,
    canEdit?: string | null,
    canCreateSolutions?: string | null,
    canDelete?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isTestProperty?: boolean | null,
    isArchived?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreatePropertyCounterMutationVariables = {
  input: CreatePropertyCounterInput,
  condition?: ModelPropertyCounterConditionInput | null,
};

export type CreatePropertyCounterMutation = {
  createPropertyCounter?:  {
    __typename: "PropertyCounter",
    id: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdatePropertyCounterMutationVariables = {
  input: UpdatePropertyCounterInput,
  condition?: ModelPropertyCounterConditionInput | null,
};

export type UpdatePropertyCounterMutation = {
  updatePropertyCounter?:  {
    __typename: "PropertyCounter",
    id: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeletePropertyCounterMutationVariables = {
  input: DeletePropertyCounterInput,
  condition?: ModelPropertyCounterConditionInput | null,
};

export type DeletePropertyCounterMutation = {
  deletePropertyCounter?:  {
    __typename: "PropertyCounter",
    id: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateProposalMutationVariables = {
  input: CreateProposalInput,
  condition?: ModelProposalConditionInput | null,
};

export type CreateProposalMutation = {
  createProposal?:  {
    __typename: "Proposal",
    id: string,
    schemaVersion?: number | null,
    designDocumentGroupId: string,
    designDocumentVersion: number,
    proposalKey: string,
    proposalNumber?: number | null,
    status?: ProposalStatus | null,
    author?: string | null,
    createdAt?: string | null,
    localLastUpdatedTime?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    quickQuoteId?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateProposalMutationVariables = {
  input: UpdateProposalInput,
  condition?: ModelProposalConditionInput | null,
};

export type UpdateProposalMutation = {
  updateProposal?:  {
    __typename: "Proposal",
    id: string,
    schemaVersion?: number | null,
    designDocumentGroupId: string,
    designDocumentVersion: number,
    proposalKey: string,
    proposalNumber?: number | null,
    status?: ProposalStatus | null,
    author?: string | null,
    createdAt?: string | null,
    localLastUpdatedTime?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    quickQuoteId?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteProposalMutationVariables = {
  input: DeleteProposalInput,
  condition?: ModelProposalConditionInput | null,
};

export type DeleteProposalMutation = {
  deleteProposal?:  {
    __typename: "Proposal",
    id: string,
    schemaVersion?: number | null,
    designDocumentGroupId: string,
    designDocumentVersion: number,
    proposalKey: string,
    proposalNumber?: number | null,
    status?: ProposalStatus | null,
    author?: string | null,
    createdAt?: string | null,
    localLastUpdatedTime?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    quickQuoteId?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateProposalCounterMutationVariables = {
  input: CreateProposalCounterInput,
  condition?: ModelProposalCounterConditionInput | null,
};

export type CreateProposalCounterMutation = {
  createProposalCounter?:  {
    __typename: "ProposalCounter",
    id: string,
    solutionGroupId?: string | null,
    solutionVersion?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateProposalCounterMutationVariables = {
  input: UpdateProposalCounterInput,
  condition?: ModelProposalCounterConditionInput | null,
};

export type UpdateProposalCounterMutation = {
  updateProposalCounter?:  {
    __typename: "ProposalCounter",
    id: string,
    solutionGroupId?: string | null,
    solutionVersion?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteProposalCounterMutationVariables = {
  input: DeleteProposalCounterInput,
  condition?: ModelProposalCounterConditionInput | null,
};

export type DeleteProposalCounterMutation = {
  deleteProposalCounter?:  {
    __typename: "ProposalCounter",
    id: string,
    solutionGroupId?: string | null,
    solutionVersion?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateResourceUserPermissionsMutationVariables = {
  input: CreateResourceUserPermissionsInput,
  condition?: ModelResourceUserPermissionsConditionInput | null,
};

export type CreateResourceUserPermissionsMutation = {
  createResourceUserPermissions?:  {
    __typename: "ResourceUserPermissions",
    id: string,
    resourceId: string,
    userId?: string | null,
    userEmail?: string | null,
    userFullName?: string | null,
    resourceAndUserId?: string | null,
    permissions: string,
    resourceType?: ResourceType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateResourceUserPermissionsMutationVariables = {
  input: UpdateResourceUserPermissionsInput,
  condition?: ModelResourceUserPermissionsConditionInput | null,
};

export type UpdateResourceUserPermissionsMutation = {
  updateResourceUserPermissions?:  {
    __typename: "ResourceUserPermissions",
    id: string,
    resourceId: string,
    userId?: string | null,
    userEmail?: string | null,
    userFullName?: string | null,
    resourceAndUserId?: string | null,
    permissions: string,
    resourceType?: ResourceType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteResourceUserPermissionsMutationVariables = {
  input: DeleteResourceUserPermissionsInput,
  condition?: ModelResourceUserPermissionsConditionInput | null,
};

export type DeleteResourceUserPermissionsMutation = {
  deleteResourceUserPermissions?:  {
    __typename: "ResourceUserPermissions",
    id: string,
    resourceId: string,
    userId?: string | null,
    userEmail?: string | null,
    userFullName?: string | null,
    resourceAndUserId?: string | null,
    permissions: string,
    resourceType?: ResourceType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateSolutionMutationVariables = {
  input: CreateSolutionInput,
  condition?: ModelSolutionConditionInput | null,
};

export type CreateSolutionMutation = {
  createSolution?:  {
    __typename: "Solution",
    id: string,
    propertyId?: string | null,
    projectId?: string | null,
    name?: string | null,
    status?: SolutionStatus | null,
    latestMinorVersion?: number | null,
    latestContentKey?: string | null,
    serialNumber?: number | null,
    metadata?:  {
      __typename: "SolutionMetadata",
      name?: string | null,
      propertyContactName?: string | null,
      propertyAddress?: string | null,
      propertyType?: string | null,
      solutionDueDate?: string | null,
      consultantName?: string | null,
      consultantPhoneNumber?: string | null,
      consultantEmail?: string | null,
      tenderingType?: SolutionTenderingType | null,
      warranty?: number | null,
    } | null,
    localLastUpdatedTime?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isArchived?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateSolutionMutationVariables = {
  input: UpdateSolutionInput,
  condition?: ModelSolutionConditionInput | null,
};

export type UpdateSolutionMutation = {
  updateSolution?:  {
    __typename: "Solution",
    id: string,
    propertyId?: string | null,
    projectId?: string | null,
    name?: string | null,
    status?: SolutionStatus | null,
    latestMinorVersion?: number | null,
    latestContentKey?: string | null,
    serialNumber?: number | null,
    metadata?:  {
      __typename: "SolutionMetadata",
      name?: string | null,
      propertyContactName?: string | null,
      propertyAddress?: string | null,
      propertyType?: string | null,
      solutionDueDate?: string | null,
      consultantName?: string | null,
      consultantPhoneNumber?: string | null,
      consultantEmail?: string | null,
      tenderingType?: SolutionTenderingType | null,
      warranty?: number | null,
    } | null,
    localLastUpdatedTime?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isArchived?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteSolutionMutationVariables = {
  input: DeleteSolutionInput,
  condition?: ModelSolutionConditionInput | null,
};

export type DeleteSolutionMutation = {
  deleteSolution?:  {
    __typename: "Solution",
    id: string,
    propertyId?: string | null,
    projectId?: string | null,
    name?: string | null,
    status?: SolutionStatus | null,
    latestMinorVersion?: number | null,
    latestContentKey?: string | null,
    serialNumber?: number | null,
    metadata?:  {
      __typename: "SolutionMetadata",
      name?: string | null,
      propertyContactName?: string | null,
      propertyAddress?: string | null,
      propertyType?: string | null,
      solutionDueDate?: string | null,
      consultantName?: string | null,
      consultantPhoneNumber?: string | null,
      consultantEmail?: string | null,
      tenderingType?: SolutionTenderingType | null,
      warranty?: number | null,
    } | null,
    localLastUpdatedTime?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isArchived?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateSolutionMinorVersionMutationVariables = {
  input: CreateSolutionMinorVersionInput,
  condition?: ModelSolutionMinorVersionConditionInput | null,
};

export type CreateSolutionMinorVersionMutation = {
  createSolutionMinorVersion?:  {
    __typename: "SolutionMinorVersion",
    id: string,
    solutionId?: string | null,
    propertyId?: string | null,
    name?: string | null,
    contentKey?: string | null,
    minorVersion?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateSolutionMinorVersionMutationVariables = {
  input: UpdateSolutionMinorVersionInput,
  condition?: ModelSolutionMinorVersionConditionInput | null,
};

export type UpdateSolutionMinorVersionMutation = {
  updateSolutionMinorVersion?:  {
    __typename: "SolutionMinorVersion",
    id: string,
    solutionId?: string | null,
    propertyId?: string | null,
    name?: string | null,
    contentKey?: string | null,
    minorVersion?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteSolutionMinorVersionMutationVariables = {
  input: DeleteSolutionMinorVersionInput,
  condition?: ModelSolutionMinorVersionConditionInput | null,
};

export type DeleteSolutionMinorVersionMutation = {
  deleteSolutionMinorVersion?:  {
    __typename: "SolutionMinorVersion",
    id: string,
    solutionId?: string | null,
    propertyId?: string | null,
    name?: string | null,
    contentKey?: string | null,
    minorVersion?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateSolutionGroupCounterMutationVariables = {
  input: CreateSolutionGroupCounterInput,
  condition?: ModelSolutionGroupCounterConditionInput | null,
};

export type CreateSolutionGroupCounterMutation = {
  createSolutionGroupCounter?:  {
    __typename: "SolutionGroupCounter",
    id: string,
    propertyId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateSolutionGroupCounterMutationVariables = {
  input: UpdateSolutionGroupCounterInput,
  condition?: ModelSolutionGroupCounterConditionInput | null,
};

export type UpdateSolutionGroupCounterMutation = {
  updateSolutionGroupCounter?:  {
    __typename: "SolutionGroupCounter",
    id: string,
    propertyId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteSolutionGroupCounterMutationVariables = {
  input: DeleteSolutionGroupCounterInput,
  condition?: ModelSolutionGroupCounterConditionInput | null,
};

export type DeleteSolutionGroupCounterMutation = {
  deleteSolutionGroupCounter?:  {
    __typename: "SolutionGroupCounter",
    id: string,
    propertyId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateUserGroupMutationVariables = {
  input: CreateUserGroupInput,
  condition?: ModelUserGroupConditionInput | null,
};

export type CreateUserGroupMutation = {
  createUserGroup?:  {
    __typename: "UserGroup",
    id: string,
    resourceId: string,
    groupType: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateUserGroupMutationVariables = {
  input: UpdateUserGroupInput,
  condition?: ModelUserGroupConditionInput | null,
};

export type UpdateUserGroupMutation = {
  updateUserGroup?:  {
    __typename: "UserGroup",
    id: string,
    resourceId: string,
    groupType: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteUserGroupMutationVariables = {
  input: DeleteUserGroupInput,
  condition?: ModelUserGroupConditionInput | null,
};

export type DeleteUserGroupMutation = {
  deleteUserGroup?:  {
    __typename: "UserGroup",
    id: string,
    resourceId: string,
    groupType: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateUserGroupMemberMutationVariables = {
  input: CreateUserGroupMemberInput,
  condition?: ModelUserGroupMemberConditionInput | null,
};

export type CreateUserGroupMemberMutation = {
  createUserGroupMember?:  {
    __typename: "UserGroupMember",
    id: string,
    resourceId: string,
    resourceAndUserId: string,
    userId: string,
    userGroupId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateUserGroupMemberMutationVariables = {
  input: UpdateUserGroupMemberInput,
  condition?: ModelUserGroupMemberConditionInput | null,
};

export type UpdateUserGroupMemberMutation = {
  updateUserGroupMember?:  {
    __typename: "UserGroupMember",
    id: string,
    resourceId: string,
    resourceAndUserId: string,
    userId: string,
    userGroupId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteUserGroupMemberMutationVariables = {
  input: DeleteUserGroupMemberInput,
  condition?: ModelUserGroupMemberConditionInput | null,
};

export type DeleteUserGroupMemberMutation = {
  deleteUserGroupMember?:  {
    __typename: "UserGroupMember",
    id: string,
    resourceId: string,
    resourceAndUserId: string,
    userId: string,
    userGroupId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateUserOrganizationAssociationMutationVariables = {
  input: CreateUserOrganizationAssociationInput,
  condition?: ModelUserOrganizationAssociationConditionInput | null,
};

export type CreateUserOrganizationAssociationMutation = {
  createUserOrganizationAssociation?:  {
    __typename: "UserOrganizationAssociation",
    id: string,
    userId: string,
    organizationId: string,
    associationType: UserOrganizationAssociationType,
    permissions?: string | null,
    role?: UserOrganizationRole | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateUserOrganizationAssociationMutationVariables = {
  input: UpdateUserOrganizationAssociationInput,
  condition?: ModelUserOrganizationAssociationConditionInput | null,
};

export type UpdateUserOrganizationAssociationMutation = {
  updateUserOrganizationAssociation?:  {
    __typename: "UserOrganizationAssociation",
    id: string,
    userId: string,
    organizationId: string,
    associationType: UserOrganizationAssociationType,
    permissions?: string | null,
    role?: UserOrganizationRole | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteUserOrganizationAssociationMutationVariables = {
  input: DeleteUserOrganizationAssociationInput,
  condition?: ModelUserOrganizationAssociationConditionInput | null,
};

export type DeleteUserOrganizationAssociationMutation = {
  deleteUserOrganizationAssociation?:  {
    __typename: "UserOrganizationAssociation",
    id: string,
    userId: string,
    organizationId: string,
    associationType: UserOrganizationAssociationType,
    permissions?: string | null,
    role?: UserOrganizationRole | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateWorkSpecificationMutationVariables = {
  input: CreateWorkSpecificationInput,
  condition?: ModelWorkSpecificationConditionInput | null,
};

export type CreateWorkSpecificationMutation = {
  createWorkSpecification?:  {
    __typename: "WorkSpecification",
    id: string,
    dimensionId?: string | null,
    issueId?: string | null,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    body?: string | null,
    description?: string | null,
    workTypeId?: string | null,
    itemNumber?: number | null,
    measurement?:  {
      __typename: "Measurement",
      length?: number | null,
      width?: number | null,
      dimensionType?: DimensionType | null,
      measurementUnit?: MeasurementUnit | null,
    } | null,
    version?: number | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateWorkSpecificationMutationVariables = {
  input: UpdateWorkSpecificationInput,
  condition?: ModelWorkSpecificationConditionInput | null,
};

export type UpdateWorkSpecificationMutation = {
  updateWorkSpecification?:  {
    __typename: "WorkSpecification",
    id: string,
    dimensionId?: string | null,
    issueId?: string | null,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    body?: string | null,
    description?: string | null,
    workTypeId?: string | null,
    itemNumber?: number | null,
    measurement?:  {
      __typename: "Measurement",
      length?: number | null,
      width?: number | null,
      dimensionType?: DimensionType | null,
      measurementUnit?: MeasurementUnit | null,
    } | null,
    version?: number | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteWorkSpecificationMutationVariables = {
  input: DeleteWorkSpecificationInput,
  condition?: ModelWorkSpecificationConditionInput | null,
};

export type DeleteWorkSpecificationMutation = {
  deleteWorkSpecification?:  {
    __typename: "WorkSpecification",
    id: string,
    dimensionId?: string | null,
    issueId?: string | null,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    body?: string | null,
    description?: string | null,
    workTypeId?: string | null,
    itemNumber?: number | null,
    measurement?:  {
      __typename: "Measurement",
      length?: number | null,
      width?: number | null,
      dimensionType?: DimensionType | null,
      measurementUnit?: MeasurementUnit | null,
    } | null,
    version?: number | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateWorkTypeMutationVariables = {
  input: CreateWorkTypeInput,
  condition?: ModelWorkTypeConditionInput | null,
};

export type CreateWorkTypeMutation = {
  createWorkType?:  {
    __typename: "WorkType",
    id: string,
    name: string,
    shortDescription?: string | null,
    longDescription?: string | null,
    groupName?: string | null,
    unitPrice?: number | null,
    unitCost?: number | null,
    dimensionType?: DimensionType | null,
    measurementUnit?: MeasurementUnit | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateWorkTypeMutationVariables = {
  input: UpdateWorkTypeInput,
  condition?: ModelWorkTypeConditionInput | null,
};

export type UpdateWorkTypeMutation = {
  updateWorkType?:  {
    __typename: "WorkType",
    id: string,
    name: string,
    shortDescription?: string | null,
    longDescription?: string | null,
    groupName?: string | null,
    unitPrice?: number | null,
    unitCost?: number | null,
    dimensionType?: DimensionType | null,
    measurementUnit?: MeasurementUnit | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteWorkTypeMutationVariables = {
  input: DeleteWorkTypeInput,
  condition?: ModelWorkTypeConditionInput | null,
};

export type DeleteWorkTypeMutation = {
  deleteWorkType?:  {
    __typename: "WorkType",
    id: string,
    name: string,
    shortDescription?: string | null,
    longDescription?: string | null,
    groupName?: string | null,
    unitPrice?: number | null,
    unitCost?: number | null,
    dimensionType?: DimensionType | null,
    measurementUnit?: MeasurementUnit | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateWorkTypeGroupMutationVariables = {
  input: CreateWorkTypeGroupInput,
  condition?: ModelWorkTypeGroupConditionInput | null,
};

export type CreateWorkTypeGroupMutation = {
  createWorkTypeGroup?:  {
    __typename: "WorkTypeGroup",
    id: string,
    latestWorkTypeVersion: number,
    environmentAgnosticWorkTypeGroupId?: string | null,
    isDiscoverable?: boolean | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateWorkTypeGroupMutationVariables = {
  input: UpdateWorkTypeGroupInput,
  condition?: ModelWorkTypeGroupConditionInput | null,
};

export type UpdateWorkTypeGroupMutation = {
  updateWorkTypeGroup?:  {
    __typename: "WorkTypeGroup",
    id: string,
    latestWorkTypeVersion: number,
    environmentAgnosticWorkTypeGroupId?: string | null,
    isDiscoverable?: boolean | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteWorkTypeGroupMutationVariables = {
  input: DeleteWorkTypeGroupInput,
  condition?: ModelWorkTypeGroupConditionInput | null,
};

export type DeleteWorkTypeGroupMutation = {
  deleteWorkTypeGroup?:  {
    __typename: "WorkTypeGroup",
    id: string,
    latestWorkTypeVersion: number,
    environmentAgnosticWorkTypeGroupId?: string | null,
    isDiscoverable?: boolean | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateWorkTypePricingMutationVariables = {
  input: CreateWorkTypePricingInput,
  condition?: ModelWorkTypePricingConditionInput | null,
};

export type CreateWorkTypePricingMutation = {
  createWorkTypePricing?:  {
    __typename: "WorkTypePricing",
    id: string,
    entityId: string,
    workTypeGroupId: string,
    body: string,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateWorkTypePricingMutationVariables = {
  input: UpdateWorkTypePricingInput,
  condition?: ModelWorkTypePricingConditionInput | null,
};

export type UpdateWorkTypePricingMutation = {
  updateWorkTypePricing?:  {
    __typename: "WorkTypePricing",
    id: string,
    entityId: string,
    workTypeGroupId: string,
    body: string,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteWorkTypePricingMutationVariables = {
  input: DeleteWorkTypePricingInput,
  condition?: ModelWorkTypePricingConditionInput | null,
};

export type DeleteWorkTypePricingMutation = {
  deleteWorkTypePricing?:  {
    __typename: "WorkTypePricing",
    id: string,
    entityId: string,
    workTypeGroupId: string,
    body: string,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateDefaultWorkTypePricingMutationVariables = {
  input: CreateDefaultWorkTypePricingInput,
  condition?: ModelDefaultWorkTypePricingConditionInput | null,
};

export type CreateDefaultWorkTypePricingMutation = {
  createDefaultWorkTypePricing?:  {
    __typename: "DefaultWorkTypePricing",
    id: string,
    unitCost?: number | null,
    unitPrice?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateDefaultWorkTypePricingMutationVariables = {
  input: UpdateDefaultWorkTypePricingInput,
  condition?: ModelDefaultWorkTypePricingConditionInput | null,
};

export type UpdateDefaultWorkTypePricingMutation = {
  updateDefaultWorkTypePricing?:  {
    __typename: "DefaultWorkTypePricing",
    id: string,
    unitCost?: number | null,
    unitPrice?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteDefaultWorkTypePricingMutationVariables = {
  input: DeleteDefaultWorkTypePricingInput,
  condition?: ModelDefaultWorkTypePricingConditionInput | null,
};

export type DeleteDefaultWorkTypePricingMutation = {
  deleteDefaultWorkTypePricing?:  {
    __typename: "DefaultWorkTypePricing",
    id: string,
    unitCost?: number | null,
    unitPrice?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTemporaryWorkTypeMutationVariables = {
  input: CreateTemporaryWorkTypeInput,
  condition?: ModelTemporaryWorkTypeConditionInput | null,
};

export type CreateTemporaryWorkTypeMutation = {
  createTemporaryWorkType?:  {
    __typename: "TemporaryWorkType",
    id: string,
    workTypeGroupId: string,
    environmentAgnosticWorkTypeGroupId?: string | null,
    body: string,
    version: number,
    schemaVersion: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTemporaryWorkTypeMutationVariables = {
  input: UpdateTemporaryWorkTypeInput,
  condition?: ModelTemporaryWorkTypeConditionInput | null,
};

export type UpdateTemporaryWorkTypeMutation = {
  updateTemporaryWorkType?:  {
    __typename: "TemporaryWorkType",
    id: string,
    workTypeGroupId: string,
    environmentAgnosticWorkTypeGroupId?: string | null,
    body: string,
    version: number,
    schemaVersion: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTemporaryWorkTypeMutationVariables = {
  input: DeleteTemporaryWorkTypeInput,
  condition?: ModelTemporaryWorkTypeConditionInput | null,
};

export type DeleteTemporaryWorkTypeMutation = {
  deleteTemporaryWorkType?:  {
    __typename: "TemporaryWorkType",
    id: string,
    workTypeGroupId: string,
    environmentAgnosticWorkTypeGroupId?: string | null,
    body: string,
    version: number,
    schemaVersion: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTenderMutationVariables = {
  input: CreateTenderInput,
  condition?: ModelTenderConditionInput | null,
};

export type CreateTenderMutation = {
  createTender?:  {
    __typename: "Tender",
    id: string,
    solutionId?: string | null,
    status?: TenderStatus | null,
    latestVersion?: number | null,
    awardedVersion?: number | null,
    projectNumber?: number | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTenderMutationVariables = {
  input: UpdateTenderInput,
  condition?: ModelTenderConditionInput | null,
};

export type UpdateTenderMutation = {
  updateTender?:  {
    __typename: "Tender",
    id: string,
    solutionId?: string | null,
    status?: TenderStatus | null,
    latestVersion?: number | null,
    awardedVersion?: number | null,
    projectNumber?: number | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTenderMutationVariables = {
  input: DeleteTenderInput,
  condition?: ModelTenderConditionInput | null,
};

export type DeleteTenderMutation = {
  deleteTender?:  {
    __typename: "Tender",
    id: string,
    solutionId?: string | null,
    status?: TenderStatus | null,
    latestVersion?: number | null,
    awardedVersion?: number | null,
    projectNumber?: number | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTenderMinorVersionMutationVariables = {
  input: CreateTenderMinorVersionInput,
  condition?: ModelTenderMinorVersionConditionInput | null,
};

export type CreateTenderMinorVersionMutation = {
  createTenderMinorVersion?:  {
    __typename: "TenderMinorVersion",
    id: string,
    tenderId?: string | null,
    version?: number | null,
    solutionId?: string | null,
    solutionMinorVersion?: number | null,
    metadata?:  {
      __typename: "TenderMetadata",
      name?: string | null,
      propertyContactName?: string | null,
      propertyAddress?: string | null,
      propertyType?: string | null,
      solutionDueDate?: string | null,
      consultantName?: string | null,
      consultantPhoneNumber?: string | null,
      consultantEmail?: string | null,
    } | null,
    contentKey?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTenderMinorVersionMutationVariables = {
  input: UpdateTenderMinorVersionInput,
  condition?: ModelTenderMinorVersionConditionInput | null,
};

export type UpdateTenderMinorVersionMutation = {
  updateTenderMinorVersion?:  {
    __typename: "TenderMinorVersion",
    id: string,
    tenderId?: string | null,
    version?: number | null,
    solutionId?: string | null,
    solutionMinorVersion?: number | null,
    metadata?:  {
      __typename: "TenderMetadata",
      name?: string | null,
      propertyContactName?: string | null,
      propertyAddress?: string | null,
      propertyType?: string | null,
      solutionDueDate?: string | null,
      consultantName?: string | null,
      consultantPhoneNumber?: string | null,
      consultantEmail?: string | null,
    } | null,
    contentKey?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTenderMinorVersionMutationVariables = {
  input: DeleteTenderMinorVersionInput,
  condition?: ModelTenderMinorVersionConditionInput | null,
};

export type DeleteTenderMinorVersionMutation = {
  deleteTenderMinorVersion?:  {
    __typename: "TenderMinorVersion",
    id: string,
    tenderId?: string | null,
    version?: number | null,
    solutionId?: string | null,
    solutionMinorVersion?: number | null,
    metadata?:  {
      __typename: "TenderMetadata",
      name?: string | null,
      propertyContactName?: string | null,
      propertyAddress?: string | null,
      propertyType?: string | null,
      solutionDueDate?: string | null,
      consultantName?: string | null,
      consultantPhoneNumber?: string | null,
      consultantEmail?: string | null,
    } | null,
    contentKey?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTagMutationVariables = {
  input: CreateTagInput,
  condition?: ModelTagConditionInput | null,
};

export type CreateTagMutation = {
  createTag?:  {
    __typename: "Tag",
    id: string,
    name?: string | null,
    createdBy?: string | null,
    propertyId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTagMutationVariables = {
  input: UpdateTagInput,
  condition?: ModelTagConditionInput | null,
};

export type UpdateTagMutation = {
  updateTag?:  {
    __typename: "Tag",
    id: string,
    name?: string | null,
    createdBy?: string | null,
    propertyId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTagMutationVariables = {
  input: DeleteTagInput,
  condition?: ModelTagConditionInput | null,
};

export type DeleteTagMutation = {
  deleteTag?:  {
    __typename: "Tag",
    id: string,
    name?: string | null,
    createdBy?: string | null,
    propertyId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateUserOnboardingProgressMutationVariables = {
  input: CreateUserOnboardingProgressInput,
  condition?: ModelUserOnboardingProgressConditionInput | null,
};

export type CreateUserOnboardingProgressMutation = {
  createUserOnboardingProgress?:  {
    __typename: "UserOnboardingProgress",
    id: string,
    userId: string,
    hasUserBeenAssociatedWithOrganization: boolean,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateUserOnboardingProgressMutationVariables = {
  input: UpdateUserOnboardingProgressInput,
  condition?: ModelUserOnboardingProgressConditionInput | null,
};

export type UpdateUserOnboardingProgressMutation = {
  updateUserOnboardingProgress?:  {
    __typename: "UserOnboardingProgress",
    id: string,
    userId: string,
    hasUserBeenAssociatedWithOrganization: boolean,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteUserOnboardingProgressMutationVariables = {
  input: DeleteUserOnboardingProgressInput,
  condition?: ModelUserOnboardingProgressConditionInput | null,
};

export type DeleteUserOnboardingProgressMutation = {
  deleteUserOnboardingProgress?:  {
    __typename: "UserOnboardingProgress",
    id: string,
    userId: string,
    hasUserBeenAssociatedWithOrganization: boolean,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTemplateMutationVariables = {
  input: CreateTemplateInput,
  condition?: ModelTemplateConditionInput | null,
};

export type CreateTemplateMutation = {
  createTemplate?:  {
    __typename: "Template",
    id: string,
    type?: TemplateType | null,
    name?: string | null,
    s3Key?: string | null,
    ownerId?: string | null,
    ownerType?: TemplateEntityType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTemplateMutationVariables = {
  input: UpdateTemplateInput,
  condition?: ModelTemplateConditionInput | null,
};

export type UpdateTemplateMutation = {
  updateTemplate?:  {
    __typename: "Template",
    id: string,
    type?: TemplateType | null,
    name?: string | null,
    s3Key?: string | null,
    ownerId?: string | null,
    ownerType?: TemplateEntityType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTemplateMutationVariables = {
  input: DeleteTemplateInput,
  condition?: ModelTemplateConditionInput | null,
};

export type DeleteTemplateMutation = {
  deleteTemplate?:  {
    __typename: "Template",
    id: string,
    type?: TemplateType | null,
    name?: string | null,
    s3Key?: string | null,
    ownerId?: string | null,
    ownerType?: TemplateEntityType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTemporaryAuthorizationCodeMutationVariables = {
  input: CreateTemporaryAuthorizationCodeInput,
  condition?: ModelTemporaryAuthorizationCodeConditionInput | null,
};

export type CreateTemporaryAuthorizationCodeMutation = {
  createTemporaryAuthorizationCode?:  {
    __typename: "TemporaryAuthorizationCode",
    id: string,
    code: string,
    userId: string,
    expiresAt: number,
    createdAt: string,
    ttl: number,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTemporaryAuthorizationCodeMutationVariables = {
  input: UpdateTemporaryAuthorizationCodeInput,
  condition?: ModelTemporaryAuthorizationCodeConditionInput | null,
};

export type UpdateTemporaryAuthorizationCodeMutation = {
  updateTemporaryAuthorizationCode?:  {
    __typename: "TemporaryAuthorizationCode",
    id: string,
    code: string,
    userId: string,
    expiresAt: number,
    createdAt: string,
    ttl: number,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTemporaryAuthorizationCodeMutationVariables = {
  input: DeleteTemporaryAuthorizationCodeInput,
  condition?: ModelTemporaryAuthorizationCodeConditionInput | null,
};

export type DeleteTemporaryAuthorizationCodeMutation = {
  deleteTemporaryAuthorizationCode?:  {
    __typename: "TemporaryAuthorizationCode",
    id: string,
    code: string,
    userId: string,
    expiresAt: number,
    createdAt: string,
    ttl: number,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateLinkRegistryMutationVariables = {
  input: CreateLinkRegistryInput,
  condition?: ModelLinkRegistryConditionInput | null,
};

export type CreateLinkRegistryMutation = {
  createLinkRegistry?:  {
    __typename: "LinkRegistry",
    id: string,
    propertyId?: string | null,
    action?: LinkAction | null,
    variables?: string | null,
    published?: boolean | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateLinkRegistryMutationVariables = {
  input: UpdateLinkRegistryInput,
  condition?: ModelLinkRegistryConditionInput | null,
};

export type UpdateLinkRegistryMutation = {
  updateLinkRegistry?:  {
    __typename: "LinkRegistry",
    id: string,
    propertyId?: string | null,
    action?: LinkAction | null,
    variables?: string | null,
    published?: boolean | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteLinkRegistryMutationVariables = {
  input: DeleteLinkRegistryInput,
  condition?: ModelLinkRegistryConditionInput | null,
};

export type DeleteLinkRegistryMutation = {
  deleteLinkRegistry?:  {
    __typename: "LinkRegistry",
    id: string,
    propertyId?: string | null,
    action?: LinkAction | null,
    variables?: string | null,
    published?: boolean | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateExternalReportBrandingMutationVariables = {
  input: CreateExternalReportBrandingInput,
  condition?: ModelExternalReportBrandingConditionInput | null,
};

export type CreateExternalReportBrandingMutation = {
  createExternalReportBranding?:  {
    __typename: "ExternalReportBranding",
    id: string,
    name?: string | null,
    logoKey?: string | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateExternalReportBrandingMutationVariables = {
  input: UpdateExternalReportBrandingInput,
  condition?: ModelExternalReportBrandingConditionInput | null,
};

export type UpdateExternalReportBrandingMutation = {
  updateExternalReportBranding?:  {
    __typename: "ExternalReportBranding",
    id: string,
    name?: string | null,
    logoKey?: string | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteExternalReportBrandingMutationVariables = {
  input: DeleteExternalReportBrandingInput,
  condition?: ModelExternalReportBrandingConditionInput | null,
};

export type DeleteExternalReportBrandingMutation = {
  deleteExternalReportBranding?:  {
    __typename: "ExternalReportBranding",
    id: string,
    name?: string | null,
    logoKey?: string | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateMeetingMutationVariables = {
  input: CreateMeetingInput,
  condition?: ModelMeetingConditionInput | null,
};

export type CreateMeetingMutation = {
  createMeeting?:  {
    __typename: "Meeting",
    id: string,
    status?: MeetingStatus | null,
    data: string,
    createdBy?: string | null,
    mediaPipelineId?: string | null,
    recordingKey?: string | null,
    recordingAttachmentId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateMeetingMutationVariables = {
  input: UpdateMeetingInput,
  condition?: ModelMeetingConditionInput | null,
};

export type UpdateMeetingMutation = {
  updateMeeting?:  {
    __typename: "Meeting",
    id: string,
    status?: MeetingStatus | null,
    data: string,
    createdBy?: string | null,
    mediaPipelineId?: string | null,
    recordingKey?: string | null,
    recordingAttachmentId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteMeetingMutationVariables = {
  input: DeleteMeetingInput,
  condition?: ModelMeetingConditionInput | null,
};

export type DeleteMeetingMutation = {
  deleteMeeting?:  {
    __typename: "Meeting",
    id: string,
    status?: MeetingStatus | null,
    data: string,
    createdBy?: string | null,
    mediaPipelineId?: string | null,
    recordingKey?: string | null,
    recordingAttachmentId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAttendeeMutationVariables = {
  input: CreateAttendeeInput,
  condition?: ModelAttendeeConditionInput | null,
};

export type CreateAttendeeMutation = {
  createAttendee?:  {
    __typename: "Attendee",
    id: string,
    meetingId: string,
    entityId?: string | null,
    name?: string | null,
    role?: AttendeeRole | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAttendeeMutationVariables = {
  input: UpdateAttendeeInput,
  condition?: ModelAttendeeConditionInput | null,
};

export type UpdateAttendeeMutation = {
  updateAttendee?:  {
    __typename: "Attendee",
    id: string,
    meetingId: string,
    entityId?: string | null,
    name?: string | null,
    role?: AttendeeRole | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAttendeeMutationVariables = {
  input: DeleteAttendeeInput,
  condition?: ModelAttendeeConditionInput | null,
};

export type DeleteAttendeeMutation = {
  deleteAttendee?:  {
    __typename: "Attendee",
    id: string,
    meetingId: string,
    entityId?: string | null,
    name?: string | null,
    role?: AttendeeRole | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateCodeBuildJobMutationVariables = {
  input: CreateCodeBuildJobInput,
  condition?: ModelCodeBuildJobConditionInput | null,
};

export type CreateCodeBuildJobMutation = {
  createCodeBuildJob?:  {
    __typename: "CodeBuildJob",
    id: string,
    parentId?: string | null,
    projectName?: string | null,
    status?: BuildStatus | null,
    artifactPath?: string | null,
    buildStartTime?: number | null,
    buildEndTime?: number | null,
    requestedBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateCodeBuildJobMutationVariables = {
  input: UpdateCodeBuildJobInput,
  condition?: ModelCodeBuildJobConditionInput | null,
};

export type UpdateCodeBuildJobMutation = {
  updateCodeBuildJob?:  {
    __typename: "CodeBuildJob",
    id: string,
    parentId?: string | null,
    projectName?: string | null,
    status?: BuildStatus | null,
    artifactPath?: string | null,
    buildStartTime?: number | null,
    buildEndTime?: number | null,
    requestedBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteCodeBuildJobMutationVariables = {
  input: DeleteCodeBuildJobInput,
  condition?: ModelCodeBuildJobConditionInput | null,
};

export type DeleteCodeBuildJobMutation = {
  deleteCodeBuildJob?:  {
    __typename: "CodeBuildJob",
    id: string,
    parentId?: string | null,
    projectName?: string | null,
    status?: BuildStatus | null,
    artifactPath?: string | null,
    buildStartTime?: number | null,
    buildEndTime?: number | null,
    requestedBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateResourceNotificationSettingMutationVariables = {
  input: CreateResourceNotificationSettingInput,
  condition?: ModelResourceNotificationSettingConditionInput | null,
};

export type CreateResourceNotificationSettingMutation = {
  createResourceNotificationSetting?:  {
    __typename: "ResourceNotificationSetting",
    resourceId: string,
    resourceType: NotificationResourceType,
    notificationType: NotificationType,
    recipients?:  Array< {
      __typename: "NotificationRecipient",
      recipientId?: string | null,
      recipientIdType?: NotificationRecipientIdType | null,
      notificationChannels?: Array< NotificationChannel > | null,
      enabled?: boolean | null,
    } > | null,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateResourceNotificationSettingMutationVariables = {
  input: UpdateResourceNotificationSettingInput,
  condition?: ModelResourceNotificationSettingConditionInput | null,
};

export type UpdateResourceNotificationSettingMutation = {
  updateResourceNotificationSetting?:  {
    __typename: "ResourceNotificationSetting",
    resourceId: string,
    resourceType: NotificationResourceType,
    notificationType: NotificationType,
    recipients?:  Array< {
      __typename: "NotificationRecipient",
      recipientId?: string | null,
      recipientIdType?: NotificationRecipientIdType | null,
      notificationChannels?: Array< NotificationChannel > | null,
      enabled?: boolean | null,
    } > | null,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteResourceNotificationSettingMutationVariables = {
  input: DeleteResourceNotificationSettingInput,
  condition?: ModelResourceNotificationSettingConditionInput | null,
};

export type DeleteResourceNotificationSettingMutation = {
  deleteResourceNotificationSetting?:  {
    __typename: "ResourceNotificationSetting",
    resourceId: string,
    resourceType: NotificationResourceType,
    notificationType: NotificationType,
    recipients?:  Array< {
      __typename: "NotificationRecipient",
      recipientId?: string | null,
      recipientIdType?: NotificationRecipientIdType | null,
      notificationChannels?: Array< NotificationChannel > | null,
      enabled?: boolean | null,
    } > | null,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAssessmentScheduleMutationVariables = {
  input: CreateAssessmentScheduleInput,
  condition?: ModelAssessmentScheduleConditionInput | null,
};

export type CreateAssessmentScheduleMutation = {
  createAssessmentSchedule?:  {
    __typename: "AssessmentSchedule",
    id: string,
    propertyId?: string | null,
    name?: string | null,
    description?: string | null,
    startDate?: number | null,
    endDate?: number | null,
    recurrence?:  {
      __typename: "Recurrence",
      type?: RecurrenceType | null,
      dailyRecurrence?:  {
        __typename: "DailyRecurrence",
        interval?: number | null,
      } | null,
      weeklyRecurrence?:  {
        __typename: "WeeklyRecurrence",
        interval?: number | null,
        daysOfWeek?: Array< DayOfWeek | null > | null,
      } | null,
      monthlyRecurrence?:  {
        __typename: "MonthlyRecurrence",
        type?: MonthlyScheduleType | null,
        interval?: number | null,
        dayOfMonth?: string | null,
        nthWeekDay?:  {
          __typename: "NthWeekDay",
          weekNumber?: string | null,
          day?: DayOfWeek | null,
        } | null,
      } | null,
    } | null,
    authorizedIdentifiers?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAssessmentScheduleMutationVariables = {
  input: UpdateAssessmentScheduleInput,
  condition?: ModelAssessmentScheduleConditionInput | null,
};

export type UpdateAssessmentScheduleMutation = {
  updateAssessmentSchedule?:  {
    __typename: "AssessmentSchedule",
    id: string,
    propertyId?: string | null,
    name?: string | null,
    description?: string | null,
    startDate?: number | null,
    endDate?: number | null,
    recurrence?:  {
      __typename: "Recurrence",
      type?: RecurrenceType | null,
      dailyRecurrence?:  {
        __typename: "DailyRecurrence",
        interval?: number | null,
      } | null,
      weeklyRecurrence?:  {
        __typename: "WeeklyRecurrence",
        interval?: number | null,
        daysOfWeek?: Array< DayOfWeek | null > | null,
      } | null,
      monthlyRecurrence?:  {
        __typename: "MonthlyRecurrence",
        type?: MonthlyScheduleType | null,
        interval?: number | null,
        dayOfMonth?: string | null,
        nthWeekDay?:  {
          __typename: "NthWeekDay",
          weekNumber?: string | null,
          day?: DayOfWeek | null,
        } | null,
      } | null,
    } | null,
    authorizedIdentifiers?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAssessmentScheduleMutationVariables = {
  input: DeleteAssessmentScheduleInput,
  condition?: ModelAssessmentScheduleConditionInput | null,
};

export type DeleteAssessmentScheduleMutation = {
  deleteAssessmentSchedule?:  {
    __typename: "AssessmentSchedule",
    id: string,
    propertyId?: string | null,
    name?: string | null,
    description?: string | null,
    startDate?: number | null,
    endDate?: number | null,
    recurrence?:  {
      __typename: "Recurrence",
      type?: RecurrenceType | null,
      dailyRecurrence?:  {
        __typename: "DailyRecurrence",
        interval?: number | null,
      } | null,
      weeklyRecurrence?:  {
        __typename: "WeeklyRecurrence",
        interval?: number | null,
        daysOfWeek?: Array< DayOfWeek | null > | null,
      } | null,
      monthlyRecurrence?:  {
        __typename: "MonthlyRecurrence",
        type?: MonthlyScheduleType | null,
        interval?: number | null,
        dayOfMonth?: string | null,
        nthWeekDay?:  {
          __typename: "NthWeekDay",
          weekNumber?: string | null,
          day?: DayOfWeek | null,
        } | null,
      } | null,
    } | null,
    authorizedIdentifiers?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateResourceAssessmentScheduleAssociationMutationVariables = {
  input: CreateResourceAssessmentScheduleAssociationInput,
  condition?: ModelResourceAssessmentScheduleAssociationConditionInput | null,
};

export type CreateResourceAssessmentScheduleAssociationMutation = {
  createResourceAssessmentScheduleAssociation?:  {
    __typename: "ResourceAssessmentScheduleAssociation",
    id: string,
    assessmentScheduleId?: string | null,
    resourceId?: string | null,
    resourceType?: PermissionResourceType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateResourceAssessmentScheduleAssociationMutationVariables = {
  input: UpdateResourceAssessmentScheduleAssociationInput,
  condition?: ModelResourceAssessmentScheduleAssociationConditionInput | null,
};

export type UpdateResourceAssessmentScheduleAssociationMutation = {
  updateResourceAssessmentScheduleAssociation?:  {
    __typename: "ResourceAssessmentScheduleAssociation",
    id: string,
    assessmentScheduleId?: string | null,
    resourceId?: string | null,
    resourceType?: PermissionResourceType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteResourceAssessmentScheduleAssociationMutationVariables = {
  input: DeleteResourceAssessmentScheduleAssociationInput,
  condition?: ModelResourceAssessmentScheduleAssociationConditionInput | null,
};

export type DeleteResourceAssessmentScheduleAssociationMutation = {
  deleteResourceAssessmentScheduleAssociation?:  {
    __typename: "ResourceAssessmentScheduleAssociation",
    id: string,
    assessmentScheduleId?: string | null,
    resourceId?: string | null,
    resourceType?: PermissionResourceType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAssessmentMutationVariables = {
  input: CreateAssessmentInput,
  condition?: ModelAssessmentConditionInput | null,
};

export type CreateAssessmentMutation = {
  createAssessment?:  {
    __typename: "Assessment",
    id: string,
    scheduleId?: string | null,
    resourceId?: string | null,
    propertyId?: string | null,
    resourceType?: PermissionResourceType | null,
    createdBy?: string | null,
    submittedBy?:  {
      __typename: "ExternalUserInfo",
      firstName?: string | null,
      lastName?: string | null,
    } | null,
    createdTime?: number | null,
    status?: AssessmentStatus | null,
    issueIds?: Array< string | null > | null,
    tagIds?: Array< string > | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAssessmentMutationVariables = {
  input: UpdateAssessmentInput,
  condition?: ModelAssessmentConditionInput | null,
};

export type UpdateAssessmentMutation = {
  updateAssessment?:  {
    __typename: "Assessment",
    id: string,
    scheduleId?: string | null,
    resourceId?: string | null,
    propertyId?: string | null,
    resourceType?: PermissionResourceType | null,
    createdBy?: string | null,
    submittedBy?:  {
      __typename: "ExternalUserInfo",
      firstName?: string | null,
      lastName?: string | null,
    } | null,
    createdTime?: number | null,
    status?: AssessmentStatus | null,
    issueIds?: Array< string | null > | null,
    tagIds?: Array< string > | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAssessmentMutationVariables = {
  input: DeleteAssessmentInput,
  condition?: ModelAssessmentConditionInput | null,
};

export type DeleteAssessmentMutation = {
  deleteAssessment?:  {
    __typename: "Assessment",
    id: string,
    scheduleId?: string | null,
    resourceId?: string | null,
    propertyId?: string | null,
    resourceType?: PermissionResourceType | null,
    createdBy?: string | null,
    submittedBy?:  {
      __typename: "ExternalUserInfo",
      firstName?: string | null,
      lastName?: string | null,
    } | null,
    createdTime?: number | null,
    status?: AssessmentStatus | null,
    issueIds?: Array< string | null > | null,
    tagIds?: Array< string > | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateContactMutationVariables = {
  input: CreateContactInput,
  condition?: ModelContactConditionInput | null,
};

export type CreateContactMutation = {
  createContact?:  {
    __typename: "Contact",
    id: string,
    name?: string | null,
    email?: string | null,
    phoneNumber?: string | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateContactMutationVariables = {
  input: UpdateContactInput,
  condition?: ModelContactConditionInput | null,
};

export type UpdateContactMutation = {
  updateContact?:  {
    __typename: "Contact",
    id: string,
    name?: string | null,
    email?: string | null,
    phoneNumber?: string | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteContactMutationVariables = {
  input: DeleteContactInput,
  condition?: ModelContactConditionInput | null,
};

export type DeleteContactMutation = {
  deleteContact?:  {
    __typename: "Contact",
    id: string,
    name?: string | null,
    email?: string | null,
    phoneNumber?: string | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateProperty3PIntegrationConfigurationMutationVariables = {
  input: CreateProperty3PIntegrationConfigurationInput,
  condition?: ModelProperty3PIntegrationConfigurationConditionInput | null,
};

export type CreateProperty3PIntegrationConfigurationMutation = {
  createProperty3PIntegrationConfiguration?:  {
    __typename: "Property3PIntegrationConfiguration",
    id: string,
    propertyId: string,
    workflowEndpoint: string,
    workflowName: string,
    clientId: string,
    clientSecret: string,
    tokenUrl: string,
    authorizeUrl: string,
    scope: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateProperty3PIntegrationConfigurationMutationVariables = {
  input: UpdateProperty3PIntegrationConfigurationInput,
  condition?: ModelProperty3PIntegrationConfigurationConditionInput | null,
};

export type UpdateProperty3PIntegrationConfigurationMutation = {
  updateProperty3PIntegrationConfiguration?:  {
    __typename: "Property3PIntegrationConfiguration",
    id: string,
    propertyId: string,
    workflowEndpoint: string,
    workflowName: string,
    clientId: string,
    clientSecret: string,
    tokenUrl: string,
    authorizeUrl: string,
    scope: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteProperty3PIntegrationConfigurationMutationVariables = {
  input: DeleteProperty3PIntegrationConfigurationInput,
  condition?: ModelProperty3PIntegrationConfigurationConditionInput | null,
};

export type DeleteProperty3PIntegrationConfigurationMutation = {
  deleteProperty3PIntegrationConfiguration?:  {
    __typename: "Property3PIntegrationConfiguration",
    id: string,
    propertyId: string,
    workflowEndpoint: string,
    workflowName: string,
    clientId: string,
    clientSecret: string,
    tokenUrl: string,
    authorizeUrl: string,
    scope: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateConversationStateMutationVariables = {
  input: CreateConversationStateInput,
  condition?: ModelConversationStateConditionInput | null,
};

export type CreateConversationStateMutation = {
  createConversationState?:  {
    __typename: "ConversationState",
    id: string,
    attachments?: Array< string | null > | null,
    conversationType: string,
    extractedDetails: string,
    conversationStatus: ConversationStatus,
    invokerId: string,
    nextStep?: ConversationNextStep | null,
    nextStepMessage?: string | null,
    userId?: string | null,
    externalConversationId?: string | null,
    phoneNumber?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateConversationStateMutationVariables = {
  input: UpdateConversationStateInput,
  condition?: ModelConversationStateConditionInput | null,
};

export type UpdateConversationStateMutation = {
  updateConversationState?:  {
    __typename: "ConversationState",
    id: string,
    attachments?: Array< string | null > | null,
    conversationType: string,
    extractedDetails: string,
    conversationStatus: ConversationStatus,
    invokerId: string,
    nextStep?: ConversationNextStep | null,
    nextStepMessage?: string | null,
    userId?: string | null,
    externalConversationId?: string | null,
    phoneNumber?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteConversationStateMutationVariables = {
  input: DeleteConversationStateInput,
  condition?: ModelConversationStateConditionInput | null,
};

export type DeleteConversationStateMutation = {
  deleteConversationState?:  {
    __typename: "ConversationState",
    id: string,
    attachments?: Array< string | null > | null,
    conversationType: string,
    extractedDetails: string,
    conversationStatus: ConversationStatus,
    invokerId: string,
    nextStep?: ConversationNextStep | null,
    nextStepMessage?: string | null,
    userId?: string | null,
    externalConversationId?: string | null,
    phoneNumber?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreatePolicyTemplateLinkMutationVariables = {
  input: CreatePolicyTemplateLinkInput,
  condition?: ModelPolicyTemplateLinkConditionInput | null,
};

export type CreatePolicyTemplateLinkMutation = {
  createPolicyTemplateLink?:  {
    __typename: "PolicyTemplateLink",
    id: string,
    templateId: string,
    entityId: string,
    entityType: PermissionEntityType,
    resourceId: string,
    resourceType: PermissionResourceType,
    grantedBy?: string | null,
    grantedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdatePolicyTemplateLinkMutationVariables = {
  input: UpdatePolicyTemplateLinkInput,
  condition?: ModelPolicyTemplateLinkConditionInput | null,
};

export type UpdatePolicyTemplateLinkMutation = {
  updatePolicyTemplateLink?:  {
    __typename: "PolicyTemplateLink",
    id: string,
    templateId: string,
    entityId: string,
    entityType: PermissionEntityType,
    resourceId: string,
    resourceType: PermissionResourceType,
    grantedBy?: string | null,
    grantedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeletePolicyTemplateLinkMutationVariables = {
  input: DeletePolicyTemplateLinkInput,
  condition?: ModelPolicyTemplateLinkConditionInput | null,
};

export type DeletePolicyTemplateLinkMutation = {
  deletePolicyTemplateLink?:  {
    __typename: "PolicyTemplateLink",
    id: string,
    templateId: string,
    entityId: string,
    entityType: PermissionEntityType,
    resourceId: string,
    resourceType: PermissionResourceType,
    grantedBy?: string | null,
    grantedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateGenerateIssuesFromImagesJobMutationVariables = {
  input: CreateGenerateIssuesFromImagesJobInput,
  condition?: ModelGenerateIssuesFromImagesJobConditionInput | null,
};

export type CreateGenerateIssuesFromImagesJobMutation = {
  createGenerateIssuesFromImagesJob?:  {
    __typename: "GenerateIssuesFromImagesJob",
    id: string,
    extractedIssues: string,
    status: GenerateIssuesFromImagesJobStatus,
    invokerId: string,
    userId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateGenerateIssuesFromImagesJobMutationVariables = {
  input: UpdateGenerateIssuesFromImagesJobInput,
  condition?: ModelGenerateIssuesFromImagesJobConditionInput | null,
};

export type UpdateGenerateIssuesFromImagesJobMutation = {
  updateGenerateIssuesFromImagesJob?:  {
    __typename: "GenerateIssuesFromImagesJob",
    id: string,
    extractedIssues: string,
    status: GenerateIssuesFromImagesJobStatus,
    invokerId: string,
    userId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteGenerateIssuesFromImagesJobMutationVariables = {
  input: DeleteGenerateIssuesFromImagesJobInput,
  condition?: ModelGenerateIssuesFromImagesJobConditionInput | null,
};

export type DeleteGenerateIssuesFromImagesJobMutation = {
  deleteGenerateIssuesFromImagesJob?:  {
    __typename: "GenerateIssuesFromImagesJob",
    id: string,
    extractedIssues: string,
    status: GenerateIssuesFromImagesJobStatus,
    invokerId: string,
    userId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateStaticDashboardDataMutationVariables = {
  input: CreateStaticDashboardDataInput,
};

export type CreateStaticDashboardDataMutation = {
  createStaticDashboardData?: string | null,
};

export type CreateBillingProfileSessionMutationVariables = {
  input: CreateBillingProfileSessionInput,
};

export type CreateBillingProfileSessionMutation = {
  createBillingProfileSession?:  {
    __typename: "CreateBillingProfileSessionResponse",
    status: ResponseStatus,
    message?: string | null,
    url: string,
  } | null,
};

export type CreateBillingProfileMutationVariables = {
  input: CreateBillingProfileInput,
};

export type CreateBillingProfileMutation = {
  createBillingProfile?:  {
    __typename: "CreateBillingProfileResponse",
    status?: ResponseStatus | null,
    message?: string | null,
  } | null,
};

export type ReportMeteringUsageMutationVariables = {
  input: ReportMeteringUsageRequest,
};

export type ReportMeteringUsageMutation = {
  reportMeteringUsage?:  {
    __typename: "ReportMeteringUsageResponse",
    status?: ResponseStatus | null,
    message?: string | null,
  } | null,
};

export type UpdateSubscriptionTierMutationVariables = {
  input: UpdateSubscriptionTierInput,
};

export type UpdateSubscriptionTierMutation = {
  updateSubscriptionTier?:  {
    __typename: "UpdatesubscriptionTierResponse",
    status?: ResponseStatus | null,
    message?: string | null,
  } | null,
};

export type SendCompleteEventMutationVariables = {
  executionId: string,
  status: CompleteEventStatus,
  result?: string | null,
};

export type SendCompleteEventMutation = {
  sendCompleteEvent?:  {
    __typename: "CompleteEvent",
    executionId: string,
    status: CompleteEventStatus,
    result?: string | null,
  } | null,
};

export type HandleExternalReportSubmissionMutationVariables = {
  input: ExternalReportSubmission,
};

export type HandleExternalReportSubmissionMutation = {
  handleExternalReportSubmission?: string | null,
};

export type GenerateReportMutationVariables = {
  executionId: string,
  input: GenerateReportRequest,
};

export type GenerateReportMutation = {
  generateReport?:  {
    __typename: "CompleteEvent",
    executionId: string,
    status: CompleteEventStatus,
    result?: string | null,
  } | null,
};

export type SendNotificationToUsersMutationVariables = {
  input: sendNotificationToUsersInput,
};

export type SendNotificationToUsersMutation = {
  sendNotificationToUsers?: string | null,
};

export type JoinChimeMeetingPublicMutationVariables = {
  meetingId: string,
  name: string,
  role: AttendeeRole,
};

export type JoinChimeMeetingPublicMutation = {
  joinChimeMeetingPublic?: string | null,
};

export type ShareMeetingLinkMutationVariables = {
  input: ShareMeetingLinkInput,
};

export type ShareMeetingLinkMutation = {
  shareMeetingLink?: string | null,
};

export type TriggerBuildStaticSiteMutationVariables = {
  propertyId: string,
};

export type TriggerBuildStaticSiteMutation = {
  triggerBuildStaticSite?: string | null,
};

export type SubmitQuickQuoteMutationVariables = {
  input?: Array< SubmitQuickQuoteInput | null > | null,
  executionId?: string | null,
};

export type SubmitQuickQuoteMutation = {
  submitQuickQuote?:  {
    __typename: "SubmitQuickQuoteOutput",
    status: string,
    solutionId?: string | null,
  } | null,
};

export type SubmitQuickQuoteWithExistingDataMutationVariables = {
  input?: SubmitQuickQuoteExistingDataInput | null,
  executionId?: string | null,
};

export type SubmitQuickQuoteWithExistingDataMutation = {
  submitQuickQuoteWithExistingData?:  {
    __typename: "SubmitQuickQuoteOutput",
    status: string,
    solutionId?: string | null,
  } | null,
};

export type ManageConversationStateMutationVariables = {
  input: ConversationStateInput,
};

export type ManageConversationStateMutation = {
  manageConversationState?:  {
    __typename: "ConversationStateOutput",
    id: string,
    attachments?: Array< string | null > | null,
    conversationType: string,
    extractedDetails: string,
    nextStep?: ConversationNextStep | null,
    nextStepMessage?: string | null,
    externalConversationId?: string | null,
    phoneNumber?: string | null,
  } | null,
};

export type ChangeRoleMutationVariables = {
  input: ChangeRoleInput,
};

export type ChangeRoleMutation = {
  changeRole?: string | null,
};

export type RemoveMemberFromOrganizationMutationVariables = {
  input: RemoveMemberFromOrganizationInput,
};

export type RemoveMemberFromOrganizationMutation = {
  removeMemberFromOrganization?: string | null,
};

export type InviteUserToOrganizationMutationVariables = {
  input: InviteUserToOrganizationInput,
};

export type InviteUserToOrganizationMutation = {
  inviteUserToOrganization?: string | null,
};

export type AcceptInvitationToOrganizationMutationVariables = {
  input: AcceptInvitationInput,
};

export type AcceptInvitationToOrganizationMutation = {
  acceptInvitationToOrganization?: string | null,
};

export type UpdateSubscriptionQuantityMutationVariables = {
  input: UpdateSubscriptionQuantityInput,
};

export type UpdateSubscriptionQuantityMutation = {
  updateSubscriptionQuantity?: string | null,
};

export type GenerateIssuesFromImagesJobMutationVariables = {
  input: GenerateIssuesFromImagesJobInput,
};

export type GenerateIssuesFromImagesJobMutation = {
  generateIssuesFromImagesJob?:  Array< {
    __typename: "Issue",
    id: string,
    locationId?: string | null,
    propertyId?: string | null,
    inspectionId?: string | null,
    createdInSolution?: boolean | null,
    name?: string | null,
    description?: string | null,
    note?: string | null,
    tags?: string | null,
    tagIds?: Array< string > | null,
    status?: IssueStatus | null,
    clientCreationDate?: number | null,
    localLastUpdatedTime?: number | null,
    createdBy?: string | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isPubliclySubmitted?: boolean | null,
    suggestedWorkTypeIds?: Array< string > | null,
    quickQuoteIds?: Array< string > | null,
    proposalDocLinks?:  Array< {
      __typename: "ProposalDocLink",
      name: string,
      link: string,
      date: number,
    } > | null,
    priority?: IssuePriority | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null > | null,
};

export type ListResourceAggregateUserPermissionsQueryVariables = {
  resourceType: PermissionResourceType,
  resourceId: string,
  nextToken?: string | null,
};

export type ListResourceAggregateUserPermissionsQuery = {
  listResourceAggregateUserPermissions?:  {
    __typename: "ListResourceAggregateUserPermissionsOutput",
    items?:  Array< {
      __typename: "AggregateUserPermissions",
      userId?: string | null,
      username?: string | null,
      permissions?: Array< PermissionType | null > | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetAttachmentQueryVariables = {
  id: string,
};

export type GetAttachmentQuery = {
  getAttachment?:  {
    __typename: "Attachment",
    id: string,
    name?: string | null,
    type?: AttachmentType | null,
    parentId: string,
    parentType?: PermissionResourceType | null,
    propertyId?: string | null,
    key?: string | null,
    localCreatedAtTime?: number | null,
    status?: string | null,
    imageSource?: ImageSource | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAttachmentsQueryVariables = {
  id?: string | null,
  filter?: ModelAttachmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAttachmentsQuery = {
  listAttachments?:  {
    __typename: "ModelAttachmentConnection",
    items:  Array< {
      __typename: "Attachment",
      id: string,
      name?: string | null,
      type?: AttachmentType | null,
      parentId: string,
      parentType?: PermissionResourceType | null,
      propertyId?: string | null,
      key?: string | null,
      localCreatedAtTime?: number | null,
      status?: string | null,
      imageSource?: ImageSource | null,
      opaqueSyncReconciliationToken?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAttachmentsQueryVariables = {
  filter?: ModelAttachmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAttachmentsQuery = {
  syncAttachments?:  {
    __typename: "ModelAttachmentConnection",
    items:  Array< {
      __typename: "Attachment",
      id: string,
      name?: string | null,
      type?: AttachmentType | null,
      parentId: string,
      parentType?: PermissionResourceType | null,
      propertyId?: string | null,
      key?: string | null,
      localCreatedAtTime?: number | null,
      status?: string | null,
      imageSource?: ImageSource | null,
      opaqueSyncReconciliationToken?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListAttachmentsByParentQueryVariables = {
  parentId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAttachmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAttachmentsByParentQuery = {
  listAttachmentsByParent?:  {
    __typename: "ModelAttachmentConnection",
    items:  Array< {
      __typename: "Attachment",
      id: string,
      name?: string | null,
      type?: AttachmentType | null,
      parentId: string,
      parentType?: PermissionResourceType | null,
      propertyId?: string | null,
      key?: string | null,
      localCreatedAtTime?: number | null,
      status?: string | null,
      imageSource?: ImageSource | null,
      opaqueSyncReconciliationToken?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListAttachmentsByPropertyQueryVariables = {
  propertyId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAttachmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAttachmentsByPropertyQuery = {
  listAttachmentsByProperty?:  {
    __typename: "ModelAttachmentConnection",
    items:  Array< {
      __typename: "Attachment",
      id: string,
      name?: string | null,
      type?: AttachmentType | null,
      parentId: string,
      parentType?: PermissionResourceType | null,
      propertyId?: string | null,
      key?: string | null,
      localCreatedAtTime?: number | null,
      status?: string | null,
      imageSource?: ImageSource | null,
      opaqueSyncReconciliationToken?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetBiddingContactQueryVariables = {
  id: string,
};

export type GetBiddingContactQuery = {
  getBiddingContact?:  {
    __typename: "BiddingContact",
    id: string,
    email: string,
    ownerEntityId?: string | null,
    contactEntityId?: string | null,
    name?: string | null,
    privateDescription?: string | null,
    publicDescription?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListBiddingContactsQueryVariables = {
  id?: string | null,
  filter?: ModelBiddingContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBiddingContactsQuery = {
  listBiddingContacts?:  {
    __typename: "ModelBiddingContactConnection",
    items:  Array< {
      __typename: "BiddingContact",
      id: string,
      email: string,
      ownerEntityId?: string | null,
      contactEntityId?: string | null,
      name?: string | null,
      privateDescription?: string | null,
      publicDescription?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncBiddingContactsQueryVariables = {
  filter?: ModelBiddingContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncBiddingContactsQuery = {
  syncBiddingContacts?:  {
    __typename: "ModelBiddingContactConnection",
    items:  Array< {
      __typename: "BiddingContact",
      id: string,
      email: string,
      ownerEntityId?: string | null,
      contactEntityId?: string | null,
      name?: string | null,
      privateDescription?: string | null,
      publicDescription?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListBiddingContactsByOwnerEntityIdQueryVariables = {
  ownerEntityId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelBiddingContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBiddingContactsByOwnerEntityIdQuery = {
  listBiddingContactsByOwnerEntityId?:  {
    __typename: "ModelBiddingContactConnection",
    items:  Array< {
      __typename: "BiddingContact",
      id: string,
      email: string,
      ownerEntityId?: string | null,
      contactEntityId?: string | null,
      name?: string | null,
      privateDescription?: string | null,
      publicDescription?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetBidInvitationQueryVariables = {
  id: string,
};

export type GetBidInvitationQuery = {
  getBidInvitation?:  {
    __typename: "BidInvitation",
    id: string,
    biddingContactId?: string | null,
    tenderId?: string | null,
    ownerEntityId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListBidInvitationsQueryVariables = {
  id?: string | null,
  filter?: ModelBidInvitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBidInvitationsQuery = {
  listBidInvitations?:  {
    __typename: "ModelBidInvitationConnection",
    items:  Array< {
      __typename: "BidInvitation",
      id: string,
      biddingContactId?: string | null,
      tenderId?: string | null,
      ownerEntityId?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncBidInvitationsQueryVariables = {
  filter?: ModelBidInvitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncBidInvitationsQuery = {
  syncBidInvitations?:  {
    __typename: "ModelBidInvitationConnection",
    items:  Array< {
      __typename: "BidInvitation",
      id: string,
      biddingContactId?: string | null,
      tenderId?: string | null,
      ownerEntityId?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListBidInvitationsByTenderIdQueryVariables = {
  tenderId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelBidInvitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBidInvitationsByTenderIdQuery = {
  listBidInvitationsByTenderId?:  {
    __typename: "ModelBidInvitationConnection",
    items:  Array< {
      __typename: "BidInvitation",
      id: string,
      biddingContactId?: string | null,
      tenderId?: string | null,
      ownerEntityId?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetBidQueryVariables = {
  id: string,
};

export type GetBidQuery = {
  getBid?:  {
    __typename: "Bid",
    id: string,
    tenderId?: string | null,
    latestMinorVersion?: number | null,
    latestAcceptedMinorVersion?: number | null,
    latestSubmittedMinorVersion?: number | null,
    status?: BidStatus | null,
    bidNumber?: number | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListBidsQueryVariables = {
  id?: string | null,
  filter?: ModelBidFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBidsQuery = {
  listBids?:  {
    __typename: "ModelBidConnection",
    items:  Array< {
      __typename: "Bid",
      id: string,
      tenderId?: string | null,
      latestMinorVersion?: number | null,
      latestAcceptedMinorVersion?: number | null,
      latestSubmittedMinorVersion?: number | null,
      status?: BidStatus | null,
      bidNumber?: number | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncBidsQueryVariables = {
  filter?: ModelBidFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncBidsQuery = {
  syncBids?:  {
    __typename: "ModelBidConnection",
    items:  Array< {
      __typename: "Bid",
      id: string,
      tenderId?: string | null,
      latestMinorVersion?: number | null,
      latestAcceptedMinorVersion?: number | null,
      latestSubmittedMinorVersion?: number | null,
      status?: BidStatus | null,
      bidNumber?: number | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListBidsByTenderIdQueryVariables = {
  tenderId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelBidFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBidsByTenderIdQuery = {
  listBidsByTenderId?:  {
    __typename: "ModelBidConnection",
    items:  Array< {
      __typename: "Bid",
      id: string,
      tenderId?: string | null,
      latestMinorVersion?: number | null,
      latestAcceptedMinorVersion?: number | null,
      latestSubmittedMinorVersion?: number | null,
      status?: BidStatus | null,
      bidNumber?: number | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListBidsByCreatedByQueryVariables = {
  createdBy: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelBidFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBidsByCreatedByQuery = {
  listBidsByCreatedBy?:  {
    __typename: "ModelBidConnection",
    items:  Array< {
      __typename: "Bid",
      id: string,
      tenderId?: string | null,
      latestMinorVersion?: number | null,
      latestAcceptedMinorVersion?: number | null,
      latestSubmittedMinorVersion?: number | null,
      status?: BidStatus | null,
      bidNumber?: number | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetBidMinorVersionQueryVariables = {
  id: string,
};

export type GetBidMinorVersionQuery = {
  getBidMinorVersion?:  {
    __typename: "BidMinorVersion",
    id: string,
    bidId?: string | null,
    minorVersion?: number | null,
    tenderId?: string | null,
    tenderMinorVersion?: number | null,
    proposalId?: string | null,
    status?: DocumentStatus | null,
    metadata?:  {
      __typename: "BidMetadata",
      bidderContactName?: string | null,
      bidderContactEmail?: string | null,
      bidderCompanyName?: string | null,
      bidderContactAddress?: string | null,
      bidderContactPhoneNumber?: string | null,
      bidderWebsite?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListBidMinorVersionsQueryVariables = {
  id?: string | null,
  filter?: ModelBidMinorVersionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListBidMinorVersionsQuery = {
  listBidMinorVersions?:  {
    __typename: "ModelBidMinorVersionConnection",
    items:  Array< {
      __typename: "BidMinorVersion",
      id: string,
      bidId?: string | null,
      minorVersion?: number | null,
      tenderId?: string | null,
      tenderMinorVersion?: number | null,
      proposalId?: string | null,
      status?: DocumentStatus | null,
      metadata?:  {
        __typename: "BidMetadata",
        bidderContactName?: string | null,
        bidderContactEmail?: string | null,
        bidderCompanyName?: string | null,
        bidderContactAddress?: string | null,
        bidderContactPhoneNumber?: string | null,
        bidderWebsite?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncBidMinorVersionsQueryVariables = {
  filter?: ModelBidMinorVersionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncBidMinorVersionsQuery = {
  syncBidMinorVersions?:  {
    __typename: "ModelBidMinorVersionConnection",
    items:  Array< {
      __typename: "BidMinorVersion",
      id: string,
      bidId?: string | null,
      minorVersion?: number | null,
      tenderId?: string | null,
      tenderMinorVersion?: number | null,
      proposalId?: string | null,
      status?: DocumentStatus | null,
      metadata?:  {
        __typename: "BidMetadata",
        bidderContactName?: string | null,
        bidderContactEmail?: string | null,
        bidderCompanyName?: string | null,
        bidderContactAddress?: string | null,
        bidderContactPhoneNumber?: string | null,
        bidderWebsite?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListBidMinorVersionsByBidIdQueryVariables = {
  bidId: string,
  minorVersion?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelBidMinorVersionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBidMinorVersionsByBidIdQuery = {
  listBidMinorVersionsByBidId?:  {
    __typename: "ModelBidMinorVersionConnection",
    items:  Array< {
      __typename: "BidMinorVersion",
      id: string,
      bidId?: string | null,
      minorVersion?: number | null,
      tenderId?: string | null,
      tenderMinorVersion?: number | null,
      proposalId?: string | null,
      status?: DocumentStatus | null,
      metadata?:  {
        __typename: "BidMetadata",
        bidderContactName?: string | null,
        bidderContactEmail?: string | null,
        bidderCompanyName?: string | null,
        bidderContactAddress?: string | null,
        bidderContactPhoneNumber?: string | null,
        bidderWebsite?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetClientLogQueryVariables = {
  id: string,
};

export type GetClientLogQuery = {
  getClientLog?:  {
    __typename: "ClientLog",
    id: string,
    userId?: string | null,
    userAgent?: string | null,
    severityLevel: LogSeverityLevel,
    componentName: string,
    message?: string | null,
    details?: string | null,
    tags?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListClientLogsQueryVariables = {
  id?: string | null,
  filter?: ModelClientLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListClientLogsQuery = {
  listClientLogs?:  {
    __typename: "ModelClientLogConnection",
    items:  Array< {
      __typename: "ClientLog",
      id: string,
      userId?: string | null,
      userAgent?: string | null,
      severityLevel: LogSeverityLevel,
      componentName: string,
      message?: string | null,
      details?: string | null,
      tags?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncClientLogsQueryVariables = {
  filter?: ModelClientLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncClientLogsQuery = {
  syncClientLogs?:  {
    __typename: "ModelClientLogConnection",
    items:  Array< {
      __typename: "ClientLog",
      id: string,
      userId?: string | null,
      userAgent?: string | null,
      severityLevel: LogSeverityLevel,
      componentName: string,
      message?: string | null,
      details?: string | null,
      tags?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListClientLogsByUserIdQueryVariables = {
  userId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelClientLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListClientLogsByUserIdQuery = {
  listClientLogsByUserId?:  {
    __typename: "ModelClientLogConnection",
    items:  Array< {
      __typename: "ClientLog",
      id: string,
      userId?: string | null,
      userAgent?: string | null,
      severityLevel: LogSeverityLevel,
      componentName: string,
      message?: string | null,
      details?: string | null,
      tags?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetCounterQueryVariables = {
  id: string,
};

export type GetCounterQuery = {
  getCounter?:  {
    __typename: "Counter",
    id: string,
    type: ResourceType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListCountersQueryVariables = {
  filter?: ModelCounterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCountersQuery = {
  listCounters?:  {
    __typename: "ModelCounterConnection",
    items:  Array< {
      __typename: "Counter",
      id: string,
      type: ResourceType,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncCountersQueryVariables = {
  filter?: ModelCounterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncCountersQuery = {
  syncCounters?:  {
    __typename: "ModelCounterConnection",
    items:  Array< {
      __typename: "Counter",
      id: string,
      type: ResourceType,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetDesignDocumentQueryVariables = {
  id: string,
};

export type GetDesignDocumentQuery = {
  getDesignDocument?:  {
    __typename: "DesignDocument",
    id: string,
    designDocumentGroupId?: string | null,
    propertyId: string,
    projectId: string,
    name: string,
    status?: DesignDocumentStatus | null,
    lastEvaluatedValidityStatus?: boolean | null,
    uploadStatus?: string | null,
    documentKey?: string | null,
    lastWorkScopeSpecificationItemNumber?: number | null,
    version?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListDesignDocumentsQueryVariables = {
  id?: string | null,
  filter?: ModelDesignDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListDesignDocumentsQuery = {
  listDesignDocuments?:  {
    __typename: "ModelDesignDocumentConnection",
    items:  Array< {
      __typename: "DesignDocument",
      id: string,
      designDocumentGroupId?: string | null,
      propertyId: string,
      projectId: string,
      name: string,
      status?: DesignDocumentStatus | null,
      lastEvaluatedValidityStatus?: boolean | null,
      uploadStatus?: string | null,
      documentKey?: string | null,
      lastWorkScopeSpecificationItemNumber?: number | null,
      version?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncDesignDocumentsQueryVariables = {
  filter?: ModelDesignDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncDesignDocumentsQuery = {
  syncDesignDocuments?:  {
    __typename: "ModelDesignDocumentConnection",
    items:  Array< {
      __typename: "DesignDocument",
      id: string,
      designDocumentGroupId?: string | null,
      propertyId: string,
      projectId: string,
      name: string,
      status?: DesignDocumentStatus | null,
      lastEvaluatedValidityStatus?: boolean | null,
      uploadStatus?: string | null,
      documentKey?: string | null,
      lastWorkScopeSpecificationItemNumber?: number | null,
      version?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListDesignDocumentsByGroupByVersionQueryVariables = {
  designDocumentGroupId: string,
  version?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDesignDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDesignDocumentsByGroupByVersionQuery = {
  listDesignDocumentsByGroupByVersion?:  {
    __typename: "ModelDesignDocumentConnection",
    items:  Array< {
      __typename: "DesignDocument",
      id: string,
      designDocumentGroupId?: string | null,
      propertyId: string,
      projectId: string,
      name: string,
      status?: DesignDocumentStatus | null,
      lastEvaluatedValidityStatus?: boolean | null,
      uploadStatus?: string | null,
      documentKey?: string | null,
      lastWorkScopeSpecificationItemNumber?: number | null,
      version?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListDesignDocumentsByGroupByStatusQueryVariables = {
  designDocumentGroupId: string,
  status?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDesignDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDesignDocumentsByGroupByStatusQuery = {
  listDesignDocumentsByGroupByStatus?:  {
    __typename: "ModelDesignDocumentConnection",
    items:  Array< {
      __typename: "DesignDocument",
      id: string,
      designDocumentGroupId?: string | null,
      propertyId: string,
      projectId: string,
      name: string,
      status?: DesignDocumentStatus | null,
      lastEvaluatedValidityStatus?: boolean | null,
      uploadStatus?: string | null,
      documentKey?: string | null,
      lastWorkScopeSpecificationItemNumber?: number | null,
      version?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListDesignDocumentsByPropertyQueryVariables = {
  propertyId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDesignDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDesignDocumentsByPropertyQuery = {
  listDesignDocumentsByProperty?:  {
    __typename: "ModelDesignDocumentConnection",
    items:  Array< {
      __typename: "DesignDocument",
      id: string,
      designDocumentGroupId?: string | null,
      propertyId: string,
      projectId: string,
      name: string,
      status?: DesignDocumentStatus | null,
      lastEvaluatedValidityStatus?: boolean | null,
      uploadStatus?: string | null,
      documentKey?: string | null,
      lastWorkScopeSpecificationItemNumber?: number | null,
      version?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListDesignDocumentsByProjectQueryVariables = {
  projectId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDesignDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDesignDocumentsByProjectQuery = {
  listDesignDocumentsByProject?:  {
    __typename: "ModelDesignDocumentConnection",
    items:  Array< {
      __typename: "DesignDocument",
      id: string,
      designDocumentGroupId?: string | null,
      propertyId: string,
      projectId: string,
      name: string,
      status?: DesignDocumentStatus | null,
      lastEvaluatedValidityStatus?: boolean | null,
      uploadStatus?: string | null,
      documentKey?: string | null,
      lastWorkScopeSpecificationItemNumber?: number | null,
      version?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetDesignDocumentGroupQueryVariables = {
  id: string,
};

export type GetDesignDocumentGroupQuery = {
  getDesignDocumentGroup?:  {
    __typename: "DesignDocumentGroup",
    id: string,
    projectId: string,
    propertyId: string,
    name: string,
    latestDocumentVersion: number,
    documentContentKey?: string | null,
    solutionGroupNumber?: number | null,
    isLocked: boolean,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListDesignDocumentGroupsQueryVariables = {
  id?: string | null,
  filter?: ModelDesignDocumentGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListDesignDocumentGroupsQuery = {
  listDesignDocumentGroups?:  {
    __typename: "ModelDesignDocumentGroupConnection",
    items:  Array< {
      __typename: "DesignDocumentGroup",
      id: string,
      projectId: string,
      propertyId: string,
      name: string,
      latestDocumentVersion: number,
      documentContentKey?: string | null,
      solutionGroupNumber?: number | null,
      isLocked: boolean,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncDesignDocumentGroupsQueryVariables = {
  filter?: ModelDesignDocumentGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncDesignDocumentGroupsQuery = {
  syncDesignDocumentGroups?:  {
    __typename: "ModelDesignDocumentGroupConnection",
    items:  Array< {
      __typename: "DesignDocumentGroup",
      id: string,
      projectId: string,
      propertyId: string,
      name: string,
      latestDocumentVersion: number,
      documentContentKey?: string | null,
      solutionGroupNumber?: number | null,
      isLocked: boolean,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListDesignDocumentGroupsByProjectQueryVariables = {
  projectId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDesignDocumentGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDesignDocumentGroupsByProjectQuery = {
  listDesignDocumentGroupsByProject?:  {
    __typename: "ModelDesignDocumentGroupConnection",
    items:  Array< {
      __typename: "DesignDocumentGroup",
      id: string,
      projectId: string,
      propertyId: string,
      name: string,
      latestDocumentVersion: number,
      documentContentKey?: string | null,
      solutionGroupNumber?: number | null,
      isLocked: boolean,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListDesignDocumentGroupsByPropertyQueryVariables = {
  propertyId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDesignDocumentGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDesignDocumentGroupsByPropertyQuery = {
  listDesignDocumentGroupsByProperty?:  {
    __typename: "ModelDesignDocumentGroupConnection",
    items:  Array< {
      __typename: "DesignDocumentGroup",
      id: string,
      projectId: string,
      propertyId: string,
      name: string,
      latestDocumentVersion: number,
      documentContentKey?: string | null,
      solutionGroupNumber?: number | null,
      isLocked: boolean,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetDimensionQueryVariables = {
  id: string,
};

export type GetDimensionQuery = {
  getDimension?:  {
    __typename: "Dimension",
    id: string,
    parentId?: string | null,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    description?: string | null,
    length?: number | null,
    lengthUnit?: string | null,
    width?: number | null,
    widthUnit?: string | null,
    dimensionType?: DimensionType | null,
    measurementUnit?: MeasurementUnit | null,
    measurement?:  {
      __typename: "Measurement",
      length?: number | null,
      width?: number | null,
      dimensionType?: DimensionType | null,
      measurementUnit?: MeasurementUnit | null,
    } | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListDimensionsQueryVariables = {
  id?: string | null,
  filter?: ModelDimensionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListDimensionsQuery = {
  listDimensions?:  {
    __typename: "ModelDimensionConnection",
    items:  Array< {
      __typename: "Dimension",
      id: string,
      parentId?: string | null,
      propertyId?: string | null,
      createdInSolution?: boolean | null,
      description?: string | null,
      length?: number | null,
      lengthUnit?: string | null,
      width?: number | null,
      widthUnit?: string | null,
      dimensionType?: DimensionType | null,
      measurementUnit?: MeasurementUnit | null,
      measurement?:  {
        __typename: "Measurement",
        length?: number | null,
        width?: number | null,
        dimensionType?: DimensionType | null,
        measurementUnit?: MeasurementUnit | null,
      } | null,
      localLastUpdatedTime?: number | null,
      opaqueSyncReconciliationToken?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncDimensionsQueryVariables = {
  filter?: ModelDimensionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncDimensionsQuery = {
  syncDimensions?:  {
    __typename: "ModelDimensionConnection",
    items:  Array< {
      __typename: "Dimension",
      id: string,
      parentId?: string | null,
      propertyId?: string | null,
      createdInSolution?: boolean | null,
      description?: string | null,
      length?: number | null,
      lengthUnit?: string | null,
      width?: number | null,
      widthUnit?: string | null,
      dimensionType?: DimensionType | null,
      measurementUnit?: MeasurementUnit | null,
      measurement?:  {
        __typename: "Measurement",
        length?: number | null,
        width?: number | null,
        dimensionType?: DimensionType | null,
        measurementUnit?: MeasurementUnit | null,
      } | null,
      localLastUpdatedTime?: number | null,
      opaqueSyncReconciliationToken?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListDimensionsByParentQueryVariables = {
  parentId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDimensionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDimensionsByParentQuery = {
  listDimensionsByParent?:  {
    __typename: "ModelDimensionConnection",
    items:  Array< {
      __typename: "Dimension",
      id: string,
      parentId?: string | null,
      propertyId?: string | null,
      createdInSolution?: boolean | null,
      description?: string | null,
      length?: number | null,
      lengthUnit?: string | null,
      width?: number | null,
      widthUnit?: string | null,
      dimensionType?: DimensionType | null,
      measurementUnit?: MeasurementUnit | null,
      measurement?:  {
        __typename: "Measurement",
        length?: number | null,
        width?: number | null,
        dimensionType?: DimensionType | null,
        measurementUnit?: MeasurementUnit | null,
      } | null,
      localLastUpdatedTime?: number | null,
      opaqueSyncReconciliationToken?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListDimensionsByPropertyQueryVariables = {
  propertyId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDimensionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDimensionsByPropertyQuery = {
  listDimensionsByProperty?:  {
    __typename: "ModelDimensionConnection",
    items:  Array< {
      __typename: "Dimension",
      id: string,
      parentId?: string | null,
      propertyId?: string | null,
      createdInSolution?: boolean | null,
      description?: string | null,
      length?: number | null,
      lengthUnit?: string | null,
      width?: number | null,
      widthUnit?: string | null,
      dimensionType?: DimensionType | null,
      measurementUnit?: MeasurementUnit | null,
      measurement?:  {
        __typename: "Measurement",
        length?: number | null,
        width?: number | null,
        dimensionType?: DimensionType | null,
        measurementUnit?: MeasurementUnit | null,
      } | null,
      localLastUpdatedTime?: number | null,
      opaqueSyncReconciliationToken?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetDiscoverableWorkTypesQueryVariables = {
  id: string,
};

export type GetDiscoverableWorkTypesQuery = {
  getDiscoverableWorkTypes?:  {
    __typename: "DiscoverableWorkTypes",
    id: string,
    workTypeGroupId: string,
    defaultVersion: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListDiscoverableWorkTypesQueryVariables = {
  id?: string | null,
  filter?: ModelDiscoverableWorkTypesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListDiscoverableWorkTypesQuery = {
  listDiscoverableWorkTypes?:  {
    __typename: "ModelDiscoverableWorkTypesConnection",
    items:  Array< {
      __typename: "DiscoverableWorkTypes",
      id: string,
      workTypeGroupId: string,
      defaultVersion: number,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncDiscoverableWorkTypesQueryVariables = {
  filter?: ModelDiscoverableWorkTypesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncDiscoverableWorkTypesQuery = {
  syncDiscoverableWorkTypes?:  {
    __typename: "ModelDiscoverableWorkTypesConnection",
    items:  Array< {
      __typename: "DiscoverableWorkTypes",
      id: string,
      workTypeGroupId: string,
      defaultVersion: number,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetEntityResourcePermissionQueryVariables = {
  id: string,
};

export type GetEntityResourcePermissionQuery = {
  getEntityResourcePermission?:  {
    __typename: "EntityResourcePermission",
    id: string,
    propertyId?: string | null,
    entityId?: string | null,
    entityType?: PermissionEntityType | null,
    resourceId?: string | null,
    resourceType?: PermissionResourceType | null,
    permissionType?: PermissionType | null,
    isGranted?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListEntityResourcePermissionsQueryVariables = {
  id?: string | null,
  filter?: ModelEntityResourcePermissionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListEntityResourcePermissionsQuery = {
  listEntityResourcePermissions?:  {
    __typename: "ModelEntityResourcePermissionConnection",
    items:  Array< {
      __typename: "EntityResourcePermission",
      id: string,
      propertyId?: string | null,
      entityId?: string | null,
      entityType?: PermissionEntityType | null,
      resourceId?: string | null,
      resourceType?: PermissionResourceType | null,
      permissionType?: PermissionType | null,
      isGranted?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncEntityResourcePermissionsQueryVariables = {
  filter?: ModelEntityResourcePermissionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncEntityResourcePermissionsQuery = {
  syncEntityResourcePermissions?:  {
    __typename: "ModelEntityResourcePermissionConnection",
    items:  Array< {
      __typename: "EntityResourcePermission",
      id: string,
      propertyId?: string | null,
      entityId?: string | null,
      entityType?: PermissionEntityType | null,
      resourceId?: string | null,
      resourceType?: PermissionResourceType | null,
      permissionType?: PermissionType | null,
      isGranted?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListEntityResourcePermissionByEntityIdByResourceIdQueryVariables = {
  entityId: string,
  resourceId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEntityResourcePermissionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEntityResourcePermissionByEntityIdByResourceIdQuery = {
  listEntityResourcePermissionByEntityIdByResourceId?:  {
    __typename: "ModelEntityResourcePermissionConnection",
    items:  Array< {
      __typename: "EntityResourcePermission",
      id: string,
      propertyId?: string | null,
      entityId?: string | null,
      entityType?: PermissionEntityType | null,
      resourceId?: string | null,
      resourceType?: PermissionResourceType | null,
      permissionType?: PermissionType | null,
      isGranted?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListEntityResourcePermissionByResourceIdQueryVariables = {
  resourceId: string,
  resourceType?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEntityResourcePermissionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEntityResourcePermissionByResourceIdQuery = {
  listEntityResourcePermissionByResourceId?:  {
    __typename: "ModelEntityResourcePermissionConnection",
    items:  Array< {
      __typename: "EntityResourcePermission",
      id: string,
      propertyId?: string | null,
      entityId?: string | null,
      entityType?: PermissionEntityType | null,
      resourceId?: string | null,
      resourceType?: PermissionResourceType | null,
      permissionType?: PermissionType | null,
      isGranted?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetEntityWorkTypeAssociationQueryVariables = {
  id: string,
};

export type GetEntityWorkTypeAssociationQuery = {
  getEntityWorkTypeAssociation?:  {
    __typename: "EntityWorkTypeAssociation",
    id: string,
    entityId: string,
    entityType: WorkTypeAssociationScopeEntity,
    workTypeGroupId: string,
    workTypeVersion?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListEntityWorkTypeAssociationsQueryVariables = {
  filter?: ModelEntityWorkTypeAssociationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEntityWorkTypeAssociationsQuery = {
  listEntityWorkTypeAssociations?:  {
    __typename: "ModelEntityWorkTypeAssociationConnection",
    items:  Array< {
      __typename: "EntityWorkTypeAssociation",
      id: string,
      entityId: string,
      entityType: WorkTypeAssociationScopeEntity,
      workTypeGroupId: string,
      workTypeVersion?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncEntityWorkTypeAssociationsQueryVariables = {
  filter?: ModelEntityWorkTypeAssociationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncEntityWorkTypeAssociationsQuery = {
  syncEntityWorkTypeAssociations?:  {
    __typename: "ModelEntityWorkTypeAssociationConnection",
    items:  Array< {
      __typename: "EntityWorkTypeAssociation",
      id: string,
      entityId: string,
      entityType: WorkTypeAssociationScopeEntity,
      workTypeGroupId: string,
      workTypeVersion?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListEntityWorkTypeAssociationsByEntityIdByWorkTypeGroupIdQueryVariables = {
  entityId: string,
  workTypeGroupId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEntityWorkTypeAssociationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEntityWorkTypeAssociationsByEntityIdByWorkTypeGroupIdQuery = {
  listEntityWorkTypeAssociationsByEntityIdByWorkTypeGroupId?:  {
    __typename: "ModelEntityWorkTypeAssociationConnection",
    items:  Array< {
      __typename: "EntityWorkTypeAssociation",
      id: string,
      entityId: string,
      entityType: WorkTypeAssociationScopeEntity,
      workTypeGroupId: string,
      workTypeVersion?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetInspectionQueryVariables = {
  id: string,
};

export type GetInspectionQuery = {
  getInspection?:  {
    __typename: "Inspection",
    id: string,
    propertyId: string,
    createdByOrganizationId: string,
    createdByUserId: string,
    startTime: number,
    endTime?: number | null,
    status: InspectionStatus,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListInspectionsQueryVariables = {
  id?: string | null,
  filter?: ModelInspectionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListInspectionsQuery = {
  listInspections?:  {
    __typename: "ModelInspectionConnection",
    items:  Array< {
      __typename: "Inspection",
      id: string,
      propertyId: string,
      createdByOrganizationId: string,
      createdByUserId: string,
      startTime: number,
      endTime?: number | null,
      status: InspectionStatus,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncInspectionsQueryVariables = {
  filter?: ModelInspectionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncInspectionsQuery = {
  syncInspections?:  {
    __typename: "ModelInspectionConnection",
    items:  Array< {
      __typename: "Inspection",
      id: string,
      propertyId: string,
      createdByOrganizationId: string,
      createdByUserId: string,
      startTime: number,
      endTime?: number | null,
      status: InspectionStatus,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetIssueQueryVariables = {
  id: string,
};

export type GetIssueQuery = {
  getIssue?:  {
    __typename: "Issue",
    id: string,
    locationId?: string | null,
    propertyId?: string | null,
    inspectionId?: string | null,
    createdInSolution?: boolean | null,
    name?: string | null,
    description?: string | null,
    note?: string | null,
    tags?: string | null,
    tagIds?: Array< string > | null,
    status?: IssueStatus | null,
    clientCreationDate?: number | null,
    localLastUpdatedTime?: number | null,
    createdBy?: string | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isPubliclySubmitted?: boolean | null,
    suggestedWorkTypeIds?: Array< string > | null,
    quickQuoteIds?: Array< string > | null,
    proposalDocLinks?:  Array< {
      __typename: "ProposalDocLink",
      name: string,
      link: string,
      date: number,
    } > | null,
    priority?: IssuePriority | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListIssuesQueryVariables = {
  id?: string | null,
  filter?: ModelIssueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListIssuesQuery = {
  listIssues?:  {
    __typename: "ModelIssueConnection",
    items:  Array< {
      __typename: "Issue",
      id: string,
      locationId?: string | null,
      propertyId?: string | null,
      inspectionId?: string | null,
      createdInSolution?: boolean | null,
      name?: string | null,
      description?: string | null,
      note?: string | null,
      tags?: string | null,
      tagIds?: Array< string > | null,
      status?: IssueStatus | null,
      clientCreationDate?: number | null,
      localLastUpdatedTime?: number | null,
      createdBy?: string | null,
      opaqueSyncReconciliationToken?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      isPubliclySubmitted?: boolean | null,
      suggestedWorkTypeIds?: Array< string > | null,
      quickQuoteIds?: Array< string > | null,
      proposalDocLinks?:  Array< {
        __typename: "ProposalDocLink",
        name: string,
        link: string,
        date: number,
      } > | null,
      priority?: IssuePriority | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncIssuesQueryVariables = {
  filter?: ModelIssueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncIssuesQuery = {
  syncIssues?:  {
    __typename: "ModelIssueConnection",
    items:  Array< {
      __typename: "Issue",
      id: string,
      locationId?: string | null,
      propertyId?: string | null,
      inspectionId?: string | null,
      createdInSolution?: boolean | null,
      name?: string | null,
      description?: string | null,
      note?: string | null,
      tags?: string | null,
      tagIds?: Array< string > | null,
      status?: IssueStatus | null,
      clientCreationDate?: number | null,
      localLastUpdatedTime?: number | null,
      createdBy?: string | null,
      opaqueSyncReconciliationToken?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      isPubliclySubmitted?: boolean | null,
      suggestedWorkTypeIds?: Array< string > | null,
      quickQuoteIds?: Array< string > | null,
      proposalDocLinks?:  Array< {
        __typename: "ProposalDocLink",
        name: string,
        link: string,
        date: number,
      } > | null,
      priority?: IssuePriority | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListIssuesByLocationQueryVariables = {
  locationId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelIssueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListIssuesByLocationQuery = {
  listIssuesByLocation?:  {
    __typename: "ModelIssueConnection",
    items:  Array< {
      __typename: "Issue",
      id: string,
      locationId?: string | null,
      propertyId?: string | null,
      inspectionId?: string | null,
      createdInSolution?: boolean | null,
      name?: string | null,
      description?: string | null,
      note?: string | null,
      tags?: string | null,
      tagIds?: Array< string > | null,
      status?: IssueStatus | null,
      clientCreationDate?: number | null,
      localLastUpdatedTime?: number | null,
      createdBy?: string | null,
      opaqueSyncReconciliationToken?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      isPubliclySubmitted?: boolean | null,
      suggestedWorkTypeIds?: Array< string > | null,
      quickQuoteIds?: Array< string > | null,
      proposalDocLinks?:  Array< {
        __typename: "ProposalDocLink",
        name: string,
        link: string,
        date: number,
      } > | null,
      priority?: IssuePriority | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListIssuesByPropertyQueryVariables = {
  propertyId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelIssueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListIssuesByPropertyQuery = {
  listIssuesByProperty?:  {
    __typename: "ModelIssueConnection",
    items:  Array< {
      __typename: "Issue",
      id: string,
      locationId?: string | null,
      propertyId?: string | null,
      inspectionId?: string | null,
      createdInSolution?: boolean | null,
      name?: string | null,
      description?: string | null,
      note?: string | null,
      tags?: string | null,
      tagIds?: Array< string > | null,
      status?: IssueStatus | null,
      clientCreationDate?: number | null,
      localLastUpdatedTime?: number | null,
      createdBy?: string | null,
      opaqueSyncReconciliationToken?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      isPubliclySubmitted?: boolean | null,
      suggestedWorkTypeIds?: Array< string > | null,
      quickQuoteIds?: Array< string > | null,
      proposalDocLinks?:  Array< {
        __typename: "ProposalDocLink",
        name: string,
        link: string,
        date: number,
      } > | null,
      priority?: IssuePriority | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListIssuesByInspectionQueryVariables = {
  inspectionId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelIssueFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListIssuesByInspectionQuery = {
  listIssuesByInspection?:  {
    __typename: "ModelIssueConnection",
    items:  Array< {
      __typename: "Issue",
      id: string,
      locationId?: string | null,
      propertyId?: string | null,
      inspectionId?: string | null,
      createdInSolution?: boolean | null,
      name?: string | null,
      description?: string | null,
      note?: string | null,
      tags?: string | null,
      tagIds?: Array< string > | null,
      status?: IssueStatus | null,
      clientCreationDate?: number | null,
      localLastUpdatedTime?: number | null,
      createdBy?: string | null,
      opaqueSyncReconciliationToken?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      isPubliclySubmitted?: boolean | null,
      suggestedWorkTypeIds?: Array< string > | null,
      quickQuoteIds?: Array< string > | null,
      proposalDocLinks?:  Array< {
        __typename: "ProposalDocLink",
        name: string,
        link: string,
        date: number,
      } > | null,
      priority?: IssuePriority | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetQuickQuoteQueryVariables = {
  id: string,
};

export type GetQuickQuoteQuery = {
  getQuickQuote?:  {
    __typename: "QuickQuote",
    id: string,
    propertyId: string,
    generatedProposalId?: string | null,
    status: QuickQuoteStatus,
    generatedSolutionId?: string | null,
    issueIds?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListQuickQuotesQueryVariables = {
  id?: string | null,
  filter?: ModelQuickQuoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListQuickQuotesQuery = {
  listQuickQuotes?:  {
    __typename: "ModelQuickQuoteConnection",
    items:  Array< {
      __typename: "QuickQuote",
      id: string,
      propertyId: string,
      generatedProposalId?: string | null,
      status: QuickQuoteStatus,
      generatedSolutionId?: string | null,
      issueIds?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncQuickQuotesQueryVariables = {
  filter?: ModelQuickQuoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncQuickQuotesQuery = {
  syncQuickQuotes?:  {
    __typename: "ModelQuickQuoteConnection",
    items:  Array< {
      __typename: "QuickQuote",
      id: string,
      propertyId: string,
      generatedProposalId?: string | null,
      status: QuickQuoteStatus,
      generatedSolutionId?: string | null,
      issueIds?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListQuickQuotesByPropertyQueryVariables = {
  propertyId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelQuickQuoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListQuickQuotesByPropertyQuery = {
  listQuickQuotesByProperty?:  {
    __typename: "ModelQuickQuoteConnection",
    items:  Array< {
      __typename: "QuickQuote",
      id: string,
      propertyId: string,
      generatedProposalId?: string | null,
      status: QuickQuoteStatus,
      generatedSolutionId?: string | null,
      issueIds?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListQuickQuotesBySolutionQueryVariables = {
  generatedSolutionId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelQuickQuoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListQuickQuotesBySolutionQuery = {
  listQuickQuotesBySolution?:  {
    __typename: "ModelQuickQuoteConnection",
    items:  Array< {
      __typename: "QuickQuote",
      id: string,
      propertyId: string,
      generatedProposalId?: string | null,
      status: QuickQuoteStatus,
      generatedSolutionId?: string | null,
      issueIds?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetLocationQueryVariables = {
  id: string,
};

export type GetLocationQuery = {
  getLocation?:  {
    __typename: "Location",
    id: string,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    name?: string | null,
    tags?: string | null,
    localCreationTime?: number | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListLocationsQueryVariables = {
  id?: string | null,
  filter?: ModelLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListLocationsQuery = {
  listLocations?:  {
    __typename: "ModelLocationConnection",
    items:  Array< {
      __typename: "Location",
      id: string,
      propertyId?: string | null,
      createdInSolution?: boolean | null,
      name?: string | null,
      tags?: string | null,
      localCreationTime?: number | null,
      localLastUpdatedTime?: number | null,
      opaqueSyncReconciliationToken?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncLocationsQueryVariables = {
  filter?: ModelLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncLocationsQuery = {
  syncLocations?:  {
    __typename: "ModelLocationConnection",
    items:  Array< {
      __typename: "Location",
      id: string,
      propertyId?: string | null,
      createdInSolution?: boolean | null,
      name?: string | null,
      tags?: string | null,
      localCreationTime?: number | null,
      localLastUpdatedTime?: number | null,
      opaqueSyncReconciliationToken?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListLocationsByPropertyQueryVariables = {
  propertyId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLocationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLocationsByPropertyQuery = {
  listLocationsByProperty?:  {
    __typename: "ModelLocationConnection",
    items:  Array< {
      __typename: "Location",
      id: string,
      propertyId?: string | null,
      createdInSolution?: boolean | null,
      name?: string | null,
      tags?: string | null,
      localCreationTime?: number | null,
      localLastUpdatedTime?: number | null,
      opaqueSyncReconciliationToken?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetNoteQueryVariables = {
  id: string,
};

export type GetNoteQuery = {
  getNote?:  {
    __typename: "Note",
    id: string,
    parentId?: string | null,
    propertyId?: string | null,
    note?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListNotesQueryVariables = {
  id?: string | null,
  filter?: ModelNoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListNotesQuery = {
  listNotes?:  {
    __typename: "ModelNoteConnection",
    items:  Array< {
      __typename: "Note",
      id: string,
      parentId?: string | null,
      propertyId?: string | null,
      note?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncNotesQueryVariables = {
  filter?: ModelNoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncNotesQuery = {
  syncNotes?:  {
    __typename: "ModelNoteConnection",
    items:  Array< {
      __typename: "Note",
      id: string,
      parentId?: string | null,
      propertyId?: string | null,
      note?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListNotesByParentQueryVariables = {
  parentId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListNotesByParentQuery = {
  listNotesByParent?:  {
    __typename: "ModelNoteConnection",
    items:  Array< {
      __typename: "Note",
      id: string,
      parentId?: string | null,
      propertyId?: string | null,
      note?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListNotesByPropertyQueryVariables = {
  propertyId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListNotesByPropertyQuery = {
  listNotesByProperty?:  {
    __typename: "ModelNoteConnection",
    items:  Array< {
      __typename: "Note",
      id: string,
      parentId?: string | null,
      propertyId?: string | null,
      note?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetOrganizationQueryVariables = {
  id: string,
};

export type GetOrganizationQuery = {
  getOrganization?:  {
    __typename: "Organization",
    id: string,
    legalName: string,
    type?: OrganizationType | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListOrganizationsQueryVariables = {
  id?: string | null,
  filter?: ModelOrganizationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListOrganizationsQuery = {
  listOrganizations?:  {
    __typename: "ModelOrganizationConnection",
    items:  Array< {
      __typename: "Organization",
      id: string,
      legalName: string,
      type?: OrganizationType | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncOrganizationsQueryVariables = {
  filter?: ModelOrganizationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncOrganizationsQuery = {
  syncOrganizations?:  {
    __typename: "ModelOrganizationConnection",
    items:  Array< {
      __typename: "Organization",
      id: string,
      legalName: string,
      type?: OrganizationType | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetOrganizationBillingProfileQueryVariables = {
  organizationId: string,
};

export type GetOrganizationBillingProfileQuery = {
  getOrganizationBillingProfile?:  {
    __typename: "OrganizationBillingProfile",
    organizationId: string,
    billingProfileId: string,
    billingProvider: BillingProvider,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListOrganizationBillingProfilesQueryVariables = {
  organizationId?: string | null,
  filter?: ModelOrganizationBillingProfileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListOrganizationBillingProfilesQuery = {
  listOrganizationBillingProfiles?:  {
    __typename: "ModelOrganizationBillingProfileConnection",
    items:  Array< {
      __typename: "OrganizationBillingProfile",
      organizationId: string,
      billingProfileId: string,
      billingProvider: BillingProvider,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncOrganizationBillingProfilesQueryVariables = {
  filter?: ModelOrganizationBillingProfileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncOrganizationBillingProfilesQuery = {
  syncOrganizationBillingProfiles?:  {
    __typename: "ModelOrganizationBillingProfileConnection",
    items:  Array< {
      __typename: "OrganizationBillingProfile",
      organizationId: string,
      billingProfileId: string,
      billingProvider: BillingProvider,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTeamQueryVariables = {
  id: string,
};

export type GetTeamQuery = {
  getTeam?:  {
    __typename: "Team",
    id: string,
    organizationId: string,
    type: TeamType,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTeamsQueryVariables = {
  id?: string | null,
  filter?: ModelTeamFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTeamsQuery = {
  listTeams?:  {
    __typename: "ModelTeamConnection",
    items:  Array< {
      __typename: "Team",
      id: string,
      organizationId: string,
      type: TeamType,
      name?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTeamsQueryVariables = {
  filter?: ModelTeamFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTeamsQuery = {
  syncTeams?:  {
    __typename: "ModelTeamConnection",
    items:  Array< {
      __typename: "Team",
      id: string,
      organizationId: string,
      type: TeamType,
      name?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListTeamsByOrganizationIdQueryVariables = {
  organizationId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTeamFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTeamsByOrganizationIdQuery = {
  listTeamsByOrganizationId?:  {
    __typename: "ModelTeamConnection",
    items:  Array< {
      __typename: "Team",
      id: string,
      organizationId: string,
      type: TeamType,
      name?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTeamMemberQueryVariables = {
  id: string,
};

export type GetTeamMemberQuery = {
  getTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    teamId: string,
    organizationId: string,
    userId: string,
    joinedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTeamMembersQueryVariables = {
  id?: string | null,
  filter?: ModelTeamMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTeamMembersQuery = {
  listTeamMembers?:  {
    __typename: "ModelTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      teamId: string,
      organizationId: string,
      userId: string,
      joinedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTeamMembersQueryVariables = {
  filter?: ModelTeamMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTeamMembersQuery = {
  syncTeamMembers?:  {
    __typename: "ModelTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      teamId: string,
      organizationId: string,
      userId: string,
      joinedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListTeamMembersByTeamIdQueryVariables = {
  teamId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTeamMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTeamMembersByTeamIdQuery = {
  listTeamMembersByTeamId?:  {
    __typename: "ModelTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      teamId: string,
      organizationId: string,
      userId: string,
      joinedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListTeamMembersByUserIdQueryVariables = {
  userId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTeamMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTeamMembersByUserIdQuery = {
  listTeamMembersByUserId?:  {
    __typename: "ModelTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      teamId: string,
      organizationId: string,
      userId: string,
      joinedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAccountInvitationQueryVariables = {
  id: string,
};

export type GetAccountInvitationQuery = {
  getAccountInvitation?:  {
    __typename: "AccountInvitation",
    id: string,
    organizationId: string,
    role?: TeamType | null,
    email: string,
    expiresAt: number,
    status?: AccountInvitationStatus | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAccountInvitationsQueryVariables = {
  id?: string | null,
  filter?: ModelAccountInvitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAccountInvitationsQuery = {
  listAccountInvitations?:  {
    __typename: "ModelAccountInvitationConnection",
    items:  Array< {
      __typename: "AccountInvitation",
      id: string,
      organizationId: string,
      role?: TeamType | null,
      email: string,
      expiresAt: number,
      status?: AccountInvitationStatus | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAccountInvitationsQueryVariables = {
  filter?: ModelAccountInvitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAccountInvitationsQuery = {
  syncAccountInvitations?:  {
    __typename: "ModelAccountInvitationConnection",
    items:  Array< {
      __typename: "AccountInvitation",
      id: string,
      organizationId: string,
      role?: TeamType | null,
      email: string,
      expiresAt: number,
      status?: AccountInvitationStatus | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListAccountInvitationsByOrganizationIdQueryVariables = {
  organizationId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAccountInvitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAccountInvitationsByOrganizationIdQuery = {
  listAccountInvitationsByOrganizationId?:  {
    __typename: "ModelAccountInvitationConnection",
    items:  Array< {
      __typename: "AccountInvitation",
      id: string,
      organizationId: string,
      role?: TeamType | null,
      email: string,
      expiresAt: number,
      status?: AccountInvitationStatus | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetProjectQueryVariables = {
  id: string,
};

export type GetProjectQuery = {
  getProject?:  {
    __typename: "Project",
    id: string,
    propertyId: string,
    name: string,
    tenderNumber?: string | null,
    customer?: string | null,
    address?: string | null,
    propertyType?: string | null,
    dueDate?: string | null,
    contactName?: string | null,
    contactNumber?: string | null,
    contactEmail?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListProjectsQueryVariables = {
  id?: string | null,
  filter?: ModelProjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListProjectsQuery = {
  listProjects?:  {
    __typename: "ModelProjectConnection",
    items:  Array< {
      __typename: "Project",
      id: string,
      propertyId: string,
      name: string,
      tenderNumber?: string | null,
      customer?: string | null,
      address?: string | null,
      propertyType?: string | null,
      dueDate?: string | null,
      contactName?: string | null,
      contactNumber?: string | null,
      contactEmail?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncProjectsQueryVariables = {
  filter?: ModelProjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncProjectsQuery = {
  syncProjects?:  {
    __typename: "ModelProjectConnection",
    items:  Array< {
      __typename: "Project",
      id: string,
      propertyId: string,
      name: string,
      tenderNumber?: string | null,
      customer?: string | null,
      address?: string | null,
      propertyType?: string | null,
      dueDate?: string | null,
      contactName?: string | null,
      contactNumber?: string | null,
      contactEmail?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListDesignProjectsByPropertyQueryVariables = {
  propertyId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDesignProjectsByPropertyQuery = {
  listDesignProjectsByProperty?:  {
    __typename: "ModelProjectConnection",
    items:  Array< {
      __typename: "Project",
      id: string,
      propertyId: string,
      name: string,
      tenderNumber?: string | null,
      customer?: string | null,
      address?: string | null,
      propertyType?: string | null,
      dueDate?: string | null,
      contactName?: string | null,
      contactNumber?: string | null,
      contactEmail?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetProjectCounterQueryVariables = {
  id: string,
};

export type GetProjectCounterQuery = {
  getProjectCounter?:  {
    __typename: "ProjectCounter",
    id: string,
    propertyId: string,
    latestProjectNumber?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListProjectCountersQueryVariables = {
  id?: string | null,
  filter?: ModelProjectCounterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListProjectCountersQuery = {
  listProjectCounters?:  {
    __typename: "ModelProjectCounterConnection",
    items:  Array< {
      __typename: "ProjectCounter",
      id: string,
      propertyId: string,
      latestProjectNumber?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncProjectCountersQueryVariables = {
  filter?: ModelProjectCounterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncProjectCountersQuery = {
  syncProjectCounters?:  {
    __typename: "ModelProjectCounterConnection",
    items:  Array< {
      __typename: "ProjectCounter",
      id: string,
      propertyId: string,
      latestProjectNumber?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetProjectCounterByPropertyQueryVariables = {
  propertyId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProjectCounterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetProjectCounterByPropertyQuery = {
  getProjectCounterByProperty?:  {
    __typename: "ModelProjectCounterConnection",
    items:  Array< {
      __typename: "ProjectCounter",
      id: string,
      propertyId: string,
      latestProjectNumber?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetPropertyQueryVariables = {
  id: string,
};

export type GetPropertyQuery = {
  getProperty?:  {
    __typename: "Property",
    id: string,
    name?: string | null,
    description?: string | null,
    address?: string | null,
    ownerOrganizationId?: string | null,
    primaryContactNumber?: string | null,
    primaryContactEmail?: string | null,
    primaryContactName?: string | null,
    propertyNumber?: string | null,
    locations?:  {
      __typename: "ModelLocationConnection",
      items:  Array< {
        __typename: "Location",
        id: string,
        propertyId?: string | null,
        createdInSolution?: boolean | null,
        name?: string | null,
        tags?: string | null,
        localCreationTime?: number | null,
        localLastUpdatedTime?: number | null,
        opaqueSyncReconciliationToken?: string | null,
        canView?: string | null,
        canEdit?: string | null,
        canDelete?: string | null,
        createdBy?: string | null,
        canViewList?: Array< string | null > | null,
        canViewEntityVersionMap?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdBy?: string | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    autoDashboardRebuild?: boolean | null,
    canView?: string | null,
    canEdit?: string | null,
    canCreateSolutions?: string | null,
    canDelete?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isTestProperty?: boolean | null,
    isArchived?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListPropertiesQueryVariables = {
  id?: string | null,
  filter?: ModelPropertyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPropertiesQuery = {
  listProperties?:  {
    __typename: "ModelPropertyConnection",
    items:  Array< {
      __typename: "Property",
      id: string,
      name?: string | null,
      description?: string | null,
      address?: string | null,
      ownerOrganizationId?: string | null,
      primaryContactNumber?: string | null,
      primaryContactEmail?: string | null,
      primaryContactName?: string | null,
      propertyNumber?: string | null,
      locations?:  {
        __typename: "ModelLocationConnection",
        items:  Array< {
          __typename: "Location",
          id: string,
          propertyId?: string | null,
          createdInSolution?: boolean | null,
          name?: string | null,
          tags?: string | null,
          localCreationTime?: number | null,
          localLastUpdatedTime?: number | null,
          opaqueSyncReconciliationToken?: string | null,
          canView?: string | null,
          canEdit?: string | null,
          canDelete?: string | null,
          createdBy?: string | null,
          canViewList?: Array< string | null > | null,
          canViewEntityVersionMap?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdBy?: string | null,
      localLastUpdatedTime?: number | null,
      opaqueSyncReconciliationToken?: string | null,
      autoDashboardRebuild?: boolean | null,
      canView?: string | null,
      canEdit?: string | null,
      canCreateSolutions?: string | null,
      canDelete?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      isTestProperty?: boolean | null,
      isArchived?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncPropertiesQueryVariables = {
  filter?: ModelPropertyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncPropertiesQuery = {
  syncProperties?:  {
    __typename: "ModelPropertyConnection",
    items:  Array< {
      __typename: "Property",
      id: string,
      name?: string | null,
      description?: string | null,
      address?: string | null,
      ownerOrganizationId?: string | null,
      primaryContactNumber?: string | null,
      primaryContactEmail?: string | null,
      primaryContactName?: string | null,
      propertyNumber?: string | null,
      locations?:  {
        __typename: "ModelLocationConnection",
        items:  Array< {
          __typename: "Location",
          id: string,
          propertyId?: string | null,
          createdInSolution?: boolean | null,
          name?: string | null,
          tags?: string | null,
          localCreationTime?: number | null,
          localLastUpdatedTime?: number | null,
          opaqueSyncReconciliationToken?: string | null,
          canView?: string | null,
          canEdit?: string | null,
          canDelete?: string | null,
          createdBy?: string | null,
          canViewList?: Array< string | null > | null,
          canViewEntityVersionMap?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdBy?: string | null,
      localLastUpdatedTime?: number | null,
      opaqueSyncReconciliationToken?: string | null,
      autoDashboardRebuild?: boolean | null,
      canView?: string | null,
      canEdit?: string | null,
      canCreateSolutions?: string | null,
      canDelete?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      isTestProperty?: boolean | null,
      isArchived?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetPropertyCounterQueryVariables = {
  id: string,
};

export type GetPropertyCounterQuery = {
  getPropertyCounter?:  {
    __typename: "PropertyCounter",
    id: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListPropertyCountersQueryVariables = {
  filter?: ModelPropertyCounterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPropertyCountersQuery = {
  listPropertyCounters?:  {
    __typename: "ModelPropertyCounterConnection",
    items:  Array< {
      __typename: "PropertyCounter",
      id: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncPropertyCountersQueryVariables = {
  filter?: ModelPropertyCounterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncPropertyCountersQuery = {
  syncPropertyCounters?:  {
    __typename: "ModelPropertyCounterConnection",
    items:  Array< {
      __typename: "PropertyCounter",
      id: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetProposalQueryVariables = {
  id: string,
};

export type GetProposalQuery = {
  getProposal?:  {
    __typename: "Proposal",
    id: string,
    schemaVersion?: number | null,
    designDocumentGroupId: string,
    designDocumentVersion: number,
    proposalKey: string,
    proposalNumber?: number | null,
    status?: ProposalStatus | null,
    author?: string | null,
    createdAt?: string | null,
    localLastUpdatedTime?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    quickQuoteId?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListProposalsQueryVariables = {
  filter?: ModelProposalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProposalsQuery = {
  listProposals?:  {
    __typename: "ModelProposalConnection",
    items:  Array< {
      __typename: "Proposal",
      id: string,
      schemaVersion?: number | null,
      designDocumentGroupId: string,
      designDocumentVersion: number,
      proposalKey: string,
      proposalNumber?: number | null,
      status?: ProposalStatus | null,
      author?: string | null,
      createdAt?: string | null,
      localLastUpdatedTime?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      quickQuoteId?: string | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncProposalsQueryVariables = {
  filter?: ModelProposalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncProposalsQuery = {
  syncProposals?:  {
    __typename: "ModelProposalConnection",
    items:  Array< {
      __typename: "Proposal",
      id: string,
      schemaVersion?: number | null,
      designDocumentGroupId: string,
      designDocumentVersion: number,
      proposalKey: string,
      proposalNumber?: number | null,
      status?: ProposalStatus | null,
      author?: string | null,
      createdAt?: string | null,
      localLastUpdatedTime?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      quickQuoteId?: string | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetProposalByIdQueryVariables = {
  id: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProposalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetProposalByIdQuery = {
  getProposalById?:  {
    __typename: "ModelProposalConnection",
    items:  Array< {
      __typename: "Proposal",
      id: string,
      schemaVersion?: number | null,
      designDocumentGroupId: string,
      designDocumentVersion: number,
      proposalKey: string,
      proposalNumber?: number | null,
      status?: ProposalStatus | null,
      author?: string | null,
      createdAt?: string | null,
      localLastUpdatedTime?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      quickQuoteId?: string | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListProposalsByDesignDocumentGroupIdQueryVariables = {
  designDocumentGroupId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProposalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProposalsByDesignDocumentGroupIdQuery = {
  listProposalsByDesignDocumentGroupId?:  {
    __typename: "ModelProposalConnection",
    items:  Array< {
      __typename: "Proposal",
      id: string,
      schemaVersion?: number | null,
      designDocumentGroupId: string,
      designDocumentVersion: number,
      proposalKey: string,
      proposalNumber?: number | null,
      status?: ProposalStatus | null,
      author?: string | null,
      createdAt?: string | null,
      localLastUpdatedTime?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      quickQuoteId?: string | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListProposalsByDesignDocumentGroupIdAndVersionQueryVariables = {
  designDocumentGroupId: string,
  designDocumentVersion?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProposalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProposalsByDesignDocumentGroupIdAndVersionQuery = {
  listProposalsByDesignDocumentGroupIdAndVersion?:  {
    __typename: "ModelProposalConnection",
    items:  Array< {
      __typename: "Proposal",
      id: string,
      schemaVersion?: number | null,
      designDocumentGroupId: string,
      designDocumentVersion: number,
      proposalKey: string,
      proposalNumber?: number | null,
      status?: ProposalStatus | null,
      author?: string | null,
      createdAt?: string | null,
      localLastUpdatedTime?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      quickQuoteId?: string | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetProposalByProposalNumberQueryVariables = {
  proposalNumber: number,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProposalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetProposalByProposalNumberQuery = {
  getProposalByProposalNumber?:  {
    __typename: "ModelProposalConnection",
    items:  Array< {
      __typename: "Proposal",
      id: string,
      schemaVersion?: number | null,
      designDocumentGroupId: string,
      designDocumentVersion: number,
      proposalKey: string,
      proposalNumber?: number | null,
      status?: ProposalStatus | null,
      author?: string | null,
      createdAt?: string | null,
      localLastUpdatedTime?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      quickQuoteId?: string | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListProposalsByAuthorQueryVariables = {
  author: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProposalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProposalsByAuthorQuery = {
  listProposalsByAuthor?:  {
    __typename: "ModelProposalConnection",
    items:  Array< {
      __typename: "Proposal",
      id: string,
      schemaVersion?: number | null,
      designDocumentGroupId: string,
      designDocumentVersion: number,
      proposalKey: string,
      proposalNumber?: number | null,
      status?: ProposalStatus | null,
      author?: string | null,
      createdAt?: string | null,
      localLastUpdatedTime?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      quickQuoteId?: string | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetProposalCounterQueryVariables = {
  id: string,
};

export type GetProposalCounterQuery = {
  getProposalCounter?:  {
    __typename: "ProposalCounter",
    id: string,
    solutionGroupId?: string | null,
    solutionVersion?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListProposalCountersQueryVariables = {
  id?: string | null,
  filter?: ModelProposalCounterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListProposalCountersQuery = {
  listProposalCounters?:  {
    __typename: "ModelProposalCounterConnection",
    items:  Array< {
      __typename: "ProposalCounter",
      id: string,
      solutionGroupId?: string | null,
      solutionVersion?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncProposalCountersQueryVariables = {
  filter?: ModelProposalCounterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncProposalCountersQuery = {
  syncProposalCounters?:  {
    __typename: "ModelProposalCounterConnection",
    items:  Array< {
      __typename: "ProposalCounter",
      id: string,
      solutionGroupId?: string | null,
      solutionVersion?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetProposalCounterBySolutionByVersionQueryVariables = {
  solutionGroupId: string,
  solutionVersion?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProposalCounterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetProposalCounterBySolutionByVersionQuery = {
  getProposalCounterBySolutionByVersion?:  {
    __typename: "ModelProposalCounterConnection",
    items:  Array< {
      __typename: "ProposalCounter",
      id: string,
      solutionGroupId?: string | null,
      solutionVersion?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetResourceUserPermissionsQueryVariables = {
  id: string,
};

export type GetResourceUserPermissionsQuery = {
  getResourceUserPermissions?:  {
    __typename: "ResourceUserPermissions",
    id: string,
    resourceId: string,
    userId?: string | null,
    userEmail?: string | null,
    userFullName?: string | null,
    resourceAndUserId?: string | null,
    permissions: string,
    resourceType?: ResourceType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListResourceUserPermissionsQueryVariables = {
  id?: string | null,
  filter?: ModelResourceUserPermissionsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListResourceUserPermissionsQuery = {
  listResourceUserPermissions?:  {
    __typename: "ModelResourceUserPermissionsConnection",
    items:  Array< {
      __typename: "ResourceUserPermissions",
      id: string,
      resourceId: string,
      userId?: string | null,
      userEmail?: string | null,
      userFullName?: string | null,
      resourceAndUserId?: string | null,
      permissions: string,
      resourceType?: ResourceType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncResourceUserPermissionsQueryVariables = {
  filter?: ModelResourceUserPermissionsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncResourceUserPermissionsQuery = {
  syncResourceUserPermissions?:  {
    __typename: "ModelResourceUserPermissionsConnection",
    items:  Array< {
      __typename: "ResourceUserPermissions",
      id: string,
      resourceId: string,
      userId?: string | null,
      userEmail?: string | null,
      userFullName?: string | null,
      resourceAndUserId?: string | null,
      permissions: string,
      resourceType?: ResourceType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListResourceUserPermissionsByResourceQueryVariables = {
  resourceId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelResourceUserPermissionsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListResourceUserPermissionsByResourceQuery = {
  listResourceUserPermissionsByResource?:  {
    __typename: "ModelResourceUserPermissionsConnection",
    items:  Array< {
      __typename: "ResourceUserPermissions",
      id: string,
      resourceId: string,
      userId?: string | null,
      userEmail?: string | null,
      userFullName?: string | null,
      resourceAndUserId?: string | null,
      permissions: string,
      resourceType?: ResourceType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListResourceUserPermissionsByUserIdAndResourceTypeQueryVariables = {
  userId: string,
  resourceType?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelResourceUserPermissionsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListResourceUserPermissionsByUserIdAndResourceTypeQuery = {
  listResourceUserPermissionsByUserIdAndResourceType?:  {
    __typename: "ModelResourceUserPermissionsConnection",
    items:  Array< {
      __typename: "ResourceUserPermissions",
      id: string,
      resourceId: string,
      userId?: string | null,
      userEmail?: string | null,
      userFullName?: string | null,
      resourceAndUserId?: string | null,
      permissions: string,
      resourceType?: ResourceType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListResourceUserPermissionsByUserEmailQueryVariables = {
  userEmail: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelResourceUserPermissionsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListResourceUserPermissionsByUserEmailQuery = {
  listResourceUserPermissionsByUserEmail?:  {
    __typename: "ModelResourceUserPermissionsConnection",
    items:  Array< {
      __typename: "ResourceUserPermissions",
      id: string,
      resourceId: string,
      userId?: string | null,
      userEmail?: string | null,
      userFullName?: string | null,
      resourceAndUserId?: string | null,
      permissions: string,
      resourceType?: ResourceType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListResourceUserPermissionsByResourceAndUserQueryVariables = {
  resourceAndUserId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelResourceUserPermissionsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListResourceUserPermissionsByResourceAndUserQuery = {
  listResourceUserPermissionsByResourceAndUser?:  {
    __typename: "ModelResourceUserPermissionsConnection",
    items:  Array< {
      __typename: "ResourceUserPermissions",
      id: string,
      resourceId: string,
      userId?: string | null,
      userEmail?: string | null,
      userFullName?: string | null,
      resourceAndUserId?: string | null,
      permissions: string,
      resourceType?: ResourceType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetSolutionQueryVariables = {
  id: string,
};

export type GetSolutionQuery = {
  getSolution?:  {
    __typename: "Solution",
    id: string,
    propertyId?: string | null,
    projectId?: string | null,
    name?: string | null,
    status?: SolutionStatus | null,
    latestMinorVersion?: number | null,
    latestContentKey?: string | null,
    serialNumber?: number | null,
    metadata?:  {
      __typename: "SolutionMetadata",
      name?: string | null,
      propertyContactName?: string | null,
      propertyAddress?: string | null,
      propertyType?: string | null,
      solutionDueDate?: string | null,
      consultantName?: string | null,
      consultantPhoneNumber?: string | null,
      consultantEmail?: string | null,
      tenderingType?: SolutionTenderingType | null,
      warranty?: number | null,
    } | null,
    localLastUpdatedTime?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isArchived?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListSolutionsQueryVariables = {
  id?: string | null,
  filter?: ModelSolutionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSolutionsQuery = {
  listSolutions?:  {
    __typename: "ModelSolutionConnection",
    items:  Array< {
      __typename: "Solution",
      id: string,
      propertyId?: string | null,
      projectId?: string | null,
      name?: string | null,
      status?: SolutionStatus | null,
      latestMinorVersion?: number | null,
      latestContentKey?: string | null,
      serialNumber?: number | null,
      metadata?:  {
        __typename: "SolutionMetadata",
        name?: string | null,
        propertyContactName?: string | null,
        propertyAddress?: string | null,
        propertyType?: string | null,
        solutionDueDate?: string | null,
        consultantName?: string | null,
        consultantPhoneNumber?: string | null,
        consultantEmail?: string | null,
        tenderingType?: SolutionTenderingType | null,
        warranty?: number | null,
      } | null,
      localLastUpdatedTime?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      isArchived?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncSolutionsQueryVariables = {
  filter?: ModelSolutionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncSolutionsQuery = {
  syncSolutions?:  {
    __typename: "ModelSolutionConnection",
    items:  Array< {
      __typename: "Solution",
      id: string,
      propertyId?: string | null,
      projectId?: string | null,
      name?: string | null,
      status?: SolutionStatus | null,
      latestMinorVersion?: number | null,
      latestContentKey?: string | null,
      serialNumber?: number | null,
      metadata?:  {
        __typename: "SolutionMetadata",
        name?: string | null,
        propertyContactName?: string | null,
        propertyAddress?: string | null,
        propertyType?: string | null,
        solutionDueDate?: string | null,
        consultantName?: string | null,
        consultantPhoneNumber?: string | null,
        consultantEmail?: string | null,
        tenderingType?: SolutionTenderingType | null,
        warranty?: number | null,
      } | null,
      localLastUpdatedTime?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      isArchived?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListSolutionsByPropertyQueryVariables = {
  propertyId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSolutionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSolutionsByPropertyQuery = {
  listSolutionsByProperty?:  {
    __typename: "ModelSolutionConnection",
    items:  Array< {
      __typename: "Solution",
      id: string,
      propertyId?: string | null,
      projectId?: string | null,
      name?: string | null,
      status?: SolutionStatus | null,
      latestMinorVersion?: number | null,
      latestContentKey?: string | null,
      serialNumber?: number | null,
      metadata?:  {
        __typename: "SolutionMetadata",
        name?: string | null,
        propertyContactName?: string | null,
        propertyAddress?: string | null,
        propertyType?: string | null,
        solutionDueDate?: string | null,
        consultantName?: string | null,
        consultantPhoneNumber?: string | null,
        consultantEmail?: string | null,
        tenderingType?: SolutionTenderingType | null,
        warranty?: number | null,
      } | null,
      localLastUpdatedTime?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      isArchived?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetSolutionMinorVersionQueryVariables = {
  id: string,
};

export type GetSolutionMinorVersionQuery = {
  getSolutionMinorVersion?:  {
    __typename: "SolutionMinorVersion",
    id: string,
    solutionId?: string | null,
    propertyId?: string | null,
    name?: string | null,
    contentKey?: string | null,
    minorVersion?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListSolutionMinorVersionsQueryVariables = {
  id?: string | null,
  filter?: ModelSolutionMinorVersionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSolutionMinorVersionsQuery = {
  listSolutionMinorVersions?:  {
    __typename: "ModelSolutionMinorVersionConnection",
    items:  Array< {
      __typename: "SolutionMinorVersion",
      id: string,
      solutionId?: string | null,
      propertyId?: string | null,
      name?: string | null,
      contentKey?: string | null,
      minorVersion?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncSolutionMinorVersionsQueryVariables = {
  filter?: ModelSolutionMinorVersionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncSolutionMinorVersionsQuery = {
  syncSolutionMinorVersions?:  {
    __typename: "ModelSolutionMinorVersionConnection",
    items:  Array< {
      __typename: "SolutionMinorVersion",
      id: string,
      solutionId?: string | null,
      propertyId?: string | null,
      name?: string | null,
      contentKey?: string | null,
      minorVersion?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListSolutionMinorVersionsBySolutionByMinorVersionQueryVariables = {
  solutionId: string,
  minorVersion?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSolutionMinorVersionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSolutionMinorVersionsBySolutionByMinorVersionQuery = {
  listSolutionMinorVersionsBySolutionByMinorVersion?:  {
    __typename: "ModelSolutionMinorVersionConnection",
    items:  Array< {
      __typename: "SolutionMinorVersion",
      id: string,
      solutionId?: string | null,
      propertyId?: string | null,
      name?: string | null,
      contentKey?: string | null,
      minorVersion?: number | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetSolutionGroupCounterQueryVariables = {
  id: string,
};

export type GetSolutionGroupCounterQuery = {
  getSolutionGroupCounter?:  {
    __typename: "SolutionGroupCounter",
    id: string,
    propertyId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListSolutionGroupCountersQueryVariables = {
  id?: string | null,
  filter?: ModelSolutionGroupCounterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSolutionGroupCountersQuery = {
  listSolutionGroupCounters?:  {
    __typename: "ModelSolutionGroupCounterConnection",
    items:  Array< {
      __typename: "SolutionGroupCounter",
      id: string,
      propertyId?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncSolutionGroupCountersQueryVariables = {
  filter?: ModelSolutionGroupCounterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncSolutionGroupCountersQuery = {
  syncSolutionGroupCounters?:  {
    __typename: "ModelSolutionGroupCounterConnection",
    items:  Array< {
      __typename: "SolutionGroupCounter",
      id: string,
      propertyId?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetSolutionGroupCounterByPropertyQueryVariables = {
  propertyId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSolutionGroupCounterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetSolutionGroupCounterByPropertyQuery = {
  getSolutionGroupCounterByProperty?:  {
    __typename: "ModelSolutionGroupCounterConnection",
    items:  Array< {
      __typename: "SolutionGroupCounter",
      id: string,
      propertyId?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUserGroupQueryVariables = {
  id: string,
};

export type GetUserGroupQuery = {
  getUserGroup?:  {
    __typename: "UserGroup",
    id: string,
    resourceId: string,
    groupType: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListUserGroupsQueryVariables = {
  id?: string | null,
  filter?: ModelUserGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserGroupsQuery = {
  listUserGroups?:  {
    __typename: "ModelUserGroupConnection",
    items:  Array< {
      __typename: "UserGroup",
      id: string,
      resourceId: string,
      groupType: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUserGroupsQueryVariables = {
  filter?: ModelUserGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUserGroupsQuery = {
  syncUserGroups?:  {
    __typename: "ModelUserGroupConnection",
    items:  Array< {
      __typename: "UserGroup",
      id: string,
      resourceId: string,
      groupType: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListUserGroupsByResourceQueryVariables = {
  resourceId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserGroupsByResourceQuery = {
  listUserGroupsByResource?:  {
    __typename: "ModelUserGroupConnection",
    items:  Array< {
      __typename: "UserGroup",
      id: string,
      resourceId: string,
      groupType: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUserGroupMemberQueryVariables = {
  id: string,
};

export type GetUserGroupMemberQuery = {
  getUserGroupMember?:  {
    __typename: "UserGroupMember",
    id: string,
    resourceId: string,
    resourceAndUserId: string,
    userId: string,
    userGroupId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListUserGroupMembersQueryVariables = {
  id?: string | null,
  filter?: ModelUserGroupMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserGroupMembersQuery = {
  listUserGroupMembers?:  {
    __typename: "ModelUserGroupMemberConnection",
    items:  Array< {
      __typename: "UserGroupMember",
      id: string,
      resourceId: string,
      resourceAndUserId: string,
      userId: string,
      userGroupId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUserGroupMembersQueryVariables = {
  filter?: ModelUserGroupMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUserGroupMembersQuery = {
  syncUserGroupMembers?:  {
    __typename: "ModelUserGroupMemberConnection",
    items:  Array< {
      __typename: "UserGroupMember",
      id: string,
      resourceId: string,
      resourceAndUserId: string,
      userId: string,
      userGroupId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListUserGroupMembersByResourceQueryVariables = {
  resourceId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserGroupMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserGroupMembersByResourceQuery = {
  listUserGroupMembersByResource?:  {
    __typename: "ModelUserGroupMemberConnection",
    items:  Array< {
      __typename: "UserGroupMember",
      id: string,
      resourceId: string,
      resourceAndUserId: string,
      userId: string,
      userGroupId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListUserGroupMembersByResourceAndUserQueryVariables = {
  resourceAndUserId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserGroupMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserGroupMembersByResourceAndUserQuery = {
  listUserGroupMembersByResourceAndUser?:  {
    __typename: "ModelUserGroupMemberConnection",
    items:  Array< {
      __typename: "UserGroupMember",
      id: string,
      resourceId: string,
      resourceAndUserId: string,
      userId: string,
      userGroupId: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUserOrganizationAssociationQueryVariables = {
  id: string,
};

export type GetUserOrganizationAssociationQuery = {
  getUserOrganizationAssociation?:  {
    __typename: "UserOrganizationAssociation",
    id: string,
    userId: string,
    organizationId: string,
    associationType: UserOrganizationAssociationType,
    permissions?: string | null,
    role?: UserOrganizationRole | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListUserOrganizationAssociationsQueryVariables = {
  id?: string | null,
  filter?: ModelUserOrganizationAssociationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserOrganizationAssociationsQuery = {
  listUserOrganizationAssociations?:  {
    __typename: "ModelUserOrganizationAssociationConnection",
    items:  Array< {
      __typename: "UserOrganizationAssociation",
      id: string,
      userId: string,
      organizationId: string,
      associationType: UserOrganizationAssociationType,
      permissions?: string | null,
      role?: UserOrganizationRole | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUserOrganizationAssociationsQueryVariables = {
  filter?: ModelUserOrganizationAssociationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUserOrganizationAssociationsQuery = {
  syncUserOrganizationAssociations?:  {
    __typename: "ModelUserOrganizationAssociationConnection",
    items:  Array< {
      __typename: "UserOrganizationAssociation",
      id: string,
      userId: string,
      organizationId: string,
      associationType: UserOrganizationAssociationType,
      permissions?: string | null,
      role?: UserOrganizationRole | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListUserOrganizationAssociationsByUserAndAssociationTypeQueryVariables = {
  userId: string,
  associationType?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserOrganizationAssociationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserOrganizationAssociationsByUserAndAssociationTypeQuery = {
  listUserOrganizationAssociationsByUserAndAssociationType?:  {
    __typename: "ModelUserOrganizationAssociationConnection",
    items:  Array< {
      __typename: "UserOrganizationAssociation",
      id: string,
      userId: string,
      organizationId: string,
      associationType: UserOrganizationAssociationType,
      permissions?: string | null,
      role?: UserOrganizationRole | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListUserOrganizationAssociationsByOrganizationAndAssociationTypeQueryVariables = {
  organizationId: string,
  associationType?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserOrganizationAssociationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserOrganizationAssociationsByOrganizationAndAssociationTypeQuery = {
  listUserOrganizationAssociationsByOrganizationAndAssociationType?:  {
    __typename: "ModelUserOrganizationAssociationConnection",
    items:  Array< {
      __typename: "UserOrganizationAssociation",
      id: string,
      userId: string,
      organizationId: string,
      associationType: UserOrganizationAssociationType,
      permissions?: string | null,
      role?: UserOrganizationRole | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetWorkSpecificationQueryVariables = {
  id: string,
};

export type GetWorkSpecificationQuery = {
  getWorkSpecification?:  {
    __typename: "WorkSpecification",
    id: string,
    dimensionId?: string | null,
    issueId?: string | null,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    body?: string | null,
    description?: string | null,
    workTypeId?: string | null,
    itemNumber?: number | null,
    measurement?:  {
      __typename: "Measurement",
      length?: number | null,
      width?: number | null,
      dimensionType?: DimensionType | null,
      measurementUnit?: MeasurementUnit | null,
    } | null,
    version?: number | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListWorkSpecificationsQueryVariables = {
  id?: string | null,
  filter?: ModelWorkSpecificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListWorkSpecificationsQuery = {
  listWorkSpecifications?:  {
    __typename: "ModelWorkSpecificationConnection",
    items:  Array< {
      __typename: "WorkSpecification",
      id: string,
      dimensionId?: string | null,
      issueId?: string | null,
      propertyId?: string | null,
      createdInSolution?: boolean | null,
      body?: string | null,
      description?: string | null,
      workTypeId?: string | null,
      itemNumber?: number | null,
      measurement?:  {
        __typename: "Measurement",
        length?: number | null,
        width?: number | null,
        dimensionType?: DimensionType | null,
        measurementUnit?: MeasurementUnit | null,
      } | null,
      version?: number | null,
      localLastUpdatedTime?: number | null,
      opaqueSyncReconciliationToken?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncWorkSpecificationsQueryVariables = {
  filter?: ModelWorkSpecificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncWorkSpecificationsQuery = {
  syncWorkSpecifications?:  {
    __typename: "ModelWorkSpecificationConnection",
    items:  Array< {
      __typename: "WorkSpecification",
      id: string,
      dimensionId?: string | null,
      issueId?: string | null,
      propertyId?: string | null,
      createdInSolution?: boolean | null,
      body?: string | null,
      description?: string | null,
      workTypeId?: string | null,
      itemNumber?: number | null,
      measurement?:  {
        __typename: "Measurement",
        length?: number | null,
        width?: number | null,
        dimensionType?: DimensionType | null,
        measurementUnit?: MeasurementUnit | null,
      } | null,
      version?: number | null,
      localLastUpdatedTime?: number | null,
      opaqueSyncReconciliationToken?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListWorkScopeSpecificationsByDimensionIdQueryVariables = {
  dimensionId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelWorkSpecificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListWorkScopeSpecificationsByDimensionIdQuery = {
  listWorkScopeSpecificationsByDimensionId?:  {
    __typename: "ModelWorkSpecificationConnection",
    items:  Array< {
      __typename: "WorkSpecification",
      id: string,
      dimensionId?: string | null,
      issueId?: string | null,
      propertyId?: string | null,
      createdInSolution?: boolean | null,
      body?: string | null,
      description?: string | null,
      workTypeId?: string | null,
      itemNumber?: number | null,
      measurement?:  {
        __typename: "Measurement",
        length?: number | null,
        width?: number | null,
        dimensionType?: DimensionType | null,
        measurementUnit?: MeasurementUnit | null,
      } | null,
      version?: number | null,
      localLastUpdatedTime?: number | null,
      opaqueSyncReconciliationToken?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListWorkScopeSpecificationsByIssueIdQueryVariables = {
  issueId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelWorkSpecificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListWorkScopeSpecificationsByIssueIdQuery = {
  listWorkScopeSpecificationsByIssueId?:  {
    __typename: "ModelWorkSpecificationConnection",
    items:  Array< {
      __typename: "WorkSpecification",
      id: string,
      dimensionId?: string | null,
      issueId?: string | null,
      propertyId?: string | null,
      createdInSolution?: boolean | null,
      body?: string | null,
      description?: string | null,
      workTypeId?: string | null,
      itemNumber?: number | null,
      measurement?:  {
        __typename: "Measurement",
        length?: number | null,
        width?: number | null,
        dimensionType?: DimensionType | null,
        measurementUnit?: MeasurementUnit | null,
      } | null,
      version?: number | null,
      localLastUpdatedTime?: number | null,
      opaqueSyncReconciliationToken?: string | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdBy?: string | null,
      canViewList?: Array< string | null > | null,
      canViewEntityVersionMap?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetWorkTypeQueryVariables = {
  id: string,
};

export type GetWorkTypeQuery = {
  getWorkType?:  {
    __typename: "WorkType",
    id: string,
    name: string,
    shortDescription?: string | null,
    longDescription?: string | null,
    groupName?: string | null,
    unitPrice?: number | null,
    unitCost?: number | null,
    dimensionType?: DimensionType | null,
    measurementUnit?: MeasurementUnit | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListWorkTypesQueryVariables = {
  id?: string | null,
  filter?: ModelWorkTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListWorkTypesQuery = {
  listWorkTypes?:  {
    __typename: "ModelWorkTypeConnection",
    items:  Array< {
      __typename: "WorkType",
      id: string,
      name: string,
      shortDescription?: string | null,
      longDescription?: string | null,
      groupName?: string | null,
      unitPrice?: number | null,
      unitCost?: number | null,
      dimensionType?: DimensionType | null,
      measurementUnit?: MeasurementUnit | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncWorkTypesQueryVariables = {
  filter?: ModelWorkTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncWorkTypesQuery = {
  syncWorkTypes?:  {
    __typename: "ModelWorkTypeConnection",
    items:  Array< {
      __typename: "WorkType",
      id: string,
      name: string,
      shortDescription?: string | null,
      longDescription?: string | null,
      groupName?: string | null,
      unitPrice?: number | null,
      unitCost?: number | null,
      dimensionType?: DimensionType | null,
      measurementUnit?: MeasurementUnit | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetWorkTypeGroupQueryVariables = {
  id: string,
};

export type GetWorkTypeGroupQuery = {
  getWorkTypeGroup?:  {
    __typename: "WorkTypeGroup",
    id: string,
    latestWorkTypeVersion: number,
    environmentAgnosticWorkTypeGroupId?: string | null,
    isDiscoverable?: boolean | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListWorkTypeGroupsQueryVariables = {
  id?: string | null,
  filter?: ModelWorkTypeGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListWorkTypeGroupsQuery = {
  listWorkTypeGroups?:  {
    __typename: "ModelWorkTypeGroupConnection",
    items:  Array< {
      __typename: "WorkTypeGroup",
      id: string,
      latestWorkTypeVersion: number,
      environmentAgnosticWorkTypeGroupId?: string | null,
      isDiscoverable?: boolean | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncWorkTypeGroupsQueryVariables = {
  filter?: ModelWorkTypeGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncWorkTypeGroupsQuery = {
  syncWorkTypeGroups?:  {
    __typename: "ModelWorkTypeGroupConnection",
    items:  Array< {
      __typename: "WorkTypeGroup",
      id: string,
      latestWorkTypeVersion: number,
      environmentAgnosticWorkTypeGroupId?: string | null,
      isDiscoverable?: boolean | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetWorkTypePricingQueryVariables = {
  id: string,
};

export type GetWorkTypePricingQuery = {
  getWorkTypePricing?:  {
    __typename: "WorkTypePricing",
    id: string,
    entityId: string,
    workTypeGroupId: string,
    body: string,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListWorkTypePricingsQueryVariables = {
  id?: string | null,
  filter?: ModelWorkTypePricingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListWorkTypePricingsQuery = {
  listWorkTypePricings?:  {
    __typename: "ModelWorkTypePricingConnection",
    items:  Array< {
      __typename: "WorkTypePricing",
      id: string,
      entityId: string,
      workTypeGroupId: string,
      body: string,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncWorkTypePricingsQueryVariables = {
  filter?: ModelWorkTypePricingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncWorkTypePricingsQuery = {
  syncWorkTypePricings?:  {
    __typename: "ModelWorkTypePricingConnection",
    items:  Array< {
      __typename: "WorkTypePricing",
      id: string,
      entityId: string,
      workTypeGroupId: string,
      body: string,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListWorkTypePricingByEntityIdByWorkTypeGroupIdQueryVariables = {
  entityId: string,
  workTypeGroupId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelWorkTypePricingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListWorkTypePricingByEntityIdByWorkTypeGroupIdQuery = {
  listWorkTypePricingByEntityIdByWorkTypeGroupId?:  {
    __typename: "ModelWorkTypePricingConnection",
    items:  Array< {
      __typename: "WorkTypePricing",
      id: string,
      entityId: string,
      workTypeGroupId: string,
      body: string,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetDefaultWorkTypePricingQueryVariables = {
  id: string,
};

export type GetDefaultWorkTypePricingQuery = {
  getDefaultWorkTypePricing?:  {
    __typename: "DefaultWorkTypePricing",
    id: string,
    unitCost?: number | null,
    unitPrice?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListDefaultWorkTypePricingsQueryVariables = {
  id?: string | null,
  filter?: ModelDefaultWorkTypePricingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListDefaultWorkTypePricingsQuery = {
  listDefaultWorkTypePricings?:  {
    __typename: "ModelDefaultWorkTypePricingConnection",
    items:  Array< {
      __typename: "DefaultWorkTypePricing",
      id: string,
      unitCost?: number | null,
      unitPrice?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncDefaultWorkTypePricingsQueryVariables = {
  filter?: ModelDefaultWorkTypePricingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncDefaultWorkTypePricingsQuery = {
  syncDefaultWorkTypePricings?:  {
    __typename: "ModelDefaultWorkTypePricingConnection",
    items:  Array< {
      __typename: "DefaultWorkTypePricing",
      id: string,
      unitCost?: number | null,
      unitPrice?: number | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTemporaryWorkTypeQueryVariables = {
  id: string,
};

export type GetTemporaryWorkTypeQuery = {
  getTemporaryWorkType?:  {
    __typename: "TemporaryWorkType",
    id: string,
    workTypeGroupId: string,
    environmentAgnosticWorkTypeGroupId?: string | null,
    body: string,
    version: number,
    schemaVersion: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTemporaryWorkTypesQueryVariables = {
  filter?: ModelTemporaryWorkTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTemporaryWorkTypesQuery = {
  listTemporaryWorkTypes?:  {
    __typename: "ModelTemporaryWorkTypeConnection",
    items:  Array< {
      __typename: "TemporaryWorkType",
      id: string,
      workTypeGroupId: string,
      environmentAgnosticWorkTypeGroupId?: string | null,
      body: string,
      version: number,
      schemaVersion: number,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTemporaryWorkTypesQueryVariables = {
  filter?: ModelTemporaryWorkTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTemporaryWorkTypesQuery = {
  syncTemporaryWorkTypes?:  {
    __typename: "ModelTemporaryWorkTypeConnection",
    items:  Array< {
      __typename: "TemporaryWorkType",
      id: string,
      workTypeGroupId: string,
      environmentAgnosticWorkTypeGroupId?: string | null,
      body: string,
      version: number,
      schemaVersion: number,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetWorkTypeByWorkTypeGroupIdAndVersionQueryVariables = {
  workTypeGroupId: string,
  version?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTemporaryWorkTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetWorkTypeByWorkTypeGroupIdAndVersionQuery = {
  getWorkTypeByWorkTypeGroupIdAndVersion?:  {
    __typename: "ModelTemporaryWorkTypeConnection",
    items:  Array< {
      __typename: "TemporaryWorkType",
      id: string,
      workTypeGroupId: string,
      environmentAgnosticWorkTypeGroupId?: string | null,
      body: string,
      version: number,
      schemaVersion: number,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetWorkTypeByEnvironmentAgnosticWorkTypeGroupIdQueryVariables = {
  environmentAgnosticWorkTypeGroupId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTemporaryWorkTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetWorkTypeByEnvironmentAgnosticWorkTypeGroupIdQuery = {
  getWorkTypeByEnvironmentAgnosticWorkTypeGroupId?:  {
    __typename: "ModelTemporaryWorkTypeConnection",
    items:  Array< {
      __typename: "TemporaryWorkType",
      id: string,
      workTypeGroupId: string,
      environmentAgnosticWorkTypeGroupId?: string | null,
      body: string,
      version: number,
      schemaVersion: number,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTenderQueryVariables = {
  id: string,
};

export type GetTenderQuery = {
  getTender?:  {
    __typename: "Tender",
    id: string,
    solutionId?: string | null,
    status?: TenderStatus | null,
    latestVersion?: number | null,
    awardedVersion?: number | null,
    projectNumber?: number | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTendersQueryVariables = {
  filter?: ModelTenderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTendersQuery = {
  listTenders?:  {
    __typename: "ModelTenderConnection",
    items:  Array< {
      __typename: "Tender",
      id: string,
      solutionId?: string | null,
      status?: TenderStatus | null,
      latestVersion?: number | null,
      awardedVersion?: number | null,
      projectNumber?: number | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTendersQueryVariables = {
  filter?: ModelTenderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTendersQuery = {
  syncTenders?:  {
    __typename: "ModelTenderConnection",
    items:  Array< {
      __typename: "Tender",
      id: string,
      solutionId?: string | null,
      status?: TenderStatus | null,
      latestVersion?: number | null,
      awardedVersion?: number | null,
      projectNumber?: number | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListTendersByProjectNumberQueryVariables = {
  projectNumber: number,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTenderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTendersByProjectNumberQuery = {
  listTendersByProjectNumber?:  {
    __typename: "ModelTenderConnection",
    items:  Array< {
      __typename: "Tender",
      id: string,
      solutionId?: string | null,
      status?: TenderStatus | null,
      latestVersion?: number | null,
      awardedVersion?: number | null,
      projectNumber?: number | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTenderMinorVersionQueryVariables = {
  id: string,
};

export type GetTenderMinorVersionQuery = {
  getTenderMinorVersion?:  {
    __typename: "TenderMinorVersion",
    id: string,
    tenderId?: string | null,
    version?: number | null,
    solutionId?: string | null,
    solutionMinorVersion?: number | null,
    metadata?:  {
      __typename: "TenderMetadata",
      name?: string | null,
      propertyContactName?: string | null,
      propertyAddress?: string | null,
      propertyType?: string | null,
      solutionDueDate?: string | null,
      consultantName?: string | null,
      consultantPhoneNumber?: string | null,
      consultantEmail?: string | null,
    } | null,
    contentKey?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTenderMinorVersionsQueryVariables = {
  filter?: ModelTenderMinorVersionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTenderMinorVersionsQuery = {
  listTenderMinorVersions?:  {
    __typename: "ModelTenderMinorVersionConnection",
    items:  Array< {
      __typename: "TenderMinorVersion",
      id: string,
      tenderId?: string | null,
      version?: number | null,
      solutionId?: string | null,
      solutionMinorVersion?: number | null,
      metadata?:  {
        __typename: "TenderMetadata",
        name?: string | null,
        propertyContactName?: string | null,
        propertyAddress?: string | null,
        propertyType?: string | null,
        solutionDueDate?: string | null,
        consultantName?: string | null,
        consultantPhoneNumber?: string | null,
        consultantEmail?: string | null,
      } | null,
      contentKey?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTenderMinorVersionsQueryVariables = {
  filter?: ModelTenderMinorVersionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTenderMinorVersionsQuery = {
  syncTenderMinorVersions?:  {
    __typename: "ModelTenderMinorVersionConnection",
    items:  Array< {
      __typename: "TenderMinorVersion",
      id: string,
      tenderId?: string | null,
      version?: number | null,
      solutionId?: string | null,
      solutionMinorVersion?: number | null,
      metadata?:  {
        __typename: "TenderMetadata",
        name?: string | null,
        propertyContactName?: string | null,
        propertyAddress?: string | null,
        propertyType?: string | null,
        solutionDueDate?: string | null,
        consultantName?: string | null,
        consultantPhoneNumber?: string | null,
        consultantEmail?: string | null,
      } | null,
      contentKey?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListTenderMinorVersionsByTenderIdQueryVariables = {
  tenderId: string,
  version?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTenderMinorVersionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTenderMinorVersionsByTenderIdQuery = {
  listTenderMinorVersionsByTenderId?:  {
    __typename: "ModelTenderMinorVersionConnection",
    items:  Array< {
      __typename: "TenderMinorVersion",
      id: string,
      tenderId?: string | null,
      version?: number | null,
      solutionId?: string | null,
      solutionMinorVersion?: number | null,
      metadata?:  {
        __typename: "TenderMetadata",
        name?: string | null,
        propertyContactName?: string | null,
        propertyAddress?: string | null,
        propertyType?: string | null,
        solutionDueDate?: string | null,
        consultantName?: string | null,
        consultantPhoneNumber?: string | null,
        consultantEmail?: string | null,
      } | null,
      contentKey?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTagQueryVariables = {
  id: string,
};

export type GetTagQuery = {
  getTag?:  {
    __typename: "Tag",
    id: string,
    name?: string | null,
    createdBy?: string | null,
    propertyId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTagsQueryVariables = {
  id?: string | null,
  filter?: ModelTagFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTagsQuery = {
  listTags?:  {
    __typename: "ModelTagConnection",
    items:  Array< {
      __typename: "Tag",
      id: string,
      name?: string | null,
      createdBy?: string | null,
      propertyId?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTagsQueryVariables = {
  filter?: ModelTagFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTagsQuery = {
  syncTags?:  {
    __typename: "ModelTagConnection",
    items:  Array< {
      __typename: "Tag",
      id: string,
      name?: string | null,
      createdBy?: string | null,
      propertyId?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUserOnboardingProgressQueryVariables = {
  id: string,
};

export type GetUserOnboardingProgressQuery = {
  getUserOnboardingProgress?:  {
    __typename: "UserOnboardingProgress",
    id: string,
    userId: string,
    hasUserBeenAssociatedWithOrganization: boolean,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListUserOnboardingProgressesQueryVariables = {
  id?: string | null,
  filter?: ModelUserOnboardingProgressFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUserOnboardingProgressesQuery = {
  listUserOnboardingProgresses?:  {
    __typename: "ModelUserOnboardingProgressConnection",
    items:  Array< {
      __typename: "UserOnboardingProgress",
      id: string,
      userId: string,
      hasUserBeenAssociatedWithOrganization: boolean,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUserOnboardingProgressesQueryVariables = {
  filter?: ModelUserOnboardingProgressFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUserOnboardingProgressesQuery = {
  syncUserOnboardingProgresses?:  {
    __typename: "ModelUserOnboardingProgressConnection",
    items:  Array< {
      __typename: "UserOnboardingProgress",
      id: string,
      userId: string,
      hasUserBeenAssociatedWithOrganization: boolean,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUserOnboardingProgressByUserIdQueryVariables = {
  userId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserOnboardingProgressFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetUserOnboardingProgressByUserIdQuery = {
  getUserOnboardingProgressByUserId?:  {
    __typename: "ModelUserOnboardingProgressConnection",
    items:  Array< {
      __typename: "UserOnboardingProgress",
      id: string,
      userId: string,
      hasUserBeenAssociatedWithOrganization: boolean,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    name?: string | null,
    email?: string | null,
    phoneNumber?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListUsersQueryVariables = {
  id?: string | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUsersQuery = {
  syncUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListUsersByEmailQueryVariables = {
  email: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersByEmailQuery = {
  listUsersByEmail?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListUsersByPhoneNumberQueryVariables = {
  phoneNumber: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersByPhoneNumberQuery = {
  listUsersByPhoneNumber?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTemplateQueryVariables = {
  id: string,
};

export type GetTemplateQuery = {
  getTemplate?:  {
    __typename: "Template",
    id: string,
    type?: TemplateType | null,
    name?: string | null,
    s3Key?: string | null,
    ownerId?: string | null,
    ownerType?: TemplateEntityType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTemplatesQueryVariables = {
  id?: string | null,
  filter?: ModelTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTemplatesQuery = {
  listTemplates?:  {
    __typename: "ModelTemplateConnection",
    items:  Array< {
      __typename: "Template",
      id: string,
      type?: TemplateType | null,
      name?: string | null,
      s3Key?: string | null,
      ownerId?: string | null,
      ownerType?: TemplateEntityType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTemplatesQueryVariables = {
  filter?: ModelTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTemplatesQuery = {
  syncTemplates?:  {
    __typename: "ModelTemplateConnection",
    items:  Array< {
      __typename: "Template",
      id: string,
      type?: TemplateType | null,
      name?: string | null,
      s3Key?: string | null,
      ownerId?: string | null,
      ownerType?: TemplateEntityType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListTemplatesByOwnerEntityIdQueryVariables = {
  ownerId: string,
  ownerType?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTemplatesByOwnerEntityIdQuery = {
  listTemplatesByOwnerEntityId?:  {
    __typename: "ModelTemplateConnection",
    items:  Array< {
      __typename: "Template",
      id: string,
      type?: TemplateType | null,
      name?: string | null,
      s3Key?: string | null,
      ownerId?: string | null,
      ownerType?: TemplateEntityType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTemporaryAuthorizationCodeQueryVariables = {
  id: string,
};

export type GetTemporaryAuthorizationCodeQuery = {
  getTemporaryAuthorizationCode?:  {
    __typename: "TemporaryAuthorizationCode",
    id: string,
    code: string,
    userId: string,
    expiresAt: number,
    createdAt: string,
    ttl: number,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTemporaryAuthorizationCodesQueryVariables = {
  id?: string | null,
  filter?: ModelTemporaryAuthorizationCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListTemporaryAuthorizationCodesQuery = {
  listTemporaryAuthorizationCodes?:  {
    __typename: "ModelTemporaryAuthorizationCodeConnection",
    items:  Array< {
      __typename: "TemporaryAuthorizationCode",
      id: string,
      code: string,
      userId: string,
      expiresAt: number,
      createdAt: string,
      ttl: number,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTemporaryAuthorizationCodesQueryVariables = {
  filter?: ModelTemporaryAuthorizationCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTemporaryAuthorizationCodesQuery = {
  syncTemporaryAuthorizationCodes?:  {
    __typename: "ModelTemporaryAuthorizationCodeConnection",
    items:  Array< {
      __typename: "TemporaryAuthorizationCode",
      id: string,
      code: string,
      userId: string,
      expiresAt: number,
      createdAt: string,
      ttl: number,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListTemporaryAuthorizationCodesByUserIdQueryVariables = {
  userId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTemporaryAuthorizationCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTemporaryAuthorizationCodesByUserIdQuery = {
  listTemporaryAuthorizationCodesByUserId?:  {
    __typename: "ModelTemporaryAuthorizationCodeConnection",
    items:  Array< {
      __typename: "TemporaryAuthorizationCode",
      id: string,
      code: string,
      userId: string,
      expiresAt: number,
      createdAt: string,
      ttl: number,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetLinkRegistryQueryVariables = {
  id: string,
};

export type GetLinkRegistryQuery = {
  getLinkRegistry?:  {
    __typename: "LinkRegistry",
    id: string,
    propertyId?: string | null,
    action?: LinkAction | null,
    variables?: string | null,
    published?: boolean | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListLinkRegistriesQueryVariables = {
  id?: string | null,
  filter?: ModelLinkRegistryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListLinkRegistriesQuery = {
  listLinkRegistries?:  {
    __typename: "ModelLinkRegistryConnection",
    items:  Array< {
      __typename: "LinkRegistry",
      id: string,
      propertyId?: string | null,
      action?: LinkAction | null,
      variables?: string | null,
      published?: boolean | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncLinkRegistriesQueryVariables = {
  filter?: ModelLinkRegistryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncLinkRegistriesQuery = {
  syncLinkRegistries?:  {
    __typename: "ModelLinkRegistryConnection",
    items:  Array< {
      __typename: "LinkRegistry",
      id: string,
      propertyId?: string | null,
      action?: LinkAction | null,
      variables?: string | null,
      published?: boolean | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListLinkRegistriesByPropertyQueryVariables = {
  propertyId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLinkRegistryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLinkRegistriesByPropertyQuery = {
  listLinkRegistriesByProperty?:  {
    __typename: "ModelLinkRegistryConnection",
    items:  Array< {
      __typename: "LinkRegistry",
      id: string,
      propertyId?: string | null,
      action?: LinkAction | null,
      variables?: string | null,
      published?: boolean | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetExternalReportBrandingQueryVariables = {
  id: string,
};

export type GetExternalReportBrandingQuery = {
  getExternalReportBranding?:  {
    __typename: "ExternalReportBranding",
    id: string,
    name?: string | null,
    logoKey?: string | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListExternalReportBrandingsQueryVariables = {
  id?: string | null,
  filter?: ModelExternalReportBrandingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListExternalReportBrandingsQuery = {
  listExternalReportBrandings?:  {
    __typename: "ModelExternalReportBrandingConnection",
    items:  Array< {
      __typename: "ExternalReportBranding",
      id: string,
      name?: string | null,
      logoKey?: string | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncExternalReportBrandingsQueryVariables = {
  filter?: ModelExternalReportBrandingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncExternalReportBrandingsQuery = {
  syncExternalReportBrandings?:  {
    __typename: "ModelExternalReportBrandingConnection",
    items:  Array< {
      __typename: "ExternalReportBranding",
      id: string,
      name?: string | null,
      logoKey?: string | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListExternalReportBrandingsByCreatedByQueryVariables = {
  createdBy: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelExternalReportBrandingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListExternalReportBrandingsByCreatedByQuery = {
  listExternalReportBrandingsByCreatedBy?:  {
    __typename: "ModelExternalReportBrandingConnection",
    items:  Array< {
      __typename: "ExternalReportBranding",
      id: string,
      name?: string | null,
      logoKey?: string | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetMeetingQueryVariables = {
  id: string,
};

export type GetMeetingQuery = {
  getMeeting?:  {
    __typename: "Meeting",
    id: string,
    status?: MeetingStatus | null,
    data: string,
    createdBy?: string | null,
    mediaPipelineId?: string | null,
    recordingKey?: string | null,
    recordingAttachmentId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListMeetingsQueryVariables = {
  id?: string | null,
  filter?: ModelMeetingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListMeetingsQuery = {
  listMeetings?:  {
    __typename: "ModelMeetingConnection",
    items:  Array< {
      __typename: "Meeting",
      id: string,
      status?: MeetingStatus | null,
      data: string,
      createdBy?: string | null,
      mediaPipelineId?: string | null,
      recordingKey?: string | null,
      recordingAttachmentId?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncMeetingsQueryVariables = {
  filter?: ModelMeetingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncMeetingsQuery = {
  syncMeetings?:  {
    __typename: "ModelMeetingConnection",
    items:  Array< {
      __typename: "Meeting",
      id: string,
      status?: MeetingStatus | null,
      data: string,
      createdBy?: string | null,
      mediaPipelineId?: string | null,
      recordingKey?: string | null,
      recordingAttachmentId?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListMeetingsByMediaPipelineIdQueryVariables = {
  mediaPipelineId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMeetingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMeetingsByMediaPipelineIdQuery = {
  listMeetingsByMediaPipelineId?:  {
    __typename: "ModelMeetingConnection",
    items:  Array< {
      __typename: "Meeting",
      id: string,
      status?: MeetingStatus | null,
      data: string,
      createdBy?: string | null,
      mediaPipelineId?: string | null,
      recordingKey?: string | null,
      recordingAttachmentId?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAttendeeQueryVariables = {
  id: string,
};

export type GetAttendeeQuery = {
  getAttendee?:  {
    __typename: "Attendee",
    id: string,
    meetingId: string,
    entityId?: string | null,
    name?: string | null,
    role?: AttendeeRole | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAttendeesQueryVariables = {
  id?: string | null,
  filter?: ModelAttendeeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAttendeesQuery = {
  listAttendees?:  {
    __typename: "ModelAttendeeConnection",
    items:  Array< {
      __typename: "Attendee",
      id: string,
      meetingId: string,
      entityId?: string | null,
      name?: string | null,
      role?: AttendeeRole | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAttendeesQueryVariables = {
  filter?: ModelAttendeeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAttendeesQuery = {
  syncAttendees?:  {
    __typename: "ModelAttendeeConnection",
    items:  Array< {
      __typename: "Attendee",
      id: string,
      meetingId: string,
      entityId?: string | null,
      name?: string | null,
      role?: AttendeeRole | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListAttendeesByMeetingIdQueryVariables = {
  meetingId: string,
  entityId?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAttendeeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAttendeesByMeetingIdQuery = {
  listAttendeesByMeetingId?:  {
    __typename: "ModelAttendeeConnection",
    items:  Array< {
      __typename: "Attendee",
      id: string,
      meetingId: string,
      entityId?: string | null,
      name?: string | null,
      role?: AttendeeRole | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetCodeBuildJobQueryVariables = {
  id: string,
};

export type GetCodeBuildJobQuery = {
  getCodeBuildJob?:  {
    __typename: "CodeBuildJob",
    id: string,
    parentId?: string | null,
    projectName?: string | null,
    status?: BuildStatus | null,
    artifactPath?: string | null,
    buildStartTime?: number | null,
    buildEndTime?: number | null,
    requestedBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListCodeBuildJobsQueryVariables = {
  id?: string | null,
  filter?: ModelCodeBuildJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListCodeBuildJobsQuery = {
  listCodeBuildJobs?:  {
    __typename: "ModelCodeBuildJobConnection",
    items:  Array< {
      __typename: "CodeBuildJob",
      id: string,
      parentId?: string | null,
      projectName?: string | null,
      status?: BuildStatus | null,
      artifactPath?: string | null,
      buildStartTime?: number | null,
      buildEndTime?: number | null,
      requestedBy?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncCodeBuildJobsQueryVariables = {
  filter?: ModelCodeBuildJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncCodeBuildJobsQuery = {
  syncCodeBuildJobs?:  {
    __typename: "ModelCodeBuildJobConnection",
    items:  Array< {
      __typename: "CodeBuildJob",
      id: string,
      parentId?: string | null,
      projectName?: string | null,
      status?: BuildStatus | null,
      artifactPath?: string | null,
      buildStartTime?: number | null,
      buildEndTime?: number | null,
      requestedBy?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListCodeBuildJobsByParentQueryVariables = {
  parentId: string,
  buildStartTime?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCodeBuildJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCodeBuildJobsByParentQuery = {
  listCodeBuildJobsByParent?:  {
    __typename: "ModelCodeBuildJobConnection",
    items:  Array< {
      __typename: "CodeBuildJob",
      id: string,
      parentId?: string | null,
      projectName?: string | null,
      status?: BuildStatus | null,
      artifactPath?: string | null,
      buildStartTime?: number | null,
      buildEndTime?: number | null,
      requestedBy?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetResourceNotificationSettingQueryVariables = {
  resourceId: string,
  resourceType: NotificationResourceType,
  notificationType: NotificationType,
};

export type GetResourceNotificationSettingQuery = {
  getResourceNotificationSetting?:  {
    __typename: "ResourceNotificationSetting",
    resourceId: string,
    resourceType: NotificationResourceType,
    notificationType: NotificationType,
    recipients?:  Array< {
      __typename: "NotificationRecipient",
      recipientId?: string | null,
      recipientIdType?: NotificationRecipientIdType | null,
      notificationChannels?: Array< NotificationChannel > | null,
      enabled?: boolean | null,
    } > | null,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListResourceNotificationSettingsQueryVariables = {
  resourceId?: string | null,
  resourceTypeNotificationType?: ModelResourceNotificationSettingPrimaryCompositeKeyConditionInput | null,
  filter?: ModelResourceNotificationSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListResourceNotificationSettingsQuery = {
  listResourceNotificationSettings?:  {
    __typename: "ModelResourceNotificationSettingConnection",
    items:  Array< {
      __typename: "ResourceNotificationSetting",
      resourceId: string,
      resourceType: NotificationResourceType,
      notificationType: NotificationType,
      recipients?:  Array< {
        __typename: "NotificationRecipient",
        recipientId?: string | null,
        recipientIdType?: NotificationRecipientIdType | null,
        notificationChannels?: Array< NotificationChannel > | null,
        enabled?: boolean | null,
      } > | null,
      enabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncResourceNotificationSettingsQueryVariables = {
  filter?: ModelResourceNotificationSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncResourceNotificationSettingsQuery = {
  syncResourceNotificationSettings?:  {
    __typename: "ModelResourceNotificationSettingConnection",
    items:  Array< {
      __typename: "ResourceNotificationSetting",
      resourceId: string,
      resourceType: NotificationResourceType,
      notificationType: NotificationType,
      recipients?:  Array< {
        __typename: "NotificationRecipient",
        recipientId?: string | null,
        recipientIdType?: NotificationRecipientIdType | null,
        notificationChannels?: Array< NotificationChannel > | null,
        enabled?: boolean | null,
      } > | null,
      enabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAssessmentScheduleQueryVariables = {
  id: string,
};

export type GetAssessmentScheduleQuery = {
  getAssessmentSchedule?:  {
    __typename: "AssessmentSchedule",
    id: string,
    propertyId?: string | null,
    name?: string | null,
    description?: string | null,
    startDate?: number | null,
    endDate?: number | null,
    recurrence?:  {
      __typename: "Recurrence",
      type?: RecurrenceType | null,
      dailyRecurrence?:  {
        __typename: "DailyRecurrence",
        interval?: number | null,
      } | null,
      weeklyRecurrence?:  {
        __typename: "WeeklyRecurrence",
        interval?: number | null,
        daysOfWeek?: Array< DayOfWeek | null > | null,
      } | null,
      monthlyRecurrence?:  {
        __typename: "MonthlyRecurrence",
        type?: MonthlyScheduleType | null,
        interval?: number | null,
        dayOfMonth?: string | null,
        nthWeekDay?:  {
          __typename: "NthWeekDay",
          weekNumber?: string | null,
          day?: DayOfWeek | null,
        } | null,
      } | null,
    } | null,
    authorizedIdentifiers?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAssessmentSchedulesQueryVariables = {
  id?: string | null,
  filter?: ModelAssessmentScheduleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAssessmentSchedulesQuery = {
  listAssessmentSchedules?:  {
    __typename: "ModelAssessmentScheduleConnection",
    items:  Array< {
      __typename: "AssessmentSchedule",
      id: string,
      propertyId?: string | null,
      name?: string | null,
      description?: string | null,
      startDate?: number | null,
      endDate?: number | null,
      recurrence?:  {
        __typename: "Recurrence",
        type?: RecurrenceType | null,
        dailyRecurrence?:  {
          __typename: "DailyRecurrence",
          interval?: number | null,
        } | null,
        weeklyRecurrence?:  {
          __typename: "WeeklyRecurrence",
          interval?: number | null,
          daysOfWeek?: Array< DayOfWeek | null > | null,
        } | null,
        monthlyRecurrence?:  {
          __typename: "MonthlyRecurrence",
          type?: MonthlyScheduleType | null,
          interval?: number | null,
          dayOfMonth?: string | null,
          nthWeekDay?:  {
            __typename: "NthWeekDay",
            weekNumber?: string | null,
            day?: DayOfWeek | null,
          } | null,
        } | null,
      } | null,
      authorizedIdentifiers?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAssessmentSchedulesQueryVariables = {
  filter?: ModelAssessmentScheduleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAssessmentSchedulesQuery = {
  syncAssessmentSchedules?:  {
    __typename: "ModelAssessmentScheduleConnection",
    items:  Array< {
      __typename: "AssessmentSchedule",
      id: string,
      propertyId?: string | null,
      name?: string | null,
      description?: string | null,
      startDate?: number | null,
      endDate?: number | null,
      recurrence?:  {
        __typename: "Recurrence",
        type?: RecurrenceType | null,
        dailyRecurrence?:  {
          __typename: "DailyRecurrence",
          interval?: number | null,
        } | null,
        weeklyRecurrence?:  {
          __typename: "WeeklyRecurrence",
          interval?: number | null,
          daysOfWeek?: Array< DayOfWeek | null > | null,
        } | null,
        monthlyRecurrence?:  {
          __typename: "MonthlyRecurrence",
          type?: MonthlyScheduleType | null,
          interval?: number | null,
          dayOfMonth?: string | null,
          nthWeekDay?:  {
            __typename: "NthWeekDay",
            weekNumber?: string | null,
            day?: DayOfWeek | null,
          } | null,
        } | null,
      } | null,
      authorizedIdentifiers?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListAssessmentSchedulesByPropertyQueryVariables = {
  propertyId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAssessmentScheduleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAssessmentSchedulesByPropertyQuery = {
  listAssessmentSchedulesByProperty?:  {
    __typename: "ModelAssessmentScheduleConnection",
    items:  Array< {
      __typename: "AssessmentSchedule",
      id: string,
      propertyId?: string | null,
      name?: string | null,
      description?: string | null,
      startDate?: number | null,
      endDate?: number | null,
      recurrence?:  {
        __typename: "Recurrence",
        type?: RecurrenceType | null,
        dailyRecurrence?:  {
          __typename: "DailyRecurrence",
          interval?: number | null,
        } | null,
        weeklyRecurrence?:  {
          __typename: "WeeklyRecurrence",
          interval?: number | null,
          daysOfWeek?: Array< DayOfWeek | null > | null,
        } | null,
        monthlyRecurrence?:  {
          __typename: "MonthlyRecurrence",
          type?: MonthlyScheduleType | null,
          interval?: number | null,
          dayOfMonth?: string | null,
          nthWeekDay?:  {
            __typename: "NthWeekDay",
            weekNumber?: string | null,
            day?: DayOfWeek | null,
          } | null,
        } | null,
      } | null,
      authorizedIdentifiers?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetResourceAssessmentScheduleAssociationQueryVariables = {
  id: string,
};

export type GetResourceAssessmentScheduleAssociationQuery = {
  getResourceAssessmentScheduleAssociation?:  {
    __typename: "ResourceAssessmentScheduleAssociation",
    id: string,
    assessmentScheduleId?: string | null,
    resourceId?: string | null,
    resourceType?: PermissionResourceType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListResourceAssessmentScheduleAssociationsQueryVariables = {
  id?: string | null,
  filter?: ModelResourceAssessmentScheduleAssociationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListResourceAssessmentScheduleAssociationsQuery = {
  listResourceAssessmentScheduleAssociations?:  {
    __typename: "ModelResourceAssessmentScheduleAssociationConnection",
    items:  Array< {
      __typename: "ResourceAssessmentScheduleAssociation",
      id: string,
      assessmentScheduleId?: string | null,
      resourceId?: string | null,
      resourceType?: PermissionResourceType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncResourceAssessmentScheduleAssociationsQueryVariables = {
  filter?: ModelResourceAssessmentScheduleAssociationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncResourceAssessmentScheduleAssociationsQuery = {
  syncResourceAssessmentScheduleAssociations?:  {
    __typename: "ModelResourceAssessmentScheduleAssociationConnection",
    items:  Array< {
      __typename: "ResourceAssessmentScheduleAssociation",
      id: string,
      assessmentScheduleId?: string | null,
      resourceId?: string | null,
      resourceType?: PermissionResourceType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListResourceAssessmentScheduleAssociationsByAssessmentScheduleQueryVariables = {
  assessmentScheduleId: string,
  resourceId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelResourceAssessmentScheduleAssociationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListResourceAssessmentScheduleAssociationsByAssessmentScheduleQuery = {
  listResourceAssessmentScheduleAssociationsByAssessmentSchedule?:  {
    __typename: "ModelResourceAssessmentScheduleAssociationConnection",
    items:  Array< {
      __typename: "ResourceAssessmentScheduleAssociation",
      id: string,
      assessmentScheduleId?: string | null,
      resourceId?: string | null,
      resourceType?: PermissionResourceType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListResourceAssessmentScheduleAssociationsByResourceQueryVariables = {
  resourceId: string,
  resourceType?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelResourceAssessmentScheduleAssociationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListResourceAssessmentScheduleAssociationsByResourceQuery = {
  listResourceAssessmentScheduleAssociationsByResource?:  {
    __typename: "ModelResourceAssessmentScheduleAssociationConnection",
    items:  Array< {
      __typename: "ResourceAssessmentScheduleAssociation",
      id: string,
      assessmentScheduleId?: string | null,
      resourceId?: string | null,
      resourceType?: PermissionResourceType | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAssessmentQueryVariables = {
  id: string,
};

export type GetAssessmentQuery = {
  getAssessment?:  {
    __typename: "Assessment",
    id: string,
    scheduleId?: string | null,
    resourceId?: string | null,
    propertyId?: string | null,
    resourceType?: PermissionResourceType | null,
    createdBy?: string | null,
    submittedBy?:  {
      __typename: "ExternalUserInfo",
      firstName?: string | null,
      lastName?: string | null,
    } | null,
    createdTime?: number | null,
    status?: AssessmentStatus | null,
    issueIds?: Array< string | null > | null,
    tagIds?: Array< string > | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAssessmentsQueryVariables = {
  id?: string | null,
  filter?: ModelAssessmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListAssessmentsQuery = {
  listAssessments?:  {
    __typename: "ModelAssessmentConnection",
    items:  Array< {
      __typename: "Assessment",
      id: string,
      scheduleId?: string | null,
      resourceId?: string | null,
      propertyId?: string | null,
      resourceType?: PermissionResourceType | null,
      createdBy?: string | null,
      submittedBy?:  {
        __typename: "ExternalUserInfo",
        firstName?: string | null,
        lastName?: string | null,
      } | null,
      createdTime?: number | null,
      status?: AssessmentStatus | null,
      issueIds?: Array< string | null > | null,
      tagIds?: Array< string > | null,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAssessmentsQueryVariables = {
  filter?: ModelAssessmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAssessmentsQuery = {
  syncAssessments?:  {
    __typename: "ModelAssessmentConnection",
    items:  Array< {
      __typename: "Assessment",
      id: string,
      scheduleId?: string | null,
      resourceId?: string | null,
      propertyId?: string | null,
      resourceType?: PermissionResourceType | null,
      createdBy?: string | null,
      submittedBy?:  {
        __typename: "ExternalUserInfo",
        firstName?: string | null,
        lastName?: string | null,
      } | null,
      createdTime?: number | null,
      status?: AssessmentStatus | null,
      issueIds?: Array< string | null > | null,
      tagIds?: Array< string > | null,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListAssessmentsByScheduleQueryVariables = {
  scheduleId: string,
  createdTime?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAssessmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAssessmentsByScheduleQuery = {
  listAssessmentsBySchedule?:  {
    __typename: "ModelAssessmentConnection",
    items:  Array< {
      __typename: "Assessment",
      id: string,
      scheduleId?: string | null,
      resourceId?: string | null,
      propertyId?: string | null,
      resourceType?: PermissionResourceType | null,
      createdBy?: string | null,
      submittedBy?:  {
        __typename: "ExternalUserInfo",
        firstName?: string | null,
        lastName?: string | null,
      } | null,
      createdTime?: number | null,
      status?: AssessmentStatus | null,
      issueIds?: Array< string | null > | null,
      tagIds?: Array< string > | null,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListAssessmentsByResourceQueryVariables = {
  resourceId: string,
  resourceType?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAssessmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAssessmentsByResourceQuery = {
  listAssessmentsByResource?:  {
    __typename: "ModelAssessmentConnection",
    items:  Array< {
      __typename: "Assessment",
      id: string,
      scheduleId?: string | null,
      resourceId?: string | null,
      propertyId?: string | null,
      resourceType?: PermissionResourceType | null,
      createdBy?: string | null,
      submittedBy?:  {
        __typename: "ExternalUserInfo",
        firstName?: string | null,
        lastName?: string | null,
      } | null,
      createdTime?: number | null,
      status?: AssessmentStatus | null,
      issueIds?: Array< string | null > | null,
      tagIds?: Array< string > | null,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListAssessmentsByPropertyQueryVariables = {
  propertyId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAssessmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAssessmentsByPropertyQuery = {
  listAssessmentsByProperty?:  {
    __typename: "ModelAssessmentConnection",
    items:  Array< {
      __typename: "Assessment",
      id: string,
      scheduleId?: string | null,
      resourceId?: string | null,
      propertyId?: string | null,
      resourceType?: PermissionResourceType | null,
      createdBy?: string | null,
      submittedBy?:  {
        __typename: "ExternalUserInfo",
        firstName?: string | null,
        lastName?: string | null,
      } | null,
      createdTime?: number | null,
      status?: AssessmentStatus | null,
      issueIds?: Array< string | null > | null,
      tagIds?: Array< string > | null,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetContactQueryVariables = {
  id: string,
};

export type GetContactQuery = {
  getContact?:  {
    __typename: "Contact",
    id: string,
    name?: string | null,
    email?: string | null,
    phoneNumber?: string | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListContactsQueryVariables = {
  filter?: ModelContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListContactsQuery = {
  listContacts?:  {
    __typename: "ModelContactConnection",
    items:  Array< {
      __typename: "Contact",
      id: string,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncContactsQueryVariables = {
  filter?: ModelContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncContactsQuery = {
  syncContacts?:  {
    __typename: "ModelContactConnection",
    items:  Array< {
      __typename: "Contact",
      id: string,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetProperty3PIntegrationConfigurationQueryVariables = {
  id: string,
};

export type GetProperty3PIntegrationConfigurationQuery = {
  getProperty3PIntegrationConfiguration?:  {
    __typename: "Property3PIntegrationConfiguration",
    id: string,
    propertyId: string,
    workflowEndpoint: string,
    workflowName: string,
    clientId: string,
    clientSecret: string,
    tokenUrl: string,
    authorizeUrl: string,
    scope: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListProperty3PIntegrationConfigurationsQueryVariables = {
  id?: string | null,
  filter?: ModelProperty3PIntegrationConfigurationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListProperty3PIntegrationConfigurationsQuery = {
  listProperty3PIntegrationConfigurations?:  {
    __typename: "ModelProperty3PIntegrationConfigurationConnection",
    items:  Array< {
      __typename: "Property3PIntegrationConfiguration",
      id: string,
      propertyId: string,
      workflowEndpoint: string,
      workflowName: string,
      clientId: string,
      clientSecret: string,
      tokenUrl: string,
      authorizeUrl: string,
      scope: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncProperty3PIntegrationConfigurationsQueryVariables = {
  filter?: ModelProperty3PIntegrationConfigurationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncProperty3PIntegrationConfigurationsQuery = {
  syncProperty3PIntegrationConfigurations?:  {
    __typename: "ModelProperty3PIntegrationConfigurationConnection",
    items:  Array< {
      __typename: "Property3PIntegrationConfiguration",
      id: string,
      propertyId: string,
      workflowEndpoint: string,
      workflowName: string,
      clientId: string,
      clientSecret: string,
      tokenUrl: string,
      authorizeUrl: string,
      scope: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListConfigurationsByPropertyQueryVariables = {
  propertyId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProperty3PIntegrationConfigurationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListConfigurationsByPropertyQuery = {
  listConfigurationsByProperty?:  {
    __typename: "ModelProperty3PIntegrationConfigurationConnection",
    items:  Array< {
      __typename: "Property3PIntegrationConfiguration",
      id: string,
      propertyId: string,
      workflowEndpoint: string,
      workflowName: string,
      clientId: string,
      clientSecret: string,
      tokenUrl: string,
      authorizeUrl: string,
      scope: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetConversationStateQueryVariables = {
  id: string,
};

export type GetConversationStateQuery = {
  getConversationState?:  {
    __typename: "ConversationState",
    id: string,
    attachments?: Array< string | null > | null,
    conversationType: string,
    extractedDetails: string,
    conversationStatus: ConversationStatus,
    invokerId: string,
    nextStep?: ConversationNextStep | null,
    nextStepMessage?: string | null,
    userId?: string | null,
    externalConversationId?: string | null,
    phoneNumber?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListConversationStatesQueryVariables = {
  id?: string | null,
  filter?: ModelConversationStateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListConversationStatesQuery = {
  listConversationStates?:  {
    __typename: "ModelConversationStateConnection",
    items:  Array< {
      __typename: "ConversationState",
      id: string,
      attachments?: Array< string | null > | null,
      conversationType: string,
      extractedDetails: string,
      conversationStatus: ConversationStatus,
      invokerId: string,
      nextStep?: ConversationNextStep | null,
      nextStepMessage?: string | null,
      userId?: string | null,
      externalConversationId?: string | null,
      phoneNumber?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncConversationStatesQueryVariables = {
  filter?: ModelConversationStateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncConversationStatesQuery = {
  syncConversationStates?:  {
    __typename: "ModelConversationStateConnection",
    items:  Array< {
      __typename: "ConversationState",
      id: string,
      attachments?: Array< string | null > | null,
      conversationType: string,
      extractedDetails: string,
      conversationStatus: ConversationStatus,
      invokerId: string,
      nextStep?: ConversationNextStep | null,
      nextStepMessage?: string | null,
      userId?: string | null,
      externalConversationId?: string | null,
      phoneNumber?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListConversationStatesByPhoneNumberAndStatusQueryVariables = {
  phoneNumber: string,
  conversationStatus?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelConversationStateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListConversationStatesByPhoneNumberAndStatusQuery = {
  listConversationStatesByPhoneNumberAndStatus?:  {
    __typename: "ModelConversationStateConnection",
    items:  Array< {
      __typename: "ConversationState",
      id: string,
      attachments?: Array< string | null > | null,
      conversationType: string,
      extractedDetails: string,
      conversationStatus: ConversationStatus,
      invokerId: string,
      nextStep?: ConversationNextStep | null,
      nextStepMessage?: string | null,
      userId?: string | null,
      externalConversationId?: string | null,
      phoneNumber?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetPolicyTemplateLinkQueryVariables = {
  id: string,
};

export type GetPolicyTemplateLinkQuery = {
  getPolicyTemplateLink?:  {
    __typename: "PolicyTemplateLink",
    id: string,
    templateId: string,
    entityId: string,
    entityType: PermissionEntityType,
    resourceId: string,
    resourceType: PermissionResourceType,
    grantedBy?: string | null,
    grantedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListPolicyTemplateLinksQueryVariables = {
  id?: string | null,
  filter?: ModelPolicyTemplateLinkFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPolicyTemplateLinksQuery = {
  listPolicyTemplateLinks?:  {
    __typename: "ModelPolicyTemplateLinkConnection",
    items:  Array< {
      __typename: "PolicyTemplateLink",
      id: string,
      templateId: string,
      entityId: string,
      entityType: PermissionEntityType,
      resourceId: string,
      resourceType: PermissionResourceType,
      grantedBy?: string | null,
      grantedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncPolicyTemplateLinksQueryVariables = {
  filter?: ModelPolicyTemplateLinkFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncPolicyTemplateLinksQuery = {
  syncPolicyTemplateLinks?:  {
    __typename: "ModelPolicyTemplateLinkConnection",
    items:  Array< {
      __typename: "PolicyTemplateLink",
      id: string,
      templateId: string,
      entityId: string,
      entityType: PermissionEntityType,
      resourceId: string,
      resourceType: PermissionResourceType,
      grantedBy?: string | null,
      grantedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListPolicyTemplateLinksByEntityIdQueryVariables = {
  entityId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPolicyTemplateLinkFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPolicyTemplateLinksByEntityIdQuery = {
  listPolicyTemplateLinksByEntityId?:  {
    __typename: "ModelPolicyTemplateLinkConnection",
    items:  Array< {
      __typename: "PolicyTemplateLink",
      id: string,
      templateId: string,
      entityId: string,
      entityType: PermissionEntityType,
      resourceId: string,
      resourceType: PermissionResourceType,
      grantedBy?: string | null,
      grantedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ListPolicyTemplateLinksByResourceIdQueryVariables = {
  resourceId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPolicyTemplateLinkFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPolicyTemplateLinksByResourceIdQuery = {
  listPolicyTemplateLinksByResourceId?:  {
    __typename: "ModelPolicyTemplateLinkConnection",
    items:  Array< {
      __typename: "PolicyTemplateLink",
      id: string,
      templateId: string,
      entityId: string,
      entityType: PermissionEntityType,
      resourceId: string,
      resourceType: PermissionResourceType,
      grantedBy?: string | null,
      grantedAt?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetGenerateIssuesFromImagesJobQueryVariables = {
  id: string,
};

export type GetGenerateIssuesFromImagesJobQuery = {
  getGenerateIssuesFromImagesJob?:  {
    __typename: "GenerateIssuesFromImagesJob",
    id: string,
    extractedIssues: string,
    status: GenerateIssuesFromImagesJobStatus,
    invokerId: string,
    userId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListGenerateIssuesFromImagesJobsQueryVariables = {
  id?: string | null,
  filter?: ModelGenerateIssuesFromImagesJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListGenerateIssuesFromImagesJobsQuery = {
  listGenerateIssuesFromImagesJobs?:  {
    __typename: "ModelGenerateIssuesFromImagesJobConnection",
    items:  Array< {
      __typename: "GenerateIssuesFromImagesJob",
      id: string,
      extractedIssues: string,
      status: GenerateIssuesFromImagesJobStatus,
      invokerId: string,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncGenerateIssuesFromImagesJobsQueryVariables = {
  filter?: ModelGenerateIssuesFromImagesJobFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncGenerateIssuesFromImagesJobsQuery = {
  syncGenerateIssuesFromImagesJobs?:  {
    __typename: "ModelGenerateIssuesFromImagesJobConnection",
    items:  Array< {
      __typename: "GenerateIssuesFromImagesJob",
      id: string,
      extractedIssues: string,
      status: GenerateIssuesFromImagesJobStatus,
      invokerId: string,
      userId?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetPreSignedUploadURLQueryVariables = {
  input: GetPreSignedUploadURLRequest,
};

export type GetPreSignedUploadURLQuery = {
  getPreSignedUploadURL?: string | null,
};

export type GetPreSignedDownloadURLQueryVariables = {
  input: GetPreSignedDownloadRequest,
};

export type GetPreSignedDownloadURLQuery = {
  getPreSignedDownloadURL?: string | null,
};

export type GetAccountClaimStatusQueryVariables = {
};

export type GetAccountClaimStatusQuery = {
  getAccountClaimStatus?:  {
    __typename: "GetAccountClaimStatusResponse",
    status?: AccountClaimStatus | null,
  } | null,
};

export type HandleConverseCommandQueryVariables = {
  input?: HandleConverseCommandInput | null,
};

export type HandleConverseCommandQuery = {
  handleConverseCommand?: string | null,
};

export type SummarizeIssueQueryVariables = {
  input?: SummarizeIssueInput | null,
};

export type SummarizeIssueQuery = {
  summarizeIssue?:  {
    __typename: "SummarizeIssueOutput",
    description: string,
    workTypes?:  Array< {
      __typename: "WorkTypeDTO",
      id?: string | null,
      groupId?: string | null,
      version?: number | null,
      name?: string | null,
      categoryName?: string | null,
      shortDescription?: string | null,
      longDescription?: string | null,
      dimensionType?: DimensionType | null,
    } | null > | null,
  } | null,
};

export type CustomSearchUsersQueryVariables = {
  input: SearchUsersVariables,
};

export type CustomSearchUsersQuery = {
  customSearchUsers?:  {
    __typename: "SearchUsersOutput",
    items?:  Array< {
      __typename: "User",
      id: string,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type CustomSearchOrganizationsQueryVariables = {
  input: SearchOrganizationsVariables,
};

export type CustomSearchOrganizationsQuery = {
  customSearchOrganizations?:  {
    __typename: "SearchOrganizationsOutput",
    items?:  Array< {
      __typename: "Organization",
      id: string,
      legalName: string,
      type?: OrganizationType | null,
      canView?: string | null,
      canEdit?: string | null,
      canDelete?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type CustomSearchContactsQueryVariables = {
  input: SearchContactsVariables,
};

export type CustomSearchContactsQuery = {
  customSearchContacts?:  {
    __typename: "SearchableContactFilterOutput",
    items?:  Array< {
      __typename: "Contact",
      id: string,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      createdBy?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetFormConfigurationQueryVariables = {
  id?: string | null,
};

export type GetFormConfigurationQuery = {
  getFormConfiguration: ( {
      __typename: "PlainFormConfiguration",
      linkRegistry?:  {
        __typename: string,
        id: string,
        propertyId?: string | null,
        action?: LinkAction | null,
        variables?: string | null,
        published?: boolean | null,
        createdBy?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
    } | {
      __typename: "AssessmentFormConfiguration",
      linkRegistry?:  {
        __typename: string,
        id: string,
        propertyId?: string | null,
        action?: LinkAction | null,
        variables?: string | null,
        published?: boolean | null,
        createdBy?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      branding?:  {
        __typename: string,
        id: string,
        name?: string | null,
        logoKey?: string | null,
        createdBy?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      locationId?: string | null,
      locationName?: string | null,
      propertyId?: string | null,
      authorizedIdentifiers?: Array< string > | null,
    } | {
      __typename: "IssueSubmissionFormConfiguration",
      linkRegistry?:  {
        __typename: string,
        id: string,
        propertyId?: string | null,
        action?: LinkAction | null,
        variables?: string | null,
        published?: boolean | null,
        createdBy?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      branding?:  {
        __typename: string,
        id: string,
        name?: string | null,
        logoKey?: string | null,
        createdBy?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      locationId?: string | null,
      locationName?: string | null,
      propertyId?: string | null,
    }
  ) | null,
};

export type ListFormConfigurationsByPropertyQueryVariables = {
  propertyId: string,
  actions?: Array< LinkAction > | null,
  nextToken?: string | null,
};

export type ListFormConfigurationsByPropertyQuery = {
  listFormConfigurationsByProperty?:  {
    __typename: "ListFormConfigurationsByPropertyOutput",
    items?: Array< string | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListAssessmentSchedulesByAssessorsQueryVariables = {
  assessors: Array< string | null >,
  nextToken?: string | null,
};

export type ListAssessmentSchedulesByAssessorsQuery = {
  listAssessmentSchedulesByAssessors?:  {
    __typename: "ListAssessmentSchedulesByAssessorsOutput",
    items?:  Array< {
      __typename: "AssessmentScheduleByAssessors",
      scheduleName?: string | null,
      locationNames?: Array< string | null > | null,
      scheduleDate?: number | null,
      assessors: Array< string >,
      status: AssessmentCompletionStatus,
      overdue: boolean,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type GetSubscriptionDetailsQueryVariables = {
};

export type GetSubscriptionDetailsQuery = {
  getSubscriptionDetails?:  {
    __typename: "SubscriptionDetails",
    plan?: string | null,
    meteringLimit?: number | null,
    meteringUsage?: number | null,
    trialEnd?: number | null,
  } | null,
};

export type FilterImagesQueryVariables = {
  input?: FilterImagesInput | null,
};

export type FilterImagesQuery = {
  filterImages?:  {
    __typename: "FilterImagesOutput",
    validImages?: Array< string > | null,
  } | null,
};

export type ClassifyIssuesQueryVariables = {
  input?: ClassifyIssuesInput | null,
};

export type ClassifyIssuesQuery = {
  classifyIssues?:  {
    __typename: "ClassifyIssuesOutput",
    issues?:  Array< {
      __typename: "ClassifiedIssue",
      note: string,
      images?: Array< string > | null,
      attachmentLocation?: AttachmentLocation | null,
    } > | null,
  } | null,
};

export type OnCompleteEventSubscriptionVariables = {
  executionId: string,
};

export type OnCompleteEventSubscription = {
  onCompleteEvent?:  {
    __typename: "CompleteEvent",
    executionId: string,
    status: CompleteEventStatus,
    result?: string | null,
  } | null,
};

export type OnCreateAttachmentSubscriptionVariables = {
  filter?: ModelSubscriptionAttachmentFilterInput | null,
};

export type OnCreateAttachmentSubscription = {
  onCreateAttachment?:  {
    __typename: "Attachment",
    id: string,
    name?: string | null,
    type?: AttachmentType | null,
    parentId: string,
    parentType?: PermissionResourceType | null,
    propertyId?: string | null,
    key?: string | null,
    localCreatedAtTime?: number | null,
    status?: string | null,
    imageSource?: ImageSource | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAttachmentSubscriptionVariables = {
  filter?: ModelSubscriptionAttachmentFilterInput | null,
};

export type OnUpdateAttachmentSubscription = {
  onUpdateAttachment?:  {
    __typename: "Attachment",
    id: string,
    name?: string | null,
    type?: AttachmentType | null,
    parentId: string,
    parentType?: PermissionResourceType | null,
    propertyId?: string | null,
    key?: string | null,
    localCreatedAtTime?: number | null,
    status?: string | null,
    imageSource?: ImageSource | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAttachmentSubscriptionVariables = {
  filter?: ModelSubscriptionAttachmentFilterInput | null,
};

export type OnDeleteAttachmentSubscription = {
  onDeleteAttachment?:  {
    __typename: "Attachment",
    id: string,
    name?: string | null,
    type?: AttachmentType | null,
    parentId: string,
    parentType?: PermissionResourceType | null,
    propertyId?: string | null,
    key?: string | null,
    localCreatedAtTime?: number | null,
    status?: string | null,
    imageSource?: ImageSource | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateBiddingContactSubscriptionVariables = {
  filter?: ModelSubscriptionBiddingContactFilterInput | null,
};

export type OnCreateBiddingContactSubscription = {
  onCreateBiddingContact?:  {
    __typename: "BiddingContact",
    id: string,
    email: string,
    ownerEntityId?: string | null,
    contactEntityId?: string | null,
    name?: string | null,
    privateDescription?: string | null,
    publicDescription?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateBiddingContactSubscriptionVariables = {
  filter?: ModelSubscriptionBiddingContactFilterInput | null,
};

export type OnUpdateBiddingContactSubscription = {
  onUpdateBiddingContact?:  {
    __typename: "BiddingContact",
    id: string,
    email: string,
    ownerEntityId?: string | null,
    contactEntityId?: string | null,
    name?: string | null,
    privateDescription?: string | null,
    publicDescription?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteBiddingContactSubscriptionVariables = {
  filter?: ModelSubscriptionBiddingContactFilterInput | null,
};

export type OnDeleteBiddingContactSubscription = {
  onDeleteBiddingContact?:  {
    __typename: "BiddingContact",
    id: string,
    email: string,
    ownerEntityId?: string | null,
    contactEntityId?: string | null,
    name?: string | null,
    privateDescription?: string | null,
    publicDescription?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateBidInvitationSubscriptionVariables = {
  filter?: ModelSubscriptionBidInvitationFilterInput | null,
};

export type OnCreateBidInvitationSubscription = {
  onCreateBidInvitation?:  {
    __typename: "BidInvitation",
    id: string,
    biddingContactId?: string | null,
    tenderId?: string | null,
    ownerEntityId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateBidInvitationSubscriptionVariables = {
  filter?: ModelSubscriptionBidInvitationFilterInput | null,
};

export type OnUpdateBidInvitationSubscription = {
  onUpdateBidInvitation?:  {
    __typename: "BidInvitation",
    id: string,
    biddingContactId?: string | null,
    tenderId?: string | null,
    ownerEntityId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteBidInvitationSubscriptionVariables = {
  filter?: ModelSubscriptionBidInvitationFilterInput | null,
};

export type OnDeleteBidInvitationSubscription = {
  onDeleteBidInvitation?:  {
    __typename: "BidInvitation",
    id: string,
    biddingContactId?: string | null,
    tenderId?: string | null,
    ownerEntityId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateBidSubscriptionVariables = {
  filter?: ModelSubscriptionBidFilterInput | null,
};

export type OnCreateBidSubscription = {
  onCreateBid?:  {
    __typename: "Bid",
    id: string,
    tenderId?: string | null,
    latestMinorVersion?: number | null,
    latestAcceptedMinorVersion?: number | null,
    latestSubmittedMinorVersion?: number | null,
    status?: BidStatus | null,
    bidNumber?: number | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateBidSubscriptionVariables = {
  filter?: ModelSubscriptionBidFilterInput | null,
};

export type OnUpdateBidSubscription = {
  onUpdateBid?:  {
    __typename: "Bid",
    id: string,
    tenderId?: string | null,
    latestMinorVersion?: number | null,
    latestAcceptedMinorVersion?: number | null,
    latestSubmittedMinorVersion?: number | null,
    status?: BidStatus | null,
    bidNumber?: number | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteBidSubscriptionVariables = {
  filter?: ModelSubscriptionBidFilterInput | null,
};

export type OnDeleteBidSubscription = {
  onDeleteBid?:  {
    __typename: "Bid",
    id: string,
    tenderId?: string | null,
    latestMinorVersion?: number | null,
    latestAcceptedMinorVersion?: number | null,
    latestSubmittedMinorVersion?: number | null,
    status?: BidStatus | null,
    bidNumber?: number | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateBidMinorVersionSubscriptionVariables = {
  filter?: ModelSubscriptionBidMinorVersionFilterInput | null,
};

export type OnCreateBidMinorVersionSubscription = {
  onCreateBidMinorVersion?:  {
    __typename: "BidMinorVersion",
    id: string,
    bidId?: string | null,
    minorVersion?: number | null,
    tenderId?: string | null,
    tenderMinorVersion?: number | null,
    proposalId?: string | null,
    status?: DocumentStatus | null,
    metadata?:  {
      __typename: "BidMetadata",
      bidderContactName?: string | null,
      bidderContactEmail?: string | null,
      bidderCompanyName?: string | null,
      bidderContactAddress?: string | null,
      bidderContactPhoneNumber?: string | null,
      bidderWebsite?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateBidMinorVersionSubscriptionVariables = {
  filter?: ModelSubscriptionBidMinorVersionFilterInput | null,
};

export type OnUpdateBidMinorVersionSubscription = {
  onUpdateBidMinorVersion?:  {
    __typename: "BidMinorVersion",
    id: string,
    bidId?: string | null,
    minorVersion?: number | null,
    tenderId?: string | null,
    tenderMinorVersion?: number | null,
    proposalId?: string | null,
    status?: DocumentStatus | null,
    metadata?:  {
      __typename: "BidMetadata",
      bidderContactName?: string | null,
      bidderContactEmail?: string | null,
      bidderCompanyName?: string | null,
      bidderContactAddress?: string | null,
      bidderContactPhoneNumber?: string | null,
      bidderWebsite?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteBidMinorVersionSubscriptionVariables = {
  filter?: ModelSubscriptionBidMinorVersionFilterInput | null,
};

export type OnDeleteBidMinorVersionSubscription = {
  onDeleteBidMinorVersion?:  {
    __typename: "BidMinorVersion",
    id: string,
    bidId?: string | null,
    minorVersion?: number | null,
    tenderId?: string | null,
    tenderMinorVersion?: number | null,
    proposalId?: string | null,
    status?: DocumentStatus | null,
    metadata?:  {
      __typename: "BidMetadata",
      bidderContactName?: string | null,
      bidderContactEmail?: string | null,
      bidderCompanyName?: string | null,
      bidderContactAddress?: string | null,
      bidderContactPhoneNumber?: string | null,
      bidderWebsite?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateClientLogSubscriptionVariables = {
  filter?: ModelSubscriptionClientLogFilterInput | null,
};

export type OnCreateClientLogSubscription = {
  onCreateClientLog?:  {
    __typename: "ClientLog",
    id: string,
    userId?: string | null,
    userAgent?: string | null,
    severityLevel: LogSeverityLevel,
    componentName: string,
    message?: string | null,
    details?: string | null,
    tags?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateClientLogSubscriptionVariables = {
  filter?: ModelSubscriptionClientLogFilterInput | null,
};

export type OnUpdateClientLogSubscription = {
  onUpdateClientLog?:  {
    __typename: "ClientLog",
    id: string,
    userId?: string | null,
    userAgent?: string | null,
    severityLevel: LogSeverityLevel,
    componentName: string,
    message?: string | null,
    details?: string | null,
    tags?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteClientLogSubscriptionVariables = {
  filter?: ModelSubscriptionClientLogFilterInput | null,
};

export type OnDeleteClientLogSubscription = {
  onDeleteClientLog?:  {
    __typename: "ClientLog",
    id: string,
    userId?: string | null,
    userAgent?: string | null,
    severityLevel: LogSeverityLevel,
    componentName: string,
    message?: string | null,
    details?: string | null,
    tags?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateCounterSubscriptionVariables = {
  filter?: ModelSubscriptionCounterFilterInput | null,
};

export type OnCreateCounterSubscription = {
  onCreateCounter?:  {
    __typename: "Counter",
    id: string,
    type: ResourceType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateCounterSubscriptionVariables = {
  filter?: ModelSubscriptionCounterFilterInput | null,
};

export type OnUpdateCounterSubscription = {
  onUpdateCounter?:  {
    __typename: "Counter",
    id: string,
    type: ResourceType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteCounterSubscriptionVariables = {
  filter?: ModelSubscriptionCounterFilterInput | null,
};

export type OnDeleteCounterSubscription = {
  onDeleteCounter?:  {
    __typename: "Counter",
    id: string,
    type: ResourceType,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateDesignDocumentSubscriptionVariables = {
  filter?: ModelSubscriptionDesignDocumentFilterInput | null,
};

export type OnCreateDesignDocumentSubscription = {
  onCreateDesignDocument?:  {
    __typename: "DesignDocument",
    id: string,
    designDocumentGroupId?: string | null,
    propertyId: string,
    projectId: string,
    name: string,
    status?: DesignDocumentStatus | null,
    lastEvaluatedValidityStatus?: boolean | null,
    uploadStatus?: string | null,
    documentKey?: string | null,
    lastWorkScopeSpecificationItemNumber?: number | null,
    version?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateDesignDocumentSubscriptionVariables = {
  filter?: ModelSubscriptionDesignDocumentFilterInput | null,
};

export type OnUpdateDesignDocumentSubscription = {
  onUpdateDesignDocument?:  {
    __typename: "DesignDocument",
    id: string,
    designDocumentGroupId?: string | null,
    propertyId: string,
    projectId: string,
    name: string,
    status?: DesignDocumentStatus | null,
    lastEvaluatedValidityStatus?: boolean | null,
    uploadStatus?: string | null,
    documentKey?: string | null,
    lastWorkScopeSpecificationItemNumber?: number | null,
    version?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteDesignDocumentSubscriptionVariables = {
  filter?: ModelSubscriptionDesignDocumentFilterInput | null,
};

export type OnDeleteDesignDocumentSubscription = {
  onDeleteDesignDocument?:  {
    __typename: "DesignDocument",
    id: string,
    designDocumentGroupId?: string | null,
    propertyId: string,
    projectId: string,
    name: string,
    status?: DesignDocumentStatus | null,
    lastEvaluatedValidityStatus?: boolean | null,
    uploadStatus?: string | null,
    documentKey?: string | null,
    lastWorkScopeSpecificationItemNumber?: number | null,
    version?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateDesignDocumentGroupSubscriptionVariables = {
  filter?: ModelSubscriptionDesignDocumentGroupFilterInput | null,
};

export type OnCreateDesignDocumentGroupSubscription = {
  onCreateDesignDocumentGroup?:  {
    __typename: "DesignDocumentGroup",
    id: string,
    projectId: string,
    propertyId: string,
    name: string,
    latestDocumentVersion: number,
    documentContentKey?: string | null,
    solutionGroupNumber?: number | null,
    isLocked: boolean,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateDesignDocumentGroupSubscriptionVariables = {
  filter?: ModelSubscriptionDesignDocumentGroupFilterInput | null,
};

export type OnUpdateDesignDocumentGroupSubscription = {
  onUpdateDesignDocumentGroup?:  {
    __typename: "DesignDocumentGroup",
    id: string,
    projectId: string,
    propertyId: string,
    name: string,
    latestDocumentVersion: number,
    documentContentKey?: string | null,
    solutionGroupNumber?: number | null,
    isLocked: boolean,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteDesignDocumentGroupSubscriptionVariables = {
  filter?: ModelSubscriptionDesignDocumentGroupFilterInput | null,
};

export type OnDeleteDesignDocumentGroupSubscription = {
  onDeleteDesignDocumentGroup?:  {
    __typename: "DesignDocumentGroup",
    id: string,
    projectId: string,
    propertyId: string,
    name: string,
    latestDocumentVersion: number,
    documentContentKey?: string | null,
    solutionGroupNumber?: number | null,
    isLocked: boolean,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateDimensionSubscriptionVariables = {
  filter?: ModelSubscriptionDimensionFilterInput | null,
};

export type OnCreateDimensionSubscription = {
  onCreateDimension?:  {
    __typename: "Dimension",
    id: string,
    parentId?: string | null,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    description?: string | null,
    length?: number | null,
    lengthUnit?: string | null,
    width?: number | null,
    widthUnit?: string | null,
    dimensionType?: DimensionType | null,
    measurementUnit?: MeasurementUnit | null,
    measurement?:  {
      __typename: "Measurement",
      length?: number | null,
      width?: number | null,
      dimensionType?: DimensionType | null,
      measurementUnit?: MeasurementUnit | null,
    } | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateDimensionSubscriptionVariables = {
  filter?: ModelSubscriptionDimensionFilterInput | null,
};

export type OnUpdateDimensionSubscription = {
  onUpdateDimension?:  {
    __typename: "Dimension",
    id: string,
    parentId?: string | null,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    description?: string | null,
    length?: number | null,
    lengthUnit?: string | null,
    width?: number | null,
    widthUnit?: string | null,
    dimensionType?: DimensionType | null,
    measurementUnit?: MeasurementUnit | null,
    measurement?:  {
      __typename: "Measurement",
      length?: number | null,
      width?: number | null,
      dimensionType?: DimensionType | null,
      measurementUnit?: MeasurementUnit | null,
    } | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteDimensionSubscriptionVariables = {
  filter?: ModelSubscriptionDimensionFilterInput | null,
};

export type OnDeleteDimensionSubscription = {
  onDeleteDimension?:  {
    __typename: "Dimension",
    id: string,
    parentId?: string | null,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    description?: string | null,
    length?: number | null,
    lengthUnit?: string | null,
    width?: number | null,
    widthUnit?: string | null,
    dimensionType?: DimensionType | null,
    measurementUnit?: MeasurementUnit | null,
    measurement?:  {
      __typename: "Measurement",
      length?: number | null,
      width?: number | null,
      dimensionType?: DimensionType | null,
      measurementUnit?: MeasurementUnit | null,
    } | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateDiscoverableWorkTypesSubscriptionVariables = {
  filter?: ModelSubscriptionDiscoverableWorkTypesFilterInput | null,
};

export type OnCreateDiscoverableWorkTypesSubscription = {
  onCreateDiscoverableWorkTypes?:  {
    __typename: "DiscoverableWorkTypes",
    id: string,
    workTypeGroupId: string,
    defaultVersion: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateDiscoverableWorkTypesSubscriptionVariables = {
  filter?: ModelSubscriptionDiscoverableWorkTypesFilterInput | null,
};

export type OnUpdateDiscoverableWorkTypesSubscription = {
  onUpdateDiscoverableWorkTypes?:  {
    __typename: "DiscoverableWorkTypes",
    id: string,
    workTypeGroupId: string,
    defaultVersion: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteDiscoverableWorkTypesSubscriptionVariables = {
  filter?: ModelSubscriptionDiscoverableWorkTypesFilterInput | null,
};

export type OnDeleteDiscoverableWorkTypesSubscription = {
  onDeleteDiscoverableWorkTypes?:  {
    __typename: "DiscoverableWorkTypes",
    id: string,
    workTypeGroupId: string,
    defaultVersion: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateEntityResourcePermissionSubscriptionVariables = {
  filter?: ModelSubscriptionEntityResourcePermissionFilterInput | null,
};

export type OnCreateEntityResourcePermissionSubscription = {
  onCreateEntityResourcePermission?:  {
    __typename: "EntityResourcePermission",
    id: string,
    propertyId?: string | null,
    entityId?: string | null,
    entityType?: PermissionEntityType | null,
    resourceId?: string | null,
    resourceType?: PermissionResourceType | null,
    permissionType?: PermissionType | null,
    isGranted?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateEntityResourcePermissionSubscriptionVariables = {
  filter?: ModelSubscriptionEntityResourcePermissionFilterInput | null,
};

export type OnUpdateEntityResourcePermissionSubscription = {
  onUpdateEntityResourcePermission?:  {
    __typename: "EntityResourcePermission",
    id: string,
    propertyId?: string | null,
    entityId?: string | null,
    entityType?: PermissionEntityType | null,
    resourceId?: string | null,
    resourceType?: PermissionResourceType | null,
    permissionType?: PermissionType | null,
    isGranted?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteEntityResourcePermissionSubscriptionVariables = {
  filter?: ModelSubscriptionEntityResourcePermissionFilterInput | null,
};

export type OnDeleteEntityResourcePermissionSubscription = {
  onDeleteEntityResourcePermission?:  {
    __typename: "EntityResourcePermission",
    id: string,
    propertyId?: string | null,
    entityId?: string | null,
    entityType?: PermissionEntityType | null,
    resourceId?: string | null,
    resourceType?: PermissionResourceType | null,
    permissionType?: PermissionType | null,
    isGranted?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateEntityWorkTypeAssociationSubscriptionVariables = {
  filter?: ModelSubscriptionEntityWorkTypeAssociationFilterInput | null,
};

export type OnCreateEntityWorkTypeAssociationSubscription = {
  onCreateEntityWorkTypeAssociation?:  {
    __typename: "EntityWorkTypeAssociation",
    id: string,
    entityId: string,
    entityType: WorkTypeAssociationScopeEntity,
    workTypeGroupId: string,
    workTypeVersion?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateEntityWorkTypeAssociationSubscriptionVariables = {
  filter?: ModelSubscriptionEntityWorkTypeAssociationFilterInput | null,
};

export type OnUpdateEntityWorkTypeAssociationSubscription = {
  onUpdateEntityWorkTypeAssociation?:  {
    __typename: "EntityWorkTypeAssociation",
    id: string,
    entityId: string,
    entityType: WorkTypeAssociationScopeEntity,
    workTypeGroupId: string,
    workTypeVersion?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteEntityWorkTypeAssociationSubscriptionVariables = {
  filter?: ModelSubscriptionEntityWorkTypeAssociationFilterInput | null,
};

export type OnDeleteEntityWorkTypeAssociationSubscription = {
  onDeleteEntityWorkTypeAssociation?:  {
    __typename: "EntityWorkTypeAssociation",
    id: string,
    entityId: string,
    entityType: WorkTypeAssociationScopeEntity,
    workTypeGroupId: string,
    workTypeVersion?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateInspectionSubscriptionVariables = {
  filter?: ModelSubscriptionInspectionFilterInput | null,
};

export type OnCreateInspectionSubscription = {
  onCreateInspection?:  {
    __typename: "Inspection",
    id: string,
    propertyId: string,
    createdByOrganizationId: string,
    createdByUserId: string,
    startTime: number,
    endTime?: number | null,
    status: InspectionStatus,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateInspectionSubscriptionVariables = {
  filter?: ModelSubscriptionInspectionFilterInput | null,
};

export type OnUpdateInspectionSubscription = {
  onUpdateInspection?:  {
    __typename: "Inspection",
    id: string,
    propertyId: string,
    createdByOrganizationId: string,
    createdByUserId: string,
    startTime: number,
    endTime?: number | null,
    status: InspectionStatus,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteInspectionSubscriptionVariables = {
  filter?: ModelSubscriptionInspectionFilterInput | null,
};

export type OnDeleteInspectionSubscription = {
  onDeleteInspection?:  {
    __typename: "Inspection",
    id: string,
    propertyId: string,
    createdByOrganizationId: string,
    createdByUserId: string,
    startTime: number,
    endTime?: number | null,
    status: InspectionStatus,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateIssueSubscriptionVariables = {
  filter?: ModelSubscriptionIssueFilterInput | null,
};

export type OnCreateIssueSubscription = {
  onCreateIssue?:  {
    __typename: "Issue",
    id: string,
    locationId?: string | null,
    propertyId?: string | null,
    inspectionId?: string | null,
    createdInSolution?: boolean | null,
    name?: string | null,
    description?: string | null,
    note?: string | null,
    tags?: string | null,
    tagIds?: Array< string > | null,
    status?: IssueStatus | null,
    clientCreationDate?: number | null,
    localLastUpdatedTime?: number | null,
    createdBy?: string | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isPubliclySubmitted?: boolean | null,
    suggestedWorkTypeIds?: Array< string > | null,
    quickQuoteIds?: Array< string > | null,
    proposalDocLinks?:  Array< {
      __typename: "ProposalDocLink",
      name: string,
      link: string,
      date: number,
    } > | null,
    priority?: IssuePriority | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateIssueSubscriptionVariables = {
  filter?: ModelSubscriptionIssueFilterInput | null,
};

export type OnUpdateIssueSubscription = {
  onUpdateIssue?:  {
    __typename: "Issue",
    id: string,
    locationId?: string | null,
    propertyId?: string | null,
    inspectionId?: string | null,
    createdInSolution?: boolean | null,
    name?: string | null,
    description?: string | null,
    note?: string | null,
    tags?: string | null,
    tagIds?: Array< string > | null,
    status?: IssueStatus | null,
    clientCreationDate?: number | null,
    localLastUpdatedTime?: number | null,
    createdBy?: string | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isPubliclySubmitted?: boolean | null,
    suggestedWorkTypeIds?: Array< string > | null,
    quickQuoteIds?: Array< string > | null,
    proposalDocLinks?:  Array< {
      __typename: "ProposalDocLink",
      name: string,
      link: string,
      date: number,
    } > | null,
    priority?: IssuePriority | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteIssueSubscriptionVariables = {
  filter?: ModelSubscriptionIssueFilterInput | null,
};

export type OnDeleteIssueSubscription = {
  onDeleteIssue?:  {
    __typename: "Issue",
    id: string,
    locationId?: string | null,
    propertyId?: string | null,
    inspectionId?: string | null,
    createdInSolution?: boolean | null,
    name?: string | null,
    description?: string | null,
    note?: string | null,
    tags?: string | null,
    tagIds?: Array< string > | null,
    status?: IssueStatus | null,
    clientCreationDate?: number | null,
    localLastUpdatedTime?: number | null,
    createdBy?: string | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isPubliclySubmitted?: boolean | null,
    suggestedWorkTypeIds?: Array< string > | null,
    quickQuoteIds?: Array< string > | null,
    proposalDocLinks?:  Array< {
      __typename: "ProposalDocLink",
      name: string,
      link: string,
      date: number,
    } > | null,
    priority?: IssuePriority | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateQuickQuoteSubscriptionVariables = {
  filter?: ModelSubscriptionQuickQuoteFilterInput | null,
};

export type OnCreateQuickQuoteSubscription = {
  onCreateQuickQuote?:  {
    __typename: "QuickQuote",
    id: string,
    propertyId: string,
    generatedProposalId?: string | null,
    status: QuickQuoteStatus,
    generatedSolutionId?: string | null,
    issueIds?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateQuickQuoteSubscriptionVariables = {
  filter?: ModelSubscriptionQuickQuoteFilterInput | null,
};

export type OnUpdateQuickQuoteSubscription = {
  onUpdateQuickQuote?:  {
    __typename: "QuickQuote",
    id: string,
    propertyId: string,
    generatedProposalId?: string | null,
    status: QuickQuoteStatus,
    generatedSolutionId?: string | null,
    issueIds?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteQuickQuoteSubscriptionVariables = {
  filter?: ModelSubscriptionQuickQuoteFilterInput | null,
};

export type OnDeleteQuickQuoteSubscription = {
  onDeleteQuickQuote?:  {
    __typename: "QuickQuote",
    id: string,
    propertyId: string,
    generatedProposalId?: string | null,
    status: QuickQuoteStatus,
    generatedSolutionId?: string | null,
    issueIds?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateLocationSubscriptionVariables = {
  filter?: ModelSubscriptionLocationFilterInput | null,
};

export type OnCreateLocationSubscription = {
  onCreateLocation?:  {
    __typename: "Location",
    id: string,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    name?: string | null,
    tags?: string | null,
    localCreationTime?: number | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateLocationSubscriptionVariables = {
  filter?: ModelSubscriptionLocationFilterInput | null,
};

export type OnUpdateLocationSubscription = {
  onUpdateLocation?:  {
    __typename: "Location",
    id: string,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    name?: string | null,
    tags?: string | null,
    localCreationTime?: number | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteLocationSubscriptionVariables = {
  filter?: ModelSubscriptionLocationFilterInput | null,
};

export type OnDeleteLocationSubscription = {
  onDeleteLocation?:  {
    __typename: "Location",
    id: string,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    name?: string | null,
    tags?: string | null,
    localCreationTime?: number | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateNoteSubscriptionVariables = {
  filter?: ModelSubscriptionNoteFilterInput | null,
};

export type OnCreateNoteSubscription = {
  onCreateNote?:  {
    __typename: "Note",
    id: string,
    parentId?: string | null,
    propertyId?: string | null,
    note?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateNoteSubscriptionVariables = {
  filter?: ModelSubscriptionNoteFilterInput | null,
};

export type OnUpdateNoteSubscription = {
  onUpdateNote?:  {
    __typename: "Note",
    id: string,
    parentId?: string | null,
    propertyId?: string | null,
    note?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteNoteSubscriptionVariables = {
  filter?: ModelSubscriptionNoteFilterInput | null,
};

export type OnDeleteNoteSubscription = {
  onDeleteNote?:  {
    __typename: "Note",
    id: string,
    parentId?: string | null,
    propertyId?: string | null,
    note?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateOrganizationSubscriptionVariables = {
  filter?: ModelSubscriptionOrganizationFilterInput | null,
};

export type OnCreateOrganizationSubscription = {
  onCreateOrganization?:  {
    __typename: "Organization",
    id: string,
    legalName: string,
    type?: OrganizationType | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateOrganizationSubscriptionVariables = {
  filter?: ModelSubscriptionOrganizationFilterInput | null,
};

export type OnUpdateOrganizationSubscription = {
  onUpdateOrganization?:  {
    __typename: "Organization",
    id: string,
    legalName: string,
    type?: OrganizationType | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteOrganizationSubscriptionVariables = {
  filter?: ModelSubscriptionOrganizationFilterInput | null,
};

export type OnDeleteOrganizationSubscription = {
  onDeleteOrganization?:  {
    __typename: "Organization",
    id: string,
    legalName: string,
    type?: OrganizationType | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateOrganizationBillingProfileSubscriptionVariables = {
  filter?: ModelSubscriptionOrganizationBillingProfileFilterInput | null,
};

export type OnCreateOrganizationBillingProfileSubscription = {
  onCreateOrganizationBillingProfile?:  {
    __typename: "OrganizationBillingProfile",
    organizationId: string,
    billingProfileId: string,
    billingProvider: BillingProvider,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateOrganizationBillingProfileSubscriptionVariables = {
  filter?: ModelSubscriptionOrganizationBillingProfileFilterInput | null,
};

export type OnUpdateOrganizationBillingProfileSubscription = {
  onUpdateOrganizationBillingProfile?:  {
    __typename: "OrganizationBillingProfile",
    organizationId: string,
    billingProfileId: string,
    billingProvider: BillingProvider,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteOrganizationBillingProfileSubscriptionVariables = {
  filter?: ModelSubscriptionOrganizationBillingProfileFilterInput | null,
};

export type OnDeleteOrganizationBillingProfileSubscription = {
  onDeleteOrganizationBillingProfile?:  {
    __typename: "OrganizationBillingProfile",
    organizationId: string,
    billingProfileId: string,
    billingProvider: BillingProvider,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTeamSubscriptionVariables = {
  filter?: ModelSubscriptionTeamFilterInput | null,
};

export type OnCreateTeamSubscription = {
  onCreateTeam?:  {
    __typename: "Team",
    id: string,
    organizationId: string,
    type: TeamType,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTeamSubscriptionVariables = {
  filter?: ModelSubscriptionTeamFilterInput | null,
};

export type OnUpdateTeamSubscription = {
  onUpdateTeam?:  {
    __typename: "Team",
    id: string,
    organizationId: string,
    type: TeamType,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTeamSubscriptionVariables = {
  filter?: ModelSubscriptionTeamFilterInput | null,
};

export type OnDeleteTeamSubscription = {
  onDeleteTeam?:  {
    __typename: "Team",
    id: string,
    organizationId: string,
    type: TeamType,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTeamMemberSubscriptionVariables = {
  filter?: ModelSubscriptionTeamMemberFilterInput | null,
};

export type OnCreateTeamMemberSubscription = {
  onCreateTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    teamId: string,
    organizationId: string,
    userId: string,
    joinedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTeamMemberSubscriptionVariables = {
  filter?: ModelSubscriptionTeamMemberFilterInput | null,
};

export type OnUpdateTeamMemberSubscription = {
  onUpdateTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    teamId: string,
    organizationId: string,
    userId: string,
    joinedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTeamMemberSubscriptionVariables = {
  filter?: ModelSubscriptionTeamMemberFilterInput | null,
};

export type OnDeleteTeamMemberSubscription = {
  onDeleteTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    teamId: string,
    organizationId: string,
    userId: string,
    joinedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAccountInvitationSubscriptionVariables = {
  filter?: ModelSubscriptionAccountInvitationFilterInput | null,
};

export type OnCreateAccountInvitationSubscription = {
  onCreateAccountInvitation?:  {
    __typename: "AccountInvitation",
    id: string,
    organizationId: string,
    role?: TeamType | null,
    email: string,
    expiresAt: number,
    status?: AccountInvitationStatus | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAccountInvitationSubscriptionVariables = {
  filter?: ModelSubscriptionAccountInvitationFilterInput | null,
};

export type OnUpdateAccountInvitationSubscription = {
  onUpdateAccountInvitation?:  {
    __typename: "AccountInvitation",
    id: string,
    organizationId: string,
    role?: TeamType | null,
    email: string,
    expiresAt: number,
    status?: AccountInvitationStatus | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAccountInvitationSubscriptionVariables = {
  filter?: ModelSubscriptionAccountInvitationFilterInput | null,
};

export type OnDeleteAccountInvitationSubscription = {
  onDeleteAccountInvitation?:  {
    __typename: "AccountInvitation",
    id: string,
    organizationId: string,
    role?: TeamType | null,
    email: string,
    expiresAt: number,
    status?: AccountInvitationStatus | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateProjectSubscriptionVariables = {
  filter?: ModelSubscriptionProjectFilterInput | null,
};

export type OnCreateProjectSubscription = {
  onCreateProject?:  {
    __typename: "Project",
    id: string,
    propertyId: string,
    name: string,
    tenderNumber?: string | null,
    customer?: string | null,
    address?: string | null,
    propertyType?: string | null,
    dueDate?: string | null,
    contactName?: string | null,
    contactNumber?: string | null,
    contactEmail?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateProjectSubscriptionVariables = {
  filter?: ModelSubscriptionProjectFilterInput | null,
};

export type OnUpdateProjectSubscription = {
  onUpdateProject?:  {
    __typename: "Project",
    id: string,
    propertyId: string,
    name: string,
    tenderNumber?: string | null,
    customer?: string | null,
    address?: string | null,
    propertyType?: string | null,
    dueDate?: string | null,
    contactName?: string | null,
    contactNumber?: string | null,
    contactEmail?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteProjectSubscriptionVariables = {
  filter?: ModelSubscriptionProjectFilterInput | null,
};

export type OnDeleteProjectSubscription = {
  onDeleteProject?:  {
    __typename: "Project",
    id: string,
    propertyId: string,
    name: string,
    tenderNumber?: string | null,
    customer?: string | null,
    address?: string | null,
    propertyType?: string | null,
    dueDate?: string | null,
    contactName?: string | null,
    contactNumber?: string | null,
    contactEmail?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateProjectCounterSubscriptionVariables = {
  filter?: ModelSubscriptionProjectCounterFilterInput | null,
};

export type OnCreateProjectCounterSubscription = {
  onCreateProjectCounter?:  {
    __typename: "ProjectCounter",
    id: string,
    propertyId: string,
    latestProjectNumber?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateProjectCounterSubscriptionVariables = {
  filter?: ModelSubscriptionProjectCounterFilterInput | null,
};

export type OnUpdateProjectCounterSubscription = {
  onUpdateProjectCounter?:  {
    __typename: "ProjectCounter",
    id: string,
    propertyId: string,
    latestProjectNumber?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteProjectCounterSubscriptionVariables = {
  filter?: ModelSubscriptionProjectCounterFilterInput | null,
};

export type OnDeleteProjectCounterSubscription = {
  onDeleteProjectCounter?:  {
    __typename: "ProjectCounter",
    id: string,
    propertyId: string,
    latestProjectNumber?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreatePropertySubscriptionVariables = {
  filter?: ModelSubscriptionPropertyFilterInput | null,
};

export type OnCreatePropertySubscription = {
  onCreateProperty?:  {
    __typename: "Property",
    id: string,
    name?: string | null,
    description?: string | null,
    address?: string | null,
    ownerOrganizationId?: string | null,
    primaryContactNumber?: string | null,
    primaryContactEmail?: string | null,
    primaryContactName?: string | null,
    propertyNumber?: string | null,
    locations?:  {
      __typename: "ModelLocationConnection",
      items:  Array< {
        __typename: "Location",
        id: string,
        propertyId?: string | null,
        createdInSolution?: boolean | null,
        name?: string | null,
        tags?: string | null,
        localCreationTime?: number | null,
        localLastUpdatedTime?: number | null,
        opaqueSyncReconciliationToken?: string | null,
        canView?: string | null,
        canEdit?: string | null,
        canDelete?: string | null,
        createdBy?: string | null,
        canViewList?: Array< string | null > | null,
        canViewEntityVersionMap?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdBy?: string | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    autoDashboardRebuild?: boolean | null,
    canView?: string | null,
    canEdit?: string | null,
    canCreateSolutions?: string | null,
    canDelete?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isTestProperty?: boolean | null,
    isArchived?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdatePropertySubscriptionVariables = {
  filter?: ModelSubscriptionPropertyFilterInput | null,
};

export type OnUpdatePropertySubscription = {
  onUpdateProperty?:  {
    __typename: "Property",
    id: string,
    name?: string | null,
    description?: string | null,
    address?: string | null,
    ownerOrganizationId?: string | null,
    primaryContactNumber?: string | null,
    primaryContactEmail?: string | null,
    primaryContactName?: string | null,
    propertyNumber?: string | null,
    locations?:  {
      __typename: "ModelLocationConnection",
      items:  Array< {
        __typename: "Location",
        id: string,
        propertyId?: string | null,
        createdInSolution?: boolean | null,
        name?: string | null,
        tags?: string | null,
        localCreationTime?: number | null,
        localLastUpdatedTime?: number | null,
        opaqueSyncReconciliationToken?: string | null,
        canView?: string | null,
        canEdit?: string | null,
        canDelete?: string | null,
        createdBy?: string | null,
        canViewList?: Array< string | null > | null,
        canViewEntityVersionMap?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdBy?: string | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    autoDashboardRebuild?: boolean | null,
    canView?: string | null,
    canEdit?: string | null,
    canCreateSolutions?: string | null,
    canDelete?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isTestProperty?: boolean | null,
    isArchived?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeletePropertySubscriptionVariables = {
  filter?: ModelSubscriptionPropertyFilterInput | null,
};

export type OnDeletePropertySubscription = {
  onDeleteProperty?:  {
    __typename: "Property",
    id: string,
    name?: string | null,
    description?: string | null,
    address?: string | null,
    ownerOrganizationId?: string | null,
    primaryContactNumber?: string | null,
    primaryContactEmail?: string | null,
    primaryContactName?: string | null,
    propertyNumber?: string | null,
    locations?:  {
      __typename: "ModelLocationConnection",
      items:  Array< {
        __typename: "Location",
        id: string,
        propertyId?: string | null,
        createdInSolution?: boolean | null,
        name?: string | null,
        tags?: string | null,
        localCreationTime?: number | null,
        localLastUpdatedTime?: number | null,
        opaqueSyncReconciliationToken?: string | null,
        canView?: string | null,
        canEdit?: string | null,
        canDelete?: string | null,
        createdBy?: string | null,
        canViewList?: Array< string | null > | null,
        canViewEntityVersionMap?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdBy?: string | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    autoDashboardRebuild?: boolean | null,
    canView?: string | null,
    canEdit?: string | null,
    canCreateSolutions?: string | null,
    canDelete?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isTestProperty?: boolean | null,
    isArchived?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreatePropertyCounterSubscriptionVariables = {
  filter?: ModelSubscriptionPropertyCounterFilterInput | null,
};

export type OnCreatePropertyCounterSubscription = {
  onCreatePropertyCounter?:  {
    __typename: "PropertyCounter",
    id: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdatePropertyCounterSubscriptionVariables = {
  filter?: ModelSubscriptionPropertyCounterFilterInput | null,
};

export type OnUpdatePropertyCounterSubscription = {
  onUpdatePropertyCounter?:  {
    __typename: "PropertyCounter",
    id: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeletePropertyCounterSubscriptionVariables = {
  filter?: ModelSubscriptionPropertyCounterFilterInput | null,
};

export type OnDeletePropertyCounterSubscription = {
  onDeletePropertyCounter?:  {
    __typename: "PropertyCounter",
    id: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateProposalSubscriptionVariables = {
  filter?: ModelSubscriptionProposalFilterInput | null,
};

export type OnCreateProposalSubscription = {
  onCreateProposal?:  {
    __typename: "Proposal",
    id: string,
    schemaVersion?: number | null,
    designDocumentGroupId: string,
    designDocumentVersion: number,
    proposalKey: string,
    proposalNumber?: number | null,
    status?: ProposalStatus | null,
    author?: string | null,
    createdAt?: string | null,
    localLastUpdatedTime?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    quickQuoteId?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateProposalSubscriptionVariables = {
  filter?: ModelSubscriptionProposalFilterInput | null,
};

export type OnUpdateProposalSubscription = {
  onUpdateProposal?:  {
    __typename: "Proposal",
    id: string,
    schemaVersion?: number | null,
    designDocumentGroupId: string,
    designDocumentVersion: number,
    proposalKey: string,
    proposalNumber?: number | null,
    status?: ProposalStatus | null,
    author?: string | null,
    createdAt?: string | null,
    localLastUpdatedTime?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    quickQuoteId?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteProposalSubscriptionVariables = {
  filter?: ModelSubscriptionProposalFilterInput | null,
};

export type OnDeleteProposalSubscription = {
  onDeleteProposal?:  {
    __typename: "Proposal",
    id: string,
    schemaVersion?: number | null,
    designDocumentGroupId: string,
    designDocumentVersion: number,
    proposalKey: string,
    proposalNumber?: number | null,
    status?: ProposalStatus | null,
    author?: string | null,
    createdAt?: string | null,
    localLastUpdatedTime?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    quickQuoteId?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateProposalCounterSubscriptionVariables = {
  filter?: ModelSubscriptionProposalCounterFilterInput | null,
};

export type OnCreateProposalCounterSubscription = {
  onCreateProposalCounter?:  {
    __typename: "ProposalCounter",
    id: string,
    solutionGroupId?: string | null,
    solutionVersion?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateProposalCounterSubscriptionVariables = {
  filter?: ModelSubscriptionProposalCounterFilterInput | null,
};

export type OnUpdateProposalCounterSubscription = {
  onUpdateProposalCounter?:  {
    __typename: "ProposalCounter",
    id: string,
    solutionGroupId?: string | null,
    solutionVersion?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteProposalCounterSubscriptionVariables = {
  filter?: ModelSubscriptionProposalCounterFilterInput | null,
};

export type OnDeleteProposalCounterSubscription = {
  onDeleteProposalCounter?:  {
    __typename: "ProposalCounter",
    id: string,
    solutionGroupId?: string | null,
    solutionVersion?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateResourceUserPermissionsSubscriptionVariables = {
  filter?: ModelSubscriptionResourceUserPermissionsFilterInput | null,
};

export type OnCreateResourceUserPermissionsSubscription = {
  onCreateResourceUserPermissions?:  {
    __typename: "ResourceUserPermissions",
    id: string,
    resourceId: string,
    userId?: string | null,
    userEmail?: string | null,
    userFullName?: string | null,
    resourceAndUserId?: string | null,
    permissions: string,
    resourceType?: ResourceType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateResourceUserPermissionsSubscriptionVariables = {
  filter?: ModelSubscriptionResourceUserPermissionsFilterInput | null,
};

export type OnUpdateResourceUserPermissionsSubscription = {
  onUpdateResourceUserPermissions?:  {
    __typename: "ResourceUserPermissions",
    id: string,
    resourceId: string,
    userId?: string | null,
    userEmail?: string | null,
    userFullName?: string | null,
    resourceAndUserId?: string | null,
    permissions: string,
    resourceType?: ResourceType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteResourceUserPermissionsSubscriptionVariables = {
  filter?: ModelSubscriptionResourceUserPermissionsFilterInput | null,
};

export type OnDeleteResourceUserPermissionsSubscription = {
  onDeleteResourceUserPermissions?:  {
    __typename: "ResourceUserPermissions",
    id: string,
    resourceId: string,
    userId?: string | null,
    userEmail?: string | null,
    userFullName?: string | null,
    resourceAndUserId?: string | null,
    permissions: string,
    resourceType?: ResourceType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateSolutionSubscriptionVariables = {
  filter?: ModelSubscriptionSolutionFilterInput | null,
};

export type OnCreateSolutionSubscription = {
  onCreateSolution?:  {
    __typename: "Solution",
    id: string,
    propertyId?: string | null,
    projectId?: string | null,
    name?: string | null,
    status?: SolutionStatus | null,
    latestMinorVersion?: number | null,
    latestContentKey?: string | null,
    serialNumber?: number | null,
    metadata?:  {
      __typename: "SolutionMetadata",
      name?: string | null,
      propertyContactName?: string | null,
      propertyAddress?: string | null,
      propertyType?: string | null,
      solutionDueDate?: string | null,
      consultantName?: string | null,
      consultantPhoneNumber?: string | null,
      consultantEmail?: string | null,
      tenderingType?: SolutionTenderingType | null,
      warranty?: number | null,
    } | null,
    localLastUpdatedTime?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isArchived?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateSolutionSubscriptionVariables = {
  filter?: ModelSubscriptionSolutionFilterInput | null,
};

export type OnUpdateSolutionSubscription = {
  onUpdateSolution?:  {
    __typename: "Solution",
    id: string,
    propertyId?: string | null,
    projectId?: string | null,
    name?: string | null,
    status?: SolutionStatus | null,
    latestMinorVersion?: number | null,
    latestContentKey?: string | null,
    serialNumber?: number | null,
    metadata?:  {
      __typename: "SolutionMetadata",
      name?: string | null,
      propertyContactName?: string | null,
      propertyAddress?: string | null,
      propertyType?: string | null,
      solutionDueDate?: string | null,
      consultantName?: string | null,
      consultantPhoneNumber?: string | null,
      consultantEmail?: string | null,
      tenderingType?: SolutionTenderingType | null,
      warranty?: number | null,
    } | null,
    localLastUpdatedTime?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isArchived?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteSolutionSubscriptionVariables = {
  filter?: ModelSubscriptionSolutionFilterInput | null,
};

export type OnDeleteSolutionSubscription = {
  onDeleteSolution?:  {
    __typename: "Solution",
    id: string,
    propertyId?: string | null,
    projectId?: string | null,
    name?: string | null,
    status?: SolutionStatus | null,
    latestMinorVersion?: number | null,
    latestContentKey?: string | null,
    serialNumber?: number | null,
    metadata?:  {
      __typename: "SolutionMetadata",
      name?: string | null,
      propertyContactName?: string | null,
      propertyAddress?: string | null,
      propertyType?: string | null,
      solutionDueDate?: string | null,
      consultantName?: string | null,
      consultantPhoneNumber?: string | null,
      consultantEmail?: string | null,
      tenderingType?: SolutionTenderingType | null,
      warranty?: number | null,
    } | null,
    localLastUpdatedTime?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    isArchived?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateSolutionMinorVersionSubscriptionVariables = {
  filter?: ModelSubscriptionSolutionMinorVersionFilterInput | null,
};

export type OnCreateSolutionMinorVersionSubscription = {
  onCreateSolutionMinorVersion?:  {
    __typename: "SolutionMinorVersion",
    id: string,
    solutionId?: string | null,
    propertyId?: string | null,
    name?: string | null,
    contentKey?: string | null,
    minorVersion?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateSolutionMinorVersionSubscriptionVariables = {
  filter?: ModelSubscriptionSolutionMinorVersionFilterInput | null,
};

export type OnUpdateSolutionMinorVersionSubscription = {
  onUpdateSolutionMinorVersion?:  {
    __typename: "SolutionMinorVersion",
    id: string,
    solutionId?: string | null,
    propertyId?: string | null,
    name?: string | null,
    contentKey?: string | null,
    minorVersion?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteSolutionMinorVersionSubscriptionVariables = {
  filter?: ModelSubscriptionSolutionMinorVersionFilterInput | null,
};

export type OnDeleteSolutionMinorVersionSubscription = {
  onDeleteSolutionMinorVersion?:  {
    __typename: "SolutionMinorVersion",
    id: string,
    solutionId?: string | null,
    propertyId?: string | null,
    name?: string | null,
    contentKey?: string | null,
    minorVersion?: number | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateSolutionGroupCounterSubscriptionVariables = {
  filter?: ModelSubscriptionSolutionGroupCounterFilterInput | null,
};

export type OnCreateSolutionGroupCounterSubscription = {
  onCreateSolutionGroupCounter?:  {
    __typename: "SolutionGroupCounter",
    id: string,
    propertyId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateSolutionGroupCounterSubscriptionVariables = {
  filter?: ModelSubscriptionSolutionGroupCounterFilterInput | null,
};

export type OnUpdateSolutionGroupCounterSubscription = {
  onUpdateSolutionGroupCounter?:  {
    __typename: "SolutionGroupCounter",
    id: string,
    propertyId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteSolutionGroupCounterSubscriptionVariables = {
  filter?: ModelSubscriptionSolutionGroupCounterFilterInput | null,
};

export type OnDeleteSolutionGroupCounterSubscription = {
  onDeleteSolutionGroupCounter?:  {
    __typename: "SolutionGroupCounter",
    id: string,
    propertyId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateUserGroupSubscriptionVariables = {
  filter?: ModelSubscriptionUserGroupFilterInput | null,
};

export type OnCreateUserGroupSubscription = {
  onCreateUserGroup?:  {
    __typename: "UserGroup",
    id: string,
    resourceId: string,
    groupType: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateUserGroupSubscriptionVariables = {
  filter?: ModelSubscriptionUserGroupFilterInput | null,
};

export type OnUpdateUserGroupSubscription = {
  onUpdateUserGroup?:  {
    __typename: "UserGroup",
    id: string,
    resourceId: string,
    groupType: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteUserGroupSubscriptionVariables = {
  filter?: ModelSubscriptionUserGroupFilterInput | null,
};

export type OnDeleteUserGroupSubscription = {
  onDeleteUserGroup?:  {
    __typename: "UserGroup",
    id: string,
    resourceId: string,
    groupType: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateUserGroupMemberSubscriptionVariables = {
  filter?: ModelSubscriptionUserGroupMemberFilterInput | null,
};

export type OnCreateUserGroupMemberSubscription = {
  onCreateUserGroupMember?:  {
    __typename: "UserGroupMember",
    id: string,
    resourceId: string,
    resourceAndUserId: string,
    userId: string,
    userGroupId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateUserGroupMemberSubscriptionVariables = {
  filter?: ModelSubscriptionUserGroupMemberFilterInput | null,
};

export type OnUpdateUserGroupMemberSubscription = {
  onUpdateUserGroupMember?:  {
    __typename: "UserGroupMember",
    id: string,
    resourceId: string,
    resourceAndUserId: string,
    userId: string,
    userGroupId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteUserGroupMemberSubscriptionVariables = {
  filter?: ModelSubscriptionUserGroupMemberFilterInput | null,
};

export type OnDeleteUserGroupMemberSubscription = {
  onDeleteUserGroupMember?:  {
    __typename: "UserGroupMember",
    id: string,
    resourceId: string,
    resourceAndUserId: string,
    userId: string,
    userGroupId: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateUserOrganizationAssociationSubscriptionVariables = {
  filter?: ModelSubscriptionUserOrganizationAssociationFilterInput | null,
};

export type OnCreateUserOrganizationAssociationSubscription = {
  onCreateUserOrganizationAssociation?:  {
    __typename: "UserOrganizationAssociation",
    id: string,
    userId: string,
    organizationId: string,
    associationType: UserOrganizationAssociationType,
    permissions?: string | null,
    role?: UserOrganizationRole | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateUserOrganizationAssociationSubscriptionVariables = {
  filter?: ModelSubscriptionUserOrganizationAssociationFilterInput | null,
};

export type OnUpdateUserOrganizationAssociationSubscription = {
  onUpdateUserOrganizationAssociation?:  {
    __typename: "UserOrganizationAssociation",
    id: string,
    userId: string,
    organizationId: string,
    associationType: UserOrganizationAssociationType,
    permissions?: string | null,
    role?: UserOrganizationRole | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteUserOrganizationAssociationSubscriptionVariables = {
  filter?: ModelSubscriptionUserOrganizationAssociationFilterInput | null,
};

export type OnDeleteUserOrganizationAssociationSubscription = {
  onDeleteUserOrganizationAssociation?:  {
    __typename: "UserOrganizationAssociation",
    id: string,
    userId: string,
    organizationId: string,
    associationType: UserOrganizationAssociationType,
    permissions?: string | null,
    role?: UserOrganizationRole | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateWorkSpecificationSubscriptionVariables = {
  filter?: ModelSubscriptionWorkSpecificationFilterInput | null,
};

export type OnCreateWorkSpecificationSubscription = {
  onCreateWorkSpecification?:  {
    __typename: "WorkSpecification",
    id: string,
    dimensionId?: string | null,
    issueId?: string | null,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    body?: string | null,
    description?: string | null,
    workTypeId?: string | null,
    itemNumber?: number | null,
    measurement?:  {
      __typename: "Measurement",
      length?: number | null,
      width?: number | null,
      dimensionType?: DimensionType | null,
      measurementUnit?: MeasurementUnit | null,
    } | null,
    version?: number | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateWorkSpecificationSubscriptionVariables = {
  filter?: ModelSubscriptionWorkSpecificationFilterInput | null,
};

export type OnUpdateWorkSpecificationSubscription = {
  onUpdateWorkSpecification?:  {
    __typename: "WorkSpecification",
    id: string,
    dimensionId?: string | null,
    issueId?: string | null,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    body?: string | null,
    description?: string | null,
    workTypeId?: string | null,
    itemNumber?: number | null,
    measurement?:  {
      __typename: "Measurement",
      length?: number | null,
      width?: number | null,
      dimensionType?: DimensionType | null,
      measurementUnit?: MeasurementUnit | null,
    } | null,
    version?: number | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteWorkSpecificationSubscriptionVariables = {
  filter?: ModelSubscriptionWorkSpecificationFilterInput | null,
};

export type OnDeleteWorkSpecificationSubscription = {
  onDeleteWorkSpecification?:  {
    __typename: "WorkSpecification",
    id: string,
    dimensionId?: string | null,
    issueId?: string | null,
    propertyId?: string | null,
    createdInSolution?: boolean | null,
    body?: string | null,
    description?: string | null,
    workTypeId?: string | null,
    itemNumber?: number | null,
    measurement?:  {
      __typename: "Measurement",
      length?: number | null,
      width?: number | null,
      dimensionType?: DimensionType | null,
      measurementUnit?: MeasurementUnit | null,
    } | null,
    version?: number | null,
    localLastUpdatedTime?: number | null,
    opaqueSyncReconciliationToken?: string | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdBy?: string | null,
    canViewList?: Array< string | null > | null,
    canViewEntityVersionMap?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateWorkTypeSubscriptionVariables = {
  filter?: ModelSubscriptionWorkTypeFilterInput | null,
};

export type OnCreateWorkTypeSubscription = {
  onCreateWorkType?:  {
    __typename: "WorkType",
    id: string,
    name: string,
    shortDescription?: string | null,
    longDescription?: string | null,
    groupName?: string | null,
    unitPrice?: number | null,
    unitCost?: number | null,
    dimensionType?: DimensionType | null,
    measurementUnit?: MeasurementUnit | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateWorkTypeSubscriptionVariables = {
  filter?: ModelSubscriptionWorkTypeFilterInput | null,
};

export type OnUpdateWorkTypeSubscription = {
  onUpdateWorkType?:  {
    __typename: "WorkType",
    id: string,
    name: string,
    shortDescription?: string | null,
    longDescription?: string | null,
    groupName?: string | null,
    unitPrice?: number | null,
    unitCost?: number | null,
    dimensionType?: DimensionType | null,
    measurementUnit?: MeasurementUnit | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteWorkTypeSubscriptionVariables = {
  filter?: ModelSubscriptionWorkTypeFilterInput | null,
};

export type OnDeleteWorkTypeSubscription = {
  onDeleteWorkType?:  {
    __typename: "WorkType",
    id: string,
    name: string,
    shortDescription?: string | null,
    longDescription?: string | null,
    groupName?: string | null,
    unitPrice?: number | null,
    unitCost?: number | null,
    dimensionType?: DimensionType | null,
    measurementUnit?: MeasurementUnit | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateWorkTypeGroupSubscriptionVariables = {
  filter?: ModelSubscriptionWorkTypeGroupFilterInput | null,
};

export type OnCreateWorkTypeGroupSubscription = {
  onCreateWorkTypeGroup?:  {
    __typename: "WorkTypeGroup",
    id: string,
    latestWorkTypeVersion: number,
    environmentAgnosticWorkTypeGroupId?: string | null,
    isDiscoverable?: boolean | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateWorkTypeGroupSubscriptionVariables = {
  filter?: ModelSubscriptionWorkTypeGroupFilterInput | null,
};

export type OnUpdateWorkTypeGroupSubscription = {
  onUpdateWorkTypeGroup?:  {
    __typename: "WorkTypeGroup",
    id: string,
    latestWorkTypeVersion: number,
    environmentAgnosticWorkTypeGroupId?: string | null,
    isDiscoverable?: boolean | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteWorkTypeGroupSubscriptionVariables = {
  filter?: ModelSubscriptionWorkTypeGroupFilterInput | null,
};

export type OnDeleteWorkTypeGroupSubscription = {
  onDeleteWorkTypeGroup?:  {
    __typename: "WorkTypeGroup",
    id: string,
    latestWorkTypeVersion: number,
    environmentAgnosticWorkTypeGroupId?: string | null,
    isDiscoverable?: boolean | null,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateWorkTypePricingSubscriptionVariables = {
  filter?: ModelSubscriptionWorkTypePricingFilterInput | null,
};

export type OnCreateWorkTypePricingSubscription = {
  onCreateWorkTypePricing?:  {
    __typename: "WorkTypePricing",
    id: string,
    entityId: string,
    workTypeGroupId: string,
    body: string,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateWorkTypePricingSubscriptionVariables = {
  filter?: ModelSubscriptionWorkTypePricingFilterInput | null,
};

export type OnUpdateWorkTypePricingSubscription = {
  onUpdateWorkTypePricing?:  {
    __typename: "WorkTypePricing",
    id: string,
    entityId: string,
    workTypeGroupId: string,
    body: string,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteWorkTypePricingSubscriptionVariables = {
  filter?: ModelSubscriptionWorkTypePricingFilterInput | null,
};

export type OnDeleteWorkTypePricingSubscription = {
  onDeleteWorkTypePricing?:  {
    __typename: "WorkTypePricing",
    id: string,
    entityId: string,
    workTypeGroupId: string,
    body: string,
    canView?: string | null,
    canEdit?: string | null,
    canDelete?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateDefaultWorkTypePricingSubscriptionVariables = {
  filter?: ModelSubscriptionDefaultWorkTypePricingFilterInput | null,
};

export type OnCreateDefaultWorkTypePricingSubscription = {
  onCreateDefaultWorkTypePricing?:  {
    __typename: "DefaultWorkTypePricing",
    id: string,
    unitCost?: number | null,
    unitPrice?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateDefaultWorkTypePricingSubscriptionVariables = {
  filter?: ModelSubscriptionDefaultWorkTypePricingFilterInput | null,
};

export type OnUpdateDefaultWorkTypePricingSubscription = {
  onUpdateDefaultWorkTypePricing?:  {
    __typename: "DefaultWorkTypePricing",
    id: string,
    unitCost?: number | null,
    unitPrice?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteDefaultWorkTypePricingSubscriptionVariables = {
  filter?: ModelSubscriptionDefaultWorkTypePricingFilterInput | null,
};

export type OnDeleteDefaultWorkTypePricingSubscription = {
  onDeleteDefaultWorkTypePricing?:  {
    __typename: "DefaultWorkTypePricing",
    id: string,
    unitCost?: number | null,
    unitPrice?: number | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTemporaryWorkTypeSubscriptionVariables = {
  filter?: ModelSubscriptionTemporaryWorkTypeFilterInput | null,
};

export type OnCreateTemporaryWorkTypeSubscription = {
  onCreateTemporaryWorkType?:  {
    __typename: "TemporaryWorkType",
    id: string,
    workTypeGroupId: string,
    environmentAgnosticWorkTypeGroupId?: string | null,
    body: string,
    version: number,
    schemaVersion: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTemporaryWorkTypeSubscriptionVariables = {
  filter?: ModelSubscriptionTemporaryWorkTypeFilterInput | null,
};

export type OnUpdateTemporaryWorkTypeSubscription = {
  onUpdateTemporaryWorkType?:  {
    __typename: "TemporaryWorkType",
    id: string,
    workTypeGroupId: string,
    environmentAgnosticWorkTypeGroupId?: string | null,
    body: string,
    version: number,
    schemaVersion: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTemporaryWorkTypeSubscriptionVariables = {
  filter?: ModelSubscriptionTemporaryWorkTypeFilterInput | null,
};

export type OnDeleteTemporaryWorkTypeSubscription = {
  onDeleteTemporaryWorkType?:  {
    __typename: "TemporaryWorkType",
    id: string,
    workTypeGroupId: string,
    environmentAgnosticWorkTypeGroupId?: string | null,
    body: string,
    version: number,
    schemaVersion: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTenderSubscriptionVariables = {
  filter?: ModelSubscriptionTenderFilterInput | null,
};

export type OnCreateTenderSubscription = {
  onCreateTender?:  {
    __typename: "Tender",
    id: string,
    solutionId?: string | null,
    status?: TenderStatus | null,
    latestVersion?: number | null,
    awardedVersion?: number | null,
    projectNumber?: number | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTenderSubscriptionVariables = {
  filter?: ModelSubscriptionTenderFilterInput | null,
};

export type OnUpdateTenderSubscription = {
  onUpdateTender?:  {
    __typename: "Tender",
    id: string,
    solutionId?: string | null,
    status?: TenderStatus | null,
    latestVersion?: number | null,
    awardedVersion?: number | null,
    projectNumber?: number | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTenderSubscriptionVariables = {
  filter?: ModelSubscriptionTenderFilterInput | null,
};

export type OnDeleteTenderSubscription = {
  onDeleteTender?:  {
    __typename: "Tender",
    id: string,
    solutionId?: string | null,
    status?: TenderStatus | null,
    latestVersion?: number | null,
    awardedVersion?: number | null,
    projectNumber?: number | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTenderMinorVersionSubscriptionVariables = {
  filter?: ModelSubscriptionTenderMinorVersionFilterInput | null,
};

export type OnCreateTenderMinorVersionSubscription = {
  onCreateTenderMinorVersion?:  {
    __typename: "TenderMinorVersion",
    id: string,
    tenderId?: string | null,
    version?: number | null,
    solutionId?: string | null,
    solutionMinorVersion?: number | null,
    metadata?:  {
      __typename: "TenderMetadata",
      name?: string | null,
      propertyContactName?: string | null,
      propertyAddress?: string | null,
      propertyType?: string | null,
      solutionDueDate?: string | null,
      consultantName?: string | null,
      consultantPhoneNumber?: string | null,
      consultantEmail?: string | null,
    } | null,
    contentKey?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTenderMinorVersionSubscriptionVariables = {
  filter?: ModelSubscriptionTenderMinorVersionFilterInput | null,
};

export type OnUpdateTenderMinorVersionSubscription = {
  onUpdateTenderMinorVersion?:  {
    __typename: "TenderMinorVersion",
    id: string,
    tenderId?: string | null,
    version?: number | null,
    solutionId?: string | null,
    solutionMinorVersion?: number | null,
    metadata?:  {
      __typename: "TenderMetadata",
      name?: string | null,
      propertyContactName?: string | null,
      propertyAddress?: string | null,
      propertyType?: string | null,
      solutionDueDate?: string | null,
      consultantName?: string | null,
      consultantPhoneNumber?: string | null,
      consultantEmail?: string | null,
    } | null,
    contentKey?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTenderMinorVersionSubscriptionVariables = {
  filter?: ModelSubscriptionTenderMinorVersionFilterInput | null,
};

export type OnDeleteTenderMinorVersionSubscription = {
  onDeleteTenderMinorVersion?:  {
    __typename: "TenderMinorVersion",
    id: string,
    tenderId?: string | null,
    version?: number | null,
    solutionId?: string | null,
    solutionMinorVersion?: number | null,
    metadata?:  {
      __typename: "TenderMetadata",
      name?: string | null,
      propertyContactName?: string | null,
      propertyAddress?: string | null,
      propertyType?: string | null,
      solutionDueDate?: string | null,
      consultantName?: string | null,
      consultantPhoneNumber?: string | null,
      consultantEmail?: string | null,
    } | null,
    contentKey?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTagSubscriptionVariables = {
  filter?: ModelSubscriptionTagFilterInput | null,
};

export type OnCreateTagSubscription = {
  onCreateTag?:  {
    __typename: "Tag",
    id: string,
    name?: string | null,
    createdBy?: string | null,
    propertyId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTagSubscriptionVariables = {
  filter?: ModelSubscriptionTagFilterInput | null,
};

export type OnUpdateTagSubscription = {
  onUpdateTag?:  {
    __typename: "Tag",
    id: string,
    name?: string | null,
    createdBy?: string | null,
    propertyId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTagSubscriptionVariables = {
  filter?: ModelSubscriptionTagFilterInput | null,
};

export type OnDeleteTagSubscription = {
  onDeleteTag?:  {
    __typename: "Tag",
    id: string,
    name?: string | null,
    createdBy?: string | null,
    propertyId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateUserOnboardingProgressSubscriptionVariables = {
  filter?: ModelSubscriptionUserOnboardingProgressFilterInput | null,
};

export type OnCreateUserOnboardingProgressSubscription = {
  onCreateUserOnboardingProgress?:  {
    __typename: "UserOnboardingProgress",
    id: string,
    userId: string,
    hasUserBeenAssociatedWithOrganization: boolean,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateUserOnboardingProgressSubscriptionVariables = {
  filter?: ModelSubscriptionUserOnboardingProgressFilterInput | null,
};

export type OnUpdateUserOnboardingProgressSubscription = {
  onUpdateUserOnboardingProgress?:  {
    __typename: "UserOnboardingProgress",
    id: string,
    userId: string,
    hasUserBeenAssociatedWithOrganization: boolean,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteUserOnboardingProgressSubscriptionVariables = {
  filter?: ModelSubscriptionUserOnboardingProgressFilterInput | null,
};

export type OnDeleteUserOnboardingProgressSubscription = {
  onDeleteUserOnboardingProgress?:  {
    __typename: "UserOnboardingProgress",
    id: string,
    userId: string,
    hasUserBeenAssociatedWithOrganization: boolean,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionTemplateFilterInput | null,
};

export type OnCreateTemplateSubscription = {
  onCreateTemplate?:  {
    __typename: "Template",
    id: string,
    type?: TemplateType | null,
    name?: string | null,
    s3Key?: string | null,
    ownerId?: string | null,
    ownerType?: TemplateEntityType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionTemplateFilterInput | null,
};

export type OnUpdateTemplateSubscription = {
  onUpdateTemplate?:  {
    __typename: "Template",
    id: string,
    type?: TemplateType | null,
    name?: string | null,
    s3Key?: string | null,
    ownerId?: string | null,
    ownerType?: TemplateEntityType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTemplateSubscriptionVariables = {
  filter?: ModelSubscriptionTemplateFilterInput | null,
};

export type OnDeleteTemplateSubscription = {
  onDeleteTemplate?:  {
    __typename: "Template",
    id: string,
    type?: TemplateType | null,
    name?: string | null,
    s3Key?: string | null,
    ownerId?: string | null,
    ownerType?: TemplateEntityType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTemporaryAuthorizationCodeSubscriptionVariables = {
  filter?: ModelSubscriptionTemporaryAuthorizationCodeFilterInput | null,
};

export type OnCreateTemporaryAuthorizationCodeSubscription = {
  onCreateTemporaryAuthorizationCode?:  {
    __typename: "TemporaryAuthorizationCode",
    id: string,
    code: string,
    userId: string,
    expiresAt: number,
    createdAt: string,
    ttl: number,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTemporaryAuthorizationCodeSubscriptionVariables = {
  filter?: ModelSubscriptionTemporaryAuthorizationCodeFilterInput | null,
};

export type OnUpdateTemporaryAuthorizationCodeSubscription = {
  onUpdateTemporaryAuthorizationCode?:  {
    __typename: "TemporaryAuthorizationCode",
    id: string,
    code: string,
    userId: string,
    expiresAt: number,
    createdAt: string,
    ttl: number,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTemporaryAuthorizationCodeSubscriptionVariables = {
  filter?: ModelSubscriptionTemporaryAuthorizationCodeFilterInput | null,
};

export type OnDeleteTemporaryAuthorizationCodeSubscription = {
  onDeleteTemporaryAuthorizationCode?:  {
    __typename: "TemporaryAuthorizationCode",
    id: string,
    code: string,
    userId: string,
    expiresAt: number,
    createdAt: string,
    ttl: number,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateLinkRegistrySubscriptionVariables = {
  filter?: ModelSubscriptionLinkRegistryFilterInput | null,
};

export type OnCreateLinkRegistrySubscription = {
  onCreateLinkRegistry?:  {
    __typename: "LinkRegistry",
    id: string,
    propertyId?: string | null,
    action?: LinkAction | null,
    variables?: string | null,
    published?: boolean | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateLinkRegistrySubscriptionVariables = {
  filter?: ModelSubscriptionLinkRegistryFilterInput | null,
};

export type OnUpdateLinkRegistrySubscription = {
  onUpdateLinkRegistry?:  {
    __typename: "LinkRegistry",
    id: string,
    propertyId?: string | null,
    action?: LinkAction | null,
    variables?: string | null,
    published?: boolean | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteLinkRegistrySubscriptionVariables = {
  filter?: ModelSubscriptionLinkRegistryFilterInput | null,
};

export type OnDeleteLinkRegistrySubscription = {
  onDeleteLinkRegistry?:  {
    __typename: "LinkRegistry",
    id: string,
    propertyId?: string | null,
    action?: LinkAction | null,
    variables?: string | null,
    published?: boolean | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateExternalReportBrandingSubscriptionVariables = {
  filter?: ModelSubscriptionExternalReportBrandingFilterInput | null,
};

export type OnCreateExternalReportBrandingSubscription = {
  onCreateExternalReportBranding?:  {
    __typename: "ExternalReportBranding",
    id: string,
    name?: string | null,
    logoKey?: string | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateExternalReportBrandingSubscriptionVariables = {
  filter?: ModelSubscriptionExternalReportBrandingFilterInput | null,
};

export type OnUpdateExternalReportBrandingSubscription = {
  onUpdateExternalReportBranding?:  {
    __typename: "ExternalReportBranding",
    id: string,
    name?: string | null,
    logoKey?: string | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteExternalReportBrandingSubscriptionVariables = {
  filter?: ModelSubscriptionExternalReportBrandingFilterInput | null,
};

export type OnDeleteExternalReportBrandingSubscription = {
  onDeleteExternalReportBranding?:  {
    __typename: "ExternalReportBranding",
    id: string,
    name?: string | null,
    logoKey?: string | null,
    createdBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateMeetingSubscriptionVariables = {
  filter?: ModelSubscriptionMeetingFilterInput | null,
};

export type OnCreateMeetingSubscription = {
  onCreateMeeting?:  {
    __typename: "Meeting",
    id: string,
    status?: MeetingStatus | null,
    data: string,
    createdBy?: string | null,
    mediaPipelineId?: string | null,
    recordingKey?: string | null,
    recordingAttachmentId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateMeetingSubscriptionVariables = {
  filter?: ModelSubscriptionMeetingFilterInput | null,
};

export type OnUpdateMeetingSubscription = {
  onUpdateMeeting?:  {
    __typename: "Meeting",
    id: string,
    status?: MeetingStatus | null,
    data: string,
    createdBy?: string | null,
    mediaPipelineId?: string | null,
    recordingKey?: string | null,
    recordingAttachmentId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteMeetingSubscriptionVariables = {
  filter?: ModelSubscriptionMeetingFilterInput | null,
};

export type OnDeleteMeetingSubscription = {
  onDeleteMeeting?:  {
    __typename: "Meeting",
    id: string,
    status?: MeetingStatus | null,
    data: string,
    createdBy?: string | null,
    mediaPipelineId?: string | null,
    recordingKey?: string | null,
    recordingAttachmentId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAttendeeSubscriptionVariables = {
  filter?: ModelSubscriptionAttendeeFilterInput | null,
};

export type OnCreateAttendeeSubscription = {
  onCreateAttendee?:  {
    __typename: "Attendee",
    id: string,
    meetingId: string,
    entityId?: string | null,
    name?: string | null,
    role?: AttendeeRole | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAttendeeSubscriptionVariables = {
  filter?: ModelSubscriptionAttendeeFilterInput | null,
};

export type OnUpdateAttendeeSubscription = {
  onUpdateAttendee?:  {
    __typename: "Attendee",
    id: string,
    meetingId: string,
    entityId?: string | null,
    name?: string | null,
    role?: AttendeeRole | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAttendeeSubscriptionVariables = {
  filter?: ModelSubscriptionAttendeeFilterInput | null,
};

export type OnDeleteAttendeeSubscription = {
  onDeleteAttendee?:  {
    __typename: "Attendee",
    id: string,
    meetingId: string,
    entityId?: string | null,
    name?: string | null,
    role?: AttendeeRole | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateCodeBuildJobSubscriptionVariables = {
  filter?: ModelSubscriptionCodeBuildJobFilterInput | null,
};

export type OnCreateCodeBuildJobSubscription = {
  onCreateCodeBuildJob?:  {
    __typename: "CodeBuildJob",
    id: string,
    parentId?: string | null,
    projectName?: string | null,
    status?: BuildStatus | null,
    artifactPath?: string | null,
    buildStartTime?: number | null,
    buildEndTime?: number | null,
    requestedBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateCodeBuildJobSubscriptionVariables = {
  filter?: ModelSubscriptionCodeBuildJobFilterInput | null,
};

export type OnUpdateCodeBuildJobSubscription = {
  onUpdateCodeBuildJob?:  {
    __typename: "CodeBuildJob",
    id: string,
    parentId?: string | null,
    projectName?: string | null,
    status?: BuildStatus | null,
    artifactPath?: string | null,
    buildStartTime?: number | null,
    buildEndTime?: number | null,
    requestedBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteCodeBuildJobSubscriptionVariables = {
  filter?: ModelSubscriptionCodeBuildJobFilterInput | null,
};

export type OnDeleteCodeBuildJobSubscription = {
  onDeleteCodeBuildJob?:  {
    __typename: "CodeBuildJob",
    id: string,
    parentId?: string | null,
    projectName?: string | null,
    status?: BuildStatus | null,
    artifactPath?: string | null,
    buildStartTime?: number | null,
    buildEndTime?: number | null,
    requestedBy?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateResourceNotificationSettingSubscriptionVariables = {
  filter?: ModelSubscriptionResourceNotificationSettingFilterInput | null,
};

export type OnCreateResourceNotificationSettingSubscription = {
  onCreateResourceNotificationSetting?:  {
    __typename: "ResourceNotificationSetting",
    resourceId: string,
    resourceType: NotificationResourceType,
    notificationType: NotificationType,
    recipients?:  Array< {
      __typename: "NotificationRecipient",
      recipientId?: string | null,
      recipientIdType?: NotificationRecipientIdType | null,
      notificationChannels?: Array< NotificationChannel > | null,
      enabled?: boolean | null,
    } > | null,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateResourceNotificationSettingSubscriptionVariables = {
  filter?: ModelSubscriptionResourceNotificationSettingFilterInput | null,
};

export type OnUpdateResourceNotificationSettingSubscription = {
  onUpdateResourceNotificationSetting?:  {
    __typename: "ResourceNotificationSetting",
    resourceId: string,
    resourceType: NotificationResourceType,
    notificationType: NotificationType,
    recipients?:  Array< {
      __typename: "NotificationRecipient",
      recipientId?: string | null,
      recipientIdType?: NotificationRecipientIdType | null,
      notificationChannels?: Array< NotificationChannel > | null,
      enabled?: boolean | null,
    } > | null,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteResourceNotificationSettingSubscriptionVariables = {
  filter?: ModelSubscriptionResourceNotificationSettingFilterInput | null,
};

export type OnDeleteResourceNotificationSettingSubscription = {
  onDeleteResourceNotificationSetting?:  {
    __typename: "ResourceNotificationSetting",
    resourceId: string,
    resourceType: NotificationResourceType,
    notificationType: NotificationType,
    recipients?:  Array< {
      __typename: "NotificationRecipient",
      recipientId?: string | null,
      recipientIdType?: NotificationRecipientIdType | null,
      notificationChannels?: Array< NotificationChannel > | null,
      enabled?: boolean | null,
    } > | null,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAssessmentScheduleSubscriptionVariables = {
  filter?: ModelSubscriptionAssessmentScheduleFilterInput | null,
};

export type OnCreateAssessmentScheduleSubscription = {
  onCreateAssessmentSchedule?:  {
    __typename: "AssessmentSchedule",
    id: string,
    propertyId?: string | null,
    name?: string | null,
    description?: string | null,
    startDate?: number | null,
    endDate?: number | null,
    recurrence?:  {
      __typename: "Recurrence",
      type?: RecurrenceType | null,
      dailyRecurrence?:  {
        __typename: "DailyRecurrence",
        interval?: number | null,
      } | null,
      weeklyRecurrence?:  {
        __typename: "WeeklyRecurrence",
        interval?: number | null,
        daysOfWeek?: Array< DayOfWeek | null > | null,
      } | null,
      monthlyRecurrence?:  {
        __typename: "MonthlyRecurrence",
        type?: MonthlyScheduleType | null,
        interval?: number | null,
        dayOfMonth?: string | null,
        nthWeekDay?:  {
          __typename: "NthWeekDay",
          weekNumber?: string | null,
          day?: DayOfWeek | null,
        } | null,
      } | null,
    } | null,
    authorizedIdentifiers?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAssessmentScheduleSubscriptionVariables = {
  filter?: ModelSubscriptionAssessmentScheduleFilterInput | null,
};

export type OnUpdateAssessmentScheduleSubscription = {
  onUpdateAssessmentSchedule?:  {
    __typename: "AssessmentSchedule",
    id: string,
    propertyId?: string | null,
    name?: string | null,
    description?: string | null,
    startDate?: number | null,
    endDate?: number | null,
    recurrence?:  {
      __typename: "Recurrence",
      type?: RecurrenceType | null,
      dailyRecurrence?:  {
        __typename: "DailyRecurrence",
        interval?: number | null,
      } | null,
      weeklyRecurrence?:  {
        __typename: "WeeklyRecurrence",
        interval?: number | null,
        daysOfWeek?: Array< DayOfWeek | null > | null,
      } | null,
      monthlyRecurrence?:  {
        __typename: "MonthlyRecurrence",
        type?: MonthlyScheduleType | null,
        interval?: number | null,
        dayOfMonth?: string | null,
        nthWeekDay?:  {
          __typename: "NthWeekDay",
          weekNumber?: string | null,
          day?: DayOfWeek | null,
        } | null,
      } | null,
    } | null,
    authorizedIdentifiers?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAssessmentScheduleSubscriptionVariables = {
  filter?: ModelSubscriptionAssessmentScheduleFilterInput | null,
};

export type OnDeleteAssessmentScheduleSubscription = {
  onDeleteAssessmentSchedule?:  {
    __typename: "AssessmentSchedule",
    id: string,
    propertyId?: string | null,
    name?: string | null,
    description?: string | null,
    startDate?: number | null,
    endDate?: number | null,
    recurrence?:  {
      __typename: "Recurrence",
      type?: RecurrenceType | null,
      dailyRecurrence?:  {
        __typename: "DailyRecurrence",
        interval?: number | null,
      } | null,
      weeklyRecurrence?:  {
        __typename: "WeeklyRecurrence",
        interval?: number | null,
        daysOfWeek?: Array< DayOfWeek | null > | null,
      } | null,
      monthlyRecurrence?:  {
        __typename: "MonthlyRecurrence",
        type?: MonthlyScheduleType | null,
        interval?: number | null,
        dayOfMonth?: string | null,
        nthWeekDay?:  {
          __typename: "NthWeekDay",
          weekNumber?: string | null,
          day?: DayOfWeek | null,
        } | null,
      } | null,
    } | null,
    authorizedIdentifiers?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateResourceAssessmentScheduleAssociationSubscriptionVariables = {
  filter?: ModelSubscriptionResourceAssessmentScheduleAssociationFilterInput | null,
};

export type OnCreateResourceAssessmentScheduleAssociationSubscription = {
  onCreateResourceAssessmentScheduleAssociation?:  {
    __typename: "ResourceAssessmentScheduleAssociation",
    id: string,
    assessmentScheduleId?: string | null,
    resourceId?: string | null,
    resourceType?: PermissionResourceType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateResourceAssessmentScheduleAssociationSubscriptionVariables = {
  filter?: ModelSubscriptionResourceAssessmentScheduleAssociationFilterInput | null,
};

export type OnUpdateResourceAssessmentScheduleAssociationSubscription = {
  onUpdateResourceAssessmentScheduleAssociation?:  {
    __typename: "ResourceAssessmentScheduleAssociation",
    id: string,
    assessmentScheduleId?: string | null,
    resourceId?: string | null,
    resourceType?: PermissionResourceType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteResourceAssessmentScheduleAssociationSubscriptionVariables = {
  filter?: ModelSubscriptionResourceAssessmentScheduleAssociationFilterInput | null,
};

export type OnDeleteResourceAssessmentScheduleAssociationSubscription = {
  onDeleteResourceAssessmentScheduleAssociation?:  {
    __typename: "ResourceAssessmentScheduleAssociation",
    id: string,
    assessmentScheduleId?: string | null,
    resourceId?: string | null,
    resourceType?: PermissionResourceType | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAssessmentSubscriptionVariables = {
  filter?: ModelSubscriptionAssessmentFilterInput | null,
};

export type OnCreateAssessmentSubscription = {
  onCreateAssessment?:  {
    __typename: "Assessment",
    id: string,
    scheduleId?: string | null,
    resourceId?: string | null,
    propertyId?: string | null,
    resourceType?: PermissionResourceType | null,
    createdBy?: string | null,
    submittedBy?:  {
      __typename: "ExternalUserInfo",
      firstName?: string | null,
      lastName?: string | null,
    } | null,
    createdTime?: number | null,
    status?: AssessmentStatus | null,
    issueIds?: Array< string | null > | null,
    tagIds?: Array< string > | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAssessmentSubscriptionVariables = {
  filter?: ModelSubscriptionAssessmentFilterInput | null,
};

export type OnUpdateAssessmentSubscription = {
  onUpdateAssessment?:  {
    __typename: "Assessment",
    id: string,
    scheduleId?: string | null,
    resourceId?: string | null,
    propertyId?: string | null,
    resourceType?: PermissionResourceType | null,
    createdBy?: string | null,
    submittedBy?:  {
      __typename: "ExternalUserInfo",
      firstName?: string | null,
      lastName?: string | null,
    } | null,
    createdTime?: number | null,
    status?: AssessmentStatus | null,
    issueIds?: Array< string | null > | null,
    tagIds?: Array< string > | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAssessmentSubscriptionVariables = {
  filter?: ModelSubscriptionAssessmentFilterInput | null,
};

export type OnDeleteAssessmentSubscription = {
  onDeleteAssessment?:  {
    __typename: "Assessment",
    id: string,
    scheduleId?: string | null,
    resourceId?: string | null,
    propertyId?: string | null,
    resourceType?: PermissionResourceType | null,
    createdBy?: string | null,
    submittedBy?:  {
      __typename: "ExternalUserInfo",
      firstName?: string | null,
      lastName?: string | null,
    } | null,
    createdTime?: number | null,
    status?: AssessmentStatus | null,
    issueIds?: Array< string | null > | null,
    tagIds?: Array< string > | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateProperty3PIntegrationConfigurationSubscriptionVariables = {
  filter?: ModelSubscriptionProperty3PIntegrationConfigurationFilterInput | null,
};

export type OnCreateProperty3PIntegrationConfigurationSubscription = {
  onCreateProperty3PIntegrationConfiguration?:  {
    __typename: "Property3PIntegrationConfiguration",
    id: string,
    propertyId: string,
    workflowEndpoint: string,
    workflowName: string,
    clientId: string,
    clientSecret: string,
    tokenUrl: string,
    authorizeUrl: string,
    scope: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateProperty3PIntegrationConfigurationSubscriptionVariables = {
  filter?: ModelSubscriptionProperty3PIntegrationConfigurationFilterInput | null,
};

export type OnUpdateProperty3PIntegrationConfigurationSubscription = {
  onUpdateProperty3PIntegrationConfiguration?:  {
    __typename: "Property3PIntegrationConfiguration",
    id: string,
    propertyId: string,
    workflowEndpoint: string,
    workflowName: string,
    clientId: string,
    clientSecret: string,
    tokenUrl: string,
    authorizeUrl: string,
    scope: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteProperty3PIntegrationConfigurationSubscriptionVariables = {
  filter?: ModelSubscriptionProperty3PIntegrationConfigurationFilterInput | null,
};

export type OnDeleteProperty3PIntegrationConfigurationSubscription = {
  onDeleteProperty3PIntegrationConfiguration?:  {
    __typename: "Property3PIntegrationConfiguration",
    id: string,
    propertyId: string,
    workflowEndpoint: string,
    workflowName: string,
    clientId: string,
    clientSecret: string,
    tokenUrl: string,
    authorizeUrl: string,
    scope: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateConversationStateSubscriptionVariables = {
  filter?: ModelSubscriptionConversationStateFilterInput | null,
};

export type OnCreateConversationStateSubscription = {
  onCreateConversationState?:  {
    __typename: "ConversationState",
    id: string,
    attachments?: Array< string | null > | null,
    conversationType: string,
    extractedDetails: string,
    conversationStatus: ConversationStatus,
    invokerId: string,
    nextStep?: ConversationNextStep | null,
    nextStepMessage?: string | null,
    userId?: string | null,
    externalConversationId?: string | null,
    phoneNumber?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateConversationStateSubscriptionVariables = {
  filter?: ModelSubscriptionConversationStateFilterInput | null,
};

export type OnUpdateConversationStateSubscription = {
  onUpdateConversationState?:  {
    __typename: "ConversationState",
    id: string,
    attachments?: Array< string | null > | null,
    conversationType: string,
    extractedDetails: string,
    conversationStatus: ConversationStatus,
    invokerId: string,
    nextStep?: ConversationNextStep | null,
    nextStepMessage?: string | null,
    userId?: string | null,
    externalConversationId?: string | null,
    phoneNumber?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteConversationStateSubscriptionVariables = {
  filter?: ModelSubscriptionConversationStateFilterInput | null,
};

export type OnDeleteConversationStateSubscription = {
  onDeleteConversationState?:  {
    __typename: "ConversationState",
    id: string,
    attachments?: Array< string | null > | null,
    conversationType: string,
    extractedDetails: string,
    conversationStatus: ConversationStatus,
    invokerId: string,
    nextStep?: ConversationNextStep | null,
    nextStepMessage?: string | null,
    userId?: string | null,
    externalConversationId?: string | null,
    phoneNumber?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreatePolicyTemplateLinkSubscriptionVariables = {
  filter?: ModelSubscriptionPolicyTemplateLinkFilterInput | null,
};

export type OnCreatePolicyTemplateLinkSubscription = {
  onCreatePolicyTemplateLink?:  {
    __typename: "PolicyTemplateLink",
    id: string,
    templateId: string,
    entityId: string,
    entityType: PermissionEntityType,
    resourceId: string,
    resourceType: PermissionResourceType,
    grantedBy?: string | null,
    grantedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdatePolicyTemplateLinkSubscriptionVariables = {
  filter?: ModelSubscriptionPolicyTemplateLinkFilterInput | null,
};

export type OnUpdatePolicyTemplateLinkSubscription = {
  onUpdatePolicyTemplateLink?:  {
    __typename: "PolicyTemplateLink",
    id: string,
    templateId: string,
    entityId: string,
    entityType: PermissionEntityType,
    resourceId: string,
    resourceType: PermissionResourceType,
    grantedBy?: string | null,
    grantedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeletePolicyTemplateLinkSubscriptionVariables = {
  filter?: ModelSubscriptionPolicyTemplateLinkFilterInput | null,
};

export type OnDeletePolicyTemplateLinkSubscription = {
  onDeletePolicyTemplateLink?:  {
    __typename: "PolicyTemplateLink",
    id: string,
    templateId: string,
    entityId: string,
    entityType: PermissionEntityType,
    resourceId: string,
    resourceType: PermissionResourceType,
    grantedBy?: string | null,
    grantedAt?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateGenerateIssuesFromImagesJobSubscriptionVariables = {
  filter?: ModelSubscriptionGenerateIssuesFromImagesJobFilterInput | null,
};

export type OnCreateGenerateIssuesFromImagesJobSubscription = {
  onCreateGenerateIssuesFromImagesJob?:  {
    __typename: "GenerateIssuesFromImagesJob",
    id: string,
    extractedIssues: string,
    status: GenerateIssuesFromImagesJobStatus,
    invokerId: string,
    userId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateGenerateIssuesFromImagesJobSubscriptionVariables = {
  filter?: ModelSubscriptionGenerateIssuesFromImagesJobFilterInput | null,
};

export type OnUpdateGenerateIssuesFromImagesJobSubscription = {
  onUpdateGenerateIssuesFromImagesJob?:  {
    __typename: "GenerateIssuesFromImagesJob",
    id: string,
    extractedIssues: string,
    status: GenerateIssuesFromImagesJobStatus,
    invokerId: string,
    userId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteGenerateIssuesFromImagesJobSubscriptionVariables = {
  filter?: ModelSubscriptionGenerateIssuesFromImagesJobFilterInput | null,
};

export type OnDeleteGenerateIssuesFromImagesJobSubscription = {
  onDeleteGenerateIssuesFromImagesJob?:  {
    __typename: "GenerateIssuesFromImagesJob",
    id: string,
    extractedIssues: string,
    status: GenerateIssuesFromImagesJobStatus,
    invokerId: string,
    userId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};
